/* tslint:disable */
/* eslint-disable */
/**
 * Gamma Apps - Internal API
 * Internal endpoints for Gamma Apps
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AboutInfo
 */
export interface AboutInfo {
    /**
     * 
     * @type {string}
     * @memberof AboutInfo
     */
    'version': string;
    /**
     * 
     * @type {ActivationInfo}
     * @memberof AboutInfo
     */
    'activation'?: ActivationInfo | null;
}
/**
 * 
 * @export
 * @interface ActivationInfo
 */
export interface ActivationInfo {
    /**
     * 
     * @type {ActivationStatus}
     * @memberof ActivationInfo
     */
    'status': ActivationStatus;
    /**
     * 
     * @type {string}
     * @memberof ActivationInfo
     */
    'expiration_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivationInfo
     */
    'message'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ActivationStatus = {
    Active: 'Active',
    Expired: 'Expired',
    Invalid: 'Invalid',
    Disabled: 'Disabled'
} as const;

export type ActivationStatus = typeof ActivationStatus[keyof typeof ActivationStatus];


/**
 * 
 * @export
 * @interface Additionaltype
 */
export interface Additionaltype {
}
/**
 * 
 * @export
 * @interface AdvancedPrompts
 */
export interface AdvancedPrompts {
    /**
     * 
     * @type {string}
     * @memberof AdvancedPrompts
     */
    'context_prompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvancedPrompts
     */
    'context_refine_prompt'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentAvatarSettings
 */
export interface AgentAvatarSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentAvatarSettings
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AgentCreationRequest
 */
export interface AgentCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentCreationRequest
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {AgentState}
     * @memberof AgentCreationRequest
     */
    'state': AgentState;
    /**
     * 
     * @type {AgentSettingsInput}
     * @memberof AgentCreationRequest
     */
    'settings': AgentSettingsInput;
    /**
     * 
     * @type {TraceSettings}
     * @memberof AgentCreationRequest
     */
    'trace': TraceSettings;
}


/**
 * 
 * @export
 * @interface AgentCreationResponse
 */
export interface AgentCreationResponse {
    /**
     * 
     * @type {AgentModel}
     * @memberof AgentCreationResponse
     */
    'model': AgentModel;
}
/**
 * 
 * @export
 * @interface AgentExtraSettingsInput
 */
export interface AgentExtraSettingsInput {
    /**
     * 
     * @type {LLMApiType}
     * @memberof AgentExtraSettingsInput
     */
    'llm_api_type': LLMApiType;
    /**
     * 
     * @type {boolean}
     * @memberof AgentExtraSettingsInput
     */
    'streaming': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentExtraSettingsInput
     */
    'parallel_tool_calls': boolean;
    /**
     * 
     * @type {number}
     * @memberof AgentExtraSettingsInput
     */
    'max_turns': number;
    /**
     * 
     * @type {number}
     * @memberof AgentExtraSettingsInput
     */
    'tool_call_output_max_size': number;
    /**
     * 
     * @type {boolean}
     * @memberof AgentExtraSettingsInput
     */
    'use_final_answer_tool': boolean;
    /**
     * 
     * @type {AgentReasoningSettings}
     * @memberof AgentExtraSettingsInput
     */
    'reasoning': AgentReasoningSettings;
}


/**
 * 
 * @export
 * @interface AgentExtraSettingsOutput
 */
export interface AgentExtraSettingsOutput {
    /**
     * 
     * @type {LLMApiType}
     * @memberof AgentExtraSettingsOutput
     */
    'llm_api_type': LLMApiType;
    /**
     * 
     * @type {boolean}
     * @memberof AgentExtraSettingsOutput
     */
    'streaming': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentExtraSettingsOutput
     */
    'parallel_tool_calls': boolean;
    /**
     * 
     * @type {number}
     * @memberof AgentExtraSettingsOutput
     */
    'max_turns': number;
    /**
     * 
     * @type {number}
     * @memberof AgentExtraSettingsOutput
     */
    'tool_call_output_max_size': number;
    /**
     * 
     * @type {boolean}
     * @memberof AgentExtraSettingsOutput
     */
    'use_final_answer_tool': boolean;
    /**
     * 
     * @type {AgentReasoningSettings}
     * @memberof AgentExtraSettingsOutput
     */
    'reasoning': AgentReasoningSettings;
}


/**
 * 
 * @export
 * @interface AgentImportBody
 */
export interface AgentImportBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof AgentImportBody
     */
    'content': ContentJSONFile;
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof AgentImportBody
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface AgentImportResponse
 */
export interface AgentImportResponse {
    /**
     * 
     * @type {AgentModel}
     * @memberof AgentImportResponse
     */
    'agent': AgentModel;
}
/**
 * 
 * @export
 * @interface AgentInspectionBody
 */
export interface AgentInspectionBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof AgentInspectionBody
     */
    'content': ContentJSONFile;
}
/**
 * 
 * @export
 * @interface AgentInspectionResponse
 */
export interface AgentInspectionResponse {
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof AgentInspectionResponse
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface AgentMessageEventAgent
 */
export interface AgentMessageEventAgent {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventAgent
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventAgent
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventAgent
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AgentMessageEventGuardrailCheckData
 */
export interface AgentMessageEventGuardrailCheckData {
    /**
     * 
     * @type {GuardrailType}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'guardrail_type': GuardrailType;
    /**
     * 
     * @type {GuardrailCheckStatus}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'status': GuardrailCheckStatus;
    /**
     * 
     * @type {GuardrailStage}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'stage': GuardrailStage;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'check_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'check_name'?: string;
    /**
     * 
     * @type {GuardrailCheckTarget}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'check_target'?: GuardrailCheckTarget | null;
    /**
     * 
     * @type {number}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'confidence'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventGuardrailCheckData
     */
    'error_message'?: string | null;
}


/**
 * 
 * @export
 * @interface AgentMessageEventGuardrailDataInput
 */
export interface AgentMessageEventGuardrailDataInput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventGuardrailDataInput
     */
    'event_type'?: AgentMessageEventGuardrailDataInputEventTypeEnum;
    /**
     * 
     * @type {Array<AgentMessageEventGuardrailCheckData>}
     * @memberof AgentMessageEventGuardrailDataInput
     */
    'checks'?: Array<AgentMessageEventGuardrailCheckData>;
}

export const AgentMessageEventGuardrailDataInputEventTypeEnum = {
    Guardrail: 'Guardrail'
} as const;

export type AgentMessageEventGuardrailDataInputEventTypeEnum = typeof AgentMessageEventGuardrailDataInputEventTypeEnum[keyof typeof AgentMessageEventGuardrailDataInputEventTypeEnum];

/**
 * 
 * @export
 * @interface AgentMessageEventGuardrailDataOutput
 */
export interface AgentMessageEventGuardrailDataOutput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventGuardrailDataOutput
     */
    'event_type'?: AgentMessageEventGuardrailDataOutputEventTypeEnum;
    /**
     * 
     * @type {Array<AgentMessageEventGuardrailCheckData>}
     * @memberof AgentMessageEventGuardrailDataOutput
     */
    'checks'?: Array<AgentMessageEventGuardrailCheckData>;
}

export const AgentMessageEventGuardrailDataOutputEventTypeEnum = {
    Guardrail: 'Guardrail'
} as const;

export type AgentMessageEventGuardrailDataOutputEventTypeEnum = typeof AgentMessageEventGuardrailDataOutputEventTypeEnum[keyof typeof AgentMessageEventGuardrailDataOutputEventTypeEnum];

/**
 * 
 * @export
 * @interface AgentMessageEventHandoffData
 */
export interface AgentMessageEventHandoffData {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventHandoffData
     */
    'event_type'?: AgentMessageEventHandoffDataEventTypeEnum;
    /**
     * 
     * @type {AgentMessageEventAgent}
     * @memberof AgentMessageEventHandoffData
     */
    'agent': AgentMessageEventAgent;
}

export const AgentMessageEventHandoffDataEventTypeEnum = {
    Handoff: 'Handoff'
} as const;

export type AgentMessageEventHandoffDataEventTypeEnum = typeof AgentMessageEventHandoffDataEventTypeEnum[keyof typeof AgentMessageEventHandoffDataEventTypeEnum];

/**
 * 
 * @export
 * @interface AgentMessageEventInput
 */
export interface AgentMessageEventInput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventInput
     */
    'id': string;
    /**
     * 
     * @type {AgentMessageEventAgent}
     * @memberof AgentMessageEventInput
     */
    'initiator': AgentMessageEventAgent;
    /**
     * 
     * @type {AgentMessageEventType}
     * @memberof AgentMessageEventInput
     */
    'type': AgentMessageEventType;
    /**
     * 
     * @type {Data}
     * @memberof AgentMessageEventInput
     */
    'data': Data;
}


/**
 * 
 * @export
 * @interface AgentMessageEventOutput
 */
export interface AgentMessageEventOutput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventOutput
     */
    'id': string;
    /**
     * 
     * @type {AgentMessageEventAgent}
     * @memberof AgentMessageEventOutput
     */
    'initiator': AgentMessageEventAgent;
    /**
     * 
     * @type {AgentMessageEventType}
     * @memberof AgentMessageEventOutput
     */
    'type': AgentMessageEventType;
    /**
     * 
     * @type {Data1}
     * @memberof AgentMessageEventOutput
     */
    'data': Data1;
}


/**
 * 
 * @export
 * @interface AgentMessageEventRuntimeErrorData
 */
export interface AgentMessageEventRuntimeErrorData {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventRuntimeErrorData
     */
    'event_type'?: AgentMessageEventRuntimeErrorDataEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventRuntimeErrorData
     */
    'message': string;
    /**
     * 
     * @type {ProblemDetails}
     * @memberof AgentMessageEventRuntimeErrorData
     */
    'details': ProblemDetails;
}

export const AgentMessageEventRuntimeErrorDataEventTypeEnum = {
    RuntimeError: 'RuntimeError'
} as const;

export type AgentMessageEventRuntimeErrorDataEventTypeEnum = typeof AgentMessageEventRuntimeErrorDataEventTypeEnum[keyof typeof AgentMessageEventRuntimeErrorDataEventTypeEnum];

/**
 * 
 * @export
 * @interface AgentMessageEventThoughtData
 */
export interface AgentMessageEventThoughtData {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventThoughtData
     */
    'event_type'?: AgentMessageEventThoughtDataEventTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof AgentMessageEventThoughtData
     */
    'content': any;
}

export const AgentMessageEventThoughtDataEventTypeEnum = {
    AgentThought: 'AgentThought'
} as const;

export type AgentMessageEventThoughtDataEventTypeEnum = typeof AgentMessageEventThoughtDataEventTypeEnum[keyof typeof AgentMessageEventThoughtDataEventTypeEnum];

/**
 * 
 * @export
 * @interface AgentMessageEventToolCallDataInput
 */
export interface AgentMessageEventToolCallDataInput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallDataInput
     */
    'event_type'?: AgentMessageEventToolCallDataInputEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallDataInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallDataInput
     */
    'call_id': string;
    /**
     * 
     * @type {AgentMessageEventToolCallStatus}
     * @memberof AgentMessageEventToolCallDataInput
     */
    'status': AgentMessageEventToolCallStatus;
    /**
     * 
     * @type {AgentMessageEventToolCallMetadataInput}
     * @memberof AgentMessageEventToolCallDataInput
     */
    'metadata': AgentMessageEventToolCallMetadataInput;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentMessageEventToolCallDataInput
     */
    'arguments': { [key: string]: any; };
    /**
     * 
     * @type {any}
     * @memberof AgentMessageEventToolCallDataInput
     */
    'output'?: any;
}

export const AgentMessageEventToolCallDataInputEventTypeEnum = {
    ToolCall: 'ToolCall'
} as const;

export type AgentMessageEventToolCallDataInputEventTypeEnum = typeof AgentMessageEventToolCallDataInputEventTypeEnum[keyof typeof AgentMessageEventToolCallDataInputEventTypeEnum];

/**
 * 
 * @export
 * @interface AgentMessageEventToolCallDataOutput
 */
export interface AgentMessageEventToolCallDataOutput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallDataOutput
     */
    'event_type'?: AgentMessageEventToolCallDataOutputEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallDataOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallDataOutput
     */
    'call_id': string;
    /**
     * 
     * @type {AgentMessageEventToolCallStatus}
     * @memberof AgentMessageEventToolCallDataOutput
     */
    'status': AgentMessageEventToolCallStatus;
    /**
     * 
     * @type {AgentMessageEventToolCallMetadataOutput}
     * @memberof AgentMessageEventToolCallDataOutput
     */
    'metadata': AgentMessageEventToolCallMetadataOutput;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentMessageEventToolCallDataOutput
     */
    'arguments': { [key: string]: any; };
    /**
     * 
     * @type {any}
     * @memberof AgentMessageEventToolCallDataOutput
     */
    'output'?: any;
}

export const AgentMessageEventToolCallDataOutputEventTypeEnum = {
    ToolCall: 'ToolCall'
} as const;

export type AgentMessageEventToolCallDataOutputEventTypeEnum = typeof AgentMessageEventToolCallDataOutputEventTypeEnum[keyof typeof AgentMessageEventToolCallDataOutputEventTypeEnum];

/**
 * 
 * @export
 * @interface AgentMessageEventToolCallMetadataInput
 */
export interface AgentMessageEventToolCallMetadataInput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallMetadataInput
     */
    'toolset_id': string;
    /**
     * 
     * @type {ToolsetSettingsType}
     * @memberof AgentMessageEventToolCallMetadataInput
     */
    'toolset_settings_type': ToolsetSettingsType;
    /**
     * 
     * @type {Data2}
     * @memberof AgentMessageEventToolCallMetadataInput
     */
    'data': Data2;
}


/**
 * 
 * @export
 * @interface AgentMessageEventToolCallMetadataOutput
 */
export interface AgentMessageEventToolCallMetadataOutput {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageEventToolCallMetadataOutput
     */
    'toolset_id': string;
    /**
     * 
     * @type {ToolsetSettingsType}
     * @memberof AgentMessageEventToolCallMetadataOutput
     */
    'toolset_settings_type': ToolsetSettingsType;
    /**
     * 
     * @type {Data3}
     * @memberof AgentMessageEventToolCallMetadataOutput
     */
    'data': Data3;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgentMessageEventToolCallStatus = {
    Processing: 'Processing',
    Success: 'Success',
    Error: 'Error'
} as const;

export type AgentMessageEventToolCallStatus = typeof AgentMessageEventToolCallStatus[keyof typeof AgentMessageEventToolCallStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const AgentMessageEventType = {
    ToolCall: 'ToolCall',
    AgentThought: 'AgentThought',
    RuntimeError: 'RuntimeError',
    Handoff: 'Handoff',
    Guardrail: 'Guardrail'
} as const;

export type AgentMessageEventType = typeof AgentMessageEventType[keyof typeof AgentMessageEventType];


/**
 * 
 * @export
 * @interface AgentMessageModel
 */
export interface AgentMessageModel {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageModel
     */
    'message_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageModel
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageModel
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageModel
     */
    'run_id': string;
    /**
     * 
     * @type {ChatMessage}
     * @memberof AgentMessageModel
     */
    'chat_message': ChatMessage;
    /**
     * 
     * @type {Array<DataPayload>}
     * @memberof AgentMessageModel
     */
    'payloads': Array<DataPayload>;
    /**
     * 
     * @type {Array<AgentMessageEventOutput>}
     * @memberof AgentMessageModel
     */
    'events': Array<AgentMessageEventOutput>;
    /**
     * 
     * @type {Array<AgentMessageTools>}
     * @memberof AgentMessageModel
     */
    'tools': Array<AgentMessageTools>;
    /**
     * 
     * @type {Array<AgentResourceModel>}
     * @memberof AgentMessageModel
     */
    'resources': Array<AgentResourceModel>;
}
/**
 * 
 * @export
 * @interface AgentMessageToolSchema
 */
export interface AgentMessageToolSchema {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageToolSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageToolSchema
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof AgentMessageToolSchema
     */
    'strict'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AgentMessageToolSchema
     */
    'parameters': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface AgentMessageTools
 */
export interface AgentMessageTools {
    /**
     * 
     * @type {AgentMessageToolsAgent}
     * @memberof AgentMessageTools
     */
    'agent': AgentMessageToolsAgent;
    /**
     * 
     * @type {Array<AgentMessageToolSchema>}
     * @memberof AgentMessageTools
     */
    'tools': Array<AgentMessageToolSchema>;
}
/**
 * 
 * @export
 * @interface AgentMessageToolsAgent
 */
export interface AgentMessageToolsAgent {
    /**
     * 
     * @type {string}
     * @memberof AgentMessageToolsAgent
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageToolsAgent
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageToolsAgent
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AgentModel
 */
export interface AgentModel {
    /**
     * 
     * @type {string}
     * @memberof AgentModel
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentModel
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AgentModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentModel
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof AgentModel
     */
    'modified_on': string;
    /**
     * 
     * @type {AgentState}
     * @memberof AgentModel
     */
    'state': AgentState;
    /**
     * 
     * @type {AgentSettingsOutput}
     * @memberof AgentModel
     */
    'settings': AgentSettingsOutput;
    /**
     * 
     * @type {TraceSettings}
     * @memberof AgentModel
     */
    'trace': TraceSettings;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgentReasoningEffort = {
    None: 'None',
    Minimal: 'Minimal',
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Xhigh: 'Xhigh'
} as const;

export type AgentReasoningEffort = typeof AgentReasoningEffort[keyof typeof AgentReasoningEffort];


/**
 * 
 * @export
 * @interface AgentReasoningSettings
 */
export interface AgentReasoningSettings {
    /**
     * 
     * @type {boolean}
     * @memberof AgentReasoningSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {AgentReasoningEffort}
     * @memberof AgentReasoningSettings
     */
    'effort': AgentReasoningEffort;
    /**
     * 
     * @type {AgentReasoningSummary}
     * @memberof AgentReasoningSettings
     */
    'summary': AgentReasoningSummary;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgentReasoningSummary = {
    Auto: 'Auto',
    Concise: 'Concise',
    Detailed: 'Detailed'
} as const;

export type AgentReasoningSummary = typeof AgentReasoningSummary[keyof typeof AgentReasoningSummary];


/**
 * 
 * @export
 * @interface AgentRelationCreationRequest
 */
export interface AgentRelationCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentRelationCreationRequest
     */
    'managing_agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRelationCreationRequest
     */
    'managed_agent_id': string;
    /**
     * 
     * @type {AgentRelationState}
     * @memberof AgentRelationCreationRequest
     */
    'state': AgentRelationState;
    /**
     * 
     * @type {AgentRelationHandoffSettings}
     * @memberof AgentRelationCreationRequest
     */
    'handoff'?: AgentRelationHandoffSettings;
}


/**
 * 
 * @export
 * @interface AgentRelationCreationResponse
 */
export interface AgentRelationCreationResponse {
    /**
     * 
     * @type {AgentRelationModel}
     * @memberof AgentRelationCreationResponse
     */
    'model': AgentRelationModel;
}
/**
 * 
 * @export
 * @interface AgentRelationHandoffSettings
 */
export interface AgentRelationHandoffSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentRelationHandoffSettings
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentRelationModel
 */
export interface AgentRelationModel {
    /**
     * 
     * @type {string}
     * @memberof AgentRelationModel
     */
    'relation_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRelationModel
     */
    'folder_id': string;
    /**
     * 
     * @type {AgentModel}
     * @memberof AgentRelationModel
     */
    'managing_agent': AgentModel;
    /**
     * 
     * @type {AgentModel}
     * @memberof AgentRelationModel
     */
    'managed_agent': AgentModel;
    /**
     * 
     * @type {AgentRelationState}
     * @memberof AgentRelationModel
     */
    'state': AgentRelationState;
    /**
     * 
     * @type {AgentRelationHandoffSettings}
     * @memberof AgentRelationModel
     */
    'handoff'?: AgentRelationHandoffSettings;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgentRelationState = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type AgentRelationState = typeof AgentRelationState[keyof typeof AgentRelationState];


/**
 * 
 * @export
 * @interface AgentRelationUpdatingRequest
 */
export interface AgentRelationUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentRelationUpdatingRequest
     */
    'managing_agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRelationUpdatingRequest
     */
    'managed_agent_id': string;
    /**
     * 
     * @type {AgentRelationState}
     * @memberof AgentRelationUpdatingRequest
     */
    'state': AgentRelationState;
    /**
     * 
     * @type {AgentRelationHandoffSettings}
     * @memberof AgentRelationUpdatingRequest
     */
    'handoff'?: AgentRelationHandoffSettings;
}


/**
 * 
 * @export
 * @interface AgentResourceCreationRequest
 */
export interface AgentResourceCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentResourceCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {Settings}
     * @memberof AgentResourceCreationRequest
     */
    'settings': Settings;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceCreationRequest
     */
    'thread_id': string;
}
/**
 * 
 * @export
 * @interface AgentResourceCreationResponse
 */
export interface AgentResourceCreationResponse {
    /**
     * 
     * @type {AgentResourceModel}
     * @memberof AgentResourceCreationResponse
     */
    'model': AgentResourceModel;
}
/**
 * 
 * @export
 * @interface AgentResourceELMA365AppSettings
 */
export interface AgentResourceELMA365AppSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365AppSettings
     */
    'view_url': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365AppSettings
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365AppSettings
     */
    'type'?: AgentResourceELMA365AppSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365AppSettings
     */
    'namespace': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365AppSettings
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365AppSettings
     */
    'id': string;
}

export const AgentResourceELMA365AppSettingsTypeEnum = {
    Elma365App: 'ELMA365App'
} as const;

export type AgentResourceELMA365AppSettingsTypeEnum = typeof AgentResourceELMA365AppSettingsTypeEnum[keyof typeof AgentResourceELMA365AppSettingsTypeEnum];

/**
 * 
 * @export
 * @interface AgentResourceELMA365FileSettings
 */
export interface AgentResourceELMA365FileSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365FileSettings
     */
    'view_url': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365FileSettings
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365FileSettings
     */
    'type'?: AgentResourceELMA365FileSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365FileSettings
     */
    'file_id': string;
}

export const AgentResourceELMA365FileSettingsTypeEnum = {
    Elma365File: 'ELMA365File'
} as const;

export type AgentResourceELMA365FileSettingsTypeEnum = typeof AgentResourceELMA365FileSettingsTypeEnum[keyof typeof AgentResourceELMA365FileSettingsTypeEnum];

/**
 * 
 * @export
 * @interface AgentResourceELMA365SessionSettings
 */
export interface AgentResourceELMA365SessionSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365SessionSettings
     */
    'view_url': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365SessionSettings
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365SessionSettings
     */
    'type'?: AgentResourceELMA365SessionSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceELMA365SessionSettings
     */
    'session_id': string;
}

export const AgentResourceELMA365SessionSettingsTypeEnum = {
    Elma365Session: 'ELMA365Session'
} as const;

export type AgentResourceELMA365SessionSettingsTypeEnum = typeof AgentResourceELMA365SessionSettingsTypeEnum[keyof typeof AgentResourceELMA365SessionSettingsTypeEnum];

/**
 * 
 * @export
 * @interface AgentResourceModel
 */
export interface AgentResourceModel {
    /**
     * 
     * @type {string}
     * @memberof AgentResourceModel
     */
    'name': string;
    /**
     * 
     * @type {Settings}
     * @memberof AgentResourceModel
     */
    'settings': Settings;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceModel
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceModel
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceModel
     */
    'thread_id': string;
}
/**
 * 
 * @export
 * @interface AgentResourceTextSettings
 */
export interface AgentResourceTextSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentResourceTextSettings
     */
    'type'?: AgentResourceTextSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentResourceTextSettings
     */
    'content': string;
}

export const AgentResourceTextSettingsTypeEnum = {
    Text: 'Text'
} as const;

export type AgentResourceTextSettingsTypeEnum = typeof AgentResourceTextSettingsTypeEnum[keyof typeof AgentResourceTextSettingsTypeEnum];

/**
 * 
 * @export
 * @interface AgentResourceUpdatingRequest
 */
export interface AgentResourceUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentResourceUpdatingRequest
     */
    'name': string;
    /**
     * 
     * @type {Settings}
     * @memberof AgentResourceUpdatingRequest
     */
    'settings': Settings;
}
/**
 * 
 * @export
 * @interface AgentRunCreationRequest
 */
export interface AgentRunCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentRunCreationRequest
     */
    'thread_id': string;
    /**
     * 
     * @type {Array<DataPayload>}
     * @memberof AgentRunCreationRequest
     */
    'input': Array<DataPayload>;
}
/**
 * 
 * @export
 * @interface AgentRunCreationResponse
 */
export interface AgentRunCreationResponse {
    /**
     * 
     * @type {AgentRunModel}
     * @memberof AgentRunCreationResponse
     */
    'model': AgentRunModel;
    /**
     * 
     * @type {string}
     * @memberof AgentRunCreationResponse
     */
    'operation_id': string;
}
/**
 * 
 * @export
 * @interface AgentRunExecutionTracing
 */
export interface AgentRunExecutionTracing {
    /**
     * 
     * @type {string}
     * @memberof AgentRunExecutionTracing
     */
    'trace_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentRunModel
 */
export interface AgentRunModel {
    /**
     * 
     * @type {string}
     * @memberof AgentRunModel
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRunModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRunModel
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRunModel
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentRunModel
     */
    'created_on': string;
    /**
     * 
     * @type {AgentRunTracing}
     * @memberof AgentRunModel
     */
    'tracing': AgentRunTracing;
    /**
     * 
     * @type {Array<DataPayload>}
     * @memberof AgentRunModel
     */
    'input': Array<DataPayload>;
    /**
     * 
     * @type {Array<DataPayload>}
     * @memberof AgentRunModel
     */
    'output': Array<DataPayload>;
    /**
     * 
     * @type {AgentRunStatus}
     * @memberof AgentRunModel
     */
    'status': AgentRunStatus;
    /**
     * 
     * @type {OperationProblem}
     * @memberof AgentRunModel
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgentRunStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Success: 'Success',
    Error: 'Error',
    Failure: 'Failure',
    Cancelled: 'Cancelled'
} as const;

export type AgentRunStatus = typeof AgentRunStatus[keyof typeof AgentRunStatus];


/**
 * 
 * @export
 * @interface AgentRunTracing
 */
export interface AgentRunTracing {
    /**
     * 
     * @type {AgentRunExecutionTracing}
     * @memberof AgentRunTracing
     */
    'execution': AgentRunExecutionTracing;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AgentRuntime = {
    OpenAi: 'OpenAI',
    ReAct: 'ReAct'
} as const;

export type AgentRuntime = typeof AgentRuntime[keyof typeof AgentRuntime];


/**
 * 
 * @export
 * @interface AgentSettingsInput
 */
export interface AgentSettingsInput {
    /**
     * 
     * @type {LLMSettings}
     * @memberof AgentSettingsInput
     */
    'llm': LLMSettings;
    /**
     * 
     * @type {AgentRuntime}
     * @memberof AgentSettingsInput
     */
    'runtime': AgentRuntime;
    /**
     * 
     * @type {string}
     * @memberof AgentSettingsInput
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {DataInterfaceInput}
     * @memberof AgentSettingsInput
     */
    'interface': DataInterfaceInput;
    /**
     * 
     * @type {AgentWidgetSettings}
     * @memberof AgentSettingsInput
     */
    'widget': AgentWidgetSettings;
    /**
     * 
     * @type {AgentExtraSettingsInput}
     * @memberof AgentSettingsInput
     */
    'extra': AgentExtraSettingsInput;
    /**
     * 
     * @type {GuardrailsSettingsInput}
     * @memberof AgentSettingsInput
     */
    'guardrails'?: GuardrailsSettingsInput;
}


/**
 * 
 * @export
 * @interface AgentSettingsOutput
 */
export interface AgentSettingsOutput {
    /**
     * 
     * @type {LLMSettings}
     * @memberof AgentSettingsOutput
     */
    'llm': LLMSettings;
    /**
     * 
     * @type {AgentRuntime}
     * @memberof AgentSettingsOutput
     */
    'runtime': AgentRuntime;
    /**
     * 
     * @type {string}
     * @memberof AgentSettingsOutput
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {DataInterfaceOutput}
     * @memberof AgentSettingsOutput
     */
    'interface': DataInterfaceOutput;
    /**
     * 
     * @type {AgentWidgetSettings}
     * @memberof AgentSettingsOutput
     */
    'widget': AgentWidgetSettings;
    /**
     * 
     * @type {AgentExtraSettingsOutput}
     * @memberof AgentSettingsOutput
     */
    'extra': AgentExtraSettingsOutput;
    /**
     * 
     * @type {GuardrailsSettingsOutput}
     * @memberof AgentSettingsOutput
     */
    'guardrails'?: GuardrailsSettingsOutput;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgentState = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type AgentState = typeof AgentState[keyof typeof AgentState];


/**
 * 
 * @export
 * @interface AgentThreadCreationRequest
 */
export interface AgentThreadCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentThreadCreationRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentThreadCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentThreadCreationRequest
     */
    'source_ref'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentThreadCreationResponse
 */
export interface AgentThreadCreationResponse {
    /**
     * 
     * @type {AgentThreadModel}
     * @memberof AgentThreadCreationResponse
     */
    'model': AgentThreadModel;
}
/**
 * 
 * @export
 * @interface AgentThreadModel
 */
export interface AgentThreadModel {
    /**
     * 
     * @type {string}
     * @memberof AgentThreadModel
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentThreadModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentThreadModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof AgentThreadModel
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentThreadModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgentThreadModel
     */
    'source_ref'?: string | null;
}
/**
 * 
 * @export
 * @interface AgentThreadUpdatingRequest
 */
export interface AgentThreadUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentThreadUpdatingRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AgentToolCallData
 */
export interface AgentToolCallData {
    /**
     * 
     * @type {string}
     * @memberof AgentToolCallData
     */
    'toolset_settings_type'?: AgentToolCallDataToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentToolCallData
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentToolCallData
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentToolCallData
     */
    'agent_external_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgentToolCallData
     */
    'agent_name': string;
    /**
     * 
     * @type {DataInterfaceType}
     * @memberof AgentToolCallData
     */
    'agent_data_interface_type': DataInterfaceType;
}

export const AgentToolCallDataToolsetSettingsTypeEnum = {
    Agent: 'Agent'
} as const;

export type AgentToolCallDataToolsetSettingsTypeEnum = typeof AgentToolCallDataToolsetSettingsTypeEnum[keyof typeof AgentToolCallDataToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface AgentToolsetSettings
 */
export interface AgentToolsetSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentToolsetSettings
     */
    'toolset_type'?: AgentToolsetSettingsToolsetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentToolsetSettings
     */
    'agent_id': string;
    /**
     * 
     * @type {CallAgentToolSettings}
     * @memberof AgentToolsetSettings
     */
    'call_agent_tool_settings': CallAgentToolSettings;
}

export const AgentToolsetSettingsToolsetTypeEnum = {
    Agent: 'Agent'
} as const;

export type AgentToolsetSettingsToolsetTypeEnum = typeof AgentToolsetSettingsToolsetTypeEnum[keyof typeof AgentToolsetSettingsToolsetTypeEnum];

/**
 * 
 * @export
 * @interface AgentUpdatingRequest
 */
export interface AgentUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentUpdatingRequest
     */
    'name': string;
    /**
     * 
     * @type {AgentState}
     * @memberof AgentUpdatingRequest
     */
    'state': AgentState;
    /**
     * 
     * @type {AgentSettingsInput}
     * @memberof AgentUpdatingRequest
     */
    'settings': AgentSettingsInput;
    /**
     * 
     * @type {TraceSettings}
     * @memberof AgentUpdatingRequest
     */
    'trace': TraceSettings;
}


/**
 * 
 * @export
 * @interface AgentWidgetSettings
 */
export interface AgentWidgetSettings {
    /**
     * 
     * @type {string}
     * @memberof AgentWidgetSettings
     */
    'display_name': string;
    /**
     * 
     * @type {AgentAvatarSettings}
     * @memberof AgentWidgetSettings
     */
    'avatar': AgentAvatarSettings;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgentWidgetSettings
     */
    'suggestions'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApiKeyAgentScopeRole = {
    Chat: 'Chat'
} as const;

export type ApiKeyAgentScopeRole = typeof ApiKeyAgentScopeRole[keyof typeof ApiKeyAgentScopeRole];


/**
 * 
 * @export
 * @interface ApiKeyCreationRequest
 */
export interface ApiKeyCreationRequest {
    [key: string]: any;

    /**
     * 
     * @type {ApiKeyScopeRef}
     * @memberof ApiKeyCreationRequest
     */
    'scope_ref': ApiKeyScopeRef;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<ApiKeyScopeRole>}
     * @memberof ApiKeyCreationRequest
     */
    'roles': Array<ApiKeyScopeRole>;
}
/**
 * 
 * @export
 * @interface ApiKeyCreationResponse
 */
export interface ApiKeyCreationResponse {
    [key: string]: any;

    /**
     * 
     * @type {ApiKeyModel}
     * @memberof ApiKeyCreationResponse
     */
    'model': ApiKeyModel;
}
/**
 * 
 * @export
 * @interface ApiKeyModel
 */
export interface ApiKeyModel {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyModel
     */
    'api_key_id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyModel
     */
    'folder_id': string | null;
    /**
     * 
     * @type {ApiKeyScopeRef}
     * @memberof ApiKeyModel
     */
    'scope_ref': ApiKeyScopeRef;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyModel
     */
    'x_token': string;
    /**
     * 
     * @type {Array<ApiKeyScopeRole>}
     * @memberof ApiKeyModel
     */
    'roles': Array<ApiKeyScopeRole>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApiKeyProjectScopeRole = {
    Chat: 'Chat',
    DataManagement: 'DataManagement'
} as const;

export type ApiKeyProjectScopeRole = typeof ApiKeyProjectScopeRole[keyof typeof ApiKeyProjectScopeRole];


/**
 * 
 * @export
 * @interface ApiKeyScopeRef
 */
export interface ApiKeyScopeRef {
    /**
     * 
     * @type {ApiKeyScopeRefType}
     * @memberof ApiKeyScopeRef
     */
    'type': ApiKeyScopeRefType;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyScopeRef
     */
    'id'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiKeyScopeRefType = {
    Tenant: 'Tenant',
    Project: 'Project',
    Agent: 'Agent'
} as const;

export type ApiKeyScopeRefType = typeof ApiKeyScopeRefType[keyof typeof ApiKeyScopeRefType];


/**
 * 
 * @export
 * @interface ApiKeyScopeRole
 */
export interface ApiKeyScopeRole {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApiKeyTenantScopeRole = {
    Integration: 'Integration'
} as const;

export type ApiKeyTenantScopeRole = typeof ApiKeyTenantScopeRole[keyof typeof ApiKeyTenantScopeRole];


/**
 * 
 * @export
 * @interface ApiKeyUpdatingRequest
 */
export interface ApiKeyUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyUpdatingRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<ApiKeyScopeRole>}
     * @memberof ApiKeyUpdatingRequest
     */
    'roles': Array<ApiKeyScopeRole>;
}
/**
 * @type Auth
 * @export
 */
export type Auth = { type: 'ApiKey' } & ConnectorApiKeyAuth | { type: 'OAuth2' } & ConnectorOAuth2Auth;

/**
 * 
 * @export
 * @interface AuthSettings
 */
export interface AuthSettings {
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'api_key_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'api_key_value': string;
    /**
     * 
     * @type {MCPServerAuthApiKeyStore}
     * @memberof AuthSettings
     */
    'api_key_store'?: MCPServerAuthApiKeyStore;
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'authorize_endpoint': string;
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'token_endpoint': string;
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'client_id': string;
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'client_secret': string;
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'scope': string;
    /**
     * 
     * @type {string}
     * @memberof AuthSettings
     */
    'connector_id': string;
}


/**
 * 
 * @export
 * @interface BasicContentSite
 */
export interface BasicContentSite {
    /**
     * 
     * @type {string}
     * @memberof BasicContentSite
     */
    'type'?: BasicContentSiteTypeEnum;
}

export const BasicContentSiteTypeEnum = {
    Basic: 'Basic'
} as const;

export type BasicContentSiteTypeEnum = typeof BasicContentSiteTypeEnum[keyof typeof BasicContentSiteTypeEnum];

/**
 * 
 * @export
 * @interface BodySearchFiles
 */
export interface BodySearchFiles {
    /**
     * 
     * @type {FileFiltration}
     * @memberof BodySearchFiles
     */
    'filtration'?: FileFiltration;
    /**
     * 
     * @type {PaginationRequest}
     * @memberof BodySearchFiles
     */
    'pagination'?: PaginationRequest;
}
/**
 * 
 * @export
 * @interface BucketContentSite
 */
export interface BucketContentSite {
    /**
     * 
     * @type {string}
     * @memberof BucketContentSite
     */
    'type'?: BucketContentSiteTypeEnum;
    /**
     * 
     * @type {ContentBucket}
     * @memberof BucketContentSite
     */
    'bucket': ContentBucket;
}

export const BucketContentSiteTypeEnum = {
    Bucket: 'Bucket'
} as const;

export type BucketContentSiteTypeEnum = typeof BucketContentSiteTypeEnum[keyof typeof BucketContentSiteTypeEnum];

/**
 * 
 * @export
 * @interface CallAgentToolSettings
 */
export interface CallAgentToolSettings {
    /**
     * 
     * @type {string}
     * @memberof CallAgentToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CallAgentToolSettings
     */
    'tool_description'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatHistorySettings
 */
export interface ChatHistorySettings {
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistorySettings
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ChatHistorySettings
     */
    'token_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChatHistorySettings
     */
    'condense_prompt'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * 
     * @type {MessageRole}
     * @memberof ChatMessage
     */
    'role'?: MessageRole;
    /**
     * 
     * @type {Array<ChatMessageContentInner>}
     * @memberof ChatMessage
     */
    'content'?: Array<ChatMessageContentInner>;
}


/**
 * 
 * @export
 * @interface ChatMessageContentFileBlock
 */
export interface ChatMessageContentFileBlock {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageContentFileBlock
     */
    'block_type'?: ChatMessageContentFileBlockBlockTypeEnum;
    /**
     * 
     * @type {File}
     * @memberof ChatMessageContentFileBlock
     */
    'data'?: File | null;
    /**
     * 
     * @type {Path}
     * @memberof ChatMessageContentFileBlock
     */
    'path'?: Path | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageContentFileBlock
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageContentFileBlock
     */
    'file_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageContentFileBlock
     */
    'mime_type'?: string | null;
}

export const ChatMessageContentFileBlockBlockTypeEnum = {
    File: 'file'
} as const;

export type ChatMessageContentFileBlockBlockTypeEnum = typeof ChatMessageContentFileBlockBlockTypeEnum[keyof typeof ChatMessageContentFileBlockBlockTypeEnum];

/**
 * @type ChatMessageContentInner
 * @export
 */
export type ChatMessageContentInner = { block_type: 'file' } & ChatMessageContentFileBlock | { block_type: 'text' } & ChatMessageContentTextBlock;

/**
 * 
 * @export
 * @interface ChatMessageContentTextBlock
 */
export interface ChatMessageContentTextBlock {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageContentTextBlock
     */
    'block_type'?: ChatMessageContentTextBlockBlockTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageContentTextBlock
     */
    'text': string;
}

export const ChatMessageContentTextBlockBlockTypeEnum = {
    Text: 'text'
} as const;

export type ChatMessageContentTextBlockBlockTypeEnum = typeof ChatMessageContentTextBlockBlockTypeEnum[keyof typeof ChatMessageContentTextBlockBlockTypeEnum];

/**
 * 
 * @export
 * @interface CheckStageSettingsInput
 */
export interface CheckStageSettingsInput {
    /**
     * 
     * @type {Array<CheckStageSettingsInputChecksInner>}
     * @memberof CheckStageSettingsInput
     */
    'checks'?: Array<CheckStageSettingsInputChecksInner>;
}
/**
 * @type CheckStageSettingsInputChecksInner
 * @export
 */
export type CheckStageSettingsInputChecksInner = { type: 'CustomPromptCheck' } & CustomPromptCheckSettings | { type: 'ExternalCheck' } & ExternalCheckSettingsInput | { type: 'RegexCheck' } & RegexCheckSettings;

/**
 * 
 * @export
 * @interface CheckStageSettingsOutput
 */
export interface CheckStageSettingsOutput {
    /**
     * 
     * @type {Array<CheckStageSettingsOutputChecksInner>}
     * @memberof CheckStageSettingsOutput
     */
    'checks'?: Array<CheckStageSettingsOutputChecksInner>;
}
/**
 * @type CheckStageSettingsOutputChecksInner
 * @export
 */
export type CheckStageSettingsOutputChecksInner = { type: 'CustomPromptCheck' } & CustomPromptCheckSettings | { type: 'ExternalCheck' } & ExternalCheckSettingsOutput | { type: 'RegexCheck' } & RegexCheckSettings;

/**
 * 
 * @export
 * @interface ChunkNodeParsing
 */
export interface ChunkNodeParsing {
    /**
     * 
     * @type {Tokenizer}
     * @memberof ChunkNodeParsing
     */
    'tokenizer'?: Tokenizer;
    /**
     * 
     * @type {number}
     * @memberof ChunkNodeParsing
     */
    'chunk_size'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChunkNodeParsing
     */
    'chunk_overlap'?: number | null;
}
/**
 * 
 * @export
 * @interface CompletionRequest
 */
export interface CompletionRequest {
    /**
     * 
     * @type {string}
     * @memberof CompletionRequest
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof CompletionRequest
     */
    'user_message': string;
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof CompletionRequest
     */
    'chat_history'?: Array<ChatMessage> | null;
    /**
     * 
     * @type {SearchPipelineInput}
     * @memberof CompletionRequest
     */
    'search_pipeline'?: SearchPipelineInput | null;
}
/**
 * 
 * @export
 * @interface CompletionResponse
 */
export interface CompletionResponse {
    /**
     * 
     * @type {Array<SearchChunk>}
     * @memberof CompletionResponse
     */
    'chunks': Array<SearchChunk>;
    /**
     * 
     * @type {string}
     * @memberof CompletionResponse
     */
    'response': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConfluenceSourceParametersLoadingMode = {
    Pages: 'Pages',
    Space: 'Space'
} as const;

export type ConfluenceSourceParametersLoadingMode = typeof ConfluenceSourceParametersLoadingMode[keyof typeof ConfluenceSourceParametersLoadingMode];


/**
 * 
 * @export
 * @interface ConfluenceSourceParametersSettings
 */
export interface ConfluenceSourceParametersSettings {
    /**
     * 
     * @type {string}
     * @memberof ConfluenceSourceParametersSettings
     */
    'source_type'?: ConfluenceSourceParametersSettingsSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfluenceSourceParametersSettings
     */
    'base_url': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConfluenceSourceParametersSettings
     */
    'page_urls'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConfluenceSourceParametersSettings
     */
    'auth_token'?: string | null;
    /**
     * 
     * @type {ConfluenceSourceParametersLoadingMode}
     * @memberof ConfluenceSourceParametersSettings
     */
    'loading_mode'?: ConfluenceSourceParametersLoadingMode;
    /**
     * 
     * @type {string}
     * @memberof ConfluenceSourceParametersSettings
     */
    'space_key'?: string | null;
}

export const ConfluenceSourceParametersSettingsSourceTypeEnum = {
    Confluence: 'Confluence'
} as const;

export type ConfluenceSourceParametersSettingsSourceTypeEnum = typeof ConfluenceSourceParametersSettingsSourceTypeEnum[keyof typeof ConfluenceSourceParametersSettingsSourceTypeEnum];

/**
 * 
 * @export
 * @interface Connector
 */
export interface Connector {
    /**
     * 
     * @type {ConnectorAvailability}
     * @memberof Connector
     */
    'availability': ConnectorAvailability;
    /**
     * 
     * @type {string}
     * @memberof Connector
     */
    'name': string;
    /**
     * 
     * @type {Settings2}
     * @memberof Connector
     */
    'settings': Settings2;
}


/**
 * 
 * @export
 * @interface ConnectorApiKeyAuth
 */
export interface ConnectorApiKeyAuth {
    /**
     * 
     * @type {string}
     * @memberof ConnectorApiKeyAuth
     */
    'type'?: ConnectorApiKeyAuthTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConnectorApiKeyAuth
     */
    'token': string;
}

export const ConnectorApiKeyAuthTypeEnum = {
    ApiKey: 'ApiKey'
} as const;

export type ConnectorApiKeyAuthTypeEnum = typeof ConnectorApiKeyAuthTypeEnum[keyof typeof ConnectorApiKeyAuthTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ConnectorAuthType = {
    ApiKey: 'ApiKey',
    OAuth2: 'OAuth2'
} as const;

export type ConnectorAuthType = typeof ConnectorAuthType[keyof typeof ConnectorAuthType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ConnectorAvailability = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ConnectorAvailability = typeof ConnectorAvailability[keyof typeof ConnectorAvailability];


/**
 * 
 * @export
 * @interface ConnectorCheckOAuthPollingResponse
 */
export interface ConnectorCheckOAuthPollingResponse {
    /**
     * 
     * @type {ConnectorOAuthCheckStatus}
     * @memberof ConnectorCheckOAuthPollingResponse
     */
    'status': ConnectorOAuthCheckStatus;
    /**
     * 
     * @type {ConnectorProblem}
     * @memberof ConnectorCheckOAuthPollingResponse
     */
    'problem': ConnectorProblem | null;
}


/**
 * 
 * @export
 * @interface ConnectorCheckingRequest
 */
export interface ConnectorCheckingRequest {
    /**
     * 
     * @type {Settings1}
     * @memberof ConnectorCheckingRequest
     */
    'settings': Settings1;
}
/**
 * 
 * @export
 * @interface ConnectorCheckingResponse
 */
export interface ConnectorCheckingResponse {
    /**
     * 
     * @type {ConnectorStatus}
     * @memberof ConnectorCheckingResponse
     */
    'status': ConnectorStatus;
    /**
     * 
     * @type {ConnectorProblem}
     * @memberof ConnectorCheckingResponse
     */
    'problem': ConnectorProblem | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectorCheckingResponse
     */
    'check_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectorCheckingResponse
     */
    'auth_url'?: string | null;
}


/**
 * 
 * @export
 * @interface ConnectorCreationRequest
 */
export interface ConnectorCreationRequest {
    /**
     * 
     * @type {ConnectorAvailability}
     * @memberof ConnectorCreationRequest
     */
    'availability': ConnectorAvailability;
    /**
     * 
     * @type {string}
     * @memberof ConnectorCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {Settings1}
     * @memberof ConnectorCreationRequest
     */
    'settings': Settings1;
}


/**
 * 
 * @export
 * @interface ConnectorCreationResponse
 */
export interface ConnectorCreationResponse {
    /**
     * 
     * @type {ConnectorModel}
     * @memberof ConnectorCreationResponse
     */
    'connector': ConnectorModel;
}
/**
 * 
 * @export
 * @interface ConnectorInfoInput
 */
export interface ConnectorInfoInput {
    /**
     * 
     * @type {ConnectorAvailability}
     * @memberof ConnectorInfoInput
     */
    'availability': ConnectorAvailability;
    /**
     * 
     * @type {string}
     * @memberof ConnectorInfoInput
     */
    'name': string;
    /**
     * 
     * @type {Settings1}
     * @memberof ConnectorInfoInput
     */
    'settings': Settings1;
}


/**
 * 
 * @export
 * @interface ConnectorInfoOutput
 */
export interface ConnectorInfoOutput {
    /**
     * 
     * @type {ConnectorAvailability}
     * @memberof ConnectorInfoOutput
     */
    'availability': ConnectorAvailability;
    /**
     * 
     * @type {string}
     * @memberof ConnectorInfoOutput
     */
    'name': string;
    /**
     * 
     * @type {Settings2}
     * @memberof ConnectorInfoOutput
     */
    'settings': Settings2;
}


/**
 * 
 * @export
 * @interface ConnectorModel
 */
export interface ConnectorModel {
    /**
     * 
     * @type {ConnectorAvailability}
     * @memberof ConnectorModel
     */
    'availability': ConnectorAvailability;
    /**
     * 
     * @type {string}
     * @memberof ConnectorModel
     */
    'name': string;
    /**
     * 
     * @type {Settings2}
     * @memberof ConnectorModel
     */
    'settings': Settings2;
    /**
     * 
     * @type {ConnectorStatus}
     * @memberof ConnectorModel
     */
    'status': ConnectorStatus;
    /**
     * 
     * @type {ConnectorProblem}
     * @memberof ConnectorModel
     */
    'problem': ConnectorProblem | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectorModel
     */
    'connector_id': string;
}


/**
 * 
 * @export
 * @interface ConnectorOAuth2Auth
 */
export interface ConnectorOAuth2Auth {
    /**
     * 
     * @type {string}
     * @memberof ConnectorOAuth2Auth
     */
    'type'?: ConnectorOAuth2AuthTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConnectorOAuth2Auth
     */
    'client_id': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectorOAuth2Auth
     */
    'client_secret': string;
}

export const ConnectorOAuth2AuthTypeEnum = {
    OAuth2: 'OAuth2'
} as const;

export type ConnectorOAuth2AuthTypeEnum = typeof ConnectorOAuth2AuthTypeEnum[keyof typeof ConnectorOAuth2AuthTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ConnectorOAuthCheckStatus = {
    Pending: 'Pending',
    Complete: 'Complete',
    Failed: 'Failed'
} as const;

export type ConnectorOAuthCheckStatus = typeof ConnectorOAuthCheckStatus[keyof typeof ConnectorOAuthCheckStatus];


/**
 * 
 * @export
 * @interface ConnectorProblem
 */
export interface ConnectorProblem {
    /**
     * 
     * @type {ProblemDetails}
     * @memberof ConnectorProblem
     */
    'details': ProblemDetails;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConnectorStatus = {
    Unknown: 'Unknown',
    Problem: 'Problem',
    Ready: 'Ready',
    OAuthRequired: 'OAuthRequired'
} as const;

export type ConnectorStatus = typeof ConnectorStatus[keyof typeof ConnectorStatus];


/**
 * 
 * @export
 * @interface ConnectorUpdatingRequest
 */
export interface ConnectorUpdatingRequest {
    /**
     * 
     * @type {ConnectorAvailability}
     * @memberof ConnectorUpdatingRequest
     */
    'availability': ConnectorAvailability;
    /**
     * 
     * @type {string}
     * @memberof ConnectorUpdatingRequest
     */
    'name': string;
    /**
     * 
     * @type {Settings1}
     * @memberof ConnectorUpdatingRequest
     */
    'settings': Settings1;
}


/**
 * 
 * @export
 * @interface ConnectorUpdatingResponse
 */
export interface ConnectorUpdatingResponse {
    /**
     * 
     * @type {ConnectorModel}
     * @memberof ConnectorUpdatingResponse
     */
    'connector': ConnectorModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContentBucket = {
    SmartSearch: 'SmartSearch',
    RefImages: 'RefImages',
    AgentFiles: 'AgentFiles'
} as const;

export type ContentBucket = typeof ContentBucket[keyof typeof ContentBucket];


/**
 * 
 * @export
 * @enum {string}
 */

export const ContentFormat = {
    Object: 'Object',
    String: 'String',
    Binary: 'Binary'
} as const;

export type ContentFormat = typeof ContentFormat[keyof typeof ContentFormat];


/**
 * 
 * @export
 * @interface ContentInfoInput
 */
export interface ContentInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ContentInfoInput
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoInput
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoInput
     */
    'ext': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoInput
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoInput
     */
    'mime': string;
    /**
     * 
     * @type {number}
     * @memberof ContentInfoInput
     */
    'size': number;
    /**
     * 
     * @type {ContentStore}
     * @memberof ContentInfoInput
     */
    'store': ContentStore;
    /**
     * 
     * @type {Site}
     * @memberof ContentInfoInput
     */
    'site': Site;
    /**
     * 
     * @type {ContentFormat}
     * @memberof ContentInfoInput
     */
    'format'?: ContentFormat | null;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoInput
     */
    'encoding'?: string | null;
    /**
     * 
     * @type {ContentMarkup}
     * @memberof ContentInfoInput
     */
    'markup'?: ContentMarkup | null;
    /**
     * 
     * @type {any}
     * @memberof ContentInfoInput
     */
    'data'?: any;
}


/**
 * 
 * @export
 * @interface ContentInfoOutput
 */
export interface ContentInfoOutput {
    /**
     * 
     * @type {string}
     * @memberof ContentInfoOutput
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoOutput
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoOutput
     */
    'ext': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoOutput
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoOutput
     */
    'mime': string;
    /**
     * 
     * @type {number}
     * @memberof ContentInfoOutput
     */
    'size': number;
    /**
     * 
     * @type {ContentStore}
     * @memberof ContentInfoOutput
     */
    'store': ContentStore;
    /**
     * 
     * @type {Site}
     * @memberof ContentInfoOutput
     */
    'site': Site;
    /**
     * 
     * @type {ContentFormat}
     * @memberof ContentInfoOutput
     */
    'format'?: ContentFormat | null;
    /**
     * 
     * @type {string}
     * @memberof ContentInfoOutput
     */
    'encoding'?: string | null;
    /**
     * 
     * @type {ContentMarkup}
     * @memberof ContentInfoOutput
     */
    'markup'?: ContentMarkup | null;
    /**
     * 
     * @type {any}
     * @memberof ContentInfoOutput
     */
    'data'?: any;
}


/**
 * 
 * @export
 * @interface ContentJSONFile
 */
export interface ContentJSONFile {
    /**
     * 
     * @type {string}
     * @memberof ContentJSONFile
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ContentJSONFile
     */
    'mime_type': string;
    /**
     * 
     * @type {string}
     * @memberof ContentJSONFile
     */
    'content_data': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContentMarkup = {
    Yaml: 'YAML',
    Json: 'JSON',
    Html: 'HTML',
    Xml: 'XML',
    Ast: 'AST',
    Md: 'MD'
} as const;

export type ContentMarkup = typeof ContentMarkup[keyof typeof ContentMarkup];


/**
 * 
 * @export
 * @enum {string}
 */

export const ContentStore = {
    Document: 'Document',
    GridFs: 'GridFS',
    S3: 'S3'
} as const;

export type ContentStore = typeof ContentStore[keyof typeof ContentStore];


/**
 * 
 * @export
 * @interface ContentUrls
 */
export interface ContentUrls {
    /**
     * 
     * @type {string}
     * @memberof ContentUrls
     */
    'stream': string;
    /**
     * 
     * @type {string}
     * @memberof ContentUrls
     */
    'buffer': string;
    /**
     * 
     * @type {string}
     * @memberof ContentUrls
     */
    'string': string;
    /**
     * 
     * @type {string}
     * @memberof ContentUrls
     */
    'object': string;
    /**
     * 
     * @type {string}
     * @memberof ContentUrls
     */
    'public': string;
}
/**
 * 
 * @export
 * @interface ContextElementDataModel
 */
export interface ContextElementDataModel {
    [key: string]: any;

    /**
     * 
     * @type {Enumitems}
     * @memberof ContextElementDataModel
     */
    'enumItems'?: Enumitems;
}
/**
 * 
 * @export
 * @interface ContextElementModelInput
 */
export interface ContextElementModelInput {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ContextElementModelInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ContextElementModelInput
     */
    'type': string;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelInput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelInput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelInput
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelInput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelInput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelInput
     */
    'single': boolean;
    /**
     * 
     * @type {Defaultvalue}
     * @memberof ContextElementModelInput
     */
    'defaultValue'?: Defaultvalue;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelInput
     */
    'calcByFormula': boolean;
    /**
     * 
     * @type {string}
     * @memberof ContextElementModelInput
     */
    'formula': string;
    /**
     * 
     * @type {ContextElementModelInputData}
     * @memberof ContextElementModelInput
     */
    'data': ContextElementModelInputData;
    /**
     * 
     * @type {ContextElementModelInputView}
     * @memberof ContextElementModelInput
     */
    'view': ContextElementModelInputView;
}
/**
 * 
 * @export
 * @interface ContextElementModelInputData
 */
export interface ContextElementModelInputData {
    /**
     * 
     * @type {Enumitems}
     * @memberof ContextElementModelInputData
     */
    'enumItems'?: Enumitems;
}
/**
 * 
 * @export
 * @interface ContextElementModelInputView
 */
export interface ContextElementModelInputView {
    /**
     * 
     * @type {Name}
     * @memberof ContextElementModelInputView
     */
    'name'?: Name;
    /**
     * 
     * @type {Tooltip}
     * @memberof ContextElementModelInputView
     */
    'tooltip'?: Tooltip;
    /**
     * 
     * @type {System}
     * @memberof ContextElementModelInputView
     */
    'system'?: System;
    /**
     * 
     * @type {Hidden}
     * @memberof ContextElementModelInputView
     */
    'hidden'?: Hidden;
    /**
     * 
     * @type {ContextElementViewModelData}
     * @memberof ContextElementModelInputView
     */
    'data'?: ContextElementViewModelData;
}
/**
 * 
 * @export
 * @interface ContextElementModelOutput
 */
export interface ContextElementModelOutput {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ContextElementModelOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ContextElementModelOutput
     */
    'type': string;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelOutput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelOutput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelOutput
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelOutput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelOutput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelOutput
     */
    'single': boolean;
    /**
     * 
     * @type {Defaultvalue}
     * @memberof ContextElementModelOutput
     */
    'defaultValue'?: Defaultvalue;
    /**
     * 
     * @type {boolean}
     * @memberof ContextElementModelOutput
     */
    'calcByFormula': boolean;
    /**
     * 
     * @type {string}
     * @memberof ContextElementModelOutput
     */
    'formula': string;
    /**
     * 
     * @type {ContextElementModelInputData}
     * @memberof ContextElementModelOutput
     */
    'data': ContextElementModelInputData;
    /**
     * 
     * @type {ContextElementModelInputView}
     * @memberof ContextElementModelOutput
     */
    'view': ContextElementModelInputView;
}
/**
 * 
 * @export
 * @interface ContextElementViewDataModel
 */
export interface ContextElementViewDataModel {
    [key: string]: any;

    /**
     * 
     * @type {Additionaltype}
     * @memberof ContextElementViewDataModel
     */
    'additionalType'?: Additionaltype;
    /**
     * 
     * @type {Currency}
     * @memberof ContextElementViewDataModel
     */
    'currency'?: Currency;
    /**
     * 
     * @type {Type}
     * @memberof ContextElementViewDataModel
     */
    'type'?: Type;
}
/**
 * 
 * @export
 * @interface ContextElementViewModel
 */
export interface ContextElementViewModel {
    [key: string]: any;

    /**
     * 
     * @type {Name}
     * @memberof ContextElementViewModel
     */
    'name'?: Name;
    /**
     * 
     * @type {Tooltip}
     * @memberof ContextElementViewModel
     */
    'tooltip'?: Tooltip;
    /**
     * 
     * @type {System}
     * @memberof ContextElementViewModel
     */
    'system'?: System;
    /**
     * 
     * @type {Hidden}
     * @memberof ContextElementViewModel
     */
    'hidden'?: Hidden;
    /**
     * 
     * @type {ContextElementViewModelData}
     * @memberof ContextElementViewModel
     */
    'data'?: ContextElementViewModelData;
}
/**
 * 
 * @export
 * @interface ContextElementViewModelData
 */
export interface ContextElementViewModelData {
    /**
     * 
     * @type {Additionaltype}
     * @memberof ContextElementViewModelData
     */
    'additionalType'?: Additionaltype;
    /**
     * 
     * @type {Currency}
     * @memberof ContextElementViewModelData
     */
    'currency'?: Currency;
    /**
     * 
     * @type {Type}
     * @memberof ContextElementViewModelData
     */
    'type'?: Type;
}
/**
 * 
 * @export
 * @interface ContextSettingsModelInput
 */
export interface ContextSettingsModelInput {
    [key: string]: any;

    /**
     * 
     * @type {ContextStatusModel}
     * @memberof ContextSettingsModelInput
     */
    'status': ContextStatusModel;
}
/**
 * 
 * @export
 * @interface ContextSettingsModelOutput
 */
export interface ContextSettingsModelOutput {
    [key: string]: any;

    /**
     * 
     * @type {ContextStatusModel}
     * @memberof ContextSettingsModelOutput
     */
    'status': ContextStatusModel;
}
/**
 * 
 * @export
 * @interface ContextStatusModel
 */
export interface ContextStatusModel {
    [key: string]: any;

    /**
     * 
     * @type {Array<StatusGroupModel>}
     * @memberof ContextStatusModel
     */
    'groups': Array<StatusGroupModel>;
    /**
     * 
     * @type {Array<StatusItemModel>}
     * @memberof ContextStatusModel
     */
    'items': Array<StatusItemModel>;
}
/**
 * 
 * @export
 * @interface CreateELMA365TaskToolSettings
 */
export interface CreateELMA365TaskToolSettings {
    /**
     * 
     * @type {string}
     * @memberof CreateELMA365TaskToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateELMA365TaskToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateELMA365TaskToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface Currency
 */
export interface Currency {
}
/**
 * Structured custom options sent to an external webhook.
 * @export
 * @interface CustomOptions
 */
export interface CustomOptions {
    /**
     * 
     * @type {CustomOptionsStatus}
     * @memberof CustomOptions
     */
    'status'?: CustomOptionsStatus;
    /**
     * 
     * @type {string}
     * @memberof CustomOptions
     */
    'json_value'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomOptionsStatus = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type CustomOptionsStatus = typeof CustomOptionsStatus[keyof typeof CustomOptionsStatus];


/**
 * 
 * @export
 * @interface CustomPromptCheckSettings
 */
export interface CustomPromptCheckSettings {
    /**
     * 
     * @type {string}
     * @memberof CustomPromptCheckSettings
     */
    'check_id'?: string;
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof CustomPromptCheckSettings
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {string}
     * @memberof CustomPromptCheckSettings
     */
    'type'?: CustomPromptCheckSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomPromptCheckSettings
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomPromptCheckSettings
     */
    'order'?: number;
    /**
     * 
     * @type {GuardrailBehavior}
     * @memberof CustomPromptCheckSettings
     */
    'behavior'?: GuardrailBehavior;
    /**
     * 
     * @type {string}
     * @memberof CustomPromptCheckSettings
     */
    'block_message'?: string;
    /**
     * 
     * @type {GuardrailErrorPolicy}
     * @memberof CustomPromptCheckSettings
     */
    'on_error'?: GuardrailErrorPolicy;
    /**
     * 
     * @type {number}
     * @memberof CustomPromptCheckSettings
     */
    'timeout_seconds'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomPromptCheckSettings
     */
    'use_original_text_for_check'?: boolean;
    /**
     * 
     * @type {LLMSettings}
     * @memberof CustomPromptCheckSettings
     */
    'llm'?: LLMSettings;
    /**
     * 
     * @type {boolean}
     * @memberof CustomPromptCheckSettings
     */
    'use_final_answer_tool'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomPromptCheckSettings
     */
    'prompt'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomPromptCheckSettings
     */
    'confidence_threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomPromptCheckSettings
     */
    'max_turns'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomPromptCheckSettings
     */
    'include_reasoning'?: boolean;
}

export const CustomPromptCheckSettingsTypeEnum = {
    CustomPromptCheck: 'CustomPromptCheck'
} as const;

export type CustomPromptCheckSettingsTypeEnum = typeof CustomPromptCheckSettingsTypeEnum[keyof typeof CustomPromptCheckSettingsTypeEnum];

/**
 * @type Data
 * @export
 */
export type Data = { event_type: 'AgentThought' } & AgentMessageEventThoughtData | { event_type: 'Guardrail' } & AgentMessageEventGuardrailDataInput | { event_type: 'Handoff' } & AgentMessageEventHandoffData | { event_type: 'RuntimeError' } & AgentMessageEventRuntimeErrorData | { event_type: 'ToolCall' } & AgentMessageEventToolCallDataInput;

/**
 * @type Data1
 * @export
 */
export type Data1 = { event_type: 'AgentThought' } & AgentMessageEventThoughtData | { event_type: 'Guardrail' } & AgentMessageEventGuardrailDataOutput | { event_type: 'Handoff' } & AgentMessageEventHandoffData | { event_type: 'RuntimeError' } & AgentMessageEventRuntimeErrorData | { event_type: 'ToolCall' } & AgentMessageEventToolCallDataOutput;

/**
 * @type Data2
 * @export
 */
export type Data2 = { toolset_settings_type: 'Agent' } & AgentToolCallData | { toolset_settings_type: 'DateTime' } & DateTimeToolCallData | { toolset_settings_type: 'ELMA365_GENERAL' } & ELMA365GeneralToolCallDataInput | { toolset_settings_type: 'ELMA365_TOOLKIT' } & ELMA365ToolkitToolCallData | { toolset_settings_type: 'File' } & FileToolCallDataInput | { toolset_settings_type: 'MCPServer' } & MCPServerToolCallData | { toolset_settings_type: 'SmartSearch' } & SmartSearchToolCallData | { toolset_settings_type: 'System' } & SystemToolCallData | { toolset_settings_type: 'Web' } & WebToolCallData;

/**
 * @type Data3
 * @export
 */
export type Data3 = { toolset_settings_type: 'Agent' } & AgentToolCallData | { toolset_settings_type: 'DateTime' } & DateTimeToolCallData | { toolset_settings_type: 'ELMA365_GENERAL' } & ELMA365GeneralToolCallDataOutput | { toolset_settings_type: 'ELMA365_TOOLKIT' } & ELMA365ToolkitToolCallData | { toolset_settings_type: 'File' } & FileToolCallDataOutput | { toolset_settings_type: 'MCPServer' } & MCPServerToolCallData | { toolset_settings_type: 'SmartSearch' } & SmartSearchToolCallData | { toolset_settings_type: 'System' } & SystemToolCallData | { toolset_settings_type: 'Web' } & WebToolCallData;

/**
 * 
 * @export
 * @interface DataInterchange
 */
export interface DataInterchange {
    /**
     * 
     * @type {DataInterchangeFormat}
     * @memberof DataInterchange
     */
    'data_format': DataInterchangeFormat;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DataInterchange
     */
    'json_schema': { [key: string]: any; } | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataInterchangeFormat = {
    Text: 'Text',
    Json: 'JSON',
    Schema: 'Schema'
} as const;

export type DataInterchangeFormat = typeof DataInterchangeFormat[keyof typeof DataInterchangeFormat];


/**
 * 
 * @export
 * @interface DataInterfaceInput
 */
export interface DataInterfaceInput {
    /**
     * 
     * @type {DataInterfaceType}
     * @memberof DataInterfaceInput
     */
    'type': DataInterfaceType;
    /**
     * 
     * @type {DataInterchange}
     * @memberof DataInterfaceInput
     */
    'input': DataInterchange;
    /**
     * 
     * @type {DataInterchange}
     * @memberof DataInterfaceInput
     */
    'output': DataInterchange;
}


/**
 * 
 * @export
 * @interface DataInterfaceOutput
 */
export interface DataInterfaceOutput {
    /**
     * 
     * @type {DataInterfaceType}
     * @memberof DataInterfaceOutput
     */
    'type': DataInterfaceType;
    /**
     * 
     * @type {DataInterchange}
     * @memberof DataInterfaceOutput
     */
    'input': DataInterchange;
    /**
     * 
     * @type {DataInterchange}
     * @memberof DataInterfaceOutput
     */
    'output': DataInterchange;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataInterfaceType = {
    Chat: 'Chat',
    Api: 'API'
} as const;

export type DataInterfaceType = typeof DataInterfaceType[keyof typeof DataInterfaceType];


/**
 * 
 * @export
 * @interface DataPayload
 */
export interface DataPayload {
    /**
     * 
     * @type {DataPayloadType}
     * @memberof DataPayload
     */
    'type': DataPayloadType;
    /**
     * 
     * @type {any}
     * @memberof DataPayload
     */
    'data': any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DataPayloadType = {
    Text: 'Text',
    Json: 'JSON',
    Link: 'Link',
    File: 'File',
    Resource: 'Resource'
} as const;

export type DataPayloadType = typeof DataPayloadType[keyof typeof DataPayloadType];


/**
 * 
 * @export
 * @interface DateTimeToolCallData
 */
export interface DateTimeToolCallData {
    /**
     * 
     * @type {string}
     * @memberof DateTimeToolCallData
     */
    'toolset_settings_type'?: DateTimeToolCallDataToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DateTimeToolCallData
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {ToolData}
     * @memberof DateTimeToolCallData
     */
    'tool_data': ToolData;
}

export const DateTimeToolCallDataToolsetSettingsTypeEnum = {
    DateTime: 'DateTime'
} as const;

export type DateTimeToolCallDataToolsetSettingsTypeEnum = typeof DateTimeToolCallDataToolsetSettingsTypeEnum[keyof typeof DateTimeToolCallDataToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface DateTimeToolsetSettings
 */
export interface DateTimeToolsetSettings {
    /**
     * 
     * @type {string}
     * @memberof DateTimeToolsetSettings
     */
    'toolset_type'?: DateTimeToolsetSettingsToolsetTypeEnum;
    /**
     * 
     * @type {GetCurrentDateTimeToolSettings}
     * @memberof DateTimeToolsetSettings
     */
    'get_current_datetime_tool_settings': GetCurrentDateTimeToolSettings;
}

export const DateTimeToolsetSettingsToolsetTypeEnum = {
    DateTime: 'DateTime'
} as const;

export type DateTimeToolsetSettingsToolsetTypeEnum = typeof DateTimeToolsetSettingsToolsetTypeEnum[keyof typeof DateTimeToolsetSettingsToolsetTypeEnum];

/**
 * 
 * @export
 * @interface DeepInfraProviderSettingsInput
 */
export interface DeepInfraProviderSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof DeepInfraProviderSettingsInput
     */
    'provider_type'?: DeepInfraProviderSettingsInputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof DeepInfraProviderSettingsInput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase>}
     * @memberof DeepInfraProviderSettingsInput
     */
    'models'?: Array<ProviderModelItemBase>;
    /**
     * 
     * @type {string}
     * @memberof DeepInfraProviderSettingsInput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeepInfraProviderSettingsInput
     */
    'api_base'?: string | null;
}

export const DeepInfraProviderSettingsInputProviderTypeEnum = {
    Deepinfra: 'DEEPINFRA'
} as const;

export type DeepInfraProviderSettingsInputProviderTypeEnum = typeof DeepInfraProviderSettingsInputProviderTypeEnum[keyof typeof DeepInfraProviderSettingsInputProviderTypeEnum];

/**
 * 
 * @export
 * @interface DeepInfraProviderSettingsOutput
 */
export interface DeepInfraProviderSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof DeepInfraProviderSettingsOutput
     */
    'provider_type'?: DeepInfraProviderSettingsOutputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof DeepInfraProviderSettingsOutput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase1>}
     * @memberof DeepInfraProviderSettingsOutput
     */
    'models'?: Array<ProviderModelItemBase1>;
    /**
     * 
     * @type {string}
     * @memberof DeepInfraProviderSettingsOutput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeepInfraProviderSettingsOutput
     */
    'api_base'?: string | null;
}

export const DeepInfraProviderSettingsOutputProviderTypeEnum = {
    Deepinfra: 'DEEPINFRA'
} as const;

export type DeepInfraProviderSettingsOutputProviderTypeEnum = typeof DeepInfraProviderSettingsOutputProviderTypeEnum[keyof typeof DeepInfraProviderSettingsOutputProviderTypeEnum];

/**
 * 
 * @export
 * @interface Defaultvalue
 */
export interface Defaultvalue {
}
/**
 * 
 * @export
 * @interface DescribeELMA365ImageToolSettings
 */
export interface DescribeELMA365ImageToolSettings {
    /**
     * 
     * @type {string}
     * @memberof DescribeELMA365ImageToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DescribeELMA365ImageToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DescribeELMA365ImageToolSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {LLMSettings}
     * @memberof DescribeELMA365ImageToolSettings
     */
    'llm_settings': LLMSettings;
    /**
     * 
     * @type {string}
     * @memberof DescribeELMA365ImageToolSettings
     */
    'default_prompt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DescribeELMA365ImageToolSettings
     */
    'allow_prompt_override': boolean;
}
/**
 * 
 * @export
 * @interface DescribeImageToolSettings
 */
export interface DescribeImageToolSettings {
    /**
     * 
     * @type {string}
     * @memberof DescribeImageToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DescribeImageToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DescribeImageToolSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {LLMSettings}
     * @memberof DescribeImageToolSettings
     */
    'llm_settings': LLMSettings;
    /**
     * 
     * @type {string}
     * @memberof DescribeImageToolSettings
     */
    'default_prompt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DescribeImageToolSettings
     */
    'allow_prompt_override': boolean;
}
/**
 * 
 * @export
 * @interface Duration
 */
export interface Duration {
    /**
     * 
     * @type {number}
     * @memberof Duration
     */
    'time_s': number;
    /**
     * 
     * @type {number}
     * @memberof Duration
     */
    'process_time_s': number;
    /**
     * 
     * @type {number}
     * @memberof Duration
     */
    'thread_time_s': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365AppElementToolFeedLoadMode = {
    MetadataOnly: 'MetadataOnly',
    AllData: 'AllData',
    DecisionByLlm: 'DecisionByLLM'
} as const;

export type ELMA365AppElementToolFeedLoadMode = typeof ELMA365AppElementToolFeedLoadMode[keyof typeof ELMA365AppElementToolFeedLoadMode];


/**
 * 
 * @export
 * @interface ELMA365AppModelInput
 */
export interface ELMA365AppModelInput {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelInput
     */
    '__id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelInput
     */
    'elementName': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelInput
     */
    'namespace': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelInput
     */
    'type': string;
    /**
     * 
     * @type {Array<ContextElementModelInput>}
     * @memberof ELMA365AppModelInput
     */
    'fields': Array<ContextElementModelInput>;
    /**
     * 
     * @type {Filters}
     * @memberof ELMA365AppModelInput
     */
    'filters'?: Filters;
    /**
     * 
     * @type {ContextSettingsModelInput}
     * @memberof ELMA365AppModelInput
     */
    'settings': ContextSettingsModelInput;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelInput
     */
    '__updatedAt': string;
}
/**
 * 
 * @export
 * @interface ELMA365AppModelOutput
 */
export interface ELMA365AppModelOutput {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelOutput
     */
    '__id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelOutput
     */
    'elementName': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelOutput
     */
    'namespace': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelOutput
     */
    'type': string;
    /**
     * 
     * @type {Array<ContextElementModelOutput>}
     * @memberof ELMA365AppModelOutput
     */
    'fields': Array<ContextElementModelOutput>;
    /**
     * 
     * @type {Filters}
     * @memberof ELMA365AppModelOutput
     */
    'filters'?: Filters;
    /**
     * 
     * @type {ContextSettingsModelOutput}
     * @memberof ELMA365AppModelOutput
     */
    'settings': ContextSettingsModelOutput;
    /**
     * 
     * @type {string}
     * @memberof ELMA365AppModelOutput
     */
    '__updatedAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ApplicationAvailability = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ELMA365ApplicationAvailability = typeof ELMA365ApplicationAvailability[keyof typeof ELMA365ApplicationAvailability];


/**
 * 
 * @export
 * @interface ELMA365ApplicationElementInput
 */
export interface ELMA365ApplicationElementInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationElementInput
     */
    'name': string;
    /**
     * 
     * @type {ELMA365StatusInfo}
     * @memberof ELMA365ApplicationElementInput
     */
    'status': ELMA365StatusInfo | null;
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationElementOutput
 */
export interface ELMA365ApplicationElementOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationElementOutput
     */
    'name': string;
    /**
     * 
     * @type {ELMA365StatusInfo}
     * @memberof ELMA365ApplicationElementOutput
     */
    'status': ELMA365StatusInfo | null;
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationFieldInput
 */
export interface ELMA365ApplicationFieldInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldInput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldInput
     */
    'name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldInput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldInput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldInput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldInput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldInput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldInput
     */
    'deleted': boolean;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ApplicationFieldInput
     */
    'default': any;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldInput
     */
    'formula': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldInput
     */
    'calculated': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365ApplicationFieldInput
     */
    'link': ELMA365LinkInfo | null;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365ApplicationFieldInput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365TableItemInput}
     * @memberof ELMA365ApplicationFieldInput
     */
    'table': ELMA365TableInfoELMA365TableItemInput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationFieldOutput
 */
export interface ELMA365ApplicationFieldOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'deleted': boolean;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'default': any;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'formula': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'calculated': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'link': ELMA365LinkInfo | null;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365TableItemOutput}
     * @memberof ELMA365ApplicationFieldOutput
     */
    'table': ELMA365TableInfoELMA365TableItemOutput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationIdentity
 */
export interface ELMA365ApplicationIdentity {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationIdentity
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationIdentity
     */
    'type'?: ELMA365ApplicationIdentityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationIdentity
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationIdentity
     */
    'name': string;
}

export const ELMA365ApplicationIdentityTypeEnum = {
    Application: 'Application'
} as const;

export type ELMA365ApplicationIdentityTypeEnum = typeof ELMA365ApplicationIdentityTypeEnum[keyof typeof ELMA365ApplicationIdentityTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365ApplicationInfoInput
 */
export interface ELMA365ApplicationInfoInput {
    /**
     * 
     * @type {ELMA365ApplicationAvailability}
     * @memberof ELMA365ApplicationInfoInput
     */
    'availability': ELMA365ApplicationAvailability;
    /**
     * 
     * @type {ELMA365ApplicationStatus}
     * @memberof ELMA365ApplicationInfoInput
     */
    'status': ELMA365ApplicationStatus;
    /**
     * 
     * @type {ELMA365ApplicationVisibility}
     * @memberof ELMA365ApplicationInfoInput
     */
    'visibility': ELMA365ApplicationVisibility;
    /**
     * 
     * @type {ELMA365ApplicationNamespace}
     * @memberof ELMA365ApplicationInfoInput
     */
    'namespace': ELMA365ApplicationNamespace;
    /**
     * 
     * @type {ELMA365ApplicationIdentity}
     * @memberof ELMA365ApplicationInfoInput
     */
    'identity': ELMA365ApplicationIdentity;
    /**
     * 
     * @type {ELMA365ApplicationElementInput}
     * @memberof ELMA365ApplicationInfoInput
     */
    'element': ELMA365ApplicationElementInput;
    /**
     * 
     * @type {Array<ELMA365ApplicationFieldInput>}
     * @memberof ELMA365ApplicationInfoInput
     */
    'fields': Array<ELMA365ApplicationFieldInput>;
}


/**
 * 
 * @export
 * @interface ELMA365ApplicationInfoOutput
 */
export interface ELMA365ApplicationInfoOutput {
    /**
     * 
     * @type {ELMA365ApplicationAvailability}
     * @memberof ELMA365ApplicationInfoOutput
     */
    'availability': ELMA365ApplicationAvailability;
    /**
     * 
     * @type {ELMA365ApplicationStatus}
     * @memberof ELMA365ApplicationInfoOutput
     */
    'status': ELMA365ApplicationStatus;
    /**
     * 
     * @type {ELMA365ApplicationVisibility}
     * @memberof ELMA365ApplicationInfoOutput
     */
    'visibility': ELMA365ApplicationVisibility;
    /**
     * 
     * @type {ELMA365ApplicationNamespace}
     * @memberof ELMA365ApplicationInfoOutput
     */
    'namespace': ELMA365ApplicationNamespace;
    /**
     * 
     * @type {ELMA365ApplicationIdentity}
     * @memberof ELMA365ApplicationInfoOutput
     */
    'identity': ELMA365ApplicationIdentity;
    /**
     * 
     * @type {ELMA365ApplicationElementOutput}
     * @memberof ELMA365ApplicationInfoOutput
     */
    'element': ELMA365ApplicationElementOutput;
    /**
     * 
     * @type {Array<ELMA365ApplicationFieldOutput>}
     * @memberof ELMA365ApplicationInfoOutput
     */
    'fields': Array<ELMA365ApplicationFieldOutput>;
}


/**
 * 
 * @export
 * @interface ELMA365ApplicationModel
 */
export interface ELMA365ApplicationModel {
    /**
     * 
     * @type {ELMA365ApplicationAvailability}
     * @memberof ELMA365ApplicationModel
     */
    'availability': ELMA365ApplicationAvailability;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationModel
     */
    'version_id': string;
    /**
     * 
     * @type {ELMA365ApplicationStatus}
     * @memberof ELMA365ApplicationModel
     */
    'status': ELMA365ApplicationStatus;
    /**
     * 
     * @type {ELMA365ApplicationVisibility}
     * @memberof ELMA365ApplicationModel
     */
    'visibility': ELMA365ApplicationVisibility;
    /**
     * 
     * @type {ELMA365ApplicationNamespace}
     * @memberof ELMA365ApplicationModel
     */
    'namespace': ELMA365ApplicationNamespace;
    /**
     * 
     * @type {ELMA365ApplicationElementOutput}
     * @memberof ELMA365ApplicationModel
     */
    'element': ELMA365ApplicationElementOutput;
    /**
     * 
     * @type {Array<ELMA365ApplicationFieldOutput>}
     * @memberof ELMA365ApplicationModel
     */
    'fields': Array<ELMA365ApplicationFieldOutput>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationModel
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationModel
     */
    'toolset_id': string;
    /**
     * 
     * @type {ELMA365ApplicationIdentity}
     * @memberof ELMA365ApplicationModel
     */
    'identity': ELMA365ApplicationIdentity;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationModel
     */
    'application_id': string;
}


/**
 * 
 * @export
 * @interface ELMA365ApplicationNamespace
 */
export interface ELMA365ApplicationNamespace {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationNamespace
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ApplicationNamespace
     */
    'identity': ELMA365NamespaceIdentity;
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationObtainingRequest
 */
export interface ELMA365ApplicationObtainingRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationObtainingRequest
     */
    'version_id': string;
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationObtainingResponse
 */
export interface ELMA365ApplicationObtainingResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ApplicationObtainingResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationSelectionRequest
 */
export interface ELMA365ApplicationSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ApplicationSelectionRequest
     */
    'version_id': string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ELMA365ApplicationSelectionRequest
     */
    'application_ids': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ELMA365ApplicationSelectionResponse
 */
export interface ELMA365ApplicationSelectionResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ApplicationSelectionResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ApplicationStatus = {
    Pending: 'Pending',
    Ready: 'Ready'
} as const;

export type ELMA365ApplicationStatus = typeof ELMA365ApplicationStatus[keyof typeof ELMA365ApplicationStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ApplicationVisibility = {
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;

export type ELMA365ApplicationVisibility = typeof ELMA365ApplicationVisibility[keyof typeof ELMA365ApplicationVisibility];


/**
 * 
 * @export
 * @interface ELMA365ChangeComponentModelInput
 */
export interface ELMA365ChangeComponentModelInput {
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ChangeComponentModelInput
     */
    'namespace': ELMA365NamespaceIdentity;
    /**
     * 
     * @type {ELMA365IdentityBase}
     * @memberof ELMA365ChangeComponentModelInput
     */
    'identity': ELMA365IdentityBase;
}
/**
 * 
 * @export
 * @interface ELMA365ChangeComponentModelOutput
 */
export interface ELMA365ChangeComponentModelOutput {
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ChangeComponentModelOutput
     */
    'namespace': ELMA365NamespaceIdentity;
    /**
     * 
     * @type {ELMA365IdentityBase}
     * @memberof ELMA365ChangeComponentModelOutput
     */
    'identity': ELMA365IdentityBase;
}
/**
 * 
 * @export
 * @interface ELMA365ChangeNamespaceModel
 */
export interface ELMA365ChangeNamespaceModel {
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ChangeNamespaceModel
     */
    'identity': ELMA365NamespaceIdentity;
}
/**
 * 
 * @export
 * @interface ELMA365ChangeToolModel
 */
export interface ELMA365ChangeToolModel {
    /**
     * 
     * @type {ELMA365ToolAction}
     * @memberof ELMA365ChangeToolModel
     */
    'action': ELMA365ToolAction;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ChangeToolModel
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface ELMA365ComponentChangeModelInput
 */
export interface ELMA365ComponentChangeModelInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof ELMA365ComponentChangeModelInput
     */
    'key': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ComponentChangeModelInput
     */
    'code': string;
    /**
     * 
     * @type {ELMA365ChangeComponentModelInput}
     * @memberof ELMA365ComponentChangeModelInput
     */
    'old': ELMA365ChangeComponentModelInput | null;
    /**
     * 
     * @type {ELMA365ChangeComponentModelInput}
     * @memberof ELMA365ComponentChangeModelInput
     */
    'new': ELMA365ChangeComponentModelInput | null;
    /**
     * 
     * @type {Array<ELMA365ComponentDiff>}
     * @memberof ELMA365ComponentChangeModelInput
     */
    'diffs': Array<ELMA365ComponentDiff>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ELMA365ComponentChangeModelInput
     */
    'items': Array<any>;
    /**
     * 
     * @type {Array<ELMA365ChangeToolModel>}
     * @memberof ELMA365ComponentChangeModelInput
     */
    'tools': Array<ELMA365ChangeToolModel>;
}
/**
 * 
 * @export
 * @interface ELMA365ComponentChangeModelOutput
 */
export interface ELMA365ComponentChangeModelOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof ELMA365ComponentChangeModelOutput
     */
    'key': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ComponentChangeModelOutput
     */
    'code': string;
    /**
     * 
     * @type {ELMA365ChangeComponentModelOutput}
     * @memberof ELMA365ComponentChangeModelOutput
     */
    'old': ELMA365ChangeComponentModelOutput | null;
    /**
     * 
     * @type {ELMA365ChangeComponentModelOutput}
     * @memberof ELMA365ComponentChangeModelOutput
     */
    'new': ELMA365ChangeComponentModelOutput | null;
    /**
     * 
     * @type {Array<ELMA365ComponentDiff>}
     * @memberof ELMA365ComponentChangeModelOutput
     */
    'diffs': Array<ELMA365ComponentDiff>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ELMA365ComponentChangeModelOutput
     */
    'items': Array<any>;
    /**
     * 
     * @type {Array<ELMA365ChangeToolModel>}
     * @memberof ELMA365ComponentChangeModelOutput
     */
    'tools': Array<ELMA365ChangeToolModel>;
}
/**
 * 
 * @export
 * @interface ELMA365ComponentDiff
 */
export interface ELMA365ComponentDiff {
    /**
     * 
     * @type {ELMA365ComponentDiffType}
     * @memberof ELMA365ComponentDiff
     */
    'type': ELMA365ComponentDiffType;
    /**
     * 
     * @type {ELMA365ComponentDiffItem}
     * @memberof ELMA365ComponentDiff
     */
    'item': ELMA365ComponentDiffItem;
    /**
     * 
     * @type {ELMA365ComponentDiffPart}
     * @memberof ELMA365ComponentDiff
     */
    'part': ELMA365ComponentDiffPart;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ComponentDiff
     */
    'name': string;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ComponentDiff
     */
    'old': any;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ComponentDiff
     */
    'new': any;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ComponentDiffItem = {
    Namespace: 'Namespace',
    Application: 'Application',
    Process: 'Process',
    Field: 'Field'
} as const;

export type ELMA365ComponentDiffItem = typeof ELMA365ComponentDiffItem[keyof typeof ELMA365ComponentDiffItem];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ComponentDiffPart = {
    Item: 'Item',
    Type: 'Type',
    Name: 'Name',
    Title: 'Title',
    Description: 'Description',
    Required: 'Required'
} as const;

export type ELMA365ComponentDiffPart = typeof ELMA365ComponentDiffPart[keyof typeof ELMA365ComponentDiffPart];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ComponentDiffType = {
    Created: 'Created',
    Updated: 'Updated',
    Deleted: 'Deleted'
} as const;

export type ELMA365ComponentDiffType = typeof ELMA365ComponentDiffType[keyof typeof ELMA365ComponentDiffType];


/**
 * 
 * @export
 * @interface ELMA365ComponentVolume
 */
export interface ELMA365ComponentVolume {
    /**
     * 
     * @type {number}
     * @memberof ELMA365ComponentVolume
     */
    'namespace_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ELMA365ComponentVolume
     */
    'application_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ELMA365ComponentVolume
     */
    'process_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ELMA365ComponentVolume
     */
    'tool_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ELMA365ComponentVolume
     */
    'char_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ELMA365ComponentVolume
     */
    'token_count'?: number;
}
/**
 * 
 * @export
 * @interface ELMA365ConnectorAPIsInput
 */
export interface ELMA365ConnectorAPIsInput {
    /**
     * 
     * @type {ELMA365ConnectorWebAPI}
     * @memberof ELMA365ConnectorAPIsInput
     */
    'web': ELMA365ConnectorWebAPI;
}
/**
 * 
 * @export
 * @interface ELMA365ConnectorAPIsOutput
 */
export interface ELMA365ConnectorAPIsOutput {
    /**
     * 
     * @type {ELMA365ConnectorWebAPI}
     * @memberof ELMA365ConnectorAPIsOutput
     */
    'web': ELMA365ConnectorWebAPI;
}
/**
 * 
 * @export
 * @interface ELMA365ConnectorSettingsInput
 */
export interface ELMA365ConnectorSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ConnectorSettingsInput
     */
    'type'?: ELMA365ConnectorSettingsInputTypeEnum;
    /**
     * 
     * @type {ELMA365ConnectorAPIsInput}
     * @memberof ELMA365ConnectorSettingsInput
     */
    'apis': ELMA365ConnectorAPIsInput;
}

export const ELMA365ConnectorSettingsInputTypeEnum = {
    Elma365: 'ELMA365'
} as const;

export type ELMA365ConnectorSettingsInputTypeEnum = typeof ELMA365ConnectorSettingsInputTypeEnum[keyof typeof ELMA365ConnectorSettingsInputTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365ConnectorSettingsOutput
 */
export interface ELMA365ConnectorSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ConnectorSettingsOutput
     */
    'type'?: ELMA365ConnectorSettingsOutputTypeEnum;
    /**
     * 
     * @type {ELMA365ConnectorAPIsOutput}
     * @memberof ELMA365ConnectorSettingsOutput
     */
    'apis': ELMA365ConnectorAPIsOutput;
}

export const ELMA365ConnectorSettingsOutputTypeEnum = {
    Elma365: 'ELMA365'
} as const;

export type ELMA365ConnectorSettingsOutputTypeEnum = typeof ELMA365ConnectorSettingsOutputTypeEnum[keyof typeof ELMA365ConnectorSettingsOutputTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365ConnectorWebAPI
 */
export interface ELMA365ConnectorWebAPI {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ConnectorWebAPI
     */
    'url': string;
    /**
     * 
     * @type {Auth}
     * @memberof ELMA365ConnectorWebAPI
     */
    'auth': Auth;
}
/**
 * 
 * @export
 * @interface ELMA365CreateTaskToolCallData
 */
export interface ELMA365CreateTaskToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365CreateTaskToolCallData
     */
    'tool_type'?: ELMA365CreateTaskToolCallDataToolTypeEnum;
}

export const ELMA365CreateTaskToolCallDataToolTypeEnum = {
    CreateTask: 'CreateTask'
} as const;

export type ELMA365CreateTaskToolCallDataToolTypeEnum = typeof ELMA365CreateTaskToolCallDataToolTypeEnum[keyof typeof ELMA365CreateTaskToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365DescribeImageToolCallData
 */
export interface ELMA365DescribeImageToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365DescribeImageToolCallData
     */
    'tool_type'?: ELMA365DescribeImageToolCallDataToolTypeEnum;
    /**
     * 
     * @type {LLMSettings}
     * @memberof ELMA365DescribeImageToolCallData
     */
    'llm_settings': LLMSettings;
    /**
     * 
     * @type {string}
     * @memberof ELMA365DescribeImageToolCallData
     */
    'default_prompt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365DescribeImageToolCallData
     */
    'allow_prompt_override': boolean;
}

export const ELMA365DescribeImageToolCallDataToolTypeEnum = {
    DescribeImage: 'DescribeImage'
} as const;

export type ELMA365DescribeImageToolCallDataToolTypeEnum = typeof ELMA365DescribeImageToolCallDataToolTypeEnum[keyof typeof ELMA365DescribeImageToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365EnumInfo
 */
export interface ELMA365EnumInfo {
    /**
     * 
     * @type {Array<ELMA365EnumItem>}
     * @memberof ELMA365EnumInfo
     */
    'items': Array<ELMA365EnumItem>;
}
/**
 * 
 * @export
 * @interface ELMA365EnumItem
 */
export interface ELMA365EnumItem {
    /**
     * 
     * @type {string}
     * @memberof ELMA365EnumItem
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365EnumItem
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365EnumItem
     */
    'checked': boolean;
}
/**
 * 
 * @export
 * @interface ELMA365FetchAppElementToolCallData
 */
export interface ELMA365FetchAppElementToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365FetchAppElementToolCallData
     */
    'tool_type'?: ELMA365FetchAppElementToolCallDataToolTypeEnum;
    /**
     * 
     * @type {ELMA365AppElementToolFeedLoadMode}
     * @memberof ELMA365FetchAppElementToolCallData
     */
    'feed_load_mode': ELMA365AppElementToolFeedLoadMode;
}

export const ELMA365FetchAppElementToolCallDataToolTypeEnum = {
    FetchAppElement: 'FetchAppElement'
} as const;

export type ELMA365FetchAppElementToolCallDataToolTypeEnum = typeof ELMA365FetchAppElementToolCallDataToolTypeEnum[keyof typeof ELMA365FetchAppElementToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365FetchAppFeedToolCallData
 */
export interface ELMA365FetchAppFeedToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365FetchAppFeedToolCallData
     */
    'tool_type'?: ELMA365FetchAppFeedToolCallDataToolTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ELMA365FetchAppFeedToolCallData
     */
    'max_content_token_count': number;
}

export const ELMA365FetchAppFeedToolCallDataToolTypeEnum = {
    FetchAppFeed: 'FetchAppFeed'
} as const;

export type ELMA365FetchAppFeedToolCallDataToolTypeEnum = typeof ELMA365FetchAppFeedToolCallDataToolTypeEnum[keyof typeof ELMA365FetchAppFeedToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365FetchCurrentUserToolCallData
 */
export interface ELMA365FetchCurrentUserToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365FetchCurrentUserToolCallData
     */
    'tool_type'?: ELMA365FetchCurrentUserToolCallDataToolTypeEnum;
}

export const ELMA365FetchCurrentUserToolCallDataToolTypeEnum = {
    FetchCurrentUser: 'FetchCurrentUser'
} as const;

export type ELMA365FetchCurrentUserToolCallDataToolTypeEnum = typeof ELMA365FetchCurrentUserToolCallDataToolTypeEnum[keyof typeof ELMA365FetchCurrentUserToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365FetchDocflowListsToolCallData
 */
export interface ELMA365FetchDocflowListsToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365FetchDocflowListsToolCallData
     */
    'tool_type'?: ELMA365FetchDocflowListsToolCallDataToolTypeEnum;
}

export const ELMA365FetchDocflowListsToolCallDataToolTypeEnum = {
    FetchDocflowLists: 'FetchDocflowLists'
} as const;

export type ELMA365FetchDocflowListsToolCallDataToolTypeEnum = typeof ELMA365FetchDocflowListsToolCallDataToolTypeEnum[keyof typeof ELMA365FetchDocflowListsToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365FetchTaskToolCallData
 */
export interface ELMA365FetchTaskToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365FetchTaskToolCallData
     */
    'tool_type'?: ELMA365FetchTaskToolCallDataToolTypeEnum;
}

export const ELMA365FetchTaskToolCallDataToolTypeEnum = {
    FetchTask: 'FetchTask'
} as const;

export type ELMA365FetchTaskToolCallDataToolTypeEnum = typeof ELMA365FetchTaskToolCallDataToolTypeEnum[keyof typeof ELMA365FetchTaskToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365FieldInfoInput
 */
export interface ELMA365FieldInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoInput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoInput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoInput
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoInput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoInput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoInput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoInput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoInput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoInput
     */
    'deleted': boolean;
    /**
     * 
     * @type {any}
     * @memberof ELMA365FieldInfoInput
     */
    'default': any;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoInput
     */
    'formula': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoInput
     */
    'calculated': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365FieldInfoInput
     */
    'link': ELMA365LinkInfo | null;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365FieldInfoInput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365FieldInfoInput}
     * @memberof ELMA365FieldInfoInput
     */
    'table': ELMA365TableInfoELMA365FieldInfoInput | null;
    /**
     * 
     * @type {ELMA365StatusInfo}
     * @memberof ELMA365FieldInfoInput
     */
    'status': ELMA365StatusInfo | null;
}
/**
 * 
 * @export
 * @interface ELMA365FieldInfoOutput
 */
export interface ELMA365FieldInfoOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoOutput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoOutput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoOutput
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoOutput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoOutput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoOutput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoOutput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoOutput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoOutput
     */
    'deleted': boolean;
    /**
     * 
     * @type {any}
     * @memberof ELMA365FieldInfoOutput
     */
    'default': any;
    /**
     * 
     * @type {string}
     * @memberof ELMA365FieldInfoOutput
     */
    'formula': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365FieldInfoOutput
     */
    'calculated': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365FieldInfoOutput
     */
    'link': ELMA365LinkInfo | null;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365FieldInfoOutput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365FieldInfoOutput}
     * @memberof ELMA365FieldInfoOutput
     */
    'table': ELMA365TableInfoELMA365FieldInfoOutput | null;
    /**
     * 
     * @type {ELMA365StatusInfo}
     * @memberof ELMA365FieldInfoOutput
     */
    'status': ELMA365StatusInfo | null;
}
/**
 * 
 * @export
 * @interface ELMA365GeneralToolCallDataInput
 */
export interface ELMA365GeneralToolCallDataInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataInput
     */
    'toolset_settings_type'?: ELMA365GeneralToolCallDataInputToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataInput
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataInput
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataInput
     */
    'x_token': string;
    /**
     * 
     * @type {ToolData1}
     * @memberof ELMA365GeneralToolCallDataInput
     */
    'tool_data': ToolData1;
}

export const ELMA365GeneralToolCallDataInputToolsetSettingsTypeEnum = {
    Elma365General: 'ELMA365_GENERAL'
} as const;

export type ELMA365GeneralToolCallDataInputToolsetSettingsTypeEnum = typeof ELMA365GeneralToolCallDataInputToolsetSettingsTypeEnum[keyof typeof ELMA365GeneralToolCallDataInputToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365GeneralToolCallDataOutput
 */
export interface ELMA365GeneralToolCallDataOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataOutput
     */
    'toolset_settings_type'?: ELMA365GeneralToolCallDataOutputToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataOutput
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataOutput
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolCallDataOutput
     */
    'x_token': string;
    /**
     * 
     * @type {ToolData1}
     * @memberof ELMA365GeneralToolCallDataOutput
     */
    'tool_data': ToolData1;
}

export const ELMA365GeneralToolCallDataOutputToolsetSettingsTypeEnum = {
    Elma365General: 'ELMA365_GENERAL'
} as const;

export type ELMA365GeneralToolCallDataOutputToolsetSettingsTypeEnum = typeof ELMA365GeneralToolCallDataOutputToolsetSettingsTypeEnum[keyof typeof ELMA365GeneralToolCallDataOutputToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365GeneralToolsetSettingsInput
 */
export interface ELMA365GeneralToolsetSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'toolset_type'?: ELMA365GeneralToolsetSettingsInputToolsetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'tool_names_prefix'?: string | null;
    /**
     * 
     * @type {FetchELMA365AppElementToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'fetch_app_element_tool_settings': FetchELMA365AppElementToolSettings;
    /**
     * 
     * @type {FetchELMA365AppFeedToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'fetch_app_feed_tool_settings': FetchELMA365AppFeedToolSettings;
    /**
     * 
     * @type {ReadELMA365FileToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'read_file_tool_settings': ReadELMA365FileToolSettings;
    /**
     * 
     * @type {DescribeELMA365ImageToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'describe_image_tool_settings': DescribeELMA365ImageToolSettings;
    /**
     * 
     * @type {FetchCurrentELMA365UserToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'fetch_current_user_tool_settings': FetchCurrentELMA365UserToolSettings;
    /**
     * 
     * @type {SearchELMA365TasksToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'search_elma365_tasks_tool_settings': SearchELMA365TasksToolSettings;
    /**
     * 
     * @type {FetchELMA365TaskToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'fetch_elma365_task_tool_settings': FetchELMA365TaskToolSettings;
    /**
     * 
     * @type {CreateELMA365TaskToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'create_elma365_task_tool_settings': CreateELMA365TaskToolSettings;
    /**
     * 
     * @type {ReassignELMA365TaskToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'reassign_elma365_task_tool_settings': ReassignELMA365TaskToolSettings;
    /**
     * 
     * @type {UpdateELMA365TaskPercentToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'update_elma365_task_percent_tool_settings': UpdateELMA365TaskPercentToolSettings;
    /**
     * 
     * @type {UpdateELMA365TaskDatesToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'update_elma365_task_dates_tool_settings': UpdateELMA365TaskDatesToolSettings;
    /**
     * 
     * @type {FetchDocflowListsToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsInput
     */
    'fetch_docflow_lists_tool_settings': FetchDocflowListsToolSettings;
}

export const ELMA365GeneralToolsetSettingsInputToolsetTypeEnum = {
    Elma365General: 'ELMA365_GENERAL'
} as const;

export type ELMA365GeneralToolsetSettingsInputToolsetTypeEnum = typeof ELMA365GeneralToolsetSettingsInputToolsetTypeEnum[keyof typeof ELMA365GeneralToolsetSettingsInputToolsetTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365GeneralToolsetSettingsOutput
 */
export interface ELMA365GeneralToolsetSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'toolset_type'?: ELMA365GeneralToolsetSettingsOutputToolsetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'tool_names_prefix'?: string | null;
    /**
     * 
     * @type {FetchELMA365AppElementToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'fetch_app_element_tool_settings': FetchELMA365AppElementToolSettings;
    /**
     * 
     * @type {FetchELMA365AppFeedToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'fetch_app_feed_tool_settings': FetchELMA365AppFeedToolSettings;
    /**
     * 
     * @type {ReadELMA365FileToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'read_file_tool_settings': ReadELMA365FileToolSettings;
    /**
     * 
     * @type {DescribeELMA365ImageToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'describe_image_tool_settings': DescribeELMA365ImageToolSettings;
    /**
     * 
     * @type {FetchCurrentELMA365UserToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'fetch_current_user_tool_settings': FetchCurrentELMA365UserToolSettings;
    /**
     * 
     * @type {SearchELMA365TasksToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'search_elma365_tasks_tool_settings': SearchELMA365TasksToolSettings;
    /**
     * 
     * @type {FetchELMA365TaskToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'fetch_elma365_task_tool_settings': FetchELMA365TaskToolSettings;
    /**
     * 
     * @type {CreateELMA365TaskToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'create_elma365_task_tool_settings': CreateELMA365TaskToolSettings;
    /**
     * 
     * @type {ReassignELMA365TaskToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'reassign_elma365_task_tool_settings': ReassignELMA365TaskToolSettings;
    /**
     * 
     * @type {UpdateELMA365TaskPercentToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'update_elma365_task_percent_tool_settings': UpdateELMA365TaskPercentToolSettings;
    /**
     * 
     * @type {UpdateELMA365TaskDatesToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'update_elma365_task_dates_tool_settings': UpdateELMA365TaskDatesToolSettings;
    /**
     * 
     * @type {FetchDocflowListsToolSettings}
     * @memberof ELMA365GeneralToolsetSettingsOutput
     */
    'fetch_docflow_lists_tool_settings': FetchDocflowListsToolSettings;
}

export const ELMA365GeneralToolsetSettingsOutputToolsetTypeEnum = {
    Elma365General: 'ELMA365_GENERAL'
} as const;

export type ELMA365GeneralToolsetSettingsOutputToolsetTypeEnum = typeof ELMA365GeneralToolsetSettingsOutputToolsetTypeEnum[keyof typeof ELMA365GeneralToolsetSettingsOutputToolsetTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365IdentityBase
 */
export interface ELMA365IdentityBase {
    /**
     * 
     * @type {string}
     * @memberof ELMA365IdentityBase
     */
    'uid': string;
    /**
     * 
     * @type {ELMA365IdentityType}
     * @memberof ELMA365IdentityBase
     */
    'type': ELMA365IdentityType;
    /**
     * 
     * @type {string}
     * @memberof ELMA365IdentityBase
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365IdentityBase
     */
    'name': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365IdentityType = {
    Namespace: 'Namespace',
    Application: 'Application',
    Process: 'Process'
} as const;

export type ELMA365IdentityType = typeof ELMA365IdentityType[keyof typeof ELMA365IdentityType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365LinkCategory = {
    Namespace: 'namespace',
    Application: 'application',
    Process: 'process'
} as const;

export type ELMA365LinkCategory = typeof ELMA365LinkCategory[keyof typeof ELMA365LinkCategory];


/**
 * 
 * @export
 * @interface ELMA365LinkIdentity
 */
export interface ELMA365LinkIdentity {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ELMA365LinkIdentity
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ELMA365LinkInfo
 */
export interface ELMA365LinkInfo {
    [key: string]: any;

    /**
     * 
     * @type {ELMA365LinkCategory}
     * @memberof ELMA365LinkInfo
     */
    'category': ELMA365LinkCategory;
    /**
     * 
     * @type {ELMA365LinkIdentity}
     * @memberof ELMA365LinkInfo
     */
    'namespace': ELMA365LinkIdentity;
    /**
     * 
     * @type {ELMA365LinkInfoComponent}
     * @memberof ELMA365LinkInfo
     */
    'component': ELMA365LinkInfoComponent;
}


/**
 * 
 * @export
 * @interface ELMA365LinkInfoComponent
 */
export interface ELMA365LinkInfoComponent {
    /**
     * 
     * @type {string}
     * @memberof ELMA365LinkInfoComponent
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ELMA365ModelInfoInput
 */
export interface ELMA365ModelInfoInput {
    /**
     * 
     * @type {ELMA365ModelTypes}
     * @memberof ELMA365ModelInfoInput
     */
    'types': ELMA365ModelTypes;
    /**
     * 
     * @type {ELMA365TableInfoELMA365ModelInfoInput}
     * @memberof ELMA365ModelInfoInput
     */
    'table': ELMA365TableInfoELMA365ModelInfoInput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ModelInfoOutput
 */
export interface ELMA365ModelInfoOutput {
    /**
     * 
     * @type {ELMA365ModelTypes}
     * @memberof ELMA365ModelInfoOutput
     */
    'types': ELMA365ModelTypes;
    /**
     * 
     * @type {ELMA365TableInfoELMA365ModelInfoOutput}
     * @memberof ELMA365ModelInfoOutput
     */
    'table': ELMA365TableInfoELMA365ModelInfoOutput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ModelTypes
 */
export interface ELMA365ModelTypes {
    /**
     * 
     * @type {any}
     * @memberof ELMA365ModelTypes
     */
    'common': any;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ModelTypes
     */
    'inbound': any;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ModelTypes
     */
    'outbound': any;
}
/**
 * 
 * @export
 * @interface ELMA365NSModel
 */
export interface ELMA365NSModel {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ELMA365NSModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NSModel
     */
    'namespace': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NSModel
     */
    'code': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365NamespaceAvailability = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ELMA365NamespaceAvailability = typeof ELMA365NamespaceAvailability[keyof typeof ELMA365NamespaceAvailability];


/**
 * 
 * @export
 * @interface ELMA365NamespaceChangeModelInput
 */
export interface ELMA365NamespaceChangeModelInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof ELMA365NamespaceChangeModelInput
     */
    'key': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceChangeModelInput
     */
    'code': string;
    /**
     * 
     * @type {ELMA365ChangeNamespaceModel}
     * @memberof ELMA365NamespaceChangeModelInput
     */
    'old': ELMA365ChangeNamespaceModel | null;
    /**
     * 
     * @type {ELMA365ChangeNamespaceModel}
     * @memberof ELMA365NamespaceChangeModelInput
     */
    'new': ELMA365ChangeNamespaceModel | null;
    /**
     * 
     * @type {Array<ELMA365ComponentDiff>}
     * @memberof ELMA365NamespaceChangeModelInput
     */
    'diffs': Array<ELMA365ComponentDiff>;
    /**
     * 
     * @type {Array<ELMA365ComponentChangeModelInput>}
     * @memberof ELMA365NamespaceChangeModelInput
     */
    'items': Array<ELMA365ComponentChangeModelInput>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ELMA365NamespaceChangeModelInput
     */
    'tools': Array<any>;
}
/**
 * 
 * @export
 * @interface ELMA365NamespaceChangeModelOutput
 */
export interface ELMA365NamespaceChangeModelOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof ELMA365NamespaceChangeModelOutput
     */
    'key': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceChangeModelOutput
     */
    'code': string;
    /**
     * 
     * @type {ELMA365ChangeNamespaceModel}
     * @memberof ELMA365NamespaceChangeModelOutput
     */
    'old': ELMA365ChangeNamespaceModel | null;
    /**
     * 
     * @type {ELMA365ChangeNamespaceModel}
     * @memberof ELMA365NamespaceChangeModelOutput
     */
    'new': ELMA365ChangeNamespaceModel | null;
    /**
     * 
     * @type {Array<ELMA365ComponentDiff>}
     * @memberof ELMA365NamespaceChangeModelOutput
     */
    'diffs': Array<ELMA365ComponentDiff>;
    /**
     * 
     * @type {Array<ELMA365ComponentChangeModelOutput>}
     * @memberof ELMA365NamespaceChangeModelOutput
     */
    'items': Array<ELMA365ComponentChangeModelOutput>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ELMA365NamespaceChangeModelOutput
     */
    'tools': Array<any>;
}
/**
 * 
 * @export
 * @interface ELMA365NamespaceComponent
 */
export interface ELMA365NamespaceComponent {
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceComponent
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365NamespaceComponent
     */
    'identity': ELMA365NamespaceIdentity;
}
/**
 * 
 * @export
 * @interface ELMA365NamespaceIdentity
 */
export interface ELMA365NamespaceIdentity {
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceIdentity
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceIdentity
     */
    'type'?: ELMA365NamespaceIdentityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceIdentity
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceIdentity
     */
    'name': string;
}

export const ELMA365NamespaceIdentityTypeEnum = {
    Namespace: 'Namespace'
} as const;

export type ELMA365NamespaceIdentityTypeEnum = typeof ELMA365NamespaceIdentityTypeEnum[keyof typeof ELMA365NamespaceIdentityTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365NamespaceInfo
 */
export interface ELMA365NamespaceInfo {
    /**
     * 
     * @type {ELMA365NamespaceAvailability}
     * @memberof ELMA365NamespaceInfo
     */
    'availability': ELMA365NamespaceAvailability;
    /**
     * 
     * @type {ELMA365NamespaceStatus}
     * @memberof ELMA365NamespaceInfo
     */
    'status': ELMA365NamespaceStatus;
    /**
     * 
     * @type {ELMA365NamespaceVisibility}
     * @memberof ELMA365NamespaceInfo
     */
    'visibility': ELMA365NamespaceVisibility;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365NamespaceInfo
     */
    'parent': ELMA365NamespaceIdentity;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365NamespaceInfo
     */
    'identity': ELMA365NamespaceIdentity;
}


/**
 * 
 * @export
 * @interface ELMA365NamespaceModel
 */
export interface ELMA365NamespaceModel {
    /**
     * 
     * @type {ELMA365NamespaceAvailability}
     * @memberof ELMA365NamespaceModel
     */
    'availability': ELMA365NamespaceAvailability;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceModel
     */
    'version_id': string;
    /**
     * 
     * @type {ELMA365NamespaceStatus}
     * @memberof ELMA365NamespaceModel
     */
    'status': ELMA365NamespaceStatus;
    /**
     * 
     * @type {ELMA365NamespaceVisibility}
     * @memberof ELMA365NamespaceModel
     */
    'visibility': ELMA365NamespaceVisibility;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceModel
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceModel
     */
    'toolset_id': string;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365NamespaceModel
     */
    'parent': ELMA365NamespaceIdentity;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365NamespaceModel
     */
    'identity': ELMA365NamespaceIdentity;
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceModel
     */
    'namespace_id': string;
}


/**
 * 
 * @export
 * @interface ELMA365NamespaceObtainingRequest
 */
export interface ELMA365NamespaceObtainingRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceObtainingRequest
     */
    'version_id': string;
}
/**
 * 
 * @export
 * @interface ELMA365NamespaceObtainingResponse
 */
export interface ELMA365NamespaceObtainingResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365NamespaceObtainingResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @interface ELMA365NamespaceSelectionRequest
 */
export interface ELMA365NamespaceSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365NamespaceSelectionRequest
     */
    'version_id': string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ELMA365NamespaceSelectionRequest
     */
    'namespace_ids': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ELMA365NamespaceSelectionResponse
 */
export interface ELMA365NamespaceSelectionResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365NamespaceSelectionResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365NamespaceStatus = {
    Pending: 'Pending',
    Ready: 'Ready'
} as const;

export type ELMA365NamespaceStatus = typeof ELMA365NamespaceStatus[keyof typeof ELMA365NamespaceStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365NamespaceVisibility = {
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;

export type ELMA365NamespaceVisibility = typeof ELMA365NamespaceVisibility[keyof typeof ELMA365NamespaceVisibility];


/**
 * 
 * @export
 * @interface ELMA365ParamAttrs
 */
export interface ELMA365ParamAttrs {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ParamAttrs
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ParamAttrs
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ParamAttrs
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ParamAttrs
     */
    'enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ParamAttrs
     */
    'required': boolean;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ParamAttrs
     */
    'default': any;
    /**
     * 
     * @type {Array<string>}
     * @memberof ELMA365ParamAttrs
     */
    'aliases': Array<string>;
}
/**
 * 
 * @export
 * @interface ELMA365ParamInfoInput
 */
export interface ELMA365ParamInfoInput {
    /**
     * 
     * @type {ELMA365ParamAttrs}
     * @memberof ELMA365ParamInfoInput
     */
    'attrs': ELMA365ParamAttrs;
    /**
     * 
     * @type {ELMA365TableInfoELMA365ParamInfoInput}
     * @memberof ELMA365ParamInfoInput
     */
    'table': ELMA365TableInfoELMA365ParamInfoInput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ParamInfoOutput
 */
export interface ELMA365ParamInfoOutput {
    /**
     * 
     * @type {ELMA365ParamAttrs}
     * @memberof ELMA365ParamInfoOutput
     */
    'attrs': ELMA365ParamAttrs;
    /**
     * 
     * @type {ELMA365TableInfoELMA365ParamInfoOutput}
     * @memberof ELMA365ParamInfoOutput
     */
    'table': ELMA365TableInfoELMA365ParamInfoOutput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessApplicationInput
 */
export interface ELMA365ProcessApplicationInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessApplicationInput
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365ApplicationIdentity}
     * @memberof ELMA365ProcessApplicationInput
     */
    'identity': ELMA365ApplicationIdentity;
    /**
     * 
     * @type {ELMA365NamespaceComponent}
     * @memberof ELMA365ProcessApplicationInput
     */
    'namespace': ELMA365NamespaceComponent;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessApplicationOutput
 */
export interface ELMA365ProcessApplicationOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessApplicationOutput
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365ApplicationIdentity}
     * @memberof ELMA365ProcessApplicationOutput
     */
    'identity': ELMA365ApplicationIdentity;
    /**
     * 
     * @type {ELMA365NamespaceComponent}
     * @memberof ELMA365ProcessApplicationOutput
     */
    'namespace': ELMA365NamespaceComponent;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ProcessAvailability = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ELMA365ProcessAvailability = typeof ELMA365ProcessAvailability[keyof typeof ELMA365ProcessAvailability];


/**
 * 
 * @export
 * @interface ELMA365ProcessEntryInput
 */
export interface ELMA365ProcessEntryInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryInput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryInput
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryInput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryInput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryInput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryInput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryInput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryInput
     */
    'deleted': boolean;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ProcessEntryInput
     */
    'default': any;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryInput
     */
    'formula': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryInput
     */
    'calculated': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365ProcessEntryInput
     */
    'link': ELMA365LinkInfo | null;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365ProcessEntryInput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365TableItemInput}
     * @memberof ELMA365ProcessEntryInput
     */
    'table': ELMA365TableInfoELMA365TableItemInput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessEntryOutput
 */
export interface ELMA365ProcessEntryOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryOutput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryOutput
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryOutput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryOutput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryOutput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryOutput
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryOutput
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryOutput
     */
    'deleted': boolean;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ProcessEntryOutput
     */
    'default': any;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessEntryOutput
     */
    'formula': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessEntryOutput
     */
    'calculated': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365ProcessEntryOutput
     */
    'link': ELMA365LinkInfo | null;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365ProcessEntryOutput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365TableItemOutput}
     * @memberof ELMA365ProcessEntryOutput
     */
    'table': ELMA365TableInfoELMA365TableItemOutput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessFieldInput
 */
export interface ELMA365ProcessFieldInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldInput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldInput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldInput
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldInput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldInput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldInput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldInput
     */
    'searchable': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365ProcessFieldInput
     */
    'link': ELMA365LinkInfo | null;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessFieldOutput
 */
export interface ELMA365ProcessFieldOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldOutput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldOutput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessFieldOutput
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldOutput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldOutput
     */
    'single': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldOutput
     */
    'array': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessFieldOutput
     */
    'searchable': boolean;
    /**
     * 
     * @type {ELMA365LinkInfo}
     * @memberof ELMA365ProcessFieldOutput
     */
    'link': ELMA365LinkInfo | null;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessForm
 */
export interface ELMA365ProcessForm {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessForm
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessForm
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessForm
     */
    'name': string;
    /**
     * 
     * @type {Array<ELMA365ProcessInput>}
     * @memberof ELMA365ProcessForm
     */
    'inputs': Array<ELMA365ProcessInput>;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessIdentity
 */
export interface ELMA365ProcessIdentity {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessIdentity
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessIdentity
     */
    'type'?: ELMA365ProcessIdentityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessIdentity
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessIdentity
     */
    'name': string;
}

export const ELMA365ProcessIdentityTypeEnum = {
    Process: 'Process'
} as const;

export type ELMA365ProcessIdentityTypeEnum = typeof ELMA365ProcessIdentityTypeEnum[keyof typeof ELMA365ProcessIdentityTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365ProcessInfoInput
 */
export interface ELMA365ProcessInfoInput {
    /**
     * 
     * @type {ELMA365ProcessAvailability}
     * @memberof ELMA365ProcessInfoInput
     */
    'availability': ELMA365ProcessAvailability;
    /**
     * 
     * @type {ELMA365ProcessStatus}
     * @memberof ELMA365ProcessInfoInput
     */
    'status': ELMA365ProcessStatus;
    /**
     * 
     * @type {ELMA365ProcessVisibility}
     * @memberof ELMA365ProcessInfoInput
     */
    'visibility': ELMA365ProcessVisibility;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessInfoInput
     */
    'location': string;
    /**
     * 
     * @type {ELMA365ProcessNamespace}
     * @memberof ELMA365ProcessInfoInput
     */
    'namespace': ELMA365ProcessNamespace;
    /**
     * 
     * @type {ELMA365ProcessApplicationInput}
     * @memberof ELMA365ProcessInfoInput
     */
    'application': ELMA365ProcessApplicationInput;
    /**
     * 
     * @type {ELMA365ProcessIdentity}
     * @memberof ELMA365ProcessInfoInput
     */
    'identity': ELMA365ProcessIdentity;
    /**
     * 
     * @type {Array<ELMA365ProcessForm>}
     * @memberof ELMA365ProcessInfoInput
     */
    'forms': Array<ELMA365ProcessForm>;
    /**
     * 
     * @type {Array<ELMA365ProcessEntryInput>}
     * @memberof ELMA365ProcessInfoInput
     */
    'entries': Array<ELMA365ProcessEntryInput>;
    /**
     * 
     * @type {Array<ELMA365ProcessFieldInput>}
     * @memberof ELMA365ProcessInfoInput
     */
    'fields': Array<ELMA365ProcessFieldInput>;
}


/**
 * 
 * @export
 * @interface ELMA365ProcessInfoOutput
 */
export interface ELMA365ProcessInfoOutput {
    /**
     * 
     * @type {ELMA365ProcessAvailability}
     * @memberof ELMA365ProcessInfoOutput
     */
    'availability': ELMA365ProcessAvailability;
    /**
     * 
     * @type {ELMA365ProcessStatus}
     * @memberof ELMA365ProcessInfoOutput
     */
    'status': ELMA365ProcessStatus;
    /**
     * 
     * @type {ELMA365ProcessVisibility}
     * @memberof ELMA365ProcessInfoOutput
     */
    'visibility': ELMA365ProcessVisibility;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessInfoOutput
     */
    'location': string;
    /**
     * 
     * @type {ELMA365ProcessNamespace}
     * @memberof ELMA365ProcessInfoOutput
     */
    'namespace': ELMA365ProcessNamespace;
    /**
     * 
     * @type {ELMA365ProcessApplicationOutput}
     * @memberof ELMA365ProcessInfoOutput
     */
    'application': ELMA365ProcessApplicationOutput;
    /**
     * 
     * @type {ELMA365ProcessIdentity}
     * @memberof ELMA365ProcessInfoOutput
     */
    'identity': ELMA365ProcessIdentity;
    /**
     * 
     * @type {Array<ELMA365ProcessForm>}
     * @memberof ELMA365ProcessInfoOutput
     */
    'forms': Array<ELMA365ProcessForm>;
    /**
     * 
     * @type {Array<ELMA365ProcessEntryOutput>}
     * @memberof ELMA365ProcessInfoOutput
     */
    'entries': Array<ELMA365ProcessEntryOutput>;
    /**
     * 
     * @type {Array<ELMA365ProcessFieldOutput>}
     * @memberof ELMA365ProcessInfoOutput
     */
    'fields': Array<ELMA365ProcessFieldOutput>;
}


/**
 * 
 * @export
 * @interface ELMA365ProcessInput
 */
export interface ELMA365ProcessInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessInput
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessInput
     */
    'display': string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessInput
     */
    'tooltip': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessInput
     */
    'required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ProcessInput
     */
    'readonly': boolean;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessModel
 */
export interface ELMA365ProcessModel {
    /**
     * 
     * @type {ELMA365ProcessAvailability}
     * @memberof ELMA365ProcessModel
     */
    'availability': ELMA365ProcessAvailability;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessModel
     */
    'version_id': string;
    /**
     * 
     * @type {ELMA365ProcessStatus}
     * @memberof ELMA365ProcessModel
     */
    'status': ELMA365ProcessStatus;
    /**
     * 
     * @type {ELMA365ProcessVisibility}
     * @memberof ELMA365ProcessModel
     */
    'visibility': ELMA365ProcessVisibility;
    /**
     * 
     * @type {ELMA365ProcessNamespace}
     * @memberof ELMA365ProcessModel
     */
    'namespace': ELMA365ProcessNamespace;
    /**
     * 
     * @type {ELMA365ProcessApplicationOutput}
     * @memberof ELMA365ProcessModel
     */
    'application': ELMA365ProcessApplicationOutput;
    /**
     * 
     * @type {Array<ELMA365ProcessForm>}
     * @memberof ELMA365ProcessModel
     */
    'forms': Array<ELMA365ProcessForm>;
    /**
     * 
     * @type {Array<ELMA365ProcessEntryOutput>}
     * @memberof ELMA365ProcessModel
     */
    'entries': Array<ELMA365ProcessEntryOutput>;
    /**
     * 
     * @type {Array<ELMA365ProcessFieldOutput>}
     * @memberof ELMA365ProcessModel
     */
    'fields': Array<ELMA365ProcessFieldOutput>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessModel
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessModel
     */
    'toolset_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessModel
     */
    'location': string;
    /**
     * 
     * @type {ELMA365ProcessIdentity}
     * @memberof ELMA365ProcessModel
     */
    'identity': ELMA365ProcessIdentity;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessModel
     */
    'process_id': string;
}


/**
 * 
 * @export
 * @interface ELMA365ProcessNamespace
 */
export interface ELMA365ProcessNamespace {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessNamespace
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ProcessNamespace
     */
    'identity': ELMA365NamespaceIdentity;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessObtainingRequest
 */
export interface ELMA365ProcessObtainingRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessObtainingRequest
     */
    'version_id': string;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessObtainingResponse
 */
export interface ELMA365ProcessObtainingResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ProcessObtainingResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @interface ELMA365ProcessSelectionRequest
 */
export interface ELMA365ProcessSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ProcessSelectionRequest
     */
    'version_id': string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ELMA365ProcessSelectionRequest
     */
    'process_ids': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ELMA365ProcessSelectionResponse
 */
export interface ELMA365ProcessSelectionResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ProcessSelectionResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ProcessStatus = {
    Pending: 'Pending',
    Ready: 'Ready'
} as const;

export type ELMA365ProcessStatus = typeof ELMA365ProcessStatus[keyof typeof ELMA365ProcessStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ProcessVisibility = {
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;

export type ELMA365ProcessVisibility = typeof ELMA365ProcessVisibility[keyof typeof ELMA365ProcessVisibility];


/**
 * 
 * @export
 * @interface ELMA365ReadFileToolCallData
 */
export interface ELMA365ReadFileToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ReadFileToolCallData
     */
    'tool_type'?: ELMA365ReadFileToolCallDataToolTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ELMA365ReadFileToolCallData
     */
    'max_content_token_count': number;
}

export const ELMA365ReadFileToolCallDataToolTypeEnum = {
    ReadFile: 'ReadFile'
} as const;

export type ELMA365ReadFileToolCallDataToolTypeEnum = typeof ELMA365ReadFileToolCallDataToolTypeEnum[keyof typeof ELMA365ReadFileToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365ReassignTaskToolCallData
 */
export interface ELMA365ReassignTaskToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ReassignTaskToolCallData
     */
    'tool_type'?: ELMA365ReassignTaskToolCallDataToolTypeEnum;
}

export const ELMA365ReassignTaskToolCallDataToolTypeEnum = {
    ReassignTask: 'ReassignTask'
} as const;

export type ELMA365ReassignTaskToolCallDataToolTypeEnum = typeof ELMA365ReassignTaskToolCallDataToolTypeEnum[keyof typeof ELMA365ReassignTaskToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365SearchTasksToolCallData
 */
export interface ELMA365SearchTasksToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365SearchTasksToolCallData
     */
    'tool_type'?: ELMA365SearchTasksToolCallDataToolTypeEnum;
}

export const ELMA365SearchTasksToolCallDataToolTypeEnum = {
    SearchTasks: 'SearchTasks'
} as const;

export type ELMA365SearchTasksToolCallDataToolTypeEnum = typeof ELMA365SearchTasksToolCallDataToolTypeEnum[keyof typeof ELMA365SearchTasksToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365SlotInfoInput
 */
export interface ELMA365SlotInfoInput {
    /**
     * 
     * @type {ELMA365FieldInfoInput}
     * @memberof ELMA365SlotInfoInput
     */
    'field': ELMA365FieldInfoInput;
    /**
     * 
     * @type {ELMA365ParamInfoInput}
     * @memberof ELMA365SlotInfoInput
     */
    'param': ELMA365ParamInfoInput;
    /**
     * 
     * @type {ELMA365ModelInfoInput}
     * @memberof ELMA365SlotInfoInput
     */
    'model': ELMA365ModelInfoInput;
    /**
     * 
     * @type {ELMA365TableInfoELMA365SlotInfoInput}
     * @memberof ELMA365SlotInfoInput
     */
    'table': ELMA365TableInfoELMA365SlotInfoInput | null;
}
/**
 * 
 * @export
 * @interface ELMA365SlotInfoOutput
 */
export interface ELMA365SlotInfoOutput {
    /**
     * 
     * @type {ELMA365FieldInfoOutput}
     * @memberof ELMA365SlotInfoOutput
     */
    'field': ELMA365FieldInfoOutput;
    /**
     * 
     * @type {ELMA365ParamInfoOutput}
     * @memberof ELMA365SlotInfoOutput
     */
    'param': ELMA365ParamInfoOutput;
    /**
     * 
     * @type {ELMA365ModelInfoOutput}
     * @memberof ELMA365SlotInfoOutput
     */
    'model': ELMA365ModelInfoOutput;
    /**
     * 
     * @type {ELMA365TableInfoELMA365SlotInfoOutput}
     * @memberof ELMA365SlotInfoOutput
     */
    'table': ELMA365TableInfoELMA365SlotInfoOutput | null;
}
/**
 * 
 * @export
 * @interface ELMA365SourceParametersFeed
 */
export interface ELMA365SourceParametersFeed {
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365SourceParametersFeed
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ELMA365SourceParametersSettings
 */
export interface ELMA365SourceParametersSettings {
    /**
     * 
     * @type {string}
     * @memberof ELMA365SourceParametersSettings
     */
    'source_type'?: ELMA365SourceParametersSettingsSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365SourceParametersSettings
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365SourceParametersSettings
     */
    'app_namespace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365SourceParametersSettings
     */
    'app_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365SourceParametersSettings
     */
    'filtration_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ELMA365SourceParametersSettings
     */
    'filtration_json'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ELMA365SourceParametersSettings
     */
    'selected_field_codes'?: Array<string>;
    /**
     * 
     * @type {ELMA365SourceParametersFeed}
     * @memberof ELMA365SourceParametersSettings
     */
    'feed': ELMA365SourceParametersFeed;
    /**
     * 
     * @type {ELMA365SourceParametersStatus}
     * @memberof ELMA365SourceParametersSettings
     */
    'status': ELMA365SourceParametersStatus;
}

export const ELMA365SourceParametersSettingsSourceTypeEnum = {
    Elma365: 'ELMA365'
} as const;

export type ELMA365SourceParametersSettingsSourceTypeEnum = typeof ELMA365SourceParametersSettingsSourceTypeEnum[keyof typeof ELMA365SourceParametersSettingsSourceTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365SourceParametersStatus
 */
export interface ELMA365SourceParametersStatus {
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365SourceParametersStatus
     */
    'refresh_enabled': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ELMA365SourceParametersStatus
     */
    'selected_item_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface ELMA365StatusInfo
 */
export interface ELMA365StatusInfo {
    /**
     * 
     * @type {Array<ELMA365StatusItem>}
     * @memberof ELMA365StatusInfo
     */
    'items': Array<ELMA365StatusItem>;
}
/**
 * 
 * @export
 * @interface ELMA365StatusItem
 */
export interface ELMA365StatusItem {
    /**
     * 
     * @type {number}
     * @memberof ELMA365StatusItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ELMA365StatusItem
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365StatusItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365StatusItem
     */
    'group_id': string;
}
/**
 * 
 * @export
 * @interface ELMA365TableAttrs
 */
export interface ELMA365TableAttrs {
    /**
     * 
     * @type {Array<string>}
     * @memberof ELMA365TableAttrs
     */
    'path': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365TableAttrs
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365FieldInfoInput
 */
export interface ELMA365TableInfoELMA365FieldInfoInput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365FieldInfoInput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365FieldInfoInput>}
     * @memberof ELMA365TableInfoELMA365FieldInfoInput
     */
    'items': Array<ELMA365FieldInfoInput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365FieldInfoOutput
 */
export interface ELMA365TableInfoELMA365FieldInfoOutput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365FieldInfoOutput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365FieldInfoOutput>}
     * @memberof ELMA365TableInfoELMA365FieldInfoOutput
     */
    'items': Array<ELMA365FieldInfoOutput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365ModelInfoInput
 */
export interface ELMA365TableInfoELMA365ModelInfoInput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365ModelInfoInput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365ModelInfoInput>}
     * @memberof ELMA365TableInfoELMA365ModelInfoInput
     */
    'items': Array<ELMA365ModelInfoInput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365ModelInfoOutput
 */
export interface ELMA365TableInfoELMA365ModelInfoOutput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365ModelInfoOutput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365ModelInfoOutput>}
     * @memberof ELMA365TableInfoELMA365ModelInfoOutput
     */
    'items': Array<ELMA365ModelInfoOutput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365ParamInfoInput
 */
export interface ELMA365TableInfoELMA365ParamInfoInput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365ParamInfoInput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365ParamInfoInput>}
     * @memberof ELMA365TableInfoELMA365ParamInfoInput
     */
    'items': Array<ELMA365ParamInfoInput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365ParamInfoOutput
 */
export interface ELMA365TableInfoELMA365ParamInfoOutput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365ParamInfoOutput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365ParamInfoOutput>}
     * @memberof ELMA365TableInfoELMA365ParamInfoOutput
     */
    'items': Array<ELMA365ParamInfoOutput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365SlotInfoInput
 */
export interface ELMA365TableInfoELMA365SlotInfoInput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365SlotInfoInput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365SlotInfoInput>}
     * @memberof ELMA365TableInfoELMA365SlotInfoInput
     */
    'items': Array<ELMA365SlotInfoInput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365SlotInfoOutput
 */
export interface ELMA365TableInfoELMA365SlotInfoOutput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365SlotInfoOutput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365SlotInfoOutput>}
     * @memberof ELMA365TableInfoELMA365SlotInfoOutput
     */
    'items': Array<ELMA365SlotInfoOutput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365TableItemInput
 */
export interface ELMA365TableInfoELMA365TableItemInput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365TableItemInput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365TableItemInput>}
     * @memberof ELMA365TableInfoELMA365TableItemInput
     */
    'items': Array<ELMA365TableItemInput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableInfoELMA365TableItemOutput
 */
export interface ELMA365TableInfoELMA365TableItemOutput {
    /**
     * 
     * @type {ELMA365TableAttrs}
     * @memberof ELMA365TableInfoELMA365TableItemOutput
     */
    'attrs': ELMA365TableAttrs;
    /**
     * 
     * @type {Array<ELMA365TableItemOutput>}
     * @memberof ELMA365TableInfoELMA365TableItemOutput
     */
    'items': Array<ELMA365TableItemOutput>;
}
/**
 * 
 * @export
 * @interface ELMA365TableItemInput
 */
export interface ELMA365TableItemInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365TableItemInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365TableItemInput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365TableItemInput
     */
    'name': string;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365TableItemInput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365TableItemInput}
     * @memberof ELMA365TableItemInput
     */
    'table': ELMA365TableInfoELMA365TableItemInput | null;
}
/**
 * 
 * @export
 * @interface ELMA365TableItemOutput
 */
export interface ELMA365TableItemOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365TableItemOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365TableItemOutput
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365TableItemOutput
     */
    'name': string;
    /**
     * 
     * @type {ELMA365EnumInfo}
     * @memberof ELMA365TableItemOutput
     */
    'enum': ELMA365EnumInfo | null;
    /**
     * 
     * @type {ELMA365TableInfoELMA365TableItemOutput}
     * @memberof ELMA365TableItemOutput
     */
    'table': ELMA365TableInfoELMA365TableItemOutput | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolAction = {
    Search: 'Search',
    Get: 'Get',
    Create: 'Create',
    Update: 'Update',
    Upsert: 'Upsert',
    Run: 'Run'
} as const;

export type ELMA365ToolAction = typeof ELMA365ToolAction[keyof typeof ELMA365ToolAction];


/**
 * 
 * @export
 * @interface ELMA365ToolAnnotationsInput
 */
export interface ELMA365ToolAnnotationsInput {
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsInput
     */
    'readOnlyHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsInput
     */
    'destructiveHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsInput
     */
    'idempotentHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsInput
     */
    'openWorldHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
}
/**
 * 
 * @export
 * @interface ELMA365ToolAnnotationsOutput
 */
export interface ELMA365ToolAnnotationsOutput {
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsOutput
     */
    'readOnlyHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsOutput
     */
    'destructiveHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsOutput
     */
    'idempotentHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryUnionBoolNoneType}
     * @memberof ELMA365ToolAnnotationsOutput
     */
    'openWorldHint': ELMA365ToolPropertyEntryUnionBoolNoneType;
}
/**
 * 
 * @export
 * @interface ELMA365ToolAttributesInput
 */
export interface ELMA365ToolAttributesInput {
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolAttributesInput
     */
    'name': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolAttributesInput
     */
    'title': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolAttributesInput
     */
    'description': ELMA365ToolPropertyEntryStr;
}
/**
 * 
 * @export
 * @interface ELMA365ToolAttributesOutput
 */
export interface ELMA365ToolAttributesOutput {
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolAttributesOutput
     */
    'name': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolAttributesOutput
     */
    'title': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolAttributesOutput
     */
    'description': ELMA365ToolPropertyEntryStr;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolAvailability = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ELMA365ToolAvailability = typeof ELMA365ToolAvailability[keyof typeof ELMA365ToolAvailability];


/**
 * 
 * @export
 * @interface ELMA365ToolComponent
 */
export interface ELMA365ToolComponent {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolComponent
     */
    'entity_id': string;
    /**
     * 
     * @type {Identity}
     * @memberof ELMA365ToolComponent
     */
    'identity': Identity;
}
/**
 * 
 * @export
 * @interface ELMA365ToolDeletionResponse
 */
export interface ELMA365ToolDeletionResponse {
    /**
     * 
     * @type {ELMA365ToolModel}
     * @memberof ELMA365ToolDeletionResponse
     */
    'tool': ELMA365ToolModel;
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ToolDeletionResponse
     */
    'version': ELMA365VersionModel | null;
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolDeletionResponse
     */
    'toolset': ELMA365ToolsetModel | null;
}
/**
 * 
 * @export
 * @interface ELMA365ToolInfoInput
 */
export interface ELMA365ToolInfoInput {
    /**
     * 
     * @type {ELMA365ToolAttributesInput}
     * @memberof ELMA365ToolInfoInput
     */
    'attributes': ELMA365ToolAttributesInput;
    /**
     * 
     * @type {ELMA365ToolInterfaceInput}
     * @memberof ELMA365ToolInfoInput
     */
    'interface': ELMA365ToolInterfaceInput;
    /**
     * 
     * @type {ELMA365ToolAnnotationsInput}
     * @memberof ELMA365ToolInfoInput
     */
    'annotations': ELMA365ToolAnnotationsInput;
    /**
     * 
     * @type {ELMA365ToolAction}
     * @memberof ELMA365ToolInfoInput
     */
    'action': ELMA365ToolAction;
    /**
     * 
     * @type {ELMA365ToolStatus}
     * @memberof ELMA365ToolInfoInput
     */
    'status': ELMA365ToolStatus;
    /**
     * 
     * @type {ELMA365ToolVisibility}
     * @memberof ELMA365ToolInfoInput
     */
    'visibility': ELMA365ToolVisibility;
    /**
     * 
     * @type {ELMA365ToolAvailability}
     * @memberof ELMA365ToolInfoInput
     */
    'availability': ELMA365ToolAvailability;
    /**
     * 
     * @type {ELMA365ToolNamespace}
     * @memberof ELMA365ToolInfoInput
     */
    'namespace': ELMA365ToolNamespace;
    /**
     * 
     * @type {ELMA365ToolComponent}
     * @memberof ELMA365ToolInfoInput
     */
    'component': ELMA365ToolComponent;
}


/**
 * 
 * @export
 * @interface ELMA365ToolInfoOutput
 */
export interface ELMA365ToolInfoOutput {
    /**
     * 
     * @type {ELMA365ToolAttributesOutput}
     * @memberof ELMA365ToolInfoOutput
     */
    'attributes': ELMA365ToolAttributesOutput;
    /**
     * 
     * @type {ELMA365ToolInterfaceOutput}
     * @memberof ELMA365ToolInfoOutput
     */
    'interface': ELMA365ToolInterfaceOutput;
    /**
     * 
     * @type {ELMA365ToolAnnotationsOutput}
     * @memberof ELMA365ToolInfoOutput
     */
    'annotations': ELMA365ToolAnnotationsOutput;
    /**
     * 
     * @type {ELMA365ToolAction}
     * @memberof ELMA365ToolInfoOutput
     */
    'action': ELMA365ToolAction;
    /**
     * 
     * @type {ELMA365ToolStatus}
     * @memberof ELMA365ToolInfoOutput
     */
    'status': ELMA365ToolStatus;
    /**
     * 
     * @type {ELMA365ToolVisibility}
     * @memberof ELMA365ToolInfoOutput
     */
    'visibility': ELMA365ToolVisibility;
    /**
     * 
     * @type {ELMA365ToolAvailability}
     * @memberof ELMA365ToolInfoOutput
     */
    'availability': ELMA365ToolAvailability;
    /**
     * 
     * @type {ELMA365ToolNamespace}
     * @memberof ELMA365ToolInfoOutput
     */
    'namespace': ELMA365ToolNamespace;
    /**
     * 
     * @type {ELMA365ToolComponent}
     * @memberof ELMA365ToolInfoOutput
     */
    'component': ELMA365ToolComponent;
}


/**
 * 
 * @export
 * @interface ELMA365ToolInterchangeInput
 */
export interface ELMA365ToolInterchangeInput {
    /**
     * 
     * @type {DataInterchangeFormat}
     * @memberof ELMA365ToolInterchangeInput
     */
    'data_format': DataInterchangeFormat;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ELMA365ToolInterchangeInput
     */
    'json_schema': { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<ELMA365SlotInfoInput>}
     * @memberof ELMA365ToolInterchangeInput
     */
    'form_slots': Array<ELMA365SlotInfoInput>;
    /**
     * 
     * @type {}
     * @memberof ELMA365ToolInterchangeInput
     */
    'model_type':  | null;
    /**
     * 
     * @type {Array<ELMA365ToolParameterInput>}
     * @memberof ELMA365ToolInterchangeInput
     */
    'parameters': Array<ELMA365ToolParameterInput>;
}


/**
 * 
 * @export
 * @interface ELMA365ToolInterchangeOutput
 */
export interface ELMA365ToolInterchangeOutput {
    /**
     * 
     * @type {DataInterchangeFormat}
     * @memberof ELMA365ToolInterchangeOutput
     */
    'data_format': DataInterchangeFormat;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ELMA365ToolInterchangeOutput
     */
    'json_schema': { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<ELMA365SlotInfoOutput>}
     * @memberof ELMA365ToolInterchangeOutput
     */
    'form_slots': Array<ELMA365SlotInfoOutput>;
    /**
     * 
     * @type {}
     * @memberof ELMA365ToolInterchangeOutput
     */
    'model_type':  | null;
    /**
     * 
     * @type {Array<ELMA365ToolParameterOutput>}
     * @memberof ELMA365ToolInterchangeOutput
     */
    'parameters': Array<ELMA365ToolParameterOutput>;
}


/**
 * 
 * @export
 * @interface ELMA365ToolInterfaceInput
 */
export interface ELMA365ToolInterfaceInput {
    /**
     * 
     * @type {DataInterfaceType}
     * @memberof ELMA365ToolInterfaceInput
     */
    'type': DataInterfaceType;
    /**
     * 
     * @type {ELMA365ToolInterchangeInput}
     * @memberof ELMA365ToolInterfaceInput
     */
    'input': ELMA365ToolInterchangeInput;
    /**
     * 
     * @type {ELMA365ToolInterchangeInput}
     * @memberof ELMA365ToolInterfaceInput
     */
    'output': ELMA365ToolInterchangeInput;
}


/**
 * 
 * @export
 * @interface ELMA365ToolInterfaceOutput
 */
export interface ELMA365ToolInterfaceOutput {
    /**
     * 
     * @type {DataInterfaceType}
     * @memberof ELMA365ToolInterfaceOutput
     */
    'type': DataInterfaceType;
    /**
     * 
     * @type {ELMA365ToolInterchangeOutput}
     * @memberof ELMA365ToolInterfaceOutput
     */
    'input': ELMA365ToolInterchangeOutput;
    /**
     * 
     * @type {ELMA365ToolInterchangeOutput}
     * @memberof ELMA365ToolInterfaceOutput
     */
    'output': ELMA365ToolInterchangeOutput;
}


/**
 * 
 * @export
 * @interface ELMA365ToolModel
 */
export interface ELMA365ToolModel {
    /**
     * 
     * @type {ELMA365ToolAttributesOutput}
     * @memberof ELMA365ToolModel
     */
    'attributes': ELMA365ToolAttributesOutput;
    /**
     * 
     * @type {ELMA365ToolInterfaceOutput}
     * @memberof ELMA365ToolModel
     */
    'interface': ELMA365ToolInterfaceOutput;
    /**
     * 
     * @type {ELMA365ToolAnnotationsOutput}
     * @memberof ELMA365ToolModel
     */
    'annotations': ELMA365ToolAnnotationsOutput;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolModel
     */
    'version_id': string;
    /**
     * 
     * @type {ELMA365ToolStatus}
     * @memberof ELMA365ToolModel
     */
    'status': ELMA365ToolStatus;
    /**
     * 
     * @type {ELMA365ToolVisibility}
     * @memberof ELMA365ToolModel
     */
    'visibility': ELMA365ToolVisibility;
    /**
     * 
     * @type {ELMA365ToolAvailability}
     * @memberof ELMA365ToolModel
     */
    'availability': ELMA365ToolAvailability;
    /**
     * 
     * @type {ELMA365ToolNamespace}
     * @memberof ELMA365ToolModel
     */
    'namespace': ELMA365ToolNamespace;
    /**
     * 
     * @type {ELMA365ToolComponent}
     * @memberof ELMA365ToolModel
     */
    'component': ELMA365ToolComponent;
    /**
     * 
     * @type {ELMA365ComponentVolume}
     * @memberof ELMA365ToolModel
     */
    'volume': ELMA365ComponentVolume;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolModel
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolModel
     */
    'toolset_id': string;
    /**
     * 
     * @type {ELMA365ToolAction}
     * @memberof ELMA365ToolModel
     */
    'action': ELMA365ToolAction;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolModel
     */
    'tool_id': string;
}


/**
 * 
 * @export
 * @interface ELMA365ToolNamespace
 */
export interface ELMA365ToolNamespace {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolNamespace
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ToolNamespace
     */
    'identity': ELMA365NamespaceIdentity;
}
/**
 * 
 * @export
 * @interface ELMA365ToolObtainingRequest
 */
export interface ELMA365ToolObtainingRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolObtainingRequest
     */
    'version_id': string;
}
/**
 * 
 * @export
 * @interface ELMA365ToolObtainingResponse
 */
export interface ELMA365ToolObtainingResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ToolObtainingResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @interface ELMA365ToolParameterInput
 */
export interface ELMA365ToolParameterInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolParameterInput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolParameterInput
     */
    'type': string;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolParameterInput
     */
    'name': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolParameterInput
     */
    'title': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolParameterInput
     */
    'description': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryBool}
     * @memberof ELMA365ToolParameterInput
     */
    'enabled': ELMA365ToolPropertyEntryBool;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryBool}
     * @memberof ELMA365ToolParameterInput
     */
    'required': ELMA365ToolPropertyEntryBool;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryAny}
     * @memberof ELMA365ToolParameterInput
     */
    'default': ELMA365ToolPropertyEntryAny;
}
/**
 * 
 * @export
 * @interface ELMA365ToolParameterOutput
 */
export interface ELMA365ToolParameterOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolParameterOutput
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolParameterOutput
     */
    'type': string;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolParameterOutput
     */
    'name': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolParameterOutput
     */
    'title': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryStr}
     * @memberof ELMA365ToolParameterOutput
     */
    'description': ELMA365ToolPropertyEntryStr;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryBool}
     * @memberof ELMA365ToolParameterOutput
     */
    'enabled': ELMA365ToolPropertyEntryBool;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryBool}
     * @memberof ELMA365ToolParameterOutput
     */
    'required': ELMA365ToolPropertyEntryBool;
    /**
     * 
     * @type {ELMA365ToolPropertyEntryAny}
     * @memberof ELMA365ToolParameterOutput
     */
    'default': ELMA365ToolPropertyEntryAny;
}
/**
 * 
 * @export
 * @interface ELMA365ToolPropertyEntryAny
 */
export interface ELMA365ToolPropertyEntryAny {
    /**
     * 
     * @type {ELMA365ToolPropertyState}
     * @memberof ELMA365ToolPropertyEntryAny
     */
    'state': ELMA365ToolPropertyState;
    /**
     * 
     * @type {any}
     * @memberof ELMA365ToolPropertyEntryAny
     */
    'value': any;
}


/**
 * 
 * @export
 * @interface ELMA365ToolPropertyEntryBool
 */
export interface ELMA365ToolPropertyEntryBool {
    /**
     * 
     * @type {ELMA365ToolPropertyState}
     * @memberof ELMA365ToolPropertyEntryBool
     */
    'state': ELMA365ToolPropertyState;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ToolPropertyEntryBool
     */
    'value': boolean;
}


/**
 * 
 * @export
 * @interface ELMA365ToolPropertyEntryStr
 */
export interface ELMA365ToolPropertyEntryStr {
    /**
     * 
     * @type {ELMA365ToolPropertyState}
     * @memberof ELMA365ToolPropertyEntryStr
     */
    'state': ELMA365ToolPropertyState;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolPropertyEntryStr
     */
    'value': string;
}


/**
 * 
 * @export
 * @interface ELMA365ToolPropertyEntryUnionBoolNoneType
 */
export interface ELMA365ToolPropertyEntryUnionBoolNoneType {
    /**
     * 
     * @type {ELMA365ToolPropertyState}
     * @memberof ELMA365ToolPropertyEntryUnionBoolNoneType
     */
    'state': ELMA365ToolPropertyState;
    /**
     * 
     * @type {boolean}
     * @memberof ELMA365ToolPropertyEntryUnionBoolNoneType
     */
    'value': boolean | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolPropertyState = {
    Default: 'Default',
    Changed: 'Changed'
} as const;

export type ELMA365ToolPropertyState = typeof ELMA365ToolPropertyState[keyof typeof ELMA365ToolPropertyState];


/**
 * 
 * @export
 * @interface ELMA365ToolSelectionRequest
 */
export interface ELMA365ToolSelectionRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolSelectionRequest
     */
    'version_id': string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ELMA365ToolSelectionRequest
     */
    'component_keys': { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ELMA365ToolSelectionRequest
     */
    'tool_ids': { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ELMA365ToolSelectionResponse
 */
export interface ELMA365ToolSelectionResponse {
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ToolSelectionResponse
     */
    'version': ELMA365VersionModel;
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolSelectionResponse
     */
    'toolset': ELMA365ToolsetModel | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolStatus = {
    Pending: 'Pending',
    Ready: 'Ready'
} as const;

export type ELMA365ToolStatus = typeof ELMA365ToolStatus[keyof typeof ELMA365ToolStatus];


/**
 * 
 * @export
 * @interface ELMA365ToolTogglingRequest
 */
export interface ELMA365ToolTogglingRequest {
    /**
     * 
     * @type {ELMA365ToolVisibility}
     * @memberof ELMA365ToolTogglingRequest
     */
    'visibility': ELMA365ToolVisibility | null;
    /**
     * 
     * @type {ELMA365ToolAvailability}
     * @memberof ELMA365ToolTogglingRequest
     */
    'availability': ELMA365ToolAvailability | null;
}


/**
 * 
 * @export
 * @interface ELMA365ToolTogglingResponse
 */
export interface ELMA365ToolTogglingResponse {
    /**
     * 
     * @type {ELMA365ToolModel}
     * @memberof ELMA365ToolTogglingResponse
     */
    'tool': ELMA365ToolModel;
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ToolTogglingResponse
     */
    'version': ELMA365VersionModel | null;
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolTogglingResponse
     */
    'toolset': ELMA365ToolsetModel | null;
}
/**
 * 
 * @export
 * @interface ELMA365ToolUpdatingRequest
 */
export interface ELMA365ToolUpdatingRequest {
    /**
     * 
     * @type {ELMA365ToolAttributesInput}
     * @memberof ELMA365ToolUpdatingRequest
     */
    'attributes': ELMA365ToolAttributesInput | null;
    /**
     * 
     * @type {ELMA365ToolInterfaceInput}
     * @memberof ELMA365ToolUpdatingRequest
     */
    'interface': ELMA365ToolInterfaceInput | null;
    /**
     * 
     * @type {ELMA365ToolAnnotationsInput}
     * @memberof ELMA365ToolUpdatingRequest
     */
    'annotations': ELMA365ToolAnnotationsInput | null;
}
/**
 * 
 * @export
 * @interface ELMA365ToolUpdatingResponse
 */
export interface ELMA365ToolUpdatingResponse {
    /**
     * 
     * @type {ELMA365ToolModel}
     * @memberof ELMA365ToolUpdatingResponse
     */
    'tool': ELMA365ToolModel;
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ToolUpdatingResponse
     */
    'version': ELMA365VersionModel | null;
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolUpdatingResponse
     */
    'toolset': ELMA365ToolsetModel | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolVisibility = {
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;

export type ELMA365ToolVisibility = typeof ELMA365ToolVisibility[keyof typeof ELMA365ToolVisibility];


/**
 * 
 * @export
 * @interface ELMA365ToolkitToolCallData
 */
export interface ELMA365ToolkitToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolCallData
     */
    'toolset_settings_type'?: ELMA365ToolkitToolCallDataToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolCallData
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolCallData
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolCallData
     */
    'x_token': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolCallData
     */
    'tool_title': string;
}

export const ELMA365ToolkitToolCallDataToolsetSettingsTypeEnum = {
    Elma365Toolkit: 'ELMA365_TOOLKIT'
} as const;

export type ELMA365ToolkitToolCallDataToolsetSettingsTypeEnum = typeof ELMA365ToolkitToolCallDataToolsetSettingsTypeEnum[keyof typeof ELMA365ToolkitToolCallDataToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365ToolkitToolsetSettings
 */
export interface ELMA365ToolkitToolsetSettings {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolsetSettings
     */
    'toolset_type'?: ELMA365ToolkitToolsetSettingsToolsetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolsetSettings
     */
    'toolkit_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolsetSettings
     */
    'connector_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolkitToolsetSettings
     */
    'tool_names_prefix'?: string | null;
}

export const ELMA365ToolkitToolsetSettingsToolsetTypeEnum = {
    Elma365Toolkit: 'ELMA365_TOOLKIT'
} as const;

export type ELMA365ToolkitToolsetSettingsToolsetTypeEnum = typeof ELMA365ToolkitToolsetSettingsToolsetTypeEnum[keyof typeof ELMA365ToolkitToolsetSettingsToolsetTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolsetAvailability = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ELMA365ToolsetAvailability = typeof ELMA365ToolsetAvailability[keyof typeof ELMA365ToolsetAvailability];


/**
 * 
 * @export
 * @interface ELMA365ToolsetCallingRequest
 */
export interface ELMA365ToolsetCallingRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetCallingRequest
     */
    'tool_name': string;
    /**
     * 
     * @type {Array<DataPayload>}
     * @memberof ELMA365ToolsetCallingRequest
     */
    'payloads': Array<DataPayload>;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetCallingResponse
 */
export interface ELMA365ToolsetCallingResponse {
    /**
     * 
     * @type {Array<DataPayload>}
     * @memberof ELMA365ToolsetCallingResponse
     */
    'payloads': Array<DataPayload>;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetComponentInput
 */
export interface ELMA365ToolsetComponentInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetComponentInput
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365IdentityBase}
     * @memberof ELMA365ToolsetComponentInput
     */
    'identity': ELMA365IdentityBase;
    /**
     * 
     * @type {Set<string>}
     * @memberof ELMA365ToolsetComponentInput
     */
    'tool_ids': Set<string>;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetComponentOutput
 */
export interface ELMA365ToolsetComponentOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetComponentOutput
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365IdentityBase}
     * @memberof ELMA365ToolsetComponentOutput
     */
    'identity': ELMA365IdentityBase;
    /**
     * 
     * @type {Set<string>}
     * @memberof ELMA365ToolsetComponentOutput
     */
    'tool_ids': Set<string>;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetCreationRequest
 */
export interface ELMA365ToolsetCreationRequest {
    /**
     * 
     * @type {ELMA365ToolsetAvailability}
     * @memberof ELMA365ToolsetCreationRequest
     */
    'availability': ELMA365ToolsetAvailability;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetCreationRequest
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetCreationRequest
     */
    'connector_id': string;
}


/**
 * 
 * @export
 * @interface ELMA365ToolsetCreationResponse
 */
export interface ELMA365ToolsetCreationResponse {
    /**
     * 
     * @type {ConnectorModel}
     * @memberof ELMA365ToolsetCreationResponse
     */
    'connector': ConnectorModel;
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolsetCreationResponse
     */
    'toolset': ELMA365ToolsetModel;
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ToolsetCreationResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetExchange
 */
export interface ELMA365ToolsetExchange {
    /**
     * 
     * @type {ELMA365ToolsetMetadata}
     * @memberof ELMA365ToolsetExchange
     */
    'metadata': ELMA365ToolsetMetadata;
    /**
     * 
     * @type {Connector}
     * @memberof ELMA365ToolsetExchange
     */
    'connector': Connector;
    /**
     * 
     * @type {ELMA365ToolsetInfo}
     * @memberof ELMA365ToolsetExchange
     */
    'properties': ELMA365ToolsetInfo;
    /**
     * 
     * @type {ELMA365VersionInfo}
     * @memberof ELMA365ToolsetExchange
     */
    'version': ELMA365VersionInfo;
    /**
     * 
     * @type {Array<ELMA365NamespaceInfo>}
     * @memberof ELMA365ToolsetExchange
     */
    'namespaces': Array<ELMA365NamespaceInfo>;
    /**
     * 
     * @type {Array<ELMA365ApplicationInfoOutput>}
     * @memberof ELMA365ToolsetExchange
     */
    'applications': Array<ELMA365ApplicationInfoOutput>;
    /**
     * 
     * @type {Array<ELMA365ProcessInfoOutput>}
     * @memberof ELMA365ToolsetExchange
     */
    'processes': Array<ELMA365ProcessInfoOutput>;
    /**
     * 
     * @type {Array<ELMA365ToolInfoOutput>}
     * @memberof ELMA365ToolsetExchange
     */
    'tools': Array<ELMA365ToolInfoOutput>;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetImportBody
 */
export interface ELMA365ToolsetImportBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof ELMA365ToolsetImportBody
     */
    'content': ContentJSONFile;
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof ELMA365ToolsetImportBody
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetImportResponse
 */
export interface ELMA365ToolsetImportResponse {
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolsetImportResponse
     */
    'toolset': ELMA365ToolsetModel;
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365ToolsetImportResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetInfo
 */
export interface ELMA365ToolsetInfo {
    /**
     * 
     * @type {ELMA365ToolsetAvailability}
     * @memberof ELMA365ToolsetInfo
     */
    'availability': ELMA365ToolsetAvailability;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetInfo
     */
    'name': string;
    /**
     * 
     * @type {ELMA365ToolsetStatus}
     * @memberof ELMA365ToolsetInfo
     */
    'status': ELMA365ToolsetStatus;
    /**
     * 
     * @type {ELMA365ToolsetVisibility}
     * @memberof ELMA365ToolsetInfo
     */
    'visibility': ELMA365ToolsetVisibility;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetInfo
     */
    'code'?: string | null;
}


/**
 * 
 * @export
 * @interface ELMA365ToolsetInspectionBody
 */
export interface ELMA365ToolsetInspectionBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof ELMA365ToolsetInspectionBody
     */
    'content': ContentJSONFile;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetInspectionResponse
 */
export interface ELMA365ToolsetInspectionResponse {
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof ELMA365ToolsetInspectionResponse
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetMetadata
 */
export interface ELMA365ToolsetMetadata {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetMetadata
     */
    'version': string;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetModel
 */
export interface ELMA365ToolsetModel {
    /**
     * 
     * @type {ELMA365ToolsetAvailability}
     * @memberof ELMA365ToolsetModel
     */
    'availability': ELMA365ToolsetAvailability;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetModel
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetModel
     */
    'version_id': string;
    /**
     * 
     * @type {ELMA365ToolsetStatus}
     * @memberof ELMA365ToolsetModel
     */
    'status': ELMA365ToolsetStatus;
    /**
     * 
     * @type {ELMA365ToolsetVisibility}
     * @memberof ELMA365ToolsetModel
     */
    'visibility': ELMA365ToolsetVisibility;
    /**
     * 
     * @type {ELMA365ComponentVolume}
     * @memberof ELMA365ToolsetModel
     */
    'volume': ELMA365ComponentVolume;
    /**
     * 
     * @type {Array<ELMA365ToolsetNamespaceOutput>}
     * @memberof ELMA365ToolsetModel
     */
    'namespaces': Array<ELMA365ToolsetNamespaceOutput>;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetModel
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetModel
     */
    'toolset_id': string;
}


/**
 * 
 * @export
 * @interface ELMA365ToolsetNamespaceInput
 */
export interface ELMA365ToolsetNamespaceInput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetNamespaceInput
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ToolsetNamespaceInput
     */
    'identity': ELMA365NamespaceIdentity;
    /**
     * 
     * @type {Array<ELMA365ToolsetComponentInput>}
     * @memberof ELMA365ToolsetNamespaceInput
     */
    'components': Array<ELMA365ToolsetComponentInput>;
    /**
     * 
     * @type {ELMA365ComponentVolume}
     * @memberof ELMA365ToolsetNamespaceInput
     */
    'volume': ELMA365ComponentVolume;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetNamespaceOutput
 */
export interface ELMA365ToolsetNamespaceOutput {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetNamespaceOutput
     */
    'entity_id': string;
    /**
     * 
     * @type {ELMA365NamespaceIdentity}
     * @memberof ELMA365ToolsetNamespaceOutput
     */
    'identity': ELMA365NamespaceIdentity;
    /**
     * 
     * @type {Array<ELMA365ToolsetComponentOutput>}
     * @memberof ELMA365ToolsetNamespaceOutput
     */
    'components': Array<ELMA365ToolsetComponentOutput>;
    /**
     * 
     * @type {ELMA365ComponentVolume}
     * @memberof ELMA365ToolsetNamespaceOutput
     */
    'volume': ELMA365ComponentVolume;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolsetStatus = {
    Empty: 'Empty',
    Ready: 'Ready'
} as const;

export type ELMA365ToolsetStatus = typeof ELMA365ToolsetStatus[keyof typeof ELMA365ToolsetStatus];


/**
 * 
 * @export
 * @interface ELMA365ToolsetTogglingRequest
 */
export interface ELMA365ToolsetTogglingRequest {
    /**
     * 
     * @type {ELMA365ToolsetAvailability}
     * @memberof ELMA365ToolsetTogglingRequest
     */
    'availability': ELMA365ToolsetAvailability | null;
}


/**
 * 
 * @export
 * @interface ELMA365ToolsetTogglingResponse
 */
export interface ELMA365ToolsetTogglingResponse {
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolsetTogglingResponse
     */
    'toolset': ELMA365ToolsetModel | null;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetUpdatingRequest
 */
export interface ELMA365ToolsetUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetUpdatingRequest
     */
    'connector_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365ToolsetUpdatingRequest
     */
    'name': string | null;
}
/**
 * 
 * @export
 * @interface ELMA365ToolsetUpdatingResponse
 */
export interface ELMA365ToolsetUpdatingResponse {
    /**
     * 
     * @type {ELMA365ToolsetModel}
     * @memberof ELMA365ToolsetUpdatingResponse
     */
    'toolset': ELMA365ToolsetModel | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365ToolsetVisibility = {
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;

export type ELMA365ToolsetVisibility = typeof ELMA365ToolsetVisibility[keyof typeof ELMA365ToolsetVisibility];


/**
 * 
 * @export
 * @interface ELMA365UpdateTaskDatesToolCallData
 */
export interface ELMA365UpdateTaskDatesToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365UpdateTaskDatesToolCallData
     */
    'tool_type'?: ELMA365UpdateTaskDatesToolCallDataToolTypeEnum;
}

export const ELMA365UpdateTaskDatesToolCallDataToolTypeEnum = {
    UpdateTaskDates: 'UpdateTaskDates'
} as const;

export type ELMA365UpdateTaskDatesToolCallDataToolTypeEnum = typeof ELMA365UpdateTaskDatesToolCallDataToolTypeEnum[keyof typeof ELMA365UpdateTaskDatesToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface ELMA365UpdateTaskPercentToolCallData
 */
export interface ELMA365UpdateTaskPercentToolCallData {
    /**
     * 
     * @type {string}
     * @memberof ELMA365UpdateTaskPercentToolCallData
     */
    'tool_type'?: ELMA365UpdateTaskPercentToolCallDataToolTypeEnum;
}

export const ELMA365UpdateTaskPercentToolCallDataToolTypeEnum = {
    UpdateTaskPercent: 'UpdateTaskPercent'
} as const;

export type ELMA365UpdateTaskPercentToolCallDataToolTypeEnum = typeof ELMA365UpdateTaskPercentToolCallDataToolTypeEnum[keyof typeof ELMA365UpdateTaskPercentToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365VersionAction = {
    Creation: 'Creation',
    Appending: 'Appending',
    Merging: 'Merging'
} as const;

export type ELMA365VersionAction = typeof ELMA365VersionAction[keyof typeof ELMA365VersionAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365VersionAvailability = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ELMA365VersionAvailability = typeof ELMA365VersionAvailability[keyof typeof ELMA365VersionAvailability];


/**
 * 
 * @export
 * @interface ELMA365VersionComparisonRequest
 */
export interface ELMA365VersionComparisonRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionComparisonRequest
     */
    'old_version_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionComparisonRequest
     */
    'new_version_id': string;
}
/**
 * 
 * @export
 * @interface ELMA365VersionComparisonResponse
 */
export interface ELMA365VersionComparisonResponse {
    /**
     * 
     * @type {Array<ELMA365NamespaceChangeModelOutput>}
     * @memberof ELMA365VersionComparisonResponse
     */
    'changes': Array<ELMA365NamespaceChangeModelOutput>;
}
/**
 * 
 * @export
 * @interface ELMA365VersionCreationRequest
 */
export interface ELMA365VersionCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {ELMA365VersionAvailability}
     * @memberof ELMA365VersionCreationRequest
     */
    'availability': ELMA365VersionAvailability;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionCreationRequest
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionCreationRequest
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionCreationRequest
     */
    'toolset_id': string;
    /**
     * 
     * @type {ELMA365VersionAction}
     * @memberof ELMA365VersionCreationRequest
     */
    'action': ELMA365VersionAction;
}


/**
 * 
 * @export
 * @interface ELMA365VersionCreationResponse
 */
export interface ELMA365VersionCreationResponse {
    /**
     * 
     * @type {ConnectorModel}
     * @memberof ELMA365VersionCreationResponse
     */
    'connector': ConnectorModel;
    /**
     * 
     * @type {ELMA365VersionModel}
     * @memberof ELMA365VersionCreationResponse
     */
    'version': ELMA365VersionModel;
}
/**
 * 
 * @export
 * @interface ELMA365VersionInfo
 */
export interface ELMA365VersionInfo {
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionInfo
     */
    'name': string;
    /**
     * 
     * @type {ELMA365VersionAvailability}
     * @memberof ELMA365VersionInfo
     */
    'availability': ELMA365VersionAvailability;
    /**
     * 
     * @type {ELMA365VersionAction}
     * @memberof ELMA365VersionInfo
     */
    'action': ELMA365VersionAction;
    /**
     * 
     * @type {ELMA365VersionStatus}
     * @memberof ELMA365VersionInfo
     */
    'status': ELMA365VersionStatus;
    /**
     * 
     * @type {ELMA365VersionVisibility}
     * @memberof ELMA365VersionInfo
     */
    'visibility': ELMA365VersionVisibility;
    /**
     * 
     * @type {ELMA365VersionSchema}
     * @memberof ELMA365VersionInfo
     */
    'scheme': ELMA365VersionSchema;
}


/**
 * 
 * @export
 * @interface ELMA365VersionModel
 */
export interface ELMA365VersionModel {
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionModel
     */
    'name': string;
    /**
     * 
     * @type {ELMA365VersionAvailability}
     * @memberof ELMA365VersionModel
     */
    'availability': ELMA365VersionAvailability;
    /**
     * 
     * @type {ELMA365VersionStatus}
     * @memberof ELMA365VersionModel
     */
    'status': ELMA365VersionStatus;
    /**
     * 
     * @type {ELMA365VersionStage}
     * @memberof ELMA365VersionModel
     */
    'stage': ELMA365VersionStage;
    /**
     * 
     * @type {ELMA365VersionPhase}
     * @memberof ELMA365VersionModel
     */
    'phase': ELMA365VersionPhase;
    /**
     * 
     * @type {ELMA365VersionVisibility}
     * @memberof ELMA365VersionModel
     */
    'visibility': ELMA365VersionVisibility;
    /**
     * 
     * @type {ELMA365VersionSchema}
     * @memberof ELMA365VersionModel
     */
    'scheme': ELMA365VersionSchema;
    /**
     * 
     * @type {ELMA365VersionProblem}
     * @memberof ELMA365VersionModel
     */
    'problem': ELMA365VersionProblem | null;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionModel
     */
    'connector_id': string;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionModel
     */
    'toolset_id': string;
    /**
     * 
     * @type {ELMA365VersionAction}
     * @memberof ELMA365VersionModel
     */
    'action': ELMA365VersionAction;
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionModel
     */
    'version_id': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365VersionPhase = {
    Pending: 'Pending',
    Obtaining: 'Obtaining',
    Selection: 'Selection',
    Ready: 'Ready'
} as const;

export type ELMA365VersionPhase = typeof ELMA365VersionPhase[keyof typeof ELMA365VersionPhase];


/**
 * 
 * @export
 * @interface ELMA365VersionProblem
 */
export interface ELMA365VersionProblem {
    /**
     * 
     * @type {ProblemDetails}
     * @memberof ELMA365VersionProblem
     */
    'details': ProblemDetails;
}
/**
 * 
 * @export
 * @interface ELMA365VersionSchema
 */
export interface ELMA365VersionSchema {
    /**
     * 
     * @type {string}
     * @memberof ELMA365VersionSchema
     */
    'etag': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365VersionStage = {
    Connector: 'Connector',
    Namespaces: 'Namespaces',
    Applications: 'Applications',
    Processes: 'Processes',
    Tools: 'Tools',
    Ready: 'Ready'
} as const;

export type ELMA365VersionStage = typeof ELMA365VersionStage[keyof typeof ELMA365VersionStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365VersionStatus = {
    Empty: 'Empty',
    Processing: 'Processing',
    Pending: 'Pending',
    Problem: 'Problem',
    Ready: 'Ready'
} as const;

export type ELMA365VersionStatus = typeof ELMA365VersionStatus[keyof typeof ELMA365VersionStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ELMA365VersionVisibility = {
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;

export type ELMA365VersionVisibility = typeof ELMA365VersionVisibility[keyof typeof ELMA365VersionVisibility];


/**
 * 
 * @export
 * @interface EmbeddingSettings
 */
export interface EmbeddingSettings {
    /**
     * 
     * @type {string}
     * @memberof EmbeddingSettings
     */
    'provider_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmbeddingSettings
     */
    'model_name'?: string | null;
}
/**
 * 
 * @export
 * @interface EnumItemModel
 */
export interface EnumItemModel {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof EnumItemModel
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof EnumItemModel
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof EnumItemModel
     */
    'checked': boolean;
}
/**
 * 
 * @export
 * @interface Enumitems
 */
export interface Enumitems {
}
/**
 * 
 * @export
 * @interface ExchangeDependency
 */
export interface ExchangeDependency {
    /**
     * 
     * @type {ExchangeObjectType}
     * @memberof ExchangeDependency
     */
    'origin_type': ExchangeObjectType;
    /**
     * 
     * @type {any}
     * @memberof ExchangeDependency
     */
    'origin_subtype': any;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'origin_code': string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'origin_name': string | null;
    /**
     * 
     * @type {ExchangeObjectType}
     * @memberof ExchangeDependency
     */
    'parent_type': ExchangeObjectType;
    /**
     * 
     * @type {any}
     * @memberof ExchangeDependency
     */
    'parent_subtype': any;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'parent_code': string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'parent_name': string;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'parent_image': string | null;
    /**
     * 
     * @type {ExchangeObjectType}
     * @memberof ExchangeDependency
     */
    'object_type': ExchangeObjectType;
    /**
     * 
     * @type {any}
     * @memberof ExchangeDependency
     */
    'object_subtype': any;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'object_code': string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'object_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'object_title': string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'object_path': string | null;
    /**
     * 
     * @type {string}
     * @memberof ExchangeDependency
     */
    'object_id': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExchangeDependency
     */
    'extra_data'?: { [key: string]: any; };
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ExchangeObjectType = {
    Folder: 'Folder',
    ApiKey: 'API-Key',
    Tracing: 'Tracing',
    Provider: 'Provider',
    Connector: 'Connector',
    Toolkit: 'Toolkit',
    Toolset: 'Toolset',
    Project: 'Project',
    Source: 'Source',
    Agent: 'Agent',
    Relation: 'Relation',
    Schedule: 'Schedule'
} as const;

export type ExchangeObjectType = typeof ExchangeObjectType[keyof typeof ExchangeObjectType];


/**
 * 
 * @export
 * @interface ExternalCheckSettingsInput
 */
export interface ExternalCheckSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsInput
     */
    'api_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsInput
     */
    'max_retries'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExternalCheckSettingsInput
     */
    'request_headers'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsInput
     */
    'check_id'?: string;
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof ExternalCheckSettingsInput
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsInput
     */
    'type'?: ExternalCheckSettingsInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsInput
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsInput
     */
    'order'?: number;
    /**
     * 
     * @type {GuardrailBehavior}
     * @memberof ExternalCheckSettingsInput
     */
    'behavior'?: GuardrailBehavior;
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsInput
     */
    'block_message'?: string;
    /**
     * 
     * @type {GuardrailErrorPolicy}
     * @memberof ExternalCheckSettingsInput
     */
    'on_error'?: GuardrailErrorPolicy;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsInput
     */
    'timeout_seconds'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalCheckSettingsInput
     */
    'use_original_text_for_check'?: boolean;
    /**
     * 
     * @type {CustomOptions}
     * @memberof ExternalCheckSettingsInput
     */
    'custom_options'?: CustomOptions;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsInput
     */
    'max_turns'?: number;
}

export const ExternalCheckSettingsInputTypeEnum = {
    ExternalCheck: 'ExternalCheck'
} as const;

export type ExternalCheckSettingsInputTypeEnum = typeof ExternalCheckSettingsInputTypeEnum[keyof typeof ExternalCheckSettingsInputTypeEnum];

/**
 * 
 * @export
 * @interface ExternalCheckSettingsOutput
 */
export interface ExternalCheckSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsOutput
     */
    'api_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsOutput
     */
    'max_retries'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExternalCheckSettingsOutput
     */
    'request_headers'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsOutput
     */
    'check_id'?: string;
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof ExternalCheckSettingsOutput
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsOutput
     */
    'type'?: ExternalCheckSettingsOutputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsOutput
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsOutput
     */
    'order'?: number;
    /**
     * 
     * @type {GuardrailBehavior}
     * @memberof ExternalCheckSettingsOutput
     */
    'behavior'?: GuardrailBehavior;
    /**
     * 
     * @type {string}
     * @memberof ExternalCheckSettingsOutput
     */
    'block_message'?: string;
    /**
     * 
     * @type {GuardrailErrorPolicy}
     * @memberof ExternalCheckSettingsOutput
     */
    'on_error'?: GuardrailErrorPolicy;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsOutput
     */
    'timeout_seconds'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalCheckSettingsOutput
     */
    'use_original_text_for_check'?: boolean;
    /**
     * 
     * @type {CustomOptions}
     * @memberof ExternalCheckSettingsOutput
     */
    'custom_options'?: CustomOptions;
    /**
     * 
     * @type {number}
     * @memberof ExternalCheckSettingsOutput
     */
    'max_turns'?: number;
}

export const ExternalCheckSettingsOutputTypeEnum = {
    ExternalCheck: 'ExternalCheck'
} as const;

export type ExternalCheckSettingsOutputTypeEnum = typeof ExternalCheckSettingsOutputTypeEnum[keyof typeof ExternalCheckSettingsOutputTypeEnum];

/**
 * 
 * @export
 * @interface ExternalMaskingDetectorSettingsInput
 */
export interface ExternalMaskingDetectorSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'api_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'max_retries'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'request_headers'?: { [key: string]: string; };
    /**
     * 
     * @type {ExternalMaskingErrorPolicy}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'on_error'?: ExternalMaskingErrorPolicy;
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'detector_id'?: string;
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'type'?: ExternalMaskingDetectorSettingsInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'order'?: number;
    /**
     * 
     * @type {CustomOptions}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'custom_options'?: CustomOptions;
    /**
     * 
     * @type {ExternalReplacementMode}
     * @memberof ExternalMaskingDetectorSettingsInput
     */
    'replacement_mode'?: ExternalReplacementMode;
}

export const ExternalMaskingDetectorSettingsInputTypeEnum = {
    External: 'External'
} as const;

export type ExternalMaskingDetectorSettingsInputTypeEnum = typeof ExternalMaskingDetectorSettingsInputTypeEnum[keyof typeof ExternalMaskingDetectorSettingsInputTypeEnum];

/**
 * 
 * @export
 * @interface ExternalMaskingDetectorSettingsOutput
 */
export interface ExternalMaskingDetectorSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'api_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'max_retries'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'request_headers'?: { [key: string]: string; };
    /**
     * 
     * @type {ExternalMaskingErrorPolicy}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'on_error'?: ExternalMaskingErrorPolicy;
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'detector_id'?: string;
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'type'?: ExternalMaskingDetectorSettingsOutputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'order'?: number;
    /**
     * 
     * @type {CustomOptions}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'custom_options'?: CustomOptions;
    /**
     * 
     * @type {ExternalReplacementMode}
     * @memberof ExternalMaskingDetectorSettingsOutput
     */
    'replacement_mode'?: ExternalReplacementMode;
}

export const ExternalMaskingDetectorSettingsOutputTypeEnum = {
    External: 'External'
} as const;

export type ExternalMaskingDetectorSettingsOutputTypeEnum = typeof ExternalMaskingDetectorSettingsOutputTypeEnum[keyof typeof ExternalMaskingDetectorSettingsOutputTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ExternalMaskingErrorPolicy = {
    FailClosed: 'FailClosed',
    FailOpen: 'FailOpen'
} as const;

export type ExternalMaskingErrorPolicy = typeof ExternalMaskingErrorPolicy[keyof typeof ExternalMaskingErrorPolicy];


/**
 * 
 * @export
 * @enum {string}
 */

export const ExternalReplacementMode = {
    PipelineGenerated: 'PipelineGenerated',
    UseExternalReplacement: 'UseExternalReplacement'
} as const;

export type ExternalReplacementMode = typeof ExternalReplacementMode[keyof typeof ExternalReplacementMode];


/**
 * 
 * @export
 * @interface FeatureFlag
 */
export interface FeatureFlag {
    /**
     * 
     * @type {string}
     * @memberof FeatureFlag
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlag
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface FetchCurrentELMA365UserToolSettings
 */
export interface FetchCurrentELMA365UserToolSettings {
    /**
     * 
     * @type {string}
     * @memberof FetchCurrentELMA365UserToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FetchCurrentELMA365UserToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FetchCurrentELMA365UserToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface FetchDocflowListsToolSettings
 */
export interface FetchDocflowListsToolSettings {
    /**
     * 
     * @type {string}
     * @memberof FetchDocflowListsToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FetchDocflowListsToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FetchDocflowListsToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface FetchELMA365AppElementToolSettings
 */
export interface FetchELMA365AppElementToolSettings {
    /**
     * 
     * @type {string}
     * @memberof FetchELMA365AppElementToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FetchELMA365AppElementToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FetchELMA365AppElementToolSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {ELMA365AppElementToolFeedLoadMode}
     * @memberof FetchELMA365AppElementToolSettings
     */
    'feed_load_mode': ELMA365AppElementToolFeedLoadMode;
}


/**
 * 
 * @export
 * @interface FetchELMA365AppFeedToolSettings
 */
export interface FetchELMA365AppFeedToolSettings {
    /**
     * 
     * @type {string}
     * @memberof FetchELMA365AppFeedToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FetchELMA365AppFeedToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FetchELMA365AppFeedToolSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof FetchELMA365AppFeedToolSettings
     */
    'max_content_token_count': number;
}
/**
 * 
 * @export
 * @interface FetchELMA365TaskToolSettings
 */
export interface FetchELMA365TaskToolSettings {
    /**
     * 
     * @type {string}
     * @memberof FetchELMA365TaskToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FetchELMA365TaskToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FetchELMA365TaskToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface FetchUrlToolSettings
 */
export interface FetchUrlToolSettings {
    /**
     * 
     * @type {string}
     * @memberof FetchUrlToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FetchUrlToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FetchUrlToolSettings
     */
    'max_content_token_count': number;
    /**
     * 
     * @type {number}
     * @memberof FetchUrlToolSettings
     */
    'fetch_timeout_seconds': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchUrlToolSettings
     */
    'allowed_hosts': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FileConversionFormat = {
    Text: 'Text',
    Html: 'HTML',
    Markdown: 'Markdown'
} as const;

export type FileConversionFormat = typeof FileConversionFormat[keyof typeof FileConversionFormat];


/**
 * 
 * @export
 * @enum {string}
 */

export const FileConverterEngine = {
    Markitdown: 'Markitdown',
    Docling: 'Docling'
} as const;

export type FileConverterEngine = typeof FileConverterEngine[keyof typeof FileConverterEngine];


/**
 * 
 * @export
 * @interface FileCreationBody
 */
export interface FileCreationBody {
    /**
     * 
     * @type {string}
     * @memberof FileCreationBody
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof FileCreationBody
     */
    'project_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileCreationBody
     */
    'source_id'?: string | null;
    /**
     * 
     * @type {Array<FilePurpose>}
     * @memberof FileCreationBody
     */
    'purposes': Array<FilePurpose>;
    /**
     * 
     * @type {ContentStore}
     * @memberof FileCreationBody
     */
    'content_store'?: ContentStore | null;
    /**
     * 
     * @type {ContentFormat}
     * @memberof FileCreationBody
     */
    'content_format'?: ContentFormat | null;
    /**
     * 
     * @type {string}
     * @memberof FileCreationBody
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileCreationBody
     */
    'mime_type': string;
    /**
     * 
     * @type {string}
     * @memberof FileCreationBody
     */
    'content_data': string;
}


/**
 * 
 * @export
 * @interface FileCreationResponse
 */
export interface FileCreationResponse {
    /**
     * 
     * @type {FileModel}
     * @memberof FileCreationResponse
     */
    'model': FileModel;
}
/**
 * 
 * @export
 * @interface FileDeletionResponse
 */
export interface FileDeletionResponse {
    /**
     * 
     * @type {FileModel}
     * @memberof FileDeletionResponse
     */
    'model': FileModel;
}
/**
 * 
 * @export
 * @interface FileDescribeImageToolData
 */
export interface FileDescribeImageToolData {
    /**
     * 
     * @type {string}
     * @memberof FileDescribeImageToolData
     */
    'tool_type'?: FileDescribeImageToolDataToolTypeEnum;
    /**
     * 
     * @type {LLMSettings}
     * @memberof FileDescribeImageToolData
     */
    'llm_settings': LLMSettings;
    /**
     * 
     * @type {string}
     * @memberof FileDescribeImageToolData
     */
    'default_prompt': string;
    /**
     * 
     * @type {boolean}
     * @memberof FileDescribeImageToolData
     */
    'allow_prompt_override': boolean;
}

export const FileDescribeImageToolDataToolTypeEnum = {
    DescribeImage: 'DescribeImage'
} as const;

export type FileDescribeImageToolDataToolTypeEnum = typeof FileDescribeImageToolDataToolTypeEnum[keyof typeof FileDescribeImageToolDataToolTypeEnum];

/**
 * 
 * @export
 * @interface FileFiltration
 */
export interface FileFiltration {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileFiltration
     */
    'file_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileFiltration
     */
    'external_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileFiltration
     */
    'public_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileFiltration
     */
    'project_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileFiltration
     */
    'source_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<FilePurpose>}
     * @memberof FileFiltration
     */
    'purposes'?: Array<FilePurpose> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FileFiltration
     */
    'content_mimes'?: Array<string> | null;
    /**
     * 
     * @type {Array<ContentStore>}
     * @memberof FileFiltration
     */
    'content_stores'?: Array<ContentStore> | null;
    /**
     * 
     * @type {Array<ContentFormat>}
     * @memberof FileFiltration
     */
    'content_formats'?: Array<ContentFormat> | null;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof FileFiltration
     */
    'content_encodings'?: Array<string | null> | null;
    /**
     * 
     * @type {Array<ContentMarkup>}
     * @memberof FileFiltration
     */
    'content_markups'?: Array<ContentMarkup> | null;
}
/**
 * 
 * @export
 * @interface FileModel
 */
export interface FileModel {
    /**
     * 
     * @type {string}
     * @memberof FileModel
     */
    'file_id': string;
    /**
     * 
     * @type {string}
     * @memberof FileModel
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof FileModel
     */
    'public_id': string;
    /**
     * 
     * @type {string}
     * @memberof FileModel
     */
    'project_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileModel
     */
    'source_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof FileModel
     */
    'size': number;
    /**
     * 
     * @type {ContentInfoOutput}
     * @memberof FileModel
     */
    'content': ContentInfoOutput;
    /**
     * 
     * @type {ContentUrls}
     * @memberof FileModel
     */
    'urls': ContentUrls;
}
/**
 * 
 * @export
 * @interface FileParametersInfo
 */
export interface FileParametersInfo {
    /**
     * 
     * @type {string}
     * @memberof FileParametersInfo
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof FileParametersInfo
     */
    'project_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileParametersInfo
     */
    'source_id'?: string | null;
    /**
     * 
     * @type {Array<FilePurpose>}
     * @memberof FileParametersInfo
     */
    'purposes': Array<FilePurpose>;
    /**
     * 
     * @type {ContentStore}
     * @memberof FileParametersInfo
     */
    'content_store'?: ContentStore | null;
    /**
     * 
     * @type {ContentFormat}
     * @memberof FileParametersInfo
     */
    'content_format'?: ContentFormat | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FilePurpose = {
    Index: 'Index',
    Agent: 'Agent'
} as const;

export type FilePurpose = typeof FilePurpose[keyof typeof FilePurpose];


/**
 * 
 * @export
 * @interface FileReadFileToolData
 */
export interface FileReadFileToolData {
    /**
     * 
     * @type {string}
     * @memberof FileReadFileToolData
     */
    'tool_type'?: FileReadFileToolDataToolTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FileReadFileToolData
     */
    'max_content_token_count': number;
}

export const FileReadFileToolDataToolTypeEnum = {
    ReadFile: 'ReadFile'
} as const;

export type FileReadFileToolDataToolTypeEnum = typeof FileReadFileToolDataToolTypeEnum[keyof typeof FileReadFileToolDataToolTypeEnum];

/**
 * 
 * @export
 * @interface FileSourceExtractionSettings
 */
export interface FileSourceExtractionSettings {
    /**
     * 
     * @type {FileConverterEngine}
     * @memberof FileSourceExtractionSettings
     */
    'converter_engine'?: FileConverterEngine | null;
    /**
     * 
     * @type {FileConversionFormat}
     * @memberof FileSourceExtractionSettings
     */
    'conversion_format'?: FileConversionFormat | null;
}


/**
 * 
 * @export
 * @interface FileSourceParametersItem
 */
export interface FileSourceParametersItem {
    /**
     * 
     * @type {string}
     * @memberof FileSourceParametersItem
     */
    'file_id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FileSourceParametersItem
     */
    'metadata'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface FileSourceParametersSettings
 */
export interface FileSourceParametersSettings {
    /**
     * 
     * @type {string}
     * @memberof FileSourceParametersSettings
     */
    'source_type'?: FileSourceParametersSettingsSourceTypeEnum;
    /**
     * 
     * @type {Array<FileSourceParametersItem>}
     * @memberof FileSourceParametersSettings
     */
    'files'?: Array<FileSourceParametersItem>;
}

export const FileSourceParametersSettingsSourceTypeEnum = {
    File: 'File'
} as const;

export type FileSourceParametersSettingsSourceTypeEnum = typeof FileSourceParametersSettingsSourceTypeEnum[keyof typeof FileSourceParametersSettingsSourceTypeEnum];

/**
 * 
 * @export
 * @interface FileToolCallDataInput
 */
export interface FileToolCallDataInput {
    /**
     * 
     * @type {string}
     * @memberof FileToolCallDataInput
     */
    'toolset_settings_type'?: FileToolCallDataInputToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FileToolCallDataInput
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {ToolData2}
     * @memberof FileToolCallDataInput
     */
    'tool_data': ToolData2;
}

export const FileToolCallDataInputToolsetSettingsTypeEnum = {
    File: 'File'
} as const;

export type FileToolCallDataInputToolsetSettingsTypeEnum = typeof FileToolCallDataInputToolsetSettingsTypeEnum[keyof typeof FileToolCallDataInputToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface FileToolCallDataOutput
 */
export interface FileToolCallDataOutput {
    /**
     * 
     * @type {string}
     * @memberof FileToolCallDataOutput
     */
    'toolset_settings_type'?: FileToolCallDataOutputToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FileToolCallDataOutput
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {ToolData2}
     * @memberof FileToolCallDataOutput
     */
    'tool_data': ToolData2;
}

export const FileToolCallDataOutputToolsetSettingsTypeEnum = {
    File: 'File'
} as const;

export type FileToolCallDataOutputToolsetSettingsTypeEnum = typeof FileToolCallDataOutputToolsetSettingsTypeEnum[keyof typeof FileToolCallDataOutputToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface FileToolsetSettingsInput
 */
export interface FileToolsetSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof FileToolsetSettingsInput
     */
    'toolset_type'?: FileToolsetSettingsInputToolsetTypeEnum;
    /**
     * 
     * @type {ReadFileToolSettings}
     * @memberof FileToolsetSettingsInput
     */
    'read_file_tool_settings': ReadFileToolSettings;
    /**
     * 
     * @type {WriteFileToolSettings}
     * @memberof FileToolsetSettingsInput
     */
    'write_file_tool_settings': WriteFileToolSettings;
    /**
     * 
     * @type {DescribeImageToolSettings}
     * @memberof FileToolsetSettingsInput
     */
    'describe_image_tool_settings': DescribeImageToolSettings;
}

export const FileToolsetSettingsInputToolsetTypeEnum = {
    File: 'File'
} as const;

export type FileToolsetSettingsInputToolsetTypeEnum = typeof FileToolsetSettingsInputToolsetTypeEnum[keyof typeof FileToolsetSettingsInputToolsetTypeEnum];

/**
 * 
 * @export
 * @interface FileToolsetSettingsOutput
 */
export interface FileToolsetSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof FileToolsetSettingsOutput
     */
    'toolset_type'?: FileToolsetSettingsOutputToolsetTypeEnum;
    /**
     * 
     * @type {ReadFileToolSettings}
     * @memberof FileToolsetSettingsOutput
     */
    'read_file_tool_settings': ReadFileToolSettings;
    /**
     * 
     * @type {WriteFileToolSettings}
     * @memberof FileToolsetSettingsOutput
     */
    'write_file_tool_settings': WriteFileToolSettings;
    /**
     * 
     * @type {DescribeImageToolSettings}
     * @memberof FileToolsetSettingsOutput
     */
    'describe_image_tool_settings': DescribeImageToolSettings;
}

export const FileToolsetSettingsOutputToolsetTypeEnum = {
    File: 'File'
} as const;

export type FileToolsetSettingsOutputToolsetTypeEnum = typeof FileToolsetSettingsOutputToolsetTypeEnum[keyof typeof FileToolsetSettingsOutputToolsetTypeEnum];

/**
 * 
 * @export
 * @interface FileUpdatingBody
 */
export interface FileUpdatingBody {
    /**
     * 
     * @type {string}
     * @memberof FileUpdatingBody
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof FileUpdatingBody
     */
    'project_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUpdatingBody
     */
    'source_id'?: string | null;
    /**
     * 
     * @type {Array<FilePurpose>}
     * @memberof FileUpdatingBody
     */
    'purposes': Array<FilePurpose>;
    /**
     * 
     * @type {ContentStore}
     * @memberof FileUpdatingBody
     */
    'content_store'?: ContentStore | null;
    /**
     * 
     * @type {ContentFormat}
     * @memberof FileUpdatingBody
     */
    'content_format'?: ContentFormat | null;
    /**
     * 
     * @type {string}
     * @memberof FileUpdatingBody
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileUpdatingBody
     */
    'mime_type': string;
    /**
     * 
     * @type {string}
     * @memberof FileUpdatingBody
     */
    'content_data': string;
}


/**
 * 
 * @export
 * @interface FileUpdatingResponse
 */
export interface FileUpdatingResponse {
    /**
     * 
     * @type {FileModel}
     * @memberof FileUpdatingResponse
     */
    'model': FileModel;
}
/**
 * 
 * @export
 * @interface FileWriteFileToolData
 */
export interface FileWriteFileToolData {
    /**
     * 
     * @type {string}
     * @memberof FileWriteFileToolData
     */
    'tool_type'?: FileWriteFileToolDataToolTypeEnum;
}

export const FileWriteFileToolDataToolTypeEnum = {
    WriteFile: 'WriteFile'
} as const;

export type FileWriteFileToolDataToolTypeEnum = typeof FileWriteFileToolDataToolTypeEnum[keyof typeof FileWriteFileToolDataToolTypeEnum];

/**
 * 
 * @export
 * @interface Filters
 */
export interface Filters {
}
/**
 * 
 * @export
 * @interface FinalAnswerToolData
 */
export interface FinalAnswerToolData {
    /**
     * 
     * @type {string}
     * @memberof FinalAnswerToolData
     */
    'tool_type'?: FinalAnswerToolDataToolTypeEnum;
}

export const FinalAnswerToolDataToolTypeEnum = {
    FinalAnswer: 'FinalAnswer'
} as const;

export type FinalAnswerToolDataToolTypeEnum = typeof FinalAnswerToolDataToolTypeEnum[keyof typeof FinalAnswerToolDataToolTypeEnum];

/**
 * 
 * @export
 * @interface FolderAPIAgentModel
 */
export interface FolderAPIAgentModel {
    /**
     * 
     * @type {string}
     * @memberof FolderAPIAgentModel
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderAPIAgentModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface FolderChatAgentModel
 */
export interface FolderChatAgentModel {
    /**
     * 
     * @type {string}
     * @memberof FolderChatAgentModel
     */
    'agent_id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderChatAgentModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FolderChatAgentModel
     */
    'avatar': string;
}
/**
 * 
 * @export
 * @interface FolderCreationRequest
 */
export interface FolderCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof FolderCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {object}
     * @memberof FolderCreationRequest
     */
    'settings': object;
}
/**
 * 
 * @export
 * @interface FolderCreationResponse
 */
export interface FolderCreationResponse {
    /**
     * 
     * @type {FolderModel}
     * @memberof FolderCreationResponse
     */
    'model': FolderModel;
}
/**
 * 
 * @export
 * @interface FolderImportBody
 */
export interface FolderImportBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof FolderImportBody
     */
    'content': ContentJSONFile;
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof FolderImportBody
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface FolderImportResponse
 */
export interface FolderImportResponse {
    /**
     * 
     * @type {FolderModel}
     * @memberof FolderImportResponse
     */
    'folder': FolderModel;
}
/**
 * 
 * @export
 * @interface FolderInspectionBody
 */
export interface FolderInspectionBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof FolderInspectionBody
     */
    'content': ContentJSONFile;
}
/**
 * 
 * @export
 * @interface FolderInspectionResponse
 */
export interface FolderInspectionResponse {
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof FolderInspectionResponse
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface FolderModel
 */
export interface FolderModel {
    /**
     * 
     * @type {string}
     * @memberof FolderModel
     */
    'name': string;
    /**
     * 
     * @type {object}
     * @memberof FolderModel
     */
    'settings': object;
    /**
     * 
     * @type {string}
     * @memberof FolderModel
     */
    'external_id': string;
    /**
     * 
     * @type {FolderType}
     * @memberof FolderModel
     */
    'type': FolderType;
    /**
     * 
     * @type {string}
     * @memberof FolderModel
     */
    'folder_id': string;
    /**
     * 
     * @type {Array<FolderProjectModel>}
     * @memberof FolderModel
     */
    'projects': Array<FolderProjectModel>;
    /**
     * 
     * @type {Array<FolderToolkitModel>}
     * @memberof FolderModel
     */
    'toolkits': Array<FolderToolkitModel>;
    /**
     * 
     * @type {Array<FolderChatAgentModel>}
     * @memberof FolderModel
     */
    'chat_agents': Array<FolderChatAgentModel>;
    /**
     * 
     * @type {Array<FolderAPIAgentModel>}
     * @memberof FolderModel
     */
    'api_agents': Array<FolderAPIAgentModel>;
}


/**
 * 
 * @export
 * @interface FolderProjectModel
 */
export interface FolderProjectModel {
    /**
     * 
     * @type {string}
     * @memberof FolderProjectModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderProjectModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface FolderToolkitModel
 */
export interface FolderToolkitModel {
    /**
     * 
     * @type {string}
     * @memberof FolderToolkitModel
     */
    'toolkit_id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderToolkitModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FolderType = {
    System: 'System',
    Custom: 'Custom'
} as const;

export type FolderType = typeof FolderType[keyof typeof FolderType];


/**
 * 
 * @export
 * @interface FolderUpdatingRequest
 */
export interface FolderUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof FolderUpdatingRequest
     */
    'name': string;
    /**
     * 
     * @type {object}
     * @memberof FolderUpdatingRequest
     */
    'settings': object;
}
/**
 * 
 * @export
 * @interface FolderUpdatingResponse
 */
export interface FolderUpdatingResponse {
    /**
     * 
     * @type {FolderModel}
     * @memberof FolderUpdatingResponse
     */
    'model': FolderModel;
}
/**
 * 
 * @export
 * @interface GetCurrentDateTimeToolData
 */
export interface GetCurrentDateTimeToolData {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentDateTimeToolData
     */
    'tool_type'?: GetCurrentDateTimeToolDataToolTypeEnum;
}

export const GetCurrentDateTimeToolDataToolTypeEnum = {
    GetCurrentDateTime: 'GetCurrentDateTime'
} as const;

export type GetCurrentDateTimeToolDataToolTypeEnum = typeof GetCurrentDateTimeToolDataToolTypeEnum[keyof typeof GetCurrentDateTimeToolDataToolTypeEnum];

/**
 * 
 * @export
 * @interface GetCurrentDateTimeToolSettings
 */
export interface GetCurrentDateTimeToolSettings {
    /**
     * 
     * @type {string}
     * @memberof GetCurrentDateTimeToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentDateTimeToolSettings
     */
    'tool_description'?: string | null;
}
/**
 * 
 * @export
 * @interface GigaChatProviderSettingsInput
 */
export interface GigaChatProviderSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof GigaChatProviderSettingsInput
     */
    'provider_type'?: GigaChatProviderSettingsInputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof GigaChatProviderSettingsInput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase>}
     * @memberof GigaChatProviderSettingsInput
     */
    'models'?: Array<ProviderModelItemBase>;
    /**
     * 
     * @type {string}
     * @memberof GigaChatProviderSettingsInput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GigaChatProviderSettingsInput
     */
    'scope'?: string | null;
}

export const GigaChatProviderSettingsInputProviderTypeEnum = {
    Gigachat: 'GIGACHAT'
} as const;

export type GigaChatProviderSettingsInputProviderTypeEnum = typeof GigaChatProviderSettingsInputProviderTypeEnum[keyof typeof GigaChatProviderSettingsInputProviderTypeEnum];

/**
 * 
 * @export
 * @interface GigaChatProviderSettingsOutput
 */
export interface GigaChatProviderSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof GigaChatProviderSettingsOutput
     */
    'provider_type'?: GigaChatProviderSettingsOutputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof GigaChatProviderSettingsOutput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase1>}
     * @memberof GigaChatProviderSettingsOutput
     */
    'models'?: Array<ProviderModelItemBase1>;
    /**
     * 
     * @type {string}
     * @memberof GigaChatProviderSettingsOutput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GigaChatProviderSettingsOutput
     */
    'scope'?: string | null;
}

export const GigaChatProviderSettingsOutputProviderTypeEnum = {
    Gigachat: 'GIGACHAT'
} as const;

export type GigaChatProviderSettingsOutputProviderTypeEnum = typeof GigaChatProviderSettingsOutputProviderTypeEnum[keyof typeof GigaChatProviderSettingsOutputProviderTypeEnum];

/**
 * 
 * @export
 * @interface Groupid
 */
export interface Groupid {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailBehavior = {
    Allow: 'Allow',
    Block: 'Block'
} as const;

export type GuardrailBehavior = typeof GuardrailBehavior[keyof typeof GuardrailBehavior];


/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailCheckStatus = {
    Pass: 'Pass',
    Block: 'Block',
    Audit: 'Audit',
    Error: 'Error'
} as const;

export type GuardrailCheckStatus = typeof GuardrailCheckStatus[keyof typeof GuardrailCheckStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailCheckTarget = {
    UserMessage: 'UserMessage',
    ToolOutput: 'ToolOutput',
    AssistantMessage: 'AssistantMessage',
    ToolCallArguments: 'ToolCallArguments'
} as const;

export type GuardrailCheckTarget = typeof GuardrailCheckTarget[keyof typeof GuardrailCheckTarget];


/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailErrorPolicy = {
    FailClosed: 'FailClosed',
    FailOpen: 'FailOpen'
} as const;

export type GuardrailErrorPolicy = typeof GuardrailErrorPolicy[keyof typeof GuardrailErrorPolicy];


/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailSettingsState = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type GuardrailSettingsState = typeof GuardrailSettingsState[keyof typeof GuardrailSettingsState];


/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailStage = {
    Input: 'Input',
    Output: 'Output'
} as const;

export type GuardrailStage = typeof GuardrailStage[keyof typeof GuardrailStage];


/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailType = {
    Masking: 'Masking',
    CustomPromptCheck: 'CustomPromptCheck',
    ExternalCheck: 'ExternalCheck',
    RegexCheck: 'RegexCheck'
} as const;

export type GuardrailType = typeof GuardrailType[keyof typeof GuardrailType];


/**
 * 
 * @export
 * @interface GuardrailsSettingsInput
 */
export interface GuardrailsSettingsInput {
    /**
     * 
     * @type {GuardrailsTraceMaskingMode}
     * @memberof GuardrailsSettingsInput
     */
    'trace_masking'?: GuardrailsTraceMaskingMode;
    /**
     * 
     * @type {MaskingSettingsInput}
     * @memberof GuardrailsSettingsInput
     */
    'masking'?: MaskingSettingsInput;
    /**
     * 
     * @type {CheckStageSettingsInput}
     * @memberof GuardrailsSettingsInput
     */
    'input'?: CheckStageSettingsInput;
    /**
     * 
     * @type {CheckStageSettingsInput}
     * @memberof GuardrailsSettingsInput
     */
    'output'?: CheckStageSettingsInput;
}


/**
 * 
 * @export
 * @interface GuardrailsSettingsOutput
 */
export interface GuardrailsSettingsOutput {
    /**
     * 
     * @type {GuardrailsTraceMaskingMode}
     * @memberof GuardrailsSettingsOutput
     */
    'trace_masking'?: GuardrailsTraceMaskingMode;
    /**
     * 
     * @type {MaskingSettingsOutput}
     * @memberof GuardrailsSettingsOutput
     */
    'masking'?: MaskingSettingsOutput;
    /**
     * 
     * @type {CheckStageSettingsOutput}
     * @memberof GuardrailsSettingsOutput
     */
    'input'?: CheckStageSettingsOutput;
    /**
     * 
     * @type {CheckStageSettingsOutput}
     * @memberof GuardrailsSettingsOutput
     */
    'output'?: CheckStageSettingsOutput;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GuardrailsTraceMaskingMode = {
    Disabled: 'Disabled',
    Enabled: 'Enabled'
} as const;

export type GuardrailsTraceMaskingMode = typeof GuardrailsTraceMaskingMode[keyof typeof GuardrailsTraceMaskingMode];


/**
 * 
 * @export
 * @enum {string}
 */

export const HTMLImagesParsingMode = {
    Ignore: 'IGNORE',
    MarkdownOriginalUrl: 'MARKDOWN_ORIGINAL_URL',
    MarkdownStoreInS3: 'MARKDOWN_STORE_IN_S3'
} as const;

export type HTMLImagesParsingMode = typeof HTMLImagesParsingMode[keyof typeof HTMLImagesParsingMode];


/**
 * 
 * @export
 * @interface HTMLImagesSettings
 */
export interface HTMLImagesSettings {
    /**
     * 
     * @type {HTMLImagesParsingMode}
     * @memberof HTMLImagesSettings
     */
    'parsing_mode'?: HTMLImagesParsingMode;
}


/**
 * 
 * @export
 * @interface HTMLSourceExtractionSettingsInput
 */
export interface HTMLSourceExtractionSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof HTMLSourceExtractionSettingsInput
     */
    'content_selector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HTMLSourceExtractionSettingsInput
     */
    'filter_selector'?: string | null;
    /**
     * 
     * @type {HTMLImagesSettings}
     * @memberof HTMLSourceExtractionSettingsInput
     */
    'images'?: HTMLImagesSettings | null;
}
/**
 * 
 * @export
 * @interface HTMLSourceExtractionSettingsOutput
 */
export interface HTMLSourceExtractionSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof HTMLSourceExtractionSettingsOutput
     */
    'content_selector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HTMLSourceExtractionSettingsOutput
     */
    'filter_selector'?: string | null;
    /**
     * 
     * @type {HTMLImagesSettings}
     * @memberof HTMLSourceExtractionSettingsOutput
     */
    'images'?: HTMLImagesSettings | null;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HealthInfo
 */
export interface HealthInfo {
    /**
     * 
     * @type {Array<HealthProbeOutput>}
     * @memberof HealthInfo
     */
    'probes': Array<HealthProbeOutput>;
    /**
     * 
     * @type {HealthStatus}
     * @memberof HealthInfo
     */
    'status': HealthStatus;
    /**
     * 
     * @type {number}
     * @memberof HealthInfo
     */
    'code': number;
}


/**
 * 
 * @export
 * @interface HealthProbeInput
 */
export interface HealthProbeInput {
    /**
     * 
     * @type {string}
     * @memberof HealthProbeInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HealthProbeInput
     */
    'message': string;
    /**
     * 
     * @type {HealthStatus}
     * @memberof HealthProbeInput
     */
    'status': HealthStatus;
    /**
     * 
     * @type {Array<HealthProbeInput>}
     * @memberof HealthProbeInput
     */
    'probes': Array<HealthProbeInput>;
}


/**
 * 
 * @export
 * @interface HealthProbeOutput
 */
export interface HealthProbeOutput {
    /**
     * 
     * @type {string}
     * @memberof HealthProbeOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HealthProbeOutput
     */
    'message': string;
    /**
     * 
     * @type {HealthStatus}
     * @memberof HealthProbeOutput
     */
    'status': HealthStatus;
    /**
     * 
     * @type {Array<HealthProbeOutput>}
     * @memberof HealthProbeOutput
     */
    'probes': Array<HealthProbeOutput>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const HealthStatus = {
    Ok: 'OK',
    Bad: 'Bad',
    None: 'None'
} as const;

export type HealthStatus = typeof HealthStatus[keyof typeof HealthStatus];


/**
 * 
 * @export
 * @interface Hidden
 */
export interface Hidden {
}
/**
 * @type Identity
 * @export
 */
export type Identity = { type: 'Application' } & ELMA365ApplicationIdentity | { type: 'Process' } & ELMA365ProcessIdentity;

/**
 * 
 * @export
 * @interface IdentityModel
 */
export interface IdentityModel {
    /**
     * 
     * @type {Array<IdentityProviderModel>}
     * @memberof IdentityModel
     */
    'providers': Array<IdentityProviderModel>;
    /**
     * 
     * @type {IdentityProviderModel}
     * @memberof IdentityModel
     */
    'current': IdentityProviderModel;
}
/**
 * 
 * @export
 * @interface IdentityProviderModel
 */
export interface IdentityProviderModel {
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderModel
     */
    'authority': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderModel
     */
    'subject_id': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderModel
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface InfinityProviderSettingsInput
 */
export interface InfinityProviderSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof InfinityProviderSettingsInput
     */
    'provider_type'?: InfinityProviderSettingsInputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof InfinityProviderSettingsInput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase>}
     * @memberof InfinityProviderSettingsInput
     */
    'models'?: Array<ProviderModelItemBase>;
    /**
     * 
     * @type {string}
     * @memberof InfinityProviderSettingsInput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfinityProviderSettingsInput
     */
    'api_base'?: string | null;
}

export const InfinityProviderSettingsInputProviderTypeEnum = {
    Infinity: 'INFINITY'
} as const;

export type InfinityProviderSettingsInputProviderTypeEnum = typeof InfinityProviderSettingsInputProviderTypeEnum[keyof typeof InfinityProviderSettingsInputProviderTypeEnum];

/**
 * 
 * @export
 * @interface InfinityProviderSettingsOutput
 */
export interface InfinityProviderSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof InfinityProviderSettingsOutput
     */
    'provider_type'?: InfinityProviderSettingsOutputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof InfinityProviderSettingsOutput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase1>}
     * @memberof InfinityProviderSettingsOutput
     */
    'models'?: Array<ProviderModelItemBase1>;
    /**
     * 
     * @type {string}
     * @memberof InfinityProviderSettingsOutput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfinityProviderSettingsOutput
     */
    'api_base'?: string | null;
}

export const InfinityProviderSettingsOutputProviderTypeEnum = {
    Infinity: 'INFINITY'
} as const;

export type InfinityProviderSettingsOutputProviderTypeEnum = typeof InfinityProviderSettingsOutputProviderTypeEnum[keyof typeof InfinityProviderSettingsOutputProviderTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionArtifactAction = {
    Remain: 'Remain',
    Create: 'Create',
    Delete: 'Delete'
} as const;

export type IngestionArtifactAction = typeof IngestionArtifactAction[keyof typeof IngestionArtifactAction];


/**
 * 
 * @export
 * @interface IngestionArtifactModel
 */
export interface IngestionArtifactModel {
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'artifact_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'public_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'parent_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'file_id'?: string | null;
    /**
     * 
     * @type {IngestionArtifactType}
     * @memberof IngestionArtifactModel
     */
    'type': IngestionArtifactType;
    /**
     * 
     * @type {IngestionArtifactOrigin}
     * @memberof IngestionArtifactModel
     */
    'origin': IngestionArtifactOrigin;
    /**
     * 
     * @type {IngestionArtifactAction}
     * @memberof IngestionArtifactModel
     */
    'action': IngestionArtifactAction;
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'node_id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IngestionArtifactModel
     */
    'metadata': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: RelationsValue; }}
     * @memberof IngestionArtifactModel
     */
    'relations': { [key: string]: RelationsValue; };
    /**
     * 
     * @type {string}
     * @memberof IngestionArtifactModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof IngestionArtifactModel
     */
    'size': number;
    /**
     * 
     * @type {IngestionVolumesContainer}
     * @memberof IngestionArtifactModel
     */
    'volumes': IngestionVolumesContainer;
    /**
     * 
     * @type {ContentInfoOutput}
     * @memberof IngestionArtifactModel
     */
    'content': ContentInfoOutput;
    /**
     * 
     * @type {ContentUrls}
     * @memberof IngestionArtifactModel
     */
    'urls': ContentUrls;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionArtifactOrigin = {
    Loader: 'Loader',
    Extraction: 'Extraction',
    Parsing: 'Parsing',
    Embedding: 'Embedding'
} as const;

export type IngestionArtifactOrigin = typeof IngestionArtifactOrigin[keyof typeof IngestionArtifactOrigin];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionArtifactType = {
    Document: 'Document',
    Article: 'Article',
    Fragment: 'Fragment',
    Embedding: 'Embedding'
} as const;

export type IngestionArtifactType = typeof IngestionArtifactType[keyof typeof IngestionArtifactType];


/**
 * 
 * @export
 * @interface IngestionIdentitiesContainer
 */
export interface IngestionIdentitiesContainer {
    /**
     * 
     * @type {IngestionIdentityInfo}
     * @memberof IngestionIdentitiesContainer
     */
    'current'?: IngestionIdentityInfo;
    /**
     * 
     * @type {IngestionIdentityInfo}
     * @memberof IngestionIdentitiesContainer
     */
    'rolling'?: IngestionIdentityInfo;
    /**
     * 
     * @type {IngestionIdentityInfo}
     * @memberof IngestionIdentitiesContainer
     */
    'latest'?: IngestionIdentityInfo;
}
/**
 * 
 * @export
 * @interface IngestionIdentityInfo
 */
export interface IngestionIdentityInfo {
    /**
     * 
     * @type {string}
     * @memberof IngestionIdentityInfo
     */
    'mime'?: string;
    /**
     * 
     * @type {string}
     * @memberof IngestionIdentityInfo
     */
    'hash'?: string;
    /**
     * 
     * @type {string}
     * @memberof IngestionIdentityInfo
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IngestionIdentityInfo
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface IngestionIndexInfoInput
 */
export interface IngestionIndexInfoInput {
    /**
     * 
     * @type {string}
     * @memberof IngestionIndexInfoInput
     */
    'external_id': string;
    /**
     * 
     * @type {IngestionIndexStatus}
     * @memberof IngestionIndexInfoInput
     */
    'status': IngestionIndexStatus;
    /**
     * 
     * @type {Array<IngestionStoreInfo>}
     * @memberof IngestionIndexInfoInput
     */
    'stores': Array<IngestionStoreInfo>;
}


/**
 * 
 * @export
 * @interface IngestionIndexInfoOutput
 */
export interface IngestionIndexInfoOutput {
    /**
     * 
     * @type {string}
     * @memberof IngestionIndexInfoOutput
     */
    'external_id': string;
    /**
     * 
     * @type {IngestionIndexStatus}
     * @memberof IngestionIndexInfoOutput
     */
    'status': IngestionIndexStatus;
    /**
     * 
     * @type {Array<IngestionStoreInfo>}
     * @memberof IngestionIndexInfoOutput
     */
    'stores': Array<IngestionStoreInfo>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionIndexStatus = {
    Empty: 'Empty',
    Ready: 'Ready'
} as const;

export type IngestionIndexStatus = typeof IngestionIndexStatus[keyof typeof IngestionIndexStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionLaunchStatus = {
    NoProjectSources: 'NoProjectSources',
    NoSourceInstructions: 'NoSourceInstructions',
    NoSourceParameters: 'NoSourceParameters',
    NoStagesPlanned: 'NoStagesPlanned',
    AlreadyRolling: 'AlreadyRolling',
    SuccessfullyLaunched: 'SuccessfullyLaunched'
} as const;

export type IngestionLaunchStatus = typeof IngestionLaunchStatus[keyof typeof IngestionLaunchStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionNodeClass = {
    Binary: 'Binary',
    Document: 'Document',
    Text: 'Text'
} as const;

export type IngestionNodeClass = typeof IngestionNodeClass[keyof typeof IngestionNodeClass];


/**
 * 
 * @export
 * @interface IngestionPipelineInput
 */
export interface IngestionPipelineInput {
    /**
     * 
     * @type {EmbeddingSettings}
     * @memberof IngestionPipelineInput
     */
    'embedding'?: EmbeddingSettings;
    /**
     * 
     * @type {NodeParsingMode}
     * @memberof IngestionPipelineInput
     */
    'node_parsing_mode'?: NodeParsingMode;
    /**
     * 
     * @type {ChunkNodeParsing}
     * @memberof IngestionPipelineInput
     */
    'chunk_node_parsing'?: ChunkNodeParsing;
    /**
     * 
     * @type {SentenceWindowNodeParsing}
     * @memberof IngestionPipelineInput
     */
    'sentence_window_node_parsing'?: SentenceWindowNodeParsing;
    /**
     * 
     * @type {LLMNodeParsing}
     * @memberof IngestionPipelineInput
     */
    'llm_node_parsing'?: LLMNodeParsing;
}


/**
 * 
 * @export
 * @interface IngestionPipelineOutput
 */
export interface IngestionPipelineOutput {
    /**
     * 
     * @type {EmbeddingSettings}
     * @memberof IngestionPipelineOutput
     */
    'embedding'?: EmbeddingSettings;
    /**
     * 
     * @type {NodeParsingMode}
     * @memberof IngestionPipelineOutput
     */
    'node_parsing_mode'?: NodeParsingMode;
    /**
     * 
     * @type {ChunkNodeParsing}
     * @memberof IngestionPipelineOutput
     */
    'chunk_node_parsing'?: ChunkNodeParsing;
    /**
     * 
     * @type {SentenceWindowNodeParsing}
     * @memberof IngestionPipelineOutput
     */
    'sentence_window_node_parsing'?: SentenceWindowNodeParsing;
    /**
     * 
     * @type {LLMNodeParsing}
     * @memberof IngestionPipelineOutput
     */
    'llm_node_parsing'?: LLMNodeParsing;
}


/**
 * 
 * @export
 * @interface IngestionProcessCreationRequest
 */
export interface IngestionProcessCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessCreationRequest
     */
    'project_id': string;
    /**
     * 
     * @type {Array<IngestionSourceInstruction>}
     * @memberof IngestionProcessCreationRequest
     */
    'brief_instructions': Array<IngestionSourceInstruction>;
    /**
     * 
     * @type {IngestionSourceCommand}
     * @memberof IngestionProcessCreationRequest
     */
    'source_command'?: IngestionSourceCommand | null;
    /**
     * 
     * @type {Array<IngestionSourceGrade>}
     * @memberof IngestionProcessCreationRequest
     */
    'source_grades'?: Array<IngestionSourceGrade> | null;
}


/**
 * 
 * @export
 * @interface IngestionProcessCreationResponse
 */
export interface IngestionProcessCreationResponse {
    /**
     * 
     * @type {IngestionLaunchStatus}
     * @memberof IngestionProcessCreationResponse
     */
    'launch_status': IngestionLaunchStatus;
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessCreationResponse
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessCreationResponse
     */
    'process_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessCreationResponse
     */
    'operation_id': string | null;
}


/**
 * 
 * @export
 * @interface IngestionProcessModel
 */
export interface IngestionProcessModel {
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessModel
     */
    'process_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionProcessModel
     */
    'operation_id': string;
    /**
     * 
     * @type {IngestionProcessStatus}
     * @memberof IngestionProcessModel
     */
    'status': IngestionProcessStatus;
    /**
     * 
     * @type {ProjectPipelineOutput}
     * @memberof IngestionProcessModel
     */
    'pipeline': ProjectPipelineOutput;
    /**
     * 
     * @type {Array<IngestionSourceInfoOutput>}
     * @memberof IngestionProcessModel
     */
    'sources': Array<IngestionSourceInfoOutput>;
    /**
     * 
     * @type {IngestionStagesContainerOutput}
     * @memberof IngestionProcessModel
     */
    'stages': IngestionStagesContainerOutput;
    /**
     * 
     * @type {IngestionResultInfoOutput}
     * @memberof IngestionProcessModel
     */
    'result': IngestionResultInfoOutput;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionProcessModel
     */
    'progress': OperationProgress;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionProcessStatus = {
    Pending: 'Pending',
    Preparing: 'Preparing',
    Prefetch: 'Prefetch',
    Loading: 'Loading',
    Extraction: 'Extraction',
    Parsing: 'Parsing',
    Embedding: 'Embedding',
    Indexing: 'Indexing',
    Savepoint: 'Savepoint',
    Commit: 'Commit',
    Rollback: 'Rollback',
    Success: 'Success',
    Error: 'Error',
    Failure: 'Failure',
    Cancelled: 'Cancelled'
} as const;

export type IngestionProcessStatus = typeof IngestionProcessStatus[keyof typeof IngestionProcessStatus];


/**
 * 
 * @export
 * @interface IngestionReferenceLocator
 */
export interface IngestionReferenceLocator {
    /**
     * 
     * @type {string}
     * @memberof IngestionReferenceLocator
     */
    'entity_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionReferenceLocator
     */
    'public_id': string;
}
/**
 * 
 * @export
 * @interface IngestionReferenceModel
 */
export interface IngestionReferenceModel {
    /**
     * 
     * @type {Array<IngestionReferenceLocator>}
     * @memberof IngestionReferenceModel
     */
    'artifact_locators': Array<IngestionReferenceLocator>;
    /**
     * 
     * @type {Array<IngestionReferenceLocator>}
     * @memberof IngestionReferenceModel
     */
    'file_locators': Array<IngestionReferenceLocator>;
    /**
     * 
     * @type {Array<ContentUrls>}
     * @memberof IngestionReferenceModel
     */
    'artifact_urls': Array<ContentUrls>;
    /**
     * 
     * @type {Array<ContentUrls>}
     * @memberof IngestionReferenceModel
     */
    'file_urls': Array<ContentUrls>;
}
/**
 * 
 * @export
 * @interface IngestionReferencesModelInput
 */
export interface IngestionReferencesModelInput {
    /**
     * 
     * @type {IngestionReferenceModel}
     * @memberof IngestionReferencesModelInput
     */
    'current': IngestionReferenceModel;
    /**
     * 
     * @type {IngestionReferenceModel}
     * @memberof IngestionReferencesModelInput
     */
    'rolling': IngestionReferenceModel;
    /**
     * 
     * @type {IngestionReferenceModel}
     * @memberof IngestionReferencesModelInput
     */
    'latest': IngestionReferenceModel;
}
/**
 * 
 * @export
 * @interface IngestionReferencesModelOutput
 */
export interface IngestionReferencesModelOutput {
    /**
     * 
     * @type {IngestionReferenceModel}
     * @memberof IngestionReferencesModelOutput
     */
    'current': IngestionReferenceModel;
    /**
     * 
     * @type {IngestionReferenceModel}
     * @memberof IngestionReferencesModelOutput
     */
    'rolling': IngestionReferenceModel;
    /**
     * 
     * @type {IngestionReferenceModel}
     * @memberof IngestionReferencesModelOutput
     */
    'latest': IngestionReferenceModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionResourceAction = {
    Remain: 'Remain',
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete'
} as const;

export type IngestionResourceAction = typeof IngestionResourceAction[keyof typeof IngestionResourceAction];


/**
 * 
 * @export
 * @interface IngestionResourceModel
 */
export interface IngestionResourceModel {
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'modified_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'ingested_on': string | null;
    /**
     * 
     * @type {IngestionResourceStatus}
     * @memberof IngestionResourceModel
     */
    'status': IngestionResourceStatus;
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionResourceModel
     */
    'stage'?: IngestionStageType | null;
    /**
     * 
     * @type {IngestionResourceAction}
     * @memberof IngestionResourceModel
     */
    'action': IngestionResourceAction;
    /**
     * 
     * @type {string}
     * @memberof IngestionResourceModel
     */
    'url': string;
    /**
     * 
     * @type {IngestionReferencesModelOutput}
     * @memberof IngestionResourceModel
     */
    'references': IngestionReferencesModelOutput;
    /**
     * 
     * @type {IngestionIdentitiesContainer}
     * @memberof IngestionResourceModel
     */
    'identities': IngestionIdentitiesContainer;
    /**
     * 
     * @type {IngestionVolumesContainer}
     * @memberof IngestionResourceModel
     */
    'volumes': IngestionVolumesContainer;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionResourceModel
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionResourceModel
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionResourceStatus = {
    Pending: 'Pending',
    Prefetch: 'Prefetch',
    Loading: 'Loading',
    Extraction: 'Extraction',
    Parsing: 'Parsing',
    Embedding: 'Embedding',
    Indexing: 'Indexing',
    Savepoint: 'Savepoint',
    Commit: 'Commit',
    Rollback: 'Rollback',
    Deletion: 'Deletion',
    Review: 'Review',
    Ready: 'Ready',
    Error: 'Error',
    Failure: 'Failure'
} as const;

export type IngestionResourceStatus = typeof IngestionResourceStatus[keyof typeof IngestionResourceStatus];


/**
 * 
 * @export
 * @interface IngestionResultInfoInput
 */
export interface IngestionResultInfoInput {
    /**
     * 
     * @type {IngestionResultStatus}
     * @memberof IngestionResultInfoInput
     */
    'status': IngestionResultStatus;
    /**
     * 
     * @type {Array<IngestionIndexInfoInput>}
     * @memberof IngestionResultInfoInput
     */
    'indices': Array<IngestionIndexInfoInput>;
}


/**
 * 
 * @export
 * @interface IngestionResultInfoOutput
 */
export interface IngestionResultInfoOutput {
    /**
     * 
     * @type {IngestionResultStatus}
     * @memberof IngestionResultInfoOutput
     */
    'status': IngestionResultStatus;
    /**
     * 
     * @type {Array<IngestionIndexInfoOutput>}
     * @memberof IngestionResultInfoOutput
     */
    'indices': Array<IngestionIndexInfoOutput>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionResultStatus = {
    Empty: 'Empty',
    Ready: 'Ready'
} as const;

export type IngestionResultStatus = typeof IngestionResultStatus[keyof typeof IngestionResultStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionRunType = {
    Manual: 'Manual',
    Scheduled: 'Scheduled'
} as const;

export type IngestionRunType = typeof IngestionRunType[keyof typeof IngestionRunType];


/**
 * 
 * @export
 * @interface IngestionScheduleCreationRequest
 */
export interface IngestionScheduleCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof IngestionScheduleCreationRequest
     */
    'source_id': string;
    /**
     * 
     * @type {ScheduleSettings}
     * @memberof IngestionScheduleCreationRequest
     */
    'settings': ScheduleSettings;
}
/**
 * 
 * @export
 * @interface IngestionScheduleCreationResponse
 */
export interface IngestionScheduleCreationResponse {
    /**
     * 
     * @type {IngestionScheduleModel}
     * @memberof IngestionScheduleCreationResponse
     */
    'model': IngestionScheduleModel;
}
/**
 * 
 * @export
 * @interface IngestionScheduleModel
 */
export interface IngestionScheduleModel {
    /**
     * 
     * @type {string}
     * @memberof IngestionScheduleModel
     */
    'schedule_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionScheduleModel
     */
    'source_id': string;
    /**
     * 
     * @type {ScheduleSettings}
     * @memberof IngestionScheduleModel
     */
    'settings': ScheduleSettings;
}
/**
 * 
 * @export
 * @interface IngestionScheduleUpdatingRequest
 */
export interface IngestionScheduleUpdatingRequest {
    /**
     * 
     * @type {ScheduleSettings}
     * @memberof IngestionScheduleUpdatingRequest
     */
    'settings': ScheduleSettings;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionSignalCommand = {
    Cancel: 'Cancel',
    Create: 'Create'
} as const;

export type IngestionSignalCommand = typeof IngestionSignalCommand[keyof typeof IngestionSignalCommand];


/**
 * 
 * @export
 * @interface IngestionSignalCreationRequest
 */
export interface IngestionSignalCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalCreationRequest
     */
    'process_id': string;
    /**
     * 
     * @type {IngestionSignalSubject}
     * @memberof IngestionSignalCreationRequest
     */
    'subject': IngestionSignalSubject;
    /**
     * 
     * @type {IngestionSignalCommand}
     * @memberof IngestionSignalCreationRequest
     */
    'command': IngestionSignalCommand;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IngestionSignalCreationRequest
     */
    'metadata': { [key: string]: any; };
}


/**
 * 
 * @export
 * @interface IngestionSignalCreationResponse
 */
export interface IngestionSignalCreationResponse {
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalCreationResponse
     */
    'signal_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalCreationResponse
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalCreationResponse
     */
    'process_id': string;
    /**
     * 
     * @type {IngestionSignalSubject}
     * @memberof IngestionSignalCreationResponse
     */
    'subject': IngestionSignalSubject;
    /**
     * 
     * @type {IngestionSignalCommand}
     * @memberof IngestionSignalCreationResponse
     */
    'command': IngestionSignalCommand;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IngestionSignalCreationResponse
     */
    'metadata': { [key: string]: any; };
}


/**
 * 
 * @export
 * @interface IngestionSignalModel
 */
export interface IngestionSignalModel {
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalModel
     */
    'signal_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSignalModel
     */
    'process_id': string;
    /**
     * 
     * @type {IngestionSignalSubject}
     * @memberof IngestionSignalModel
     */
    'subject': IngestionSignalSubject;
    /**
     * 
     * @type {IngestionSignalCommand}
     * @memberof IngestionSignalModel
     */
    'command': IngestionSignalCommand;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IngestionSignalModel
     */
    'metadata': { [key: string]: any; };
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionSignalSubject = {
    Process: 'Process',
    Store: 'Store'
} as const;

export type IngestionSignalSubject = typeof IngestionSignalSubject[keyof typeof IngestionSignalSubject];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionSourceAction = {
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete'
} as const;

export type IngestionSourceAction = typeof IngestionSourceAction[keyof typeof IngestionSourceAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionSourceCommand = {
    Preview: 'Preview',
    Build: 'Build',
    Ingest: 'Ingest',
    Rebuild: 'Rebuild',
    Restart: 'Restart',
    Delete: 'Delete'
} as const;

export type IngestionSourceCommand = typeof IngestionSourceCommand[keyof typeof IngestionSourceCommand];


/**
 * 
 * @export
 * @interface IngestionSourceCreationRequest
 */
export interface IngestionSourceCreationRequest {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof IngestionSourceCreationRequest
     */
    'project_id': string;
    /**
     * 
     * @type {IngestionSourceParametersInput}
     * @memberof IngestionSourceCreationRequest
     */
    'parameters': IngestionSourceParametersInput;
}
/**
 * 
 * @export
 * @interface IngestionSourceCreationResponse
 */
export interface IngestionSourceCreationResponse {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof IngestionSourceCreationResponse
     */
    'source_id': string;
}
/**
 * 
 * @export
 * @interface IngestionSourceExtractionInput
 */
export interface IngestionSourceExtractionInput {
    /**
     * 
     * @type {FileSourceExtractionSettings}
     * @memberof IngestionSourceExtractionInput
     */
    'file': FileSourceExtractionSettings | null;
    /**
     * 
     * @type {HTMLSourceExtractionSettingsInput}
     * @memberof IngestionSourceExtractionInput
     */
    'html': HTMLSourceExtractionSettingsInput | null;
    /**
     * 
     * @type {object}
     * @memberof IngestionSourceExtractionInput
     */
    'text': object;
}
/**
 * 
 * @export
 * @interface IngestionSourceExtractionOutput
 */
export interface IngestionSourceExtractionOutput {
    /**
     * 
     * @type {FileSourceExtractionSettings}
     * @memberof IngestionSourceExtractionOutput
     */
    'file': FileSourceExtractionSettings | null;
    /**
     * 
     * @type {HTMLSourceExtractionSettingsOutput}
     * @memberof IngestionSourceExtractionOutput
     */
    'html': HTMLSourceExtractionSettingsOutput | null;
    /**
     * 
     * @type {object}
     * @memberof IngestionSourceExtractionOutput
     */
    'text': object;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionSourceGrade = {
    Initial: 'Initial',
    Previewing: 'Previewing',
    Previewed: 'Previewed',
    Releasing: 'Releasing',
    Released: 'Released'
} as const;

export type IngestionSourceGrade = typeof IngestionSourceGrade[keyof typeof IngestionSourceGrade];


/**
 * 
 * @export
 * @interface IngestionSourceInfoInput
 */
export interface IngestionSourceInfoInput {
    /**
     * 
     * @type {IngestionSourceParametersInput}
     * @memberof IngestionSourceInfoInput
     */
    'parameters': IngestionSourceParametersInput;
    /**
     * 
     * @type {IngestionSourceInstruction}
     * @memberof IngestionSourceInfoInput
     */
    'instruction': IngestionSourceInstruction;
}
/**
 * 
 * @export
 * @interface IngestionSourceInfoOutput
 */
export interface IngestionSourceInfoOutput {
    /**
     * 
     * @type {IngestionSourceParametersOutput}
     * @memberof IngestionSourceInfoOutput
     */
    'parameters': IngestionSourceParametersOutput;
    /**
     * 
     * @type {IngestionSourceInstruction}
     * @memberof IngestionSourceInfoOutput
     */
    'instruction': IngestionSourceInstruction;
}
/**
 * 
 * @export
 * @interface IngestionSourceInstruction
 */
export interface IngestionSourceInstruction {
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceInstruction
     */
    'source_id': string;
    /**
     * 
     * @type {IngestionSourceCommand}
     * @memberof IngestionSourceInstruction
     */
    'command': IngestionSourceCommand;
    /**
     * 
     * @type {IngestionSourceAction}
     * @memberof IngestionSourceInstruction
     */
    'action': IngestionSourceAction | null;
    /**
     * 
     * @type {{ [key: string]: IngestionStageCommand; }}
     * @memberof IngestionSourceInstruction
     */
    'stages': { [key: string]: IngestionStageCommand; };
}


/**
 * 
 * @export
 * @interface IngestionSourceModelInput
 */
export interface IngestionSourceModelInput {
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'modified_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'ingested_on': string | null;
    /**
     * 
     * @type {IngestionRunType}
     * @memberof IngestionSourceModelInput
     */
    'ingestion_run_type'?: IngestionRunType | null;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelInput
     */
    'name': string;
    /**
     * 
     * @type {IngestionSourceStatus}
     * @memberof IngestionSourceModelInput
     */
    'status': IngestionSourceStatus;
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionSourceModelInput
     */
    'stage'?: IngestionStageType | null;
    /**
     * 
     * @type {IngestionSourceGrade}
     * @memberof IngestionSourceModelInput
     */
    'grade': IngestionSourceGrade;
    /**
     * 
     * @type {IngestionVersionsContainerInput}
     * @memberof IngestionSourceModelInput
     */
    'versions': IngestionVersionsContainerInput;
    /**
     * 
     * @type {IngestionResultInfoInput}
     * @memberof IngestionSourceModelInput
     */
    'result': IngestionResultInfoInput;
    /**
     * 
     * @type {IngestionVolumesContainer}
     * @memberof IngestionSourceModelInput
     */
    'volumes': IngestionVolumesContainer;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionSourceModelInput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionSourceModelInput
     */
    'problem'?: OperationProblem | null;
    /**
     * 
     * @type {IngestionScheduleModel}
     * @memberof IngestionSourceModelInput
     */
    'schedule'?: IngestionScheduleModel | null;
}


/**
 * 
 * @export
 * @interface IngestionSourceModelOutput
 */
export interface IngestionSourceModelOutput {
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'modified_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'ingested_on': string | null;
    /**
     * 
     * @type {IngestionRunType}
     * @memberof IngestionSourceModelOutput
     */
    'ingestion_run_type'?: IngestionRunType | null;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceModelOutput
     */
    'name': string;
    /**
     * 
     * @type {IngestionSourceStatus}
     * @memberof IngestionSourceModelOutput
     */
    'status': IngestionSourceStatus;
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionSourceModelOutput
     */
    'stage'?: IngestionStageType | null;
    /**
     * 
     * @type {IngestionSourceGrade}
     * @memberof IngestionSourceModelOutput
     */
    'grade': IngestionSourceGrade;
    /**
     * 
     * @type {IngestionVersionsContainerOutput}
     * @memberof IngestionSourceModelOutput
     */
    'versions': IngestionVersionsContainerOutput;
    /**
     * 
     * @type {IngestionResultInfoOutput}
     * @memberof IngestionSourceModelOutput
     */
    'result': IngestionResultInfoOutput;
    /**
     * 
     * @type {IngestionVolumesContainer}
     * @memberof IngestionSourceModelOutput
     */
    'volumes': IngestionVolumesContainer;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionSourceModelOutput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionSourceModelOutput
     */
    'problem'?: OperationProblem | null;
    /**
     * 
     * @type {IngestionScheduleModel}
     * @memberof IngestionSourceModelOutput
     */
    'schedule'?: IngestionScheduleModel | null;
}


/**
 * 
 * @export
 * @interface IngestionSourceParametersInput
 */
export interface IngestionSourceParametersInput {
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceParametersInput
     */
    'external_id': string;
    /**
     * 
     * @type {IngestionSourceParametersType}
     * @memberof IngestionSourceParametersInput
     */
    'type': IngestionSourceParametersType;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceParametersInput
     */
    'name': string;
    /**
     * 
     * @type {Settings3}
     * @memberof IngestionSourceParametersInput
     */
    'settings': Settings3;
    /**
     * 
     * @type {IngestionSourceExtractionInput}
     * @memberof IngestionSourceParametersInput
     */
    'extraction': IngestionSourceExtractionInput;
}


/**
 * 
 * @export
 * @interface IngestionSourceParametersOutput
 */
export interface IngestionSourceParametersOutput {
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceParametersOutput
     */
    'external_id': string;
    /**
     * 
     * @type {IngestionSourceParametersType}
     * @memberof IngestionSourceParametersOutput
     */
    'type': IngestionSourceParametersType;
    /**
     * 
     * @type {string}
     * @memberof IngestionSourceParametersOutput
     */
    'name': string;
    /**
     * 
     * @type {Settings3}
     * @memberof IngestionSourceParametersOutput
     */
    'settings': Settings3;
    /**
     * 
     * @type {IngestionSourceExtractionOutput}
     * @memberof IngestionSourceParametersOutput
     */
    'extraction': IngestionSourceExtractionOutput;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionSourceParametersType = {
    WebsiteUrls: 'WebsiteURLs',
    WebsiteCrawler: 'WebsiteCrawler',
    Website: 'Website',
    File: 'File',
    Elma365: 'ELMA365',
    Confluence: 'Confluence'
} as const;

export type IngestionSourceParametersType = typeof IngestionSourceParametersType[keyof typeof IngestionSourceParametersType];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionSourceStatus = {
    Empty: 'Empty',
    Pending: 'Pending',
    Preparing: 'Preparing',
    Prefetch: 'Prefetch',
    Loading: 'Loading',
    Extraction: 'Extraction',
    Parsing: 'Parsing',
    Embedding: 'Embedding',
    Indexing: 'Indexing',
    Savepoint: 'Savepoint',
    Commit: 'Commit',
    Rollback: 'Rollback',
    Deletion: 'Deletion',
    Previewed: 'Previewed',
    Built: 'Built',
    Ingested: 'Ingested',
    Reset: 'Reset',
    Error: 'Error',
    Failure: 'Failure',
    Deleted: 'Deleted'
} as const;

export type IngestionSourceStatus = typeof IngestionSourceStatus[keyof typeof IngestionSourceStatus];


/**
 * 
 * @export
 * @interface IngestionSourceUpdatingRequest
 */
export interface IngestionSourceUpdatingRequest {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof IngestionSourceUpdatingRequest
     */
    'source_id': string;
    /**
     * 
     * @type {IngestionSourceParametersInput}
     * @memberof IngestionSourceUpdatingRequest
     */
    'parameters': IngestionSourceParametersInput;
}
/**
 * 
 * @export
 * @interface IngestionSourceUpdatingResponse
 */
export interface IngestionSourceUpdatingResponse {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof IngestionSourceUpdatingResponse
     */
    'source_id': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionStageCommand = {
    Modify: 'Modify',
    Delete: 'Delete',
    Refresh: 'Refresh'
} as const;

export type IngestionStageCommand = typeof IngestionStageCommand[keyof typeof IngestionStageCommand];


/**
 * 
 * @export
 * @interface IngestionStageInfoInput
 */
export interface IngestionStageInfoInput {
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionStageInfoInput
     */
    'type': IngestionStageType;
    /**
     * 
     * @type {IngestionStageStatus}
     * @memberof IngestionStageInfoInput
     */
    'status': IngestionStageStatus;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionStageInfoInput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionStageInfoInput
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @interface IngestionStageInfoOutput
 */
export interface IngestionStageInfoOutput {
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionStageInfoOutput
     */
    'type': IngestionStageType;
    /**
     * 
     * @type {IngestionStageStatus}
     * @memberof IngestionStageInfoOutput
     */
    'status': IngestionStageStatus;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionStageInfoOutput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionStageInfoOutput
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionStageStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Success: 'Success',
    Error: 'Error',
    Failure: 'Failure',
    Cancelled: 'Cancelled'
} as const;

export type IngestionStageStatus = typeof IngestionStageStatus[keyof typeof IngestionStageStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionStageType = {
    Prefetch: 'Prefetch',
    Loading: 'Loading',
    Extraction: 'Extraction',
    Parsing: 'Parsing',
    Embedding: 'Embedding',
    Indexing: 'Indexing',
    Savepoint: 'Savepoint',
    Commit: 'Commit',
    Rollback: 'Rollback'
} as const;

export type IngestionStageType = typeof IngestionStageType[keyof typeof IngestionStageType];


/**
 * 
 * @export
 * @interface IngestionStagesContainerInput
 */
export interface IngestionStagesContainerInput {
    /**
     * 
     * @type {Array<IngestionStageInfoInput>}
     * @memberof IngestionStagesContainerInput
     */
    'planned': Array<IngestionStageInfoInput>;
    /**
     * 
     * @type {IngestionStageInfoInput}
     * @memberof IngestionStagesContainerInput
     */
    'savepoint'?: IngestionStageInfoInput | null;
    /**
     * 
     * @type {IngestionStageInfoInput}
     * @memberof IngestionStagesContainerInput
     */
    'commit'?: IngestionStageInfoInput | null;
    /**
     * 
     * @type {IngestionStageInfoInput}
     * @memberof IngestionStagesContainerInput
     */
    'rollback'?: IngestionStageInfoInput | null;
    /**
     * 
     * @type {IngestionStageInfoInput}
     * @memberof IngestionStagesContainerInput
     */
    'current'?: IngestionStageInfoInput | null;
    /**
     * 
     * @type {IngestionStageInfoInput}
     * @memberof IngestionStagesContainerInput
     */
    'problem'?: IngestionStageInfoInput | null;
}
/**
 * 
 * @export
 * @interface IngestionStagesContainerOutput
 */
export interface IngestionStagesContainerOutput {
    /**
     * 
     * @type {Array<IngestionStageInfoOutput>}
     * @memberof IngestionStagesContainerOutput
     */
    'planned': Array<IngestionStageInfoOutput>;
    /**
     * 
     * @type {IngestionStageInfoOutput}
     * @memberof IngestionStagesContainerOutput
     */
    'savepoint'?: IngestionStageInfoOutput | null;
    /**
     * 
     * @type {IngestionStageInfoOutput}
     * @memberof IngestionStagesContainerOutput
     */
    'commit'?: IngestionStageInfoOutput | null;
    /**
     * 
     * @type {IngestionStageInfoOutput}
     * @memberof IngestionStagesContainerOutput
     */
    'rollback'?: IngestionStageInfoOutput | null;
    /**
     * 
     * @type {IngestionStageInfoOutput}
     * @memberof IngestionStagesContainerOutput
     */
    'current'?: IngestionStageInfoOutput | null;
    /**
     * 
     * @type {IngestionStageInfoOutput}
     * @memberof IngestionStagesContainerOutput
     */
    'problem'?: IngestionStageInfoOutput | null;
}
/**
 * 
 * @export
 * @interface IngestionStateModel
 */
export interface IngestionStateModel {
    /**
     * 
     * @type {IngestionStateStatus}
     * @memberof IngestionStateModel
     */
    'status': IngestionStateStatus;
    /**
     * 
     * @type {Array<IngestionStateSourceModel>}
     * @memberof IngestionStateModel
     */
    'sources': Array<IngestionStateSourceModel>;
    /**
     * 
     * @type {IngestionResultInfoOutput}
     * @memberof IngestionStateModel
     */
    'result': IngestionResultInfoOutput;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionStateModel
     */
    'progress': OperationProgress;
}


/**
 * 
 * @export
 * @interface IngestionStateResourceModelInput
 */
export interface IngestionStateResourceModelInput {
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'modified_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'ingested_on': string | null;
    /**
     * 
     * @type {IngestionResourceStatus}
     * @memberof IngestionStateResourceModelInput
     */
    'status': IngestionResourceStatus;
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionStateResourceModelInput
     */
    'stage'?: IngestionStageType | null;
    /**
     * 
     * @type {IngestionResourceAction}
     * @memberof IngestionStateResourceModelInput
     */
    'action': IngestionResourceAction;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelInput
     */
    'url': string;
    /**
     * 
     * @type {IngestionReferencesModelInput}
     * @memberof IngestionStateResourceModelInput
     */
    'references': IngestionReferencesModelInput;
    /**
     * 
     * @type {IngestionIdentitiesContainer}
     * @memberof IngestionStateResourceModelInput
     */
    'identities': IngestionIdentitiesContainer;
    /**
     * 
     * @type {IngestionVolumesContainer}
     * @memberof IngestionStateResourceModelInput
     */
    'volumes': IngestionVolumesContainer;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionStateResourceModelInput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionStateResourceModelInput
     */
    'problem'?: OperationProblem | null;
    /**
     * 
     * @type {IngestionSourceModelInput}
     * @memberof IngestionStateResourceModelInput
     */
    'source'?: IngestionSourceModelInput | null;
}


/**
 * 
 * @export
 * @interface IngestionStateResourceModelOutput
 */
export interface IngestionStateResourceModelOutput {
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'modified_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'ingested_on': string | null;
    /**
     * 
     * @type {IngestionResourceStatus}
     * @memberof IngestionStateResourceModelOutput
     */
    'status': IngestionResourceStatus;
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionStateResourceModelOutput
     */
    'stage'?: IngestionStageType | null;
    /**
     * 
     * @type {IngestionResourceAction}
     * @memberof IngestionStateResourceModelOutput
     */
    'action': IngestionResourceAction;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateResourceModelOutput
     */
    'url': string;
    /**
     * 
     * @type {IngestionReferencesModelOutput}
     * @memberof IngestionStateResourceModelOutput
     */
    'references': IngestionReferencesModelOutput;
    /**
     * 
     * @type {IngestionIdentitiesContainer}
     * @memberof IngestionStateResourceModelOutput
     */
    'identities': IngestionIdentitiesContainer;
    /**
     * 
     * @type {IngestionVolumesContainer}
     * @memberof IngestionStateResourceModelOutput
     */
    'volumes': IngestionVolumesContainer;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionStateResourceModelOutput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionStateResourceModelOutput
     */
    'problem'?: OperationProblem | null;
    /**
     * 
     * @type {IngestionSourceModelOutput}
     * @memberof IngestionStateResourceModelOutput
     */
    'source'?: IngestionSourceModelOutput | null;
}


/**
 * 
 * @export
 * @interface IngestionStateSourceModel
 */
export interface IngestionStateSourceModel {
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'modified_on': string;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'ingested_on': string | null;
    /**
     * 
     * @type {IngestionRunType}
     * @memberof IngestionStateSourceModel
     */
    'ingestion_run_type'?: IngestionRunType | null;
    /**
     * 
     * @type {string}
     * @memberof IngestionStateSourceModel
     */
    'name': string;
    /**
     * 
     * @type {IngestionSourceStatus}
     * @memberof IngestionStateSourceModel
     */
    'status': IngestionSourceStatus;
    /**
     * 
     * @type {IngestionStageType}
     * @memberof IngestionStateSourceModel
     */
    'stage'?: IngestionStageType | null;
    /**
     * 
     * @type {IngestionSourceGrade}
     * @memberof IngestionStateSourceModel
     */
    'grade': IngestionSourceGrade;
    /**
     * 
     * @type {IngestionVersionsContainerOutput}
     * @memberof IngestionStateSourceModel
     */
    'versions': IngestionVersionsContainerOutput;
    /**
     * 
     * @type {IngestionResultInfoOutput}
     * @memberof IngestionStateSourceModel
     */
    'result': IngestionResultInfoOutput;
    /**
     * 
     * @type {IngestionVolumesContainer}
     * @memberof IngestionStateSourceModel
     */
    'volumes': IngestionVolumesContainer;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionStateSourceModel
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionStateSourceModel
     */
    'problem'?: OperationProblem | null;
    /**
     * 
     * @type {IngestionScheduleModel}
     * @memberof IngestionStateSourceModel
     */
    'schedule'?: IngestionScheduleModel | null;
    /**
     * 
     * @type {Array<IngestionResourceModel>}
     * @memberof IngestionStateSourceModel
     */
    'resources': Array<IngestionResourceModel>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionStateStatus = {
    Unknown: 'Unknown',
    Empty: 'Empty',
    Pending: 'Pending',
    Processing: 'Processing',
    Ingested: 'Ingested',
    Error: 'Error',
    Failure: 'Failure'
} as const;

export type IngestionStateStatus = typeof IngestionStateStatus[keyof typeof IngestionStateStatus];


/**
 * 
 * @export
 * @interface IngestionStoreInfo
 */
export interface IngestionStoreInfo {
    /**
     * 
     * @type {string}
     * @memberof IngestionStoreInfo
     */
    'external_id': string;
    /**
     * 
     * @type {StoreEngineType}
     * @memberof IngestionStoreInfo
     */
    'type': StoreEngineType;
    /**
     * 
     * @type {VectorStoreEngine}
     * @memberof IngestionStoreInfo
     */
    'engine': VectorStoreEngine;
    /**
     * 
     * @type {IngestionStoreStatus}
     * @memberof IngestionStoreInfo
     */
    'status': IngestionStoreStatus;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionStoreStatus = {
    Empty: 'Empty',
    Ready: 'Ready'
} as const;

export type IngestionStoreStatus = typeof IngestionStoreStatus[keyof typeof IngestionStoreStatus];


/**
 * 
 * @export
 * @interface IngestionVersionInfoInput
 */
export interface IngestionVersionInfoInput {
    /**
     * 
     * @type {string}
     * @memberof IngestionVersionInfoInput
     */
    'process_id'?: string | null;
    /**
     * 
     * @type {IngestionVersionStatus}
     * @memberof IngestionVersionInfoInput
     */
    'status': IngestionVersionStatus;
    /**
     * 
     * @type {ProjectPipelineInput}
     * @memberof IngestionVersionInfoInput
     */
    'pipeline': ProjectPipelineInput;
    /**
     * 
     * @type {IngestionSourceInfoInput}
     * @memberof IngestionVersionInfoInput
     */
    'source': IngestionSourceInfoInput;
    /**
     * 
     * @type {IngestionStagesContainerInput}
     * @memberof IngestionVersionInfoInput
     */
    'stages': IngestionStagesContainerInput;
    /**
     * 
     * @type {IngestionResultInfoInput}
     * @memberof IngestionVersionInfoInput
     */
    'result': IngestionResultInfoInput;
    /**
     * 
     * @type {IngestionVersionMetadata}
     * @memberof IngestionVersionInfoInput
     */
    'metadata': IngestionVersionMetadata;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionVersionInfoInput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionVersionInfoInput
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @interface IngestionVersionInfoOutput
 */
export interface IngestionVersionInfoOutput {
    /**
     * 
     * @type {string}
     * @memberof IngestionVersionInfoOutput
     */
    'process_id'?: string | null;
    /**
     * 
     * @type {IngestionVersionStatus}
     * @memberof IngestionVersionInfoOutput
     */
    'status': IngestionVersionStatus;
    /**
     * 
     * @type {ProjectPipelineOutput}
     * @memberof IngestionVersionInfoOutput
     */
    'pipeline': ProjectPipelineOutput;
    /**
     * 
     * @type {IngestionSourceInfoOutput}
     * @memberof IngestionVersionInfoOutput
     */
    'source': IngestionSourceInfoOutput;
    /**
     * 
     * @type {IngestionStagesContainerOutput}
     * @memberof IngestionVersionInfoOutput
     */
    'stages': IngestionStagesContainerOutput;
    /**
     * 
     * @type {IngestionResultInfoOutput}
     * @memberof IngestionVersionInfoOutput
     */
    'result': IngestionResultInfoOutput;
    /**
     * 
     * @type {IngestionVersionMetadata}
     * @memberof IngestionVersionInfoOutput
     */
    'metadata': IngestionVersionMetadata;
    /**
     * 
     * @type {OperationProgress}
     * @memberof IngestionVersionInfoOutput
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof IngestionVersionInfoOutput
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @interface IngestionVersionMetadata
 */
export interface IngestionVersionMetadata {
    /**
     * 
     * @type {string}
     * @memberof IngestionVersionMetadata
     */
    'updated_at'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IngestionVersionStatus = {
    Empty: 'Empty',
    Pending: 'Pending',
    Preparing: 'Preparing',
    Prefetch: 'Prefetch',
    Loading: 'Loading',
    Extraction: 'Extraction',
    Parsing: 'Parsing',
    Embedding: 'Embedding',
    Indexing: 'Indexing',
    Savepoint: 'Savepoint',
    Commit: 'Commit',
    Rollback: 'Rollback',
    Success: 'Success',
    Error: 'Error',
    Failure: 'Failure',
    Cancelled: 'Cancelled'
} as const;

export type IngestionVersionStatus = typeof IngestionVersionStatus[keyof typeof IngestionVersionStatus];


/**
 * 
 * @export
 * @interface IngestionVersionsContainerInput
 */
export interface IngestionVersionsContainerInput {
    /**
     * 
     * @type {IngestionVersionInfoInput}
     * @memberof IngestionVersionsContainerInput
     */
    'preview'?: IngestionVersionInfoInput | null;
    /**
     * 
     * @type {IngestionVersionInfoInput}
     * @memberof IngestionVersionsContainerInput
     */
    'current'?: IngestionVersionInfoInput | null;
    /**
     * 
     * @type {IngestionVersionInfoInput}
     * @memberof IngestionVersionsContainerInput
     */
    'rolling'?: IngestionVersionInfoInput | null;
    /**
     * 
     * @type {IngestionVersionInfoInput}
     * @memberof IngestionVersionsContainerInput
     */
    'rollback'?: IngestionVersionInfoInput | null;
    /**
     * 
     * @type {IngestionVersionInfoInput}
     * @memberof IngestionVersionsContainerInput
     */
    'latest': IngestionVersionInfoInput;
    /**
     * 
     * @type {IngestionVersionInfoInput}
     * @memberof IngestionVersionsContainerInput
     */
    'draft': IngestionVersionInfoInput;
}
/**
 * 
 * @export
 * @interface IngestionVersionsContainerOutput
 */
export interface IngestionVersionsContainerOutput {
    /**
     * 
     * @type {IngestionVersionInfoOutput}
     * @memberof IngestionVersionsContainerOutput
     */
    'preview'?: IngestionVersionInfoOutput | null;
    /**
     * 
     * @type {IngestionVersionInfoOutput}
     * @memberof IngestionVersionsContainerOutput
     */
    'current'?: IngestionVersionInfoOutput | null;
    /**
     * 
     * @type {IngestionVersionInfoOutput}
     * @memberof IngestionVersionsContainerOutput
     */
    'rolling'?: IngestionVersionInfoOutput | null;
    /**
     * 
     * @type {IngestionVersionInfoOutput}
     * @memberof IngestionVersionsContainerOutput
     */
    'rollback'?: IngestionVersionInfoOutput | null;
    /**
     * 
     * @type {IngestionVersionInfoOutput}
     * @memberof IngestionVersionsContainerOutput
     */
    'latest': IngestionVersionInfoOutput;
    /**
     * 
     * @type {IngestionVersionInfoOutput}
     * @memberof IngestionVersionsContainerOutput
     */
    'draft': IngestionVersionInfoOutput;
}
/**
 * 
 * @export
 * @interface IngestionVolumeInfo
 */
export interface IngestionVolumeInfo {
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'resource_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'document_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'article_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'fragment_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'embedding_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'content_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'symbol_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'token_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'vector_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionVolumeInfo
     */
    'node_count'?: number;
}
/**
 * 
 * @export
 * @interface IngestionVolumesContainer
 */
export interface IngestionVolumesContainer {
    /**
     * 
     * @type {IngestionVolumeInfo}
     * @memberof IngestionVolumesContainer
     */
    'current'?: IngestionVolumeInfo;
    /**
     * 
     * @type {IngestionVolumeInfo}
     * @memberof IngestionVolumesContainer
     */
    'rolling'?: IngestionVolumeInfo;
    /**
     * 
     * @type {IngestionVolumeInfo}
     * @memberof IngestionVolumesContainer
     */
    'latest'?: IngestionVolumeInfo;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LLMApiType = {
    ChatCompletions: 'ChatCompletions',
    Responses: 'Responses'
} as const;

export type LLMApiType = typeof LLMApiType[keyof typeof LLMApiType];


/**
 * 
 * @export
 * @interface LLMNodeParsing
 */
export interface LLMNodeParsing {
    /**
     * 
     * @type {Tokenizer}
     * @memberof LLMNodeParsing
     */
    'tokenizer'?: Tokenizer;
    /**
     * 
     * @type {LLMSettings}
     * @memberof LLMNodeParsing
     */
    'llm'?: LLMSettings;
    /**
     * 
     * @type {string}
     * @memberof LLMNodeParsing
     */
    'prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LLMNodeParsing
     */
    'chunk_size'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMNodeParsing
     */
    'document_max_size'?: number | null;
}
/**
 * 
 * @export
 * @interface LLMRerankerSettings
 */
export interface LLMRerankerSettings {
    /**
     * 
     * @type {LLMSettings}
     * @memberof LLMRerankerSettings
     */
    'llm'?: LLMSettings | null;
    /**
     * 
     * @type {string}
     * @memberof LLMRerankerSettings
     */
    'prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LLMRerankerSettings
     */
    'batch_size'?: number | null;
}
/**
 * 
 * @export
 * @interface LLMSettings
 */
export interface LLMSettings {
    /**
     * 
     * @type {string}
     * @memberof LLMSettings
     */
    'provider_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LLMSettings
     */
    'model_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'top_p'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'seed'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'max_tokens'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'context_window'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'presence_penalty'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LLMSettings
     */
    'timeout'?: number | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof LLMSettings
     */
    'additional_kwargs'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface MCPServerAuthApiKey
 */
export interface MCPServerAuthApiKey {
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthApiKey
     */
    'api_key_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthApiKey
     */
    'api_key_value': string;
    /**
     * 
     * @type {MCPServerAuthApiKeyStore}
     * @memberof MCPServerAuthApiKey
     */
    'api_key_store'?: MCPServerAuthApiKeyStore;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MCPServerAuthApiKeyStore = {
    Header: 'Header',
    QueryParams: 'QueryParams'
} as const;

export type MCPServerAuthApiKeyStore = typeof MCPServerAuthApiKeyStore[keyof typeof MCPServerAuthApiKeyStore];


/**
 * 
 * @export
 * @interface MCPServerAuthElma365
 */
export interface MCPServerAuthElma365 {
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthElma365
     */
    'connector_id': string;
}
/**
 * 
 * @export
 * @interface MCPServerAuthInput
 */
export interface MCPServerAuthInput {
    /**
     * 
     * @type {MCPServerAuthType}
     * @memberof MCPServerAuthInput
     */
    'auth_type'?: MCPServerAuthType;
    /**
     * 
     * @type {AuthSettings}
     * @memberof MCPServerAuthInput
     */
    'auth_settings'?: AuthSettings | null;
}


/**
 * 
 * @export
 * @interface MCPServerAuthOAuth2
 */
export interface MCPServerAuthOAuth2 {
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthOAuth2
     */
    'authorize_endpoint': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthOAuth2
     */
    'token_endpoint': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthOAuth2
     */
    'client_id': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthOAuth2
     */
    'client_secret': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerAuthOAuth2
     */
    'scope': string;
}
/**
 * 
 * @export
 * @interface MCPServerAuthOutput
 */
export interface MCPServerAuthOutput {
    /**
     * 
     * @type {MCPServerAuthType}
     * @memberof MCPServerAuthOutput
     */
    'auth_type'?: MCPServerAuthType;
    /**
     * 
     * @type {AuthSettings}
     * @memberof MCPServerAuthOutput
     */
    'auth_settings'?: AuthSettings | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MCPServerAuthType = {
    NoAuth: 'NoAuth',
    ApiKey: 'ApiKey',
    OAuth2: 'OAuth2',
    Elma365: 'ELMA365'
} as const;

export type MCPServerAuthType = typeof MCPServerAuthType[keyof typeof MCPServerAuthType];


/**
 * 
 * @export
 * @interface MCPServerHTTPHeader
 */
export interface MCPServerHTTPHeader {
    /**
     * 
     * @type {boolean}
     * @memberof MCPServerHTTPHeader
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof MCPServerHTTPHeader
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerHTTPHeader
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface MCPServerToolCallData
 */
export interface MCPServerToolCallData {
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolCallData
     */
    'toolset_settings_type'?: MCPServerToolCallDataToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolCallData
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolCallData
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolCallData
     */
    'server_url': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MCPServerToolCallData
     */
    'input_schema': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MCPServerToolCallData
     */
    'output_schema'?: { [key: string]: any; } | null;
}

export const MCPServerToolCallDataToolsetSettingsTypeEnum = {
    McpServer: 'MCPServer'
} as const;

export type MCPServerToolCallDataToolsetSettingsTypeEnum = typeof MCPServerToolCallDataToolsetSettingsTypeEnum[keyof typeof MCPServerToolCallDataToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface MCPServerToolsetSettingsInput
 */
export interface MCPServerToolsetSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolsetSettingsInput
     */
    'toolset_type'?: MCPServerToolsetSettingsInputToolsetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolsetSettingsInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolsetSettingsInput
     */
    'server_url': string;
    /**
     * 
     * @type {MCPServerAuthInput}
     * @memberof MCPServerToolsetSettingsInput
     */
    'server_auth': MCPServerAuthInput;
    /**
     * 
     * @type {MCPServerTransport}
     * @memberof MCPServerToolsetSettingsInput
     */
    'server_transport': MCPServerTransport;
    /**
     * 
     * @type {Array<MCPServerHTTPHeader>}
     * @memberof MCPServerToolsetSettingsInput
     */
    'http_headers': Array<MCPServerHTTPHeader>;
}

export const MCPServerToolsetSettingsInputToolsetTypeEnum = {
    McpServer: 'MCPServer'
} as const;

export type MCPServerToolsetSettingsInputToolsetTypeEnum = typeof MCPServerToolsetSettingsInputToolsetTypeEnum[keyof typeof MCPServerToolsetSettingsInputToolsetTypeEnum];

/**
 * 
 * @export
 * @interface MCPServerToolsetSettingsOutput
 */
export interface MCPServerToolsetSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolsetSettingsOutput
     */
    'toolset_type'?: MCPServerToolsetSettingsOutputToolsetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolsetSettingsOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MCPServerToolsetSettingsOutput
     */
    'server_url': string;
    /**
     * 
     * @type {MCPServerAuthOutput}
     * @memberof MCPServerToolsetSettingsOutput
     */
    'server_auth': MCPServerAuthOutput;
    /**
     * 
     * @type {MCPServerTransport}
     * @memberof MCPServerToolsetSettingsOutput
     */
    'server_transport': MCPServerTransport;
    /**
     * 
     * @type {Array<MCPServerHTTPHeader>}
     * @memberof MCPServerToolsetSettingsOutput
     */
    'http_headers': Array<MCPServerHTTPHeader>;
}

export const MCPServerToolsetSettingsOutputToolsetTypeEnum = {
    McpServer: 'MCPServer'
} as const;

export type MCPServerToolsetSettingsOutputToolsetTypeEnum = typeof MCPServerToolsetSettingsOutputToolsetTypeEnum[keyof typeof MCPServerToolsetSettingsOutputToolsetTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const MCPServerTransport = {
    Sse: 'SSE',
    Streamable: 'Streamable'
} as const;

export type MCPServerTransport = typeof MCPServerTransport[keyof typeof MCPServerTransport];


/**
 * 
 * @export
 * @enum {string}
 */

export const MaskingDemaskingMode = {
    OnlyMasking: 'OnlyMasking',
    WithDemasking: 'WithDemasking'
} as const;

export type MaskingDemaskingMode = typeof MaskingDemaskingMode[keyof typeof MaskingDemaskingMode];


/**
 * 
 * @export
 * @enum {string}
 */

export const MaskingMode = {
    Disabled: 'Disabled',
    ReplaceWithFake: 'ReplaceWithFake',
    ReplaceWithToken: 'ReplaceWithToken'
} as const;

export type MaskingMode = typeof MaskingMode[keyof typeof MaskingMode];


/**
 * 
 * @export
 * @interface MaskingSettingsInput
 */
export interface MaskingSettingsInput {
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof MaskingSettingsInput
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {MaskingMode}
     * @memberof MaskingSettingsInput
     */
    'mode'?: MaskingMode;
    /**
     * 
     * @type {MaskingDemaskingMode}
     * @memberof MaskingSettingsInput
     */
    'demasking_mode'?: MaskingDemaskingMode;
    /**
     * 
     * @type {MaskingTokenMetaMode}
     * @memberof MaskingSettingsInput
     */
    'token_meta'?: MaskingTokenMetaMode;
    /**
     * 
     * @type {string}
     * @memberof MaskingSettingsInput
     */
    'custom_prompt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MaskingSettingsInput
     */
    'detect_all_supported_entity_types'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaskingSettingsInput
     */
    'builtin_entities'?: Array<string>;
    /**
     * 
     * @type {Array<MaskingSettingsInputDetectorsInner>}
     * @memberof MaskingSettingsInput
     */
    'detectors'?: Array<MaskingSettingsInputDetectorsInner>;
}


/**
 * @type MaskingSettingsInputDetectorsInner
 * @export
 */
export type MaskingSettingsInputDetectorsInner = { type: 'External' } & ExternalMaskingDetectorSettingsInput | { type: 'Regex' } & RegexMaskingDetectorSettings;

/**
 * 
 * @export
 * @interface MaskingSettingsOutput
 */
export interface MaskingSettingsOutput {
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof MaskingSettingsOutput
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {MaskingMode}
     * @memberof MaskingSettingsOutput
     */
    'mode'?: MaskingMode;
    /**
     * 
     * @type {MaskingDemaskingMode}
     * @memberof MaskingSettingsOutput
     */
    'demasking_mode'?: MaskingDemaskingMode;
    /**
     * 
     * @type {MaskingTokenMetaMode}
     * @memberof MaskingSettingsOutput
     */
    'token_meta'?: MaskingTokenMetaMode;
    /**
     * 
     * @type {string}
     * @memberof MaskingSettingsOutput
     */
    'custom_prompt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MaskingSettingsOutput
     */
    'detect_all_supported_entity_types'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaskingSettingsOutput
     */
    'builtin_entities'?: Array<string>;
    /**
     * 
     * @type {Array<MaskingSettingsOutputDetectorsInner>}
     * @memberof MaskingSettingsOutput
     */
    'detectors'?: Array<MaskingSettingsOutputDetectorsInner>;
}


/**
 * @type MaskingSettingsOutputDetectorsInner
 * @export
 */
export type MaskingSettingsOutputDetectorsInner = { type: 'External' } & ExternalMaskingDetectorSettingsOutput | { type: 'Regex' } & RegexMaskingDetectorSettings;

/**
 * 
 * @export
 * @enum {string}
 */

export const MaskingTokenMetaMode = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type MaskingTokenMetaMode = typeof MaskingTokenMetaMode[keyof typeof MaskingTokenMetaMode];


/**
 * Message role.
 * @export
 * @enum {string}
 */

export const MessageRole = {
    System: 'system',
    Developer: 'developer',
    User: 'user',
    Assistant: 'assistant',
    Function: 'function',
    Tool: 'tool',
    Chatbot: 'chatbot',
    Model: 'model'
} as const;

export type MessageRole = typeof MessageRole[keyof typeof MessageRole];


/**
 * 
 * @export
 * @interface MetadataFiltersValue
 */
export interface MetadataFiltersValue {
}
/**
 * 
 * @export
 * @interface MetadataFiltersValueAnyOfInner
 */
export interface MetadataFiltersValueAnyOfInner {
}
/**
 * 
 * @export
 * @interface Name
 */
export interface Name {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NodeParsingMode = {
    Chunk: 'CHUNK',
    SentenceWindow: 'SENTENCE_WINDOW',
    Llm: 'LLM'
} as const;

export type NodeParsingMode = typeof NodeParsingMode[keyof typeof NodeParsingMode];


/**
 * Node relationships used in `BaseNode` class.  Attributes:     SOURCE: The node is the source document.     PREVIOUS: The node is the previous node in the document.     NEXT: The node is the next node in the document.     PARENT: The node is the parent node in the document.     CHILD: The node is a child node in the document.
 * @export
 * @enum {string}
 */

export const NodeRelationship = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5'
} as const;

export type NodeRelationship = typeof NodeRelationship[keyof typeof NodeRelationship];


/**
 * 
 * @export
 * @interface NodeType
 */
export interface NodeType {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ObjectType = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5'
} as const;

export type ObjectType = typeof ObjectType[keyof typeof ObjectType];


/**
 * 
 * @export
 * @interface OpenAILikeProviderSettingsInput
 */
export interface OpenAILikeProviderSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof OpenAILikeProviderSettingsInput
     */
    'provider_type'?: OpenAILikeProviderSettingsInputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof OpenAILikeProviderSettingsInput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase>}
     * @memberof OpenAILikeProviderSettingsInput
     */
    'models'?: Array<ProviderModelItemBase>;
    /**
     * 
     * @type {string}
     * @memberof OpenAILikeProviderSettingsInput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenAILikeProviderSettingsInput
     */
    'api_base'?: string | null;
}

export const OpenAILikeProviderSettingsInputProviderTypeEnum = {
    OpenaiLike: 'OPENAI_LIKE'
} as const;

export type OpenAILikeProviderSettingsInputProviderTypeEnum = typeof OpenAILikeProviderSettingsInputProviderTypeEnum[keyof typeof OpenAILikeProviderSettingsInputProviderTypeEnum];

/**
 * 
 * @export
 * @interface OpenAILikeProviderSettingsOutput
 */
export interface OpenAILikeProviderSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof OpenAILikeProviderSettingsOutput
     */
    'provider_type'?: OpenAILikeProviderSettingsOutputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof OpenAILikeProviderSettingsOutput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase1>}
     * @memberof OpenAILikeProviderSettingsOutput
     */
    'models'?: Array<ProviderModelItemBase1>;
    /**
     * 
     * @type {string}
     * @memberof OpenAILikeProviderSettingsOutput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenAILikeProviderSettingsOutput
     */
    'api_base'?: string | null;
}

export const OpenAILikeProviderSettingsOutputProviderTypeEnum = {
    OpenaiLike: 'OPENAI_LIKE'
} as const;

export type OpenAILikeProviderSettingsOutputProviderTypeEnum = typeof OpenAILikeProviderSettingsOutputProviderTypeEnum[keyof typeof OpenAILikeProviderSettingsOutputProviderTypeEnum];

/**
 * 
 * @export
 * @interface OpenAIProviderSettingsInput
 */
export interface OpenAIProviderSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof OpenAIProviderSettingsInput
     */
    'provider_type'?: OpenAIProviderSettingsInputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof OpenAIProviderSettingsInput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase>}
     * @memberof OpenAIProviderSettingsInput
     */
    'models'?: Array<ProviderModelItemBase>;
    /**
     * 
     * @type {string}
     * @memberof OpenAIProviderSettingsInput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenAIProviderSettingsInput
     */
    'api_base'?: string | null;
}

export const OpenAIProviderSettingsInputProviderTypeEnum = {
    Openai: 'OPENAI'
} as const;

export type OpenAIProviderSettingsInputProviderTypeEnum = typeof OpenAIProviderSettingsInputProviderTypeEnum[keyof typeof OpenAIProviderSettingsInputProviderTypeEnum];

/**
 * 
 * @export
 * @interface OpenAIProviderSettingsOutput
 */
export interface OpenAIProviderSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof OpenAIProviderSettingsOutput
     */
    'provider_type'?: OpenAIProviderSettingsOutputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof OpenAIProviderSettingsOutput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase1>}
     * @memberof OpenAIProviderSettingsOutput
     */
    'models'?: Array<ProviderModelItemBase1>;
    /**
     * 
     * @type {string}
     * @memberof OpenAIProviderSettingsOutput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OpenAIProviderSettingsOutput
     */
    'api_base'?: string | null;
}

export const OpenAIProviderSettingsOutputProviderTypeEnum = {
    Openai: 'OPENAI'
} as const;

export type OpenAIProviderSettingsOutputProviderTypeEnum = typeof OpenAIProviderSettingsOutputProviderTypeEnum[keyof typeof OpenAIProviderSettingsOutputProviderTypeEnum];

/**
 * 
 * @export
 * @interface OperationModel
 */
export interface OperationModel {
    /**
     * 
     * @type {string}
     * @memberof OperationModel
     */
    'operation_id': string;
    /**
     * 
     * @type {string}
     * @memberof OperationModel
     */
    'subject_id': string;
    /**
     * 
     * @type {OperationStatus}
     * @memberof OperationModel
     */
    'status': OperationStatus;
    /**
     * 
     * @type {Duration}
     * @memberof OperationModel
     */
    'duration'?: Duration | null;
    /**
     * 
     * @type {OperationProgress}
     * @memberof OperationModel
     */
    'progress': OperationProgress;
    /**
     * 
     * @type {OperationProblem}
     * @memberof OperationModel
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @interface OperationProblem
 */
export interface OperationProblem {
    /**
     * 
     * @type {ProblemDetails}
     * @memberof OperationProblem
     */
    'details': ProblemDetails;
}
/**
 * 
 * @export
 * @interface OperationProgress
 */
export interface OperationProgress {
    /**
     * 
     * @type {number}
     * @memberof OperationProgress
     */
    'maximum'?: number;
    /**
     * 
     * @type {number}
     * @memberof OperationProgress
     */
    'current'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OperationStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Success: 'Success',
    Error: 'Error',
    Failure: 'Failure'
} as const;

export type OperationStatus = typeof OperationStatus[keyof typeof OperationStatus];


/**
 * 
 * @export
 * @interface PaginationRequest
 */
export interface PaginationRequest {
    /**
     * 
     * @type {number}
     * @memberof PaginationRequest
     */
    'page_index'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationRequest
     */
    'page_size'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationRequest
     */
    'with_total'?: boolean;
}
/**
 * 
 * @export
 * @interface PaginationResponseAgentMessageModel
 */
export interface PaginationResponseAgentMessageModel {
    /**
     * 
     * @type {Array<AgentMessageModel>}
     * @memberof PaginationResponseAgentMessageModel
     */
    'items'?: Array<AgentMessageModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseAgentMessageModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentMessageModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentMessageModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentMessageModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentMessageModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentMessageModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentMessageModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseAgentModel
 */
export interface PaginationResponseAgentModel {
    /**
     * 
     * @type {Array<AgentModel>}
     * @memberof PaginationResponseAgentModel
     */
    'items'?: Array<AgentModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseAgentModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseAgentRelationModel
 */
export interface PaginationResponseAgentRelationModel {
    /**
     * 
     * @type {Array<AgentRelationModel>}
     * @memberof PaginationResponseAgentRelationModel
     */
    'items'?: Array<AgentRelationModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseAgentRelationModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRelationModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRelationModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRelationModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRelationModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRelationModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRelationModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseAgentResourceModel
 */
export interface PaginationResponseAgentResourceModel {
    /**
     * 
     * @type {Array<AgentResourceModel>}
     * @memberof PaginationResponseAgentResourceModel
     */
    'items'?: Array<AgentResourceModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseAgentResourceModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentResourceModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentResourceModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentResourceModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentResourceModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentResourceModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentResourceModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseAgentRunModel
 */
export interface PaginationResponseAgentRunModel {
    /**
     * 
     * @type {Array<AgentRunModel>}
     * @memberof PaginationResponseAgentRunModel
     */
    'items'?: Array<AgentRunModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseAgentRunModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRunModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRunModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRunModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRunModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRunModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentRunModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseAgentThreadModel
 */
export interface PaginationResponseAgentThreadModel {
    /**
     * 
     * @type {Array<AgentThreadModel>}
     * @memberof PaginationResponseAgentThreadModel
     */
    'items'?: Array<AgentThreadModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseAgentThreadModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentThreadModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentThreadModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentThreadModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentThreadModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentThreadModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseAgentThreadModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseApiKeyModel
 */
export interface PaginationResponseApiKeyModel {
    /**
     * 
     * @type {Array<ApiKeyModel>}
     * @memberof PaginationResponseApiKeyModel
     */
    'items'?: Array<ApiKeyModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseApiKeyModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseApiKeyModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseApiKeyModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseApiKeyModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseApiKeyModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseApiKeyModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseApiKeyModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseConnectorModel
 */
export interface PaginationResponseConnectorModel {
    /**
     * 
     * @type {Array<ConnectorModel>}
     * @memberof PaginationResponseConnectorModel
     */
    'items'?: Array<ConnectorModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseConnectorModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseConnectorModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseConnectorModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseConnectorModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseConnectorModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseConnectorModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseConnectorModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseELMA365ApplicationModel
 */
export interface PaginationResponseELMA365ApplicationModel {
    /**
     * 
     * @type {Array<ELMA365ApplicationModel>}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'items'?: Array<ELMA365ApplicationModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ApplicationModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseELMA365NamespaceModel
 */
export interface PaginationResponseELMA365NamespaceModel {
    /**
     * 
     * @type {Array<ELMA365NamespaceModel>}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'items'?: Array<ELMA365NamespaceModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365NamespaceModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseELMA365ProcessModel
 */
export interface PaginationResponseELMA365ProcessModel {
    /**
     * 
     * @type {Array<ELMA365ProcessModel>}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'items'?: Array<ELMA365ProcessModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ProcessModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseELMA365ToolModel
 */
export interface PaginationResponseELMA365ToolModel {
    /**
     * 
     * @type {Array<ELMA365ToolModel>}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'items'?: Array<ELMA365ToolModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseELMA365ToolsetModel
 */
export interface PaginationResponseELMA365ToolsetModel {
    /**
     * 
     * @type {Array<ELMA365ToolsetModel>}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'items'?: Array<ELMA365ToolsetModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365ToolsetModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseELMA365VersionModel
 */
export interface PaginationResponseELMA365VersionModel {
    /**
     * 
     * @type {Array<ELMA365VersionModel>}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'items'?: Array<ELMA365VersionModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseELMA365VersionModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseFileModel
 */
export interface PaginationResponseFileModel {
    /**
     * 
     * @type {Array<FileModel>}
     * @memberof PaginationResponseFileModel
     */
    'items'?: Array<FileModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseFileModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFileModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFileModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFileModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFileModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFileModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFileModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseFolderModel
 */
export interface PaginationResponseFolderModel {
    /**
     * 
     * @type {Array<FolderModel>}
     * @memberof PaginationResponseFolderModel
     */
    'items'?: Array<FolderModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseFolderModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFolderModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFolderModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFolderModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFolderModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFolderModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseFolderModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseIngestionArtifactModel
 */
export interface PaginationResponseIngestionArtifactModel {
    /**
     * 
     * @type {Array<IngestionArtifactModel>}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'items'?: Array<IngestionArtifactModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionArtifactModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseIngestionProcessModel
 */
export interface PaginationResponseIngestionProcessModel {
    /**
     * 
     * @type {Array<IngestionProcessModel>}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'items'?: Array<IngestionProcessModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionProcessModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseIngestionResourceModel
 */
export interface PaginationResponseIngestionResourceModel {
    /**
     * 
     * @type {Array<IngestionResourceModel>}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'items'?: Array<IngestionResourceModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionResourceModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseIngestionSignalModel
 */
export interface PaginationResponseIngestionSignalModel {
    /**
     * 
     * @type {Array<IngestionSignalModel>}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'items'?: Array<IngestionSignalModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSignalModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseIngestionSourceModel
 */
export interface PaginationResponseIngestionSourceModel {
    /**
     * 
     * @type {Array<IngestionSourceModelOutput>}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'items'?: Array<IngestionSourceModelOutput>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseIngestionSourceModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseOperationModel
 */
export interface PaginationResponseOperationModel {
    /**
     * 
     * @type {Array<OperationModel>}
     * @memberof PaginationResponseOperationModel
     */
    'items'?: Array<OperationModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseOperationModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseOperationModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseOperationModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseOperationModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseOperationModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseOperationModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseOperationModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseProjectModel
 */
export interface PaginationResponseProjectModel {
    /**
     * 
     * @type {Array<ProjectModel>}
     * @memberof PaginationResponseProjectModel
     */
    'items'?: Array<ProjectModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseProjectModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProjectModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProjectModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProjectModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProjectModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProjectModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProjectModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseProviderModel
 */
export interface PaginationResponseProviderModel {
    /**
     * 
     * @type {Array<ProviderModel>}
     * @memberof PaginationResponseProviderModel
     */
    'items'?: Array<ProviderModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseProviderModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProviderModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProviderModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProviderModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProviderModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProviderModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseProviderModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseSearchMessageModel
 */
export interface PaginationResponseSearchMessageModel {
    /**
     * 
     * @type {Array<SearchMessageModel>}
     * @memberof PaginationResponseSearchMessageModel
     */
    'items'?: Array<SearchMessageModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseSearchMessageModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchMessageModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchMessageModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchMessageModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchMessageModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchMessageModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchMessageModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseSearchRunModel
 */
export interface PaginationResponseSearchRunModel {
    /**
     * 
     * @type {Array<SearchRunModel>}
     * @memberof PaginationResponseSearchRunModel
     */
    'items'?: Array<SearchRunModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseSearchRunModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchRunModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchRunModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchRunModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchRunModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchRunModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchRunModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseSearchThreadModel
 */
export interface PaginationResponseSearchThreadModel {
    /**
     * 
     * @type {Array<SearchThreadModel>}
     * @memberof PaginationResponseSearchThreadModel
     */
    'items'?: Array<SearchThreadModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseSearchThreadModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchThreadModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchThreadModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchThreadModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchThreadModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchThreadModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseSearchThreadModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseToolsetModel
 */
export interface PaginationResponseToolsetModel {
    /**
     * 
     * @type {Array<ToolsetModel>}
     * @memberof PaginationResponseToolsetModel
     */
    'items'?: Array<ToolsetModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseToolsetModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseToolsetModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseToolsetModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseToolsetModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseToolsetModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseToolsetModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseToolsetModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface PaginationResponseTraceProviderModel
 */
export interface PaginationResponseTraceProviderModel {
    /**
     * 
     * @type {Array<TraceProviderModel>}
     * @memberof PaginationResponseTraceProviderModel
     */
    'items'?: Array<TraceProviderModel>;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationResponseTraceProviderModel
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseTraceProviderModel
     */
    'page_index': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseTraceProviderModel
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseTraceProviderModel
     */
    'total_item_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseTraceProviderModel
     */
    'total_page_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseTraceProviderModel
     */
    'from_item_inclusive'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseTraceProviderModel
     */
    'to_item_exclusive'?: number | null;
}
/**
 * 
 * @export
 * @interface ParaphraseSettings
 */
export interface ParaphraseSettings {
    /**
     * 
     * @type {boolean}
     * @memberof ParaphraseSettings
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {LLMSettings}
     * @memberof ParaphraseSettings
     */
    'llm'?: LLMSettings | null;
    /**
     * 
     * @type {string}
     * @memberof ParaphraseSettings
     */
    'query_generation_prompt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ParaphraseSettings
     */
    'num_queries'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ParaphraseSettings
     */
    'top_k'?: number | null;
}
/**
 * 
 * @export
 * @interface Path
 */
export interface Path {
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail': string;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProblemDetails
     */
    'extensions'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ProjectAgentToolsInput
 */
export interface ProjectAgentToolsInput {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectAgentToolsInput
     */
    'mcp_server_enabled'?: boolean;
    /**
     * 
     * @type {ProjectAgentToolsMode}
     * @memberof ProjectAgentToolsInput
     */
    'mode'?: ProjectAgentToolsMode;
    /**
     * 
     * @type {ProjectAsToolSettings}
     * @memberof ProjectAgentToolsInput
     */
    'project_as_tool'?: ProjectAsToolSettings;
    /**
     * 
     * @type {SourceAsToolSettings}
     * @memberof ProjectAgentToolsInput
     */
    'source_as_tool'?: SourceAsToolSettings;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProjectAgentToolsMode = {
    ProjectAsTool: 'ProjectAsTool',
    SourceAsTool: 'SourceAsTool'
} as const;

export type ProjectAgentToolsMode = typeof ProjectAgentToolsMode[keyof typeof ProjectAgentToolsMode];


/**
 * 
 * @export
 * @interface ProjectAgentToolsOutput
 */
export interface ProjectAgentToolsOutput {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectAgentToolsOutput
     */
    'mcp_server_enabled'?: boolean;
    /**
     * 
     * @type {ProjectAgentToolsMode}
     * @memberof ProjectAgentToolsOutput
     */
    'mode'?: ProjectAgentToolsMode;
    /**
     * 
     * @type {ProjectAsToolSettings}
     * @memberof ProjectAgentToolsOutput
     */
    'project_as_tool'?: ProjectAsToolSettings;
    /**
     * 
     * @type {SourceAsToolSettings}
     * @memberof ProjectAgentToolsOutput
     */
    'source_as_tool'?: SourceAsToolSettings;
}


/**
 * 
 * @export
 * @interface ProjectAsToolSettings
 */
export interface ProjectAsToolSettings {
    /**
     * 
     * @type {ToolSettings}
     * @memberof ProjectAsToolSettings
     */
    'tool'?: ToolSettings;
}
/**
 * 
 * @export
 * @interface ProjectCreationRequest
 */
export interface ProjectCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectCreationRequest
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCreationRequest
     */
    'name': string;
    /**
     * 
     * @type {ProjectPipelineInput}
     * @memberof ProjectCreationRequest
     */
    'pipeline'?: ProjectPipelineInput | null;
    /**
     * 
     * @type {ProjectWidgetInput}
     * @memberof ProjectCreationRequest
     */
    'widget'?: ProjectWidgetInput | null;
    /**
     * 
     * @type {ProjectAgentToolsInput}
     * @memberof ProjectCreationRequest
     */
    'agent_tools'?: ProjectAgentToolsInput | null;
}
/**
 * 
 * @export
 * @interface ProjectCreationResponse
 */
export interface ProjectCreationResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectCreationResponse
     */
    'project_id': string;
}
/**
 * 
 * @export
 * @interface ProjectImportBody
 */
export interface ProjectImportBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof ProjectImportBody
     */
    'content': ContentJSONFile;
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof ProjectImportBody
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface ProjectImportResponse
 */
export interface ProjectImportResponse {
    /**
     * 
     * @type {ProjectModel}
     * @memberof ProjectImportResponse
     */
    'project': ProjectModel;
}
/**
 * 
 * @export
 * @interface ProjectInspectionBody
 */
export interface ProjectInspectionBody {
    /**
     * 
     * @type {ContentJSONFile}
     * @memberof ProjectInspectionBody
     */
    'content': ContentJSONFile;
}
/**
 * 
 * @export
 * @interface ProjectInspectionResponse
 */
export interface ProjectInspectionResponse {
    /**
     * 
     * @type {Array<ExchangeDependency>}
     * @memberof ProjectInspectionResponse
     */
    'dependencies': Array<ExchangeDependency>;
}
/**
 * 
 * @export
 * @interface ProjectModel
 */
export interface ProjectModel {
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'modified_on': string;
    /**
     * 
     * @type {ProjectPipelineOutput}
     * @memberof ProjectModel
     */
    'pipeline': ProjectPipelineOutput;
    /**
     * 
     * @type {ProjectWidgetOutput}
     * @memberof ProjectModel
     */
    'widget': ProjectWidgetOutput;
    /**
     * 
     * @type {ProjectAgentToolsOutput}
     * @memberof ProjectModel
     */
    'agent_tools': ProjectAgentToolsOutput;
}
/**
 * 
 * @export
 * @interface ProjectPipelineInput
 */
export interface ProjectPipelineInput {
    /**
     * 
     * @type {IngestionPipelineInput}
     * @memberof ProjectPipelineInput
     */
    'ingestion'?: IngestionPipelineInput;
    /**
     * 
     * @type {SearchPipelineInput}
     * @memberof ProjectPipelineInput
     */
    'search'?: SearchPipelineInput;
    /**
     * 
     * @type {TraceSettings}
     * @memberof ProjectPipelineInput
     */
    'trace'?: TraceSettings;
}
/**
 * 
 * @export
 * @interface ProjectPipelineOutput
 */
export interface ProjectPipelineOutput {
    /**
     * 
     * @type {IngestionPipelineOutput}
     * @memberof ProjectPipelineOutput
     */
    'ingestion'?: IngestionPipelineOutput;
    /**
     * 
     * @type {SearchPipelineOutput}
     * @memberof ProjectPipelineOutput
     */
    'search'?: SearchPipelineOutput;
    /**
     * 
     * @type {TraceSettings}
     * @memberof ProjectPipelineOutput
     */
    'trace'?: TraceSettings;
}
/**
 * 
 * @export
 * @interface ProjectUpdatingRequest
 */
export interface ProjectUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof ProjectUpdatingRequest
     */
    'name': string;
    /**
     * 
     * @type {ProjectPipelineInput}
     * @memberof ProjectUpdatingRequest
     */
    'pipeline': ProjectPipelineInput;
    /**
     * 
     * @type {ProjectWidgetInput}
     * @memberof ProjectUpdatingRequest
     */
    'widget': ProjectWidgetInput;
    /**
     * 
     * @type {ProjectAgentToolsInput}
     * @memberof ProjectUpdatingRequest
     */
    'agent_tools': ProjectAgentToolsInput;
}
/**
 * 
 * @export
 * @interface ProjectWidgetInput
 */
export interface ProjectWidgetInput {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectWidgetInput
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectWidgetInput
     */
    'search_mode_enabled'?: boolean;
    /**
     * 
     * @type {WidgetWelcomeMessage}
     * @memberof ProjectWidgetInput
     */
    'welcome_message'?: WidgetWelcomeMessage;
    /**
     * 
     * @type {WidgetAppearance}
     * @memberof ProjectWidgetInput
     */
    'appearance'?: WidgetAppearance;
    /**
     * 
     * @type {WidgetToggleButton}
     * @memberof ProjectWidgetInput
     */
    'toggle_button'?: WidgetToggleButton;
}
/**
 * 
 * @export
 * @interface ProjectWidgetOutput
 */
export interface ProjectWidgetOutput {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectWidgetOutput
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectWidgetOutput
     */
    'search_mode_enabled'?: boolean;
    /**
     * 
     * @type {WidgetWelcomeMessage}
     * @memberof ProjectWidgetOutput
     */
    'welcome_message'?: WidgetWelcomeMessage;
    /**
     * 
     * @type {WidgetAppearance}
     * @memberof ProjectWidgetOutput
     */
    'appearance'?: WidgetAppearance;
    /**
     * 
     * @type {WidgetToggleButton}
     * @memberof ProjectWidgetOutput
     */
    'toggle_button'?: WidgetToggleButton;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PromptMode = {
    Simple: 'SIMPLE',
    Advanced: 'ADVANCED'
} as const;

export type PromptMode = typeof PromptMode[keyof typeof PromptMode];


/**
 * 
 * @export
 * @interface ProviderCreationRequest
 */
export interface ProviderCreationRequest {
    /**
     * 
     * @type {ProviderNames}
     * @memberof ProviderCreationRequest
     */
    'name': ProviderNames;
    /**
     * 
     * @type {string}
     * @memberof ProviderCreationRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCreationRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {ProviderSettingsInput}
     * @memberof ProviderCreationRequest
     */
    'settings': ProviderSettingsInput;
}


/**
 * 
 * @export
 * @interface ProviderCreationResponse
 */
export interface ProviderCreationResponse {
    /**
     * 
     * @type {string}
     * @memberof ProviderCreationResponse
     */
    'provider_id': string;
}
/**
 * 
 * @export
 * @interface ProviderEmbeddingCheckingRequest
 */
export interface ProviderEmbeddingCheckingRequest {
    /**
     * 
     * @type {EmbeddingSettings}
     * @memberof ProviderEmbeddingCheckingRequest
     */
    'embedding_settings': EmbeddingSettings;
    /**
     * 
     * @type {string}
     * @memberof ProviderEmbeddingCheckingRequest
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface ProviderEmbeddingCheckingResponse
 */
export interface ProviderEmbeddingCheckingResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof ProviderEmbeddingCheckingResponse
     */
    'embedding': Array<number>;
}
/**
 * 
 * @export
 * @interface ProviderLLMCheckingRequest
 */
export interface ProviderLLMCheckingRequest {
    /**
     * 
     * @type {LLMSettings}
     * @memberof ProviderLLMCheckingRequest
     */
    'llm_settings': LLMSettings;
    /**
     * 
     * @type {string}
     * @memberof ProviderLLMCheckingRequest
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface ProviderLLMCheckingResponse
 */
export interface ProviderLLMCheckingResponse {
    /**
     * 
     * @type {string}
     * @memberof ProviderLLMCheckingResponse
     */
    'llm_answer': string;
}
/**
 * 
 * @export
 * @interface ProviderModel
 */
export interface ProviderModel {
    /**
     * 
     * @type {string}
     * @memberof ProviderModel
     */
    'provider_id': string;
    /**
     * 
     * @type {ProviderNames}
     * @memberof ProviderModel
     */
    'name': ProviderNames;
    /**
     * 
     * @type {string}
     * @memberof ProviderModel
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderModel
     */
    'enabled': boolean;
    /**
     * 
     * @type {ProviderSettingsOutput}
     * @memberof ProviderModel
     */
    'settings': ProviderSettingsOutput;
}


/**
 * @type ProviderModelItemBase
 * @export
 */
export type ProviderModelItemBase = { type: 'EMBEDDING' } & ProviderModelsItemBaseTypeInput | { type: 'LLM' } & ProviderModelsItemBaseTypeInput | { type: 'RERANK' } & ProviderModelsItemBaseTypeInput;

/**
 * @type ProviderModelItemBase1
 * @export
 */
export type ProviderModelItemBase1 = { type: 'EMBEDDING' } & ProviderModelsItemBaseTypeOutput | { type: 'LLM' } & ProviderModelsItemBaseTypeOutput | { type: 'RERANK' } & ProviderModelsItemBaseTypeOutput;

/**
 * 
 * @export
 * @enum {string}
 */

export const ProviderModelOriginType = {
    System: 'SYSTEM',
    Custom: 'CUSTOM'
} as const;

export type ProviderModelOriginType = typeof ProviderModelOriginType[keyof typeof ProviderModelOriginType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ProviderModelType = {
    Llm: 'LLM',
    Embedding: 'EMBEDDING',
    Rerank: 'RERANK'
} as const;

export type ProviderModelType = typeof ProviderModelType[keyof typeof ProviderModelType];


/**
 * 
 * @export
 * @interface ProviderModelsEmbeddingItem
 */
export interface ProviderModelsEmbeddingItem {
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsEmbeddingItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsEmbeddingItem
     */
    'type': ProviderModelsEmbeddingItemTypeEnum;
    /**
     * 
     * @type {ProviderModelOriginType}
     * @memberof ProviderModelsEmbeddingItem
     */
    'origin_type'?: ProviderModelOriginType;
    /**
     * 
     * @type {number}
     * @memberof ProviderModelsEmbeddingItem
     */
    'context_window'?: number | null;
}

export const ProviderModelsEmbeddingItemTypeEnum = {
    Embedding: 'EMBEDDING'
} as const;

export type ProviderModelsEmbeddingItemTypeEnum = typeof ProviderModelsEmbeddingItemTypeEnum[keyof typeof ProviderModelsEmbeddingItemTypeEnum];

/**
 * 
 * @export
 * @interface ProviderModelsItemBaseTypeInput
 */
export interface ProviderModelsItemBaseTypeInput {
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsItemBaseTypeInput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsItemBaseTypeInput
     */
    'type': ProviderModelsItemBaseTypeInputTypeEnum;
    /**
     * 
     * @type {ProviderModelOriginType}
     * @memberof ProviderModelsItemBaseTypeInput
     */
    'origin_type'?: ProviderModelOriginType;
    /**
     * 
     * @type {number}
     * @memberof ProviderModelsItemBaseTypeInput
     */
    'context_window'?: number;
}

export const ProviderModelsItemBaseTypeInputTypeEnum = {
    Llm: 'LLM',
    Embedding: 'EMBEDDING',
    Rerank: 'RERANK'
} as const;

export type ProviderModelsItemBaseTypeInputTypeEnum = typeof ProviderModelsItemBaseTypeInputTypeEnum[keyof typeof ProviderModelsItemBaseTypeInputTypeEnum];

/**
 * 
 * @export
 * @interface ProviderModelsItemBaseTypeOutput
 */
export interface ProviderModelsItemBaseTypeOutput {
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsItemBaseTypeOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsItemBaseTypeOutput
     */
    'type': ProviderModelsItemBaseTypeOutputTypeEnum;
    /**
     * 
     * @type {ProviderModelOriginType}
     * @memberof ProviderModelsItemBaseTypeOutput
     */
    'origin_type'?: ProviderModelOriginType;
    /**
     * 
     * @type {number}
     * @memberof ProviderModelsItemBaseTypeOutput
     */
    'context_window'?: number;
}

export const ProviderModelsItemBaseTypeOutputTypeEnum = {
    Llm: 'LLM',
    Embedding: 'EMBEDDING',
    Rerank: 'RERANK'
} as const;

export type ProviderModelsItemBaseTypeOutputTypeEnum = typeof ProviderModelsItemBaseTypeOutputTypeEnum[keyof typeof ProviderModelsItemBaseTypeOutputTypeEnum];

/**
 * 
 * @export
 * @interface ProviderModelsLLMItem
 */
export interface ProviderModelsLLMItem {
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsLLMItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsLLMItem
     */
    'type': ProviderModelsLLMItemTypeEnum;
    /**
     * 
     * @type {ProviderModelOriginType}
     * @memberof ProviderModelsLLMItem
     */
    'origin_type'?: ProviderModelOriginType;
    /**
     * 
     * @type {number}
     * @memberof ProviderModelsLLMItem
     */
    'context_window'?: number | null;
}

export const ProviderModelsLLMItemTypeEnum = {
    Llm: 'LLM'
} as const;

export type ProviderModelsLLMItemTypeEnum = typeof ProviderModelsLLMItemTypeEnum[keyof typeof ProviderModelsLLMItemTypeEnum];

/**
 * 
 * @export
 * @interface ProviderModelsRerankItem
 */
export interface ProviderModelsRerankItem {
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsRerankItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderModelsRerankItem
     */
    'type': ProviderModelsRerankItemTypeEnum;
    /**
     * 
     * @type {ProviderModelOriginType}
     * @memberof ProviderModelsRerankItem
     */
    'origin_type'?: ProviderModelOriginType;
}

export const ProviderModelsRerankItemTypeEnum = {
    Rerank: 'RERANK'
} as const;

export type ProviderModelsRerankItemTypeEnum = typeof ProviderModelsRerankItemTypeEnum[keyof typeof ProviderModelsRerankItemTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ProviderNames = {
    Openai: 'OPENAI',
    OpenaiLike: 'OPENAI_LIKE',
    Deepinfra: 'DEEPINFRA',
    Yandex: 'YANDEX',
    Gigachat: 'GIGACHAT',
    Vllm: 'VLLM',
    Infinity: 'INFINITY'
} as const;

export type ProviderNames = typeof ProviderNames[keyof typeof ProviderNames];


/**
 * @type ProviderSettingsInput
 * @export
 */
export type ProviderSettingsInput = { provider_type: 'DEEPINFRA' } & DeepInfraProviderSettingsInput | { provider_type: 'GIGACHAT' } & GigaChatProviderSettingsInput | { provider_type: 'INFINITY' } & InfinityProviderSettingsInput | { provider_type: 'OPENAI' } & OpenAIProviderSettingsInput | { provider_type: 'OPENAI_LIKE' } & OpenAILikeProviderSettingsInput | { provider_type: 'VLLM' } & VllmProviderSettingsInput | { provider_type: 'YANDEX' } & YandexProviderSettingsInput;

/**
 * @type ProviderSettingsOutput
 * @export
 */
export type ProviderSettingsOutput = { provider_type: 'DEEPINFRA' } & DeepInfraProviderSettingsOutput | { provider_type: 'GIGACHAT' } & GigaChatProviderSettingsOutput | { provider_type: 'INFINITY' } & InfinityProviderSettingsOutput | { provider_type: 'OPENAI' } & OpenAIProviderSettingsOutput | { provider_type: 'OPENAI_LIKE' } & OpenAILikeProviderSettingsOutput | { provider_type: 'VLLM' } & VllmProviderSettingsOutput | { provider_type: 'YANDEX' } & YandexProviderSettingsOutput;

/**
 * 
 * @export
 * @interface ProviderUpdatingRequest
 */
export interface ProviderUpdatingRequest {
    /**
     * 
     * @type {ProviderNames}
     * @memberof ProviderUpdatingRequest
     */
    'name': ProviderNames;
    /**
     * 
     * @type {string}
     * @memberof ProviderUpdatingRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderUpdatingRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {ProviderSettingsInput}
     * @memberof ProviderUpdatingRequest
     */
    'settings': ProviderSettingsInput;
}


/**
 * 
 * @export
 * @interface ReadELMA365FileToolSettings
 */
export interface ReadELMA365FileToolSettings {
    /**
     * 
     * @type {string}
     * @memberof ReadELMA365FileToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadELMA365FileToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadELMA365FileToolSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof ReadELMA365FileToolSettings
     */
    'max_content_token_count': number;
}
/**
 * 
 * @export
 * @interface ReadFileToolSettings
 */
export interface ReadFileToolSettings {
    /**
     * 
     * @type {string}
     * @memberof ReadFileToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadFileToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadFileToolSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof ReadFileToolSettings
     */
    'max_content_token_count': number;
}
/**
 * 
 * @export
 * @interface ReassignELMA365TaskToolSettings
 */
export interface ReassignELMA365TaskToolSettings {
    /**
     * 
     * @type {string}
     * @memberof ReassignELMA365TaskToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReassignELMA365TaskToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReassignELMA365TaskToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface RegexCheckSettings
 */
export interface RegexCheckSettings {
    /**
     * 
     * @type {string}
     * @memberof RegexCheckSettings
     */
    'check_id'?: string;
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof RegexCheckSettings
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {string}
     * @memberof RegexCheckSettings
     */
    'type'?: RegexCheckSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RegexCheckSettings
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegexCheckSettings
     */
    'order'?: number;
    /**
     * 
     * @type {GuardrailBehavior}
     * @memberof RegexCheckSettings
     */
    'behavior'?: GuardrailBehavior;
    /**
     * 
     * @type {string}
     * @memberof RegexCheckSettings
     */
    'block_message'?: string;
    /**
     * 
     * @type {GuardrailErrorPolicy}
     * @memberof RegexCheckSettings
     */
    'on_error'?: GuardrailErrorPolicy;
    /**
     * 
     * @type {number}
     * @memberof RegexCheckSettings
     */
    'timeout_seconds'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RegexCheckSettings
     */
    'use_original_text_for_check'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegexCheckSettings
     */
    'patterns'?: Array<string>;
    /**
     * 
     * @type {Array<RegexFlag>}
     * @memberof RegexCheckSettings
     */
    'flags'?: Array<RegexFlag>;
}

export const RegexCheckSettingsTypeEnum = {
    RegexCheck: 'RegexCheck'
} as const;

export type RegexCheckSettingsTypeEnum = typeof RegexCheckSettingsTypeEnum[keyof typeof RegexCheckSettingsTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const RegexFlag = {
    IgnoreCase: 'IgnoreCase',
    Multiline: 'Multiline',
    DotAll: 'DotAll',
    Ascii: 'Ascii'
} as const;

export type RegexFlag = typeof RegexFlag[keyof typeof RegexFlag];


/**
 * 
 * @export
 * @interface RegexMaskingDetectorSettings
 */
export interface RegexMaskingDetectorSettings {
    /**
     * 
     * @type {string}
     * @memberof RegexMaskingDetectorSettings
     */
    'detector_id'?: string;
    /**
     * 
     * @type {GuardrailSettingsState}
     * @memberof RegexMaskingDetectorSettings
     */
    'state'?: GuardrailSettingsState;
    /**
     * 
     * @type {string}
     * @memberof RegexMaskingDetectorSettings
     */
    'type'?: RegexMaskingDetectorSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RegexMaskingDetectorSettings
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegexMaskingDetectorSettings
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegexMaskingDetectorSettings
     */
    'entity_type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegexMaskingDetectorSettings
     */
    'patterns'?: Array<string>;
    /**
     * 
     * @type {Array<RegexFlag>}
     * @memberof RegexMaskingDetectorSettings
     */
    'flags'?: Array<RegexFlag>;
}

export const RegexMaskingDetectorSettingsTypeEnum = {
    Regex: 'Regex'
} as const;

export type RegexMaskingDetectorSettingsTypeEnum = typeof RegexMaskingDetectorSettingsTypeEnum[keyof typeof RegexMaskingDetectorSettingsTypeEnum];

/**
 * 
 * @export
 * @interface RelatedNodeInfoInput
 */
export interface RelatedNodeInfoInput {
    /**
     * 
     * @type {string}
     * @memberof RelatedNodeInfoInput
     */
    'node_id': string;
    /**
     * 
     * @type {NodeType}
     * @memberof RelatedNodeInfoInput
     */
    'node_type'?: NodeType | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RelatedNodeInfoInput
     */
    'metadata'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof RelatedNodeInfoInput
     */
    'hash'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedNodeInfoInput
     */
    'class_name'?: string;
}
/**
 * 
 * @export
 * @interface RelatedNodeInfoOutput
 */
export interface RelatedNodeInfoOutput {
    [key: string]: any;

}
/**
 * 
 * @export
 * @interface RelationsValue
 */
export interface RelationsValue {
}
/**
 * @type Request
 * @export
 */
export type Request = { source_type: 'Agent' } & SessionCreationByAgentRequest | { source_type: 'Connector' } & SessionCreationByConnectorRequest;

/**
 * @type Request1
 * @export
 */
export type Request1 = { source_type: 'Agent' } & SessionAssertByAgentRequest | { source_type: 'Connector' } & SessionAssertByConnectorRequest;

/**
 * 
 * @export
 * @enum {string}
 */

export const RerankMode = {
    Llm: 'LLM'
} as const;

export type RerankMode = typeof RerankMode[keyof typeof RerankMode];


/**
 * 
 * @export
 * @interface RerankSettingsInput
 */
export interface RerankSettingsInput {
    /**
     * 
     * @type {boolean}
     * @memberof RerankSettingsInput
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {RerankMode}
     * @memberof RerankSettingsInput
     */
    'rerank_mode'?: RerankMode | null;
    /**
     * 
     * @type {number}
     * @memberof RerankSettingsInput
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {LLMRerankerSettings}
     * @memberof RerankSettingsInput
     */
    'llm_reranker'?: LLMRerankerSettings;
}


/**
 * 
 * @export
 * @interface RerankSettingsOutput
 */
export interface RerankSettingsOutput {
    /**
     * 
     * @type {boolean}
     * @memberof RerankSettingsOutput
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {RerankMode}
     * @memberof RerankSettingsOutput
     */
    'rerank_mode'?: RerankMode | null;
    /**
     * 
     * @type {number}
     * @memberof RerankSettingsOutput
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {LLMRerankerSettings}
     * @memberof RerankSettingsOutput
     */
    'llm_reranker'?: LLMRerankerSettings;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RetrieveMode = {
    Nodes: 'NODES',
    Resources: 'RESOURCES'
} as const;

export type RetrieveMode = typeof RetrieveMode[keyof typeof RetrieveMode];


/**
 * 
 * @export
 * @interface RetrieveRequest
 */
export interface RetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof RetrieveRequest
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof RetrieveRequest
     */
    'user_message': string;
    /**
     * 
     * @type {number}
     * @memberof RetrieveRequest
     */
    'top_k'?: number | null;
}
/**
 * 
 * @export
 * @interface RetrieveResponse
 */
export interface RetrieveResponse {
    /**
     * 
     * @type {Array<SearchChunk>}
     * @memberof RetrieveResponse
     */
    'chunks': Array<SearchChunk>;
}
/**
 * 
 * @export
 * @interface RetrieveSettingsInput
 */
export interface RetrieveSettingsInput {
    /**
     * 
     * @type {number}
     * @memberof RetrieveSettingsInput
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {ParaphraseSettings}
     * @memberof RetrieveSettingsInput
     */
    'paraphrase'?: ParaphraseSettings;
    /**
     * 
     * @type {RetrieveMode}
     * @memberof RetrieveSettingsInput
     */
    'mode'?: RetrieveMode | null;
}


/**
 * 
 * @export
 * @interface RetrieveSettingsOutput
 */
export interface RetrieveSettingsOutput {
    /**
     * 
     * @type {number}
     * @memberof RetrieveSettingsOutput
     */
    'top_k'?: number | null;
    /**
     * 
     * @type {ParaphraseSettings}
     * @memberof RetrieveSettingsOutput
     */
    'paraphrase'?: ParaphraseSettings;
    /**
     * 
     * @type {RetrieveMode}
     * @memberof RetrieveSettingsOutput
     */
    'mode'?: RetrieveMode | null;
}


/**
 * 
 * @export
 * @interface RouteSettings
 */
export interface RouteSettings {
    /**
     * 
     * @type {string}
     * @memberof RouteSettings
     */
    'description': string;
    /**
     * 
     * @type {{ [key: string]: MetadataFiltersValue; }}
     * @memberof RouteSettings
     */
    'metadata_filters': { [key: string]: MetadataFiltersValue; };
}
/**
 * 
 * @export
 * @interface RoutingSelector
 */
export interface RoutingSelector {
    /**
     * 
     * @type {RoutingSelectorType}
     * @memberof RoutingSelector
     */
    'type'?: RoutingSelectorType;
    /**
     * 
     * @type {LLMSettings}
     * @memberof RoutingSelector
     */
    'llm'?: LLMSettings | null;
    /**
     * 
     * @type {string}
     * @memberof RoutingSelector
     */
    'single_selector_prompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoutingSelector
     */
    'multi_selector_prompt'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RoutingSelectorType = {
    LlmSingleSelector: 'LLM_SINGLE_SELECTOR',
    LlmMultiSelector: 'LLM_MULTI_SELECTOR'
} as const;

export type RoutingSelectorType = typeof RoutingSelectorType[keyof typeof RoutingSelectorType];


/**
 * 
 * @export
 * @interface RoutingSettingsInput
 */
export interface RoutingSettingsInput {
    /**
     * 
     * @type {boolean}
     * @memberof RoutingSettingsInput
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {RoutingSelector}
     * @memberof RoutingSettingsInput
     */
    'selector'?: RoutingSelector;
    /**
     * 
     * @type {Array<RouteSettings>}
     * @memberof RoutingSettingsInput
     */
    'routes'?: Array<RouteSettings>;
}
/**
 * 
 * @export
 * @interface RoutingSettingsOutput
 */
export interface RoutingSettingsOutput {
    /**
     * 
     * @type {boolean}
     * @memberof RoutingSettingsOutput
     */
    'enabled'?: boolean | null;
    /**
     * 
     * @type {RoutingSelector}
     * @memberof RoutingSettingsOutput
     */
    'selector'?: RoutingSelector;
    /**
     * 
     * @type {Array<RouteSettings>}
     * @memberof RoutingSettingsOutput
     */
    'routes'?: Array<RouteSettings>;
}
/**
 * 
 * @export
 * @interface ScheduleSettings
 */
export interface ScheduleSettings {
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ScheduleSettings
     */
    'daily_time'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ScheduleSettings
     */
    'weekly_times'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface SearchChunk
 */
export interface SearchChunk {
    /**
     * 
     * @type {string}
     * @memberof SearchChunk
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof SearchChunk
     */
    'score': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SearchChunk
     */
    'metadata': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface SearchELMA365TasksToolSettings
 */
export interface SearchELMA365TasksToolSettings {
    /**
     * 
     * @type {string}
     * @memberof SearchELMA365TasksToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchELMA365TasksToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchELMA365TasksToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface SearchMessageCreationRequest
 */
export interface SearchMessageCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchMessageCreationRequest
     */
    'thread_id': string;
    /**
     * 
     * @type {ChatMessage}
     * @memberof SearchMessageCreationRequest
     */
    'chat_message': ChatMessage;
}
/**
 * 
 * @export
 * @interface SearchMessageCreationResponse
 */
export interface SearchMessageCreationResponse {
    /**
     * 
     * @type {SearchMessageModel}
     * @memberof SearchMessageCreationResponse
     */
    'model': SearchMessageModel;
}
/**
 * 
 * @export
 * @interface SearchMessageModel
 */
export interface SearchMessageModel {
    /**
     * 
     * @type {string}
     * @memberof SearchMessageModel
     */
    'message_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMessageModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMessageModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMessageModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMessageModel
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchMessageModel
     */
    'run_id'?: string | null;
    /**
     * 
     * @type {ChatMessage}
     * @memberof SearchMessageModel
     */
    'chat_message': ChatMessage;
    /**
     * 
     * @type {Array<SearchChunk>}
     * @memberof SearchMessageModel
     */
    'chunks'?: Array<SearchChunk>;
}
/**
 * 
 * @export
 * @interface SearchPipelineInput
 */
export interface SearchPipelineInput {
    /**
     * 
     * @type {LLMSettings}
     * @memberof SearchPipelineInput
     */
    'llm'?: LLMSettings;
    /**
     * 
     * @type {SynthesizeSettings}
     * @memberof SearchPipelineInput
     */
    'synthesize'?: SynthesizeSettings;
    /**
     * 
     * @type {RetrieveSettingsInput}
     * @memberof SearchPipelineInput
     */
    'retrieve'?: RetrieveSettingsInput;
    /**
     * 
     * @type {RerankSettingsInput}
     * @memberof SearchPipelineInput
     */
    'rerank'?: RerankSettingsInput;
    /**
     * 
     * @type {RoutingSettingsInput}
     * @memberof SearchPipelineInput
     */
    'routing'?: RoutingSettingsInput;
}
/**
 * 
 * @export
 * @interface SearchPipelineOutput
 */
export interface SearchPipelineOutput {
    /**
     * 
     * @type {LLMSettings}
     * @memberof SearchPipelineOutput
     */
    'llm'?: LLMSettings;
    /**
     * 
     * @type {SynthesizeSettings}
     * @memberof SearchPipelineOutput
     */
    'synthesize'?: SynthesizeSettings;
    /**
     * 
     * @type {RetrieveSettingsOutput}
     * @memberof SearchPipelineOutput
     */
    'retrieve'?: RetrieveSettingsOutput;
    /**
     * 
     * @type {RerankSettingsOutput}
     * @memberof SearchPipelineOutput
     */
    'rerank'?: RerankSettingsOutput;
    /**
     * 
     * @type {RoutingSettingsOutput}
     * @memberof SearchPipelineOutput
     */
    'routing'?: RoutingSettingsOutput;
}
/**
 * 
 * @export
 * @interface SearchRunCreationRequest
 */
export interface SearchRunCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchRunCreationRequest
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchRunCreationRequest
     */
    'copilot_context'?: string | null;
    /**
     * 
     * @type {SearchPipelineInput}
     * @memberof SearchRunCreationRequest
     */
    'search_pipeline'?: SearchPipelineInput | null;
}
/**
 * 
 * @export
 * @interface SearchRunCreationResponse
 */
export interface SearchRunCreationResponse {
    /**
     * 
     * @type {SearchRunModel}
     * @memberof SearchRunCreationResponse
     */
    'model': SearchRunModel;
    /**
     * 
     * @type {string}
     * @memberof SearchRunCreationResponse
     */
    'operation_id': string;
}
/**
 * 
 * @export
 * @interface SearchRunExecutionTracing
 */
export interface SearchRunExecutionTracing {
    /**
     * 
     * @type {string}
     * @memberof SearchRunExecutionTracing
     */
    'trace_id'?: string | null;
}
/**
 * 
 * @export
 * @interface SearchRunModel
 */
export interface SearchRunModel {
    /**
     * 
     * @type {string}
     * @memberof SearchRunModel
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchRunModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchRunModel
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchRunModel
     */
    'project_id': string;
    /**
     * 
     * @type {SearchRunTracing}
     * @memberof SearchRunModel
     */
    'tracing': SearchRunTracing;
    /**
     * 
     * @type {string}
     * @memberof SearchRunModel
     */
    'copilot_context'?: string | null;
    /**
     * 
     * @type {SearchPipelineOutput}
     * @memberof SearchRunModel
     */
    'search_pipeline': SearchPipelineOutput;
    /**
     * 
     * @type {SearchRunStatus}
     * @memberof SearchRunModel
     */
    'status': SearchRunStatus;
    /**
     * 
     * @type {OperationProblem}
     * @memberof SearchRunModel
     */
    'problem'?: OperationProblem | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SearchRunStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Success: 'Success',
    Error: 'Error',
    Failure: 'Failure',
    Cancelled: 'Cancelled'
} as const;

export type SearchRunStatus = typeof SearchRunStatus[keyof typeof SearchRunStatus];


/**
 * 
 * @export
 * @interface SearchRunTracing
 */
export interface SearchRunTracing {
    /**
     * 
     * @type {SearchRunExecutionTracing}
     * @memberof SearchRunTracing
     */
    'execution': SearchRunExecutionTracing;
}
/**
 * 
 * @export
 * @interface SearchThreadCreationRequest
 */
export interface SearchThreadCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchThreadCreationRequest
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchThreadCreationRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchThreadCreationResponse
 */
export interface SearchThreadCreationResponse {
    /**
     * 
     * @type {SearchThreadModel}
     * @memberof SearchThreadCreationResponse
     */
    'model': SearchThreadModel;
}
/**
 * 
 * @export
 * @interface SearchThreadModel
 */
export interface SearchThreadModel {
    /**
     * 
     * @type {string}
     * @memberof SearchThreadModel
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchThreadModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchThreadModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof SearchThreadModel
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchThreadModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SearchThreadUpdatingRequest
 */
export interface SearchThreadUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchThreadUpdatingRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SentenceWindowNodeParsing
 */
export interface SentenceWindowNodeParsing {
    /**
     * 
     * @type {Tokenizer}
     * @memberof SentenceWindowNodeParsing
     */
    'tokenizer'?: Tokenizer;
    /**
     * 
     * @type {number}
     * @memberof SentenceWindowNodeParsing
     */
    'sentence_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SentenceWindowNodeParsing
     */
    'window_sentence_padding'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SentenceWindowNodeParsing
     */
    'sentence_min_length'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SentenceWindowNodeParsing
     */
    'sentence_max_length'?: number | null;
}
/**
 * 
 * @export
 * @interface SessionAssertByAgentRequest
 */
export interface SessionAssertByAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionAssertByAgentRequest
     */
    'source_type'?: SessionAssertByAgentRequestSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionAssertByAgentRequest
     */
    'agent_id': string;
}

export const SessionAssertByAgentRequestSourceTypeEnum = {
    Agent: 'Agent'
} as const;

export type SessionAssertByAgentRequestSourceTypeEnum = typeof SessionAssertByAgentRequestSourceTypeEnum[keyof typeof SessionAssertByAgentRequestSourceTypeEnum];

/**
 * 
 * @export
 * @interface SessionAssertByConnectorRequest
 */
export interface SessionAssertByConnectorRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionAssertByConnectorRequest
     */
    'source_type'?: SessionAssertByConnectorRequestSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionAssertByConnectorRequest
     */
    'connector_id': string;
}

export const SessionAssertByConnectorRequestSourceTypeEnum = {
    Connector: 'Connector'
} as const;

export type SessionAssertByConnectorRequestSourceTypeEnum = typeof SessionAssertByConnectorRequestSourceTypeEnum[keyof typeof SessionAssertByConnectorRequestSourceTypeEnum];

/**
 * 
 * @export
 * @interface SessionAssertResponse
 */
export interface SessionAssertResponse {
    /**
     * 
     * @type {SessionModel}
     * @memberof SessionAssertResponse
     */
    'model': SessionModel;
}
/**
 * 
 * @export
 * @interface SessionCreationByAgentRequest
 */
export interface SessionCreationByAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionCreationByAgentRequest
     */
    'source_type'?: SessionCreationByAgentRequestSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionCreationByAgentRequest
     */
    'agent_id': string;
}

export const SessionCreationByAgentRequestSourceTypeEnum = {
    Agent: 'Agent'
} as const;

export type SessionCreationByAgentRequestSourceTypeEnum = typeof SessionCreationByAgentRequestSourceTypeEnum[keyof typeof SessionCreationByAgentRequestSourceTypeEnum];

/**
 * 
 * @export
 * @interface SessionCreationByConnectorRequest
 */
export interface SessionCreationByConnectorRequest {
    /**
     * 
     * @type {string}
     * @memberof SessionCreationByConnectorRequest
     */
    'source_type'?: SessionCreationByConnectorRequestSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionCreationByConnectorRequest
     */
    'connector_id': string;
}

export const SessionCreationByConnectorRequestSourceTypeEnum = {
    Connector: 'Connector'
} as const;

export type SessionCreationByConnectorRequestSourceTypeEnum = typeof SessionCreationByConnectorRequestSourceTypeEnum[keyof typeof SessionCreationByConnectorRequestSourceTypeEnum];

/**
 * 
 * @export
 * @interface SessionCreationResponse
 */
export interface SessionCreationResponse {
    /**
     * 
     * @type {SessionModel}
     * @memberof SessionCreationResponse
     */
    'model': SessionModel;
}
/**
 * 
 * @export
 * @interface SessionModel
 */
export interface SessionModel {
    /**
     * 
     * @type {string}
     * @memberof SessionModel
     */
    'session_id': string;
    /**
     * 
     * @type {SessionStatus}
     * @memberof SessionModel
     */
    'status': SessionStatus;
    /**
     * 
     * @type {Array<SessionProviderModel>}
     * @memberof SessionModel
     */
    'providers': Array<SessionProviderModel>;
}


/**
 * 
 * @export
 * @interface SessionProviderModel
 */
export interface SessionProviderModel {
    /**
     * 
     * @type {string}
     * @memberof SessionProviderModel
     */
    'authority': string;
    /**
     * 
     * @type {SessionProviderStatus}
     * @memberof SessionProviderModel
     */
    'status': SessionProviderStatus;
    /**
     * 
     * @type {string}
     * @memberof SessionProviderModel
     */
    'redirect': string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SessionProviderStatus = {
    Challenged: 'Challenged',
    Unauthorized: 'Unauthorized',
    SignedIn: 'SignedIn',
    SignedOut: 'SignedOut',
    Expired: 'Expired'
} as const;

export type SessionProviderStatus = typeof SessionProviderStatus[keyof typeof SessionProviderStatus];


/**
 * 
 * @export
 * @interface SessionRequirementModel
 */
export interface SessionRequirementModel {
    /**
     * 
     * @type {boolean}
     * @memberof SessionRequirementModel
     */
    'required': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SessionStatus = {
    Challenged: 'Challenged',
    Unauthorized: 'Unauthorized',
    SignedIn: 'SignedIn',
    SignedOut: 'SignedOut',
    Expired: 'Expired'
} as const;

export type SessionStatus = typeof SessionStatus[keyof typeof SessionStatus];


/**
 * @type Settings
 * @export
 */
export type Settings = { type: 'ELMA365App' } & AgentResourceELMA365AppSettings | { type: 'ELMA365File' } & AgentResourceELMA365FileSettings | { type: 'ELMA365Session' } & AgentResourceELMA365SessionSettings | { type: 'Text' } & AgentResourceTextSettings;

/**
 * @type Settings1
 * @export
 */
export type Settings1 = { type: 'ELMA365' } & ELMA365ConnectorSettingsInput;

/**
 * @type Settings2
 * @export
 */
export type Settings2 = { type: 'ELMA365' } & ELMA365ConnectorSettingsOutput;

/**
 * @type Settings3
 * @export
 */
export type Settings3 = { source_type: 'Confluence' } & ConfluenceSourceParametersSettings | { source_type: 'ELMA365' } & ELMA365SourceParametersSettings | { source_type: 'File' } & FileSourceParametersSettings | { source_type: 'Website' } & WebsiteSourceParametersSettings | { source_type: 'WebsiteCrawler' } & WebsiteCrawlerSourceParametersSettings | { source_type: 'WebsiteURLs' } & WebsiteURLsSourceParametersSettings;

/**
 * @type Settings4
 * @export
 */
export type Settings4 = { toolset_type: 'Agent' } & AgentToolsetSettings | { toolset_type: 'DateTime' } & DateTimeToolsetSettings | { toolset_type: 'ELMA365_GENERAL' } & ELMA365GeneralToolsetSettingsInput | { toolset_type: 'ELMA365_TOOLKIT' } & ELMA365ToolkitToolsetSettings | { toolset_type: 'File' } & FileToolsetSettingsInput | { toolset_type: 'MCPServer' } & MCPServerToolsetSettingsInput | { toolset_type: 'SmartSearch' } & SmartSearchToolsetSettings | { toolset_type: 'System' } & SystemToolsetSettings | { toolset_type: 'Web' } & WebToolsetSettings;

/**
 * @type Settings5
 * @export
 */
export type Settings5 = { toolset_type: 'Agent' } & AgentToolsetSettings | { toolset_type: 'DateTime' } & DateTimeToolsetSettings | { toolset_type: 'ELMA365_GENERAL' } & ELMA365GeneralToolsetSettingsOutput | { toolset_type: 'ELMA365_TOOLKIT' } & ELMA365ToolkitToolsetSettings | { toolset_type: 'File' } & FileToolsetSettingsOutput | { toolset_type: 'MCPServer' } & MCPServerToolsetSettingsOutput | { toolset_type: 'SmartSearch' } & SmartSearchToolsetSettings | { toolset_type: 'System' } & SystemToolsetSettings | { toolset_type: 'Web' } & WebToolsetSettings;

/**
 * 
 * @export
 * @interface SimplePrompts
 */
export interface SimplePrompts {
    /**
     * 
     * @type {string}
     * @memberof SimplePrompts
     */
    'prompt'?: string | null;
}
/**
 * @type Site
 * @export
 */
export type Site = { type: 'Basic' } & BasicContentSite | { type: 'Bucket' } & BucketContentSite;

/**
 * 
 * @export
 * @interface SmartSearchDownloadDocumentToolCallData
 */
export interface SmartSearchDownloadDocumentToolCallData {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchDownloadDocumentToolCallData
     */
    'tool_type'?: SmartSearchDownloadDocumentToolCallDataToolTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SmartSearchDownloadDocumentToolCallData
     */
    'max_content_token_count': number;
}

export const SmartSearchDownloadDocumentToolCallDataToolTypeEnum = {
    DownloadDocument: 'DownloadDocument'
} as const;

export type SmartSearchDownloadDocumentToolCallDataToolTypeEnum = typeof SmartSearchDownloadDocumentToolCallDataToolTypeEnum[keyof typeof SmartSearchDownloadDocumentToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface SmartSearchDownloadDocumentToolSettings
 */
export interface SmartSearchDownloadDocumentToolSettings {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchDownloadDocumentToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchDownloadDocumentToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SmartSearchDownloadDocumentToolSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof SmartSearchDownloadDocumentToolSettings
     */
    'max_content_token_count': number;
}
/**
 * 
 * @export
 * @interface SmartSearchQueryToolCallData
 */
export interface SmartSearchQueryToolCallData {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchQueryToolCallData
     */
    'tool_type'?: SmartSearchQueryToolCallDataToolTypeEnum;
}

export const SmartSearchQueryToolCallDataToolTypeEnum = {
    Query: 'Query'
} as const;

export type SmartSearchQueryToolCallDataToolTypeEnum = typeof SmartSearchQueryToolCallDataToolTypeEnum[keyof typeof SmartSearchQueryToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface SmartSearchQueryToolSettings
 */
export interface SmartSearchQueryToolSettings {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchQueryToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchQueryToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SmartSearchQueryToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface SmartSearchSearchDocumentsToolCallData
 */
export interface SmartSearchSearchDocumentsToolCallData {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchSearchDocumentsToolCallData
     */
    'tool_type'?: SmartSearchSearchDocumentsToolCallDataToolTypeEnum;
}

export const SmartSearchSearchDocumentsToolCallDataToolTypeEnum = {
    SearchDocuments: 'SearchDocuments'
} as const;

export type SmartSearchSearchDocumentsToolCallDataToolTypeEnum = typeof SmartSearchSearchDocumentsToolCallDataToolTypeEnum[keyof typeof SmartSearchSearchDocumentsToolCallDataToolTypeEnum];

/**
 * 
 * @export
 * @interface SmartSearchSearchDocumentsToolSettings
 */
export interface SmartSearchSearchDocumentsToolSettings {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchSearchDocumentsToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchSearchDocumentsToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SmartSearchSearchDocumentsToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface SmartSearchSourceSettings
 */
export interface SmartSearchSourceSettings {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchSourceSettings
     */
    'source_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof SmartSearchSourceSettings
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchSourceSettings
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchSourceSettings
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface SmartSearchToolCallData
 */
export interface SmartSearchToolCallData {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolCallData
     */
    'toolset_settings_type'?: SmartSearchToolCallDataToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolCallData
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolCallData
     */
    'project_id': string;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolCallData
     */
    'project_external_id': string;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolCallData
     */
    'project_name': string;
    /**
     * 
     * @type {ToolData3}
     * @memberof SmartSearchToolCallData
     */
    'tool_data': ToolData3;
}

export const SmartSearchToolCallDataToolsetSettingsTypeEnum = {
    SmartSearch: 'SmartSearch'
} as const;

export type SmartSearchToolCallDataToolsetSettingsTypeEnum = typeof SmartSearchToolCallDataToolsetSettingsTypeEnum[keyof typeof SmartSearchToolCallDataToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface SmartSearchToolsetSettings
 */
export interface SmartSearchToolsetSettings {
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolsetSettings
     */
    'toolset_type'?: SmartSearchToolsetSettingsToolsetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolsetSettings
     */
    'tool_names_prefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmartSearchToolsetSettings
     */
    'project_id': string;
    /**
     * 
     * @type {Array<SmartSearchSourceSettings>}
     * @memberof SmartSearchToolsetSettings
     */
    'sources': Array<SmartSearchSourceSettings>;
    /**
     * 
     * @type {SmartSearchQueryToolSettings}
     * @memberof SmartSearchToolsetSettings
     */
    'query_tool_settings': SmartSearchQueryToolSettings;
    /**
     * 
     * @type {SmartSearchSearchDocumentsToolSettings}
     * @memberof SmartSearchToolsetSettings
     */
    'search_documents_tool_settings': SmartSearchSearchDocumentsToolSettings;
    /**
     * 
     * @type {SmartSearchDownloadDocumentToolSettings}
     * @memberof SmartSearchToolsetSettings
     */
    'download_document_tool_settings': SmartSearchDownloadDocumentToolSettings;
}

export const SmartSearchToolsetSettingsToolsetTypeEnum = {
    SmartSearch: 'SmartSearch'
} as const;

export type SmartSearchToolsetSettingsToolsetTypeEnum = typeof SmartSearchToolsetSettingsToolsetTypeEnum[keyof typeof SmartSearchToolsetSettingsToolsetTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirection = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * 
 * @export
 * @interface SourceAsToolSettings
 */
export interface SourceAsToolSettings {
    /**
     * 
     * @type {Array<SourceToolSettings>}
     * @memberof SourceAsToolSettings
     */
    'tools'?: Array<SourceToolSettings>;
}
/**
 * 
 * @export
 * @interface SourceToolSettings
 */
export interface SourceToolSettings {
    /**
     * 
     * @type {string}
     * @memberof SourceToolSettings
     */
    'tool_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SourceToolSettings
     */
    'source_id': string;
}
/**
 * 
 * @export
 * @interface StatusGroupModel
 */
export interface StatusGroupModel {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof StatusGroupModel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StatusGroupModel
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof StatusGroupModel
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface StatusItemModel
 */
export interface StatusItemModel {
    [key: string]: any;

    /**
     * 
     * @type {number}
     * @memberof StatusItemModel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof StatusItemModel
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof StatusItemModel
     */
    'name': string;
    /**
     * 
     * @type {Groupid}
     * @memberof StatusItemModel
     */
    'groupId': Groupid;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StoreEngineType = {
    Vector: 'VECTOR'
} as const;

export type StoreEngineType = typeof StoreEngineType[keyof typeof StoreEngineType];


/**
 * 
 * @export
 * @interface SynthesizeSettings
 */
export interface SynthesizeSettings {
    /**
     * 
     * @type {ChatHistorySettings}
     * @memberof SynthesizeSettings
     */
    'chat_history'?: ChatHistorySettings;
    /**
     * 
     * @type {PromptMode}
     * @memberof SynthesizeSettings
     */
    'prompt_mode'?: PromptMode;
    /**
     * 
     * @type {SimplePrompts}
     * @memberof SynthesizeSettings
     */
    'simple_prompts'?: SimplePrompts;
    /**
     * 
     * @type {AdvancedPrompts}
     * @memberof SynthesizeSettings
     */
    'advanced_prompts'?: AdvancedPrompts;
}


/**
 * 
 * @export
 * @interface System
 */
export interface System {
}
/**
 * 
 * @export
 * @interface SystemToolCallData
 */
export interface SystemToolCallData {
    /**
     * 
     * @type {string}
     * @memberof SystemToolCallData
     */
    'toolset_settings_type'?: SystemToolCallDataToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SystemToolCallData
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {ToolData4}
     * @memberof SystemToolCallData
     */
    'tool_data': ToolData4;
}

export const SystemToolCallDataToolsetSettingsTypeEnum = {
    System: 'System'
} as const;

export type SystemToolCallDataToolsetSettingsTypeEnum = typeof SystemToolCallDataToolsetSettingsTypeEnum[keyof typeof SystemToolCallDataToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface SystemToolsetSettings
 */
export interface SystemToolsetSettings {
    /**
     * 
     * @type {string}
     * @memberof SystemToolsetSettings
     */
    'toolset_type'?: SystemToolsetSettingsToolsetTypeEnum;
}

export const SystemToolsetSettingsToolsetTypeEnum = {
    System: 'System'
} as const;

export type SystemToolsetSettingsToolsetTypeEnum = typeof SystemToolsetSettingsToolsetTypeEnum[keyof typeof SystemToolsetSettingsToolsetTypeEnum];

/**
 * 
 * @export
 * @interface ToggleButtonOffset
 */
export interface ToggleButtonOffset {
    /**
     * 
     * @type {number}
     * @memberof ToggleButtonOffset
     */
    'bottom'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ToggleButtonOffset
     */
    'right'?: number | null;
}
/**
 * 
 * @export
 * @interface Tokenizer
 */
export interface Tokenizer {
    /**
     * 
     * @type {string}
     * @memberof Tokenizer
     */
    'encoding'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tokenizer
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tokenizer
     */
    'language'?: string | null;
}
/**
 * @type ToolData
 * @export
 */
export type ToolData = { tool_type: 'GetCurrentDateTime' } & GetCurrentDateTimeToolData;

/**
 * @type ToolData1
 * @export
 */
export type ToolData1 = { tool_type: 'CreateTask' } & ELMA365CreateTaskToolCallData | { tool_type: 'DescribeImage' } & ELMA365DescribeImageToolCallData | { tool_type: 'FetchAppElement' } & ELMA365FetchAppElementToolCallData | { tool_type: 'FetchAppFeed' } & ELMA365FetchAppFeedToolCallData | { tool_type: 'FetchCurrentUser' } & ELMA365FetchCurrentUserToolCallData | { tool_type: 'FetchDocflowLists' } & ELMA365FetchDocflowListsToolCallData | { tool_type: 'FetchTask' } & ELMA365FetchTaskToolCallData | { tool_type: 'ReadFile' } & ELMA365ReadFileToolCallData | { tool_type: 'ReassignTask' } & ELMA365ReassignTaskToolCallData | { tool_type: 'SearchTasks' } & ELMA365SearchTasksToolCallData | { tool_type: 'UpdateTaskDates' } & ELMA365UpdateTaskDatesToolCallData | { tool_type: 'UpdateTaskPercent' } & ELMA365UpdateTaskPercentToolCallData;

/**
 * @type ToolData2
 * @export
 */
export type ToolData2 = { tool_type: 'DescribeImage' } & FileDescribeImageToolData | { tool_type: 'ReadFile' } & FileReadFileToolData | { tool_type: 'WriteFile' } & FileWriteFileToolData;

/**
 * @type ToolData3
 * @export
 */
export type ToolData3 = { tool_type: 'DownloadDocument' } & SmartSearchDownloadDocumentToolCallData | { tool_type: 'Query' } & SmartSearchQueryToolCallData | { tool_type: 'SearchDocuments' } & SmartSearchSearchDocumentsToolCallData;

/**
 * @type ToolData4
 * @export
 */
export type ToolData4 = { tool_type: 'FinalAnswer' } & FinalAnswerToolData;

/**
 * @type ToolData5
 * @export
 */
export type ToolData5 = { tool_type: 'FetchUrl' } & WebFetchUrlToolData;

/**
 * 
 * @export
 * @interface ToolSettings
 */
export interface ToolSettings {
    /**
     * 
     * @type {string}
     * @memberof ToolSettings
     */
    'tool_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToolSettings
     */
    'tool_description'?: string | null;
}
/**
 * 
 * @export
 * @interface ToolsetCreationRequest
 */
export interface ToolsetCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof ToolsetCreationRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {ToolsetState}
     * @memberof ToolsetCreationRequest
     */
    'state': ToolsetState;
    /**
     * 
     * @type {ToolsetSettingsType}
     * @memberof ToolsetCreationRequest
     */
    'type': ToolsetSettingsType;
    /**
     * 
     * @type {Settings4}
     * @memberof ToolsetCreationRequest
     */
    'settings': Settings4;
    /**
     * 
     * @type {string}
     * @memberof ToolsetCreationRequest
     */
    'folder_id': string;
}


/**
 * 
 * @export
 * @interface ToolsetCreationResponse
 */
export interface ToolsetCreationResponse {
    /**
     * 
     * @type {ToolsetModel}
     * @memberof ToolsetCreationResponse
     */
    'model': ToolsetModel;
}
/**
 * 
 * @export
 * @interface ToolsetModel
 */
export interface ToolsetModel {
    /**
     * 
     * @type {string}
     * @memberof ToolsetModel
     */
    'agent_id': string;
    /**
     * 
     * @type {ToolsetState}
     * @memberof ToolsetModel
     */
    'state': ToolsetState;
    /**
     * 
     * @type {ToolsetSettingsType}
     * @memberof ToolsetModel
     */
    'type': ToolsetSettingsType;
    /**
     * 
     * @type {Settings5}
     * @memberof ToolsetModel
     */
    'settings': Settings5;
    /**
     * 
     * @type {string}
     * @memberof ToolsetModel
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof ToolsetModel
     */
    'toolset_id': string;
    /**
     * 
     * @type {string}
     * @memberof ToolsetModel
     */
    'created_on': string;
    /**
     * 
     * @type {string}
     * @memberof ToolsetModel
     */
    'modified_on': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ToolsetSettingsType = {
    System: 'System',
    McpServer: 'MCPServer',
    DateTime: 'DateTime',
    SmartSearch: 'SmartSearch',
    Web: 'Web',
    Elma365General: 'ELMA365_GENERAL',
    Elma365Toolkit: 'ELMA365_TOOLKIT',
    File: 'File',
    Agent: 'Agent'
} as const;

export type ToolsetSettingsType = typeof ToolsetSettingsType[keyof typeof ToolsetSettingsType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ToolsetState = {
    Enabled: 'Enabled',
    Disabled: 'Disabled'
} as const;

export type ToolsetState = typeof ToolsetState[keyof typeof ToolsetState];


/**
 * 
 * @export
 * @interface ToolsetUpdatingRequest
 */
export interface ToolsetUpdatingRequest {
    /**
     * 
     * @type {string}
     * @memberof ToolsetUpdatingRequest
     */
    'agent_id': string;
    /**
     * 
     * @type {ToolsetState}
     * @memberof ToolsetUpdatingRequest
     */
    'state': ToolsetState;
    /**
     * 
     * @type {ToolsetSettingsType}
     * @memberof ToolsetUpdatingRequest
     */
    'type': ToolsetSettingsType;
    /**
     * 
     * @type {Settings4}
     * @memberof ToolsetUpdatingRequest
     */
    'settings': Settings4;
}


/**
 * 
 * @export
 * @interface Tooltip
 */
export interface Tooltip {
}
/**
 * 
 * @export
 * @interface TraceProviderCreationRequest
 */
export interface TraceProviderCreationRequest {
    /**
     * 
     * @type {TraceProviderNames}
     * @memberof TraceProviderCreationRequest
     */
    'name': TraceProviderNames;
    /**
     * 
     * @type {string}
     * @memberof TraceProviderCreationRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TraceProviderCreationRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {TraceProviderSettings}
     * @memberof TraceProviderCreationRequest
     */
    'settings': TraceProviderSettings;
}


/**
 * 
 * @export
 * @interface TraceProviderCreationResponse
 */
export interface TraceProviderCreationResponse {
    /**
     * 
     * @type {string}
     * @memberof TraceProviderCreationResponse
     */
    'trace_provider_id': string;
}
/**
 * 
 * @export
 * @interface TraceProviderModel
 */
export interface TraceProviderModel {
    /**
     * 
     * @type {string}
     * @memberof TraceProviderModel
     */
    'trace_provider_id': string;
    /**
     * 
     * @type {TraceProviderNames}
     * @memberof TraceProviderModel
     */
    'name': TraceProviderNames;
    /**
     * 
     * @type {string}
     * @memberof TraceProviderModel
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TraceProviderModel
     */
    'enabled': boolean;
    /**
     * 
     * @type {TraceProviderSettings}
     * @memberof TraceProviderModel
     */
    'settings': TraceProviderSettings;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TraceProviderNames = {
    Phoenix: 'PHOENIX'
} as const;

export type TraceProviderNames = typeof TraceProviderNames[keyof typeof TraceProviderNames];


/**
 * 
 * @export
 * @interface TraceProviderSettings
 */
export interface TraceProviderSettings {
    /**
     * 
     * @type {string}
     * @memberof TraceProviderSettings
     */
    'api_base'?: string | null;
}
/**
 * 
 * @export
 * @interface TraceProviderUpdatingRequest
 */
export interface TraceProviderUpdatingRequest {
    /**
     * 
     * @type {TraceProviderNames}
     * @memberof TraceProviderUpdatingRequest
     */
    'name': TraceProviderNames;
    /**
     * 
     * @type {string}
     * @memberof TraceProviderUpdatingRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TraceProviderUpdatingRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {TraceProviderSettings}
     * @memberof TraceProviderUpdatingRequest
     */
    'settings': TraceProviderSettings;
}


/**
 * 
 * @export
 * @interface TraceSettings
 */
export interface TraceSettings {
    /**
     * 
     * @type {string}
     * @memberof TraceSettings
     */
    'trace_provider_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TraceSettings
     */
    'project_name'?: string | null;
}
/**
 * 
 * @export
 * @interface Type
 */
export interface Type {
}
/**
 * 
 * @export
 * @interface UpdateELMA365TaskDatesToolSettings
 */
export interface UpdateELMA365TaskDatesToolSettings {
    /**
     * 
     * @type {string}
     * @memberof UpdateELMA365TaskDatesToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateELMA365TaskDatesToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateELMA365TaskDatesToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface UpdateELMA365TaskPercentToolSettings
 */
export interface UpdateELMA365TaskPercentToolSettings {
    /**
     * 
     * @type {string}
     * @memberof UpdateELMA365TaskPercentToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateELMA365TaskPercentToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateELMA365TaskPercentToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VectorStoreEngine = {
    Qdrant: 'qdrant'
} as const;

export type VectorStoreEngine = typeof VectorStoreEngine[keyof typeof VectorStoreEngine];


/**
 * 
 * @export
 * @interface VllmProviderSettingsInput
 */
export interface VllmProviderSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof VllmProviderSettingsInput
     */
    'provider_type'?: VllmProviderSettingsInputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof VllmProviderSettingsInput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase>}
     * @memberof VllmProviderSettingsInput
     */
    'models'?: Array<ProviderModelItemBase>;
    /**
     * 
     * @type {string}
     * @memberof VllmProviderSettingsInput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VllmProviderSettingsInput
     */
    'api_base'?: string | null;
}

export const VllmProviderSettingsInputProviderTypeEnum = {
    Vllm: 'VLLM'
} as const;

export type VllmProviderSettingsInputProviderTypeEnum = typeof VllmProviderSettingsInputProviderTypeEnum[keyof typeof VllmProviderSettingsInputProviderTypeEnum];

/**
 * 
 * @export
 * @interface VllmProviderSettingsOutput
 */
export interface VllmProviderSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof VllmProviderSettingsOutput
     */
    'provider_type'?: VllmProviderSettingsOutputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof VllmProviderSettingsOutput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase1>}
     * @memberof VllmProviderSettingsOutput
     */
    'models'?: Array<ProviderModelItemBase1>;
    /**
     * 
     * @type {string}
     * @memberof VllmProviderSettingsOutput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VllmProviderSettingsOutput
     */
    'api_base'?: string | null;
}

export const VllmProviderSettingsOutputProviderTypeEnum = {
    Vllm: 'VLLM'
} as const;

export type VllmProviderSettingsOutputProviderTypeEnum = typeof VllmProviderSettingsOutputProviderTypeEnum[keyof typeof VllmProviderSettingsOutputProviderTypeEnum];

/**
 * 
 * @export
 * @interface WebFetchUrlToolData
 */
export interface WebFetchUrlToolData {
    /**
     * 
     * @type {string}
     * @memberof WebFetchUrlToolData
     */
    'tool_type'?: WebFetchUrlToolDataToolTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WebFetchUrlToolData
     */
    'max_content_token_count': number;
    /**
     * 
     * @type {number}
     * @memberof WebFetchUrlToolData
     */
    'fetch_timeout_seconds': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebFetchUrlToolData
     */
    'allowed_hosts': Array<string>;
}

export const WebFetchUrlToolDataToolTypeEnum = {
    FetchUrl: 'FetchUrl'
} as const;

export type WebFetchUrlToolDataToolTypeEnum = typeof WebFetchUrlToolDataToolTypeEnum[keyof typeof WebFetchUrlToolDataToolTypeEnum];

/**
 * 
 * @export
 * @interface WebToolCallData
 */
export interface WebToolCallData {
    /**
     * 
     * @type {string}
     * @memberof WebToolCallData
     */
    'toolset_settings_type'?: WebToolCallDataToolsetSettingsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WebToolCallData
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {ToolData5}
     * @memberof WebToolCallData
     */
    'tool_data': ToolData5;
}

export const WebToolCallDataToolsetSettingsTypeEnum = {
    Web: 'Web'
} as const;

export type WebToolCallDataToolsetSettingsTypeEnum = typeof WebToolCallDataToolsetSettingsTypeEnum[keyof typeof WebToolCallDataToolsetSettingsTypeEnum];

/**
 * 
 * @export
 * @interface WebToolsetSettings
 */
export interface WebToolsetSettings {
    /**
     * 
     * @type {string}
     * @memberof WebToolsetSettings
     */
    'toolset_type'?: WebToolsetSettingsToolsetTypeEnum;
    /**
     * 
     * @type {FetchUrlToolSettings}
     * @memberof WebToolsetSettings
     */
    'fetch_url_tool_settings': FetchUrlToolSettings;
}

export const WebToolsetSettingsToolsetTypeEnum = {
    Web: 'Web'
} as const;

export type WebToolsetSettingsToolsetTypeEnum = typeof WebToolsetSettingsToolsetTypeEnum[keyof typeof WebToolsetSettingsToolsetTypeEnum];

/**
 * 
 * @export
 * @interface WebsiteCrawlerSourceParametersSettings
 */
export interface WebsiteCrawlerSourceParametersSettings {
    /**
     * 
     * @type {string}
     * @memberof WebsiteCrawlerSourceParametersSettings
     */
    'source_type'?: WebsiteCrawlerSourceParametersSettingsSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WebsiteCrawlerSourceParametersSettings
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof WebsiteCrawlerSourceParametersSettings
     */
    'included_paths'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebsiteCrawlerSourceParametersSettings
     */
    'excluded_paths'?: string | null;
}

export const WebsiteCrawlerSourceParametersSettingsSourceTypeEnum = {
    WebsiteCrawler: 'WebsiteCrawler'
} as const;

export type WebsiteCrawlerSourceParametersSettingsSourceTypeEnum = typeof WebsiteCrawlerSourceParametersSettingsSourceTypeEnum[keyof typeof WebsiteCrawlerSourceParametersSettingsSourceTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const WebsiteSourceParametersReceivingMode = {
    Manual: 'Manual',
    Crawler: 'Crawler'
} as const;

export type WebsiteSourceParametersReceivingMode = typeof WebsiteSourceParametersReceivingMode[keyof typeof WebsiteSourceParametersReceivingMode];


/**
 * 
 * @export
 * @interface WebsiteSourceParametersSettings
 */
export interface WebsiteSourceParametersSettings {
    /**
     * 
     * @type {string}
     * @memberof WebsiteSourceParametersSettings
     */
    'source_type'?: WebsiteSourceParametersSettingsSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WebsiteSourceParametersSettings
     */
    'base_url': string;
    /**
     * 
     * @type {string}
     * @memberof WebsiteSourceParametersSettings
     */
    'included_paths'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebsiteSourceParametersSettings
     */
    'excluded_paths'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebsiteSourceParametersSettings
     */
    'extra_urls'?: Array<string>;
    /**
     * 
     * @type {WebsiteSourceParametersReceivingMode}
     * @memberof WebsiteSourceParametersSettings
     */
    'receiving_mode': WebsiteSourceParametersReceivingMode;
}

export const WebsiteSourceParametersSettingsSourceTypeEnum = {
    Website: 'Website'
} as const;

export type WebsiteSourceParametersSettingsSourceTypeEnum = typeof WebsiteSourceParametersSettingsSourceTypeEnum[keyof typeof WebsiteSourceParametersSettingsSourceTypeEnum];

/**
 * 
 * @export
 * @interface WebsiteURLsSourceParametersSettings
 */
export interface WebsiteURLsSourceParametersSettings {
    /**
     * 
     * @type {string}
     * @memberof WebsiteURLsSourceParametersSettings
     */
    'source_type'?: WebsiteURLsSourceParametersSettingsSourceTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebsiteURLsSourceParametersSettings
     */
    'extra_urls'?: Array<string>;
}

export const WebsiteURLsSourceParametersSettingsSourceTypeEnum = {
    WebsiteUrls: 'WebsiteURLs'
} as const;

export type WebsiteURLsSourceParametersSettingsSourceTypeEnum = typeof WebsiteURLsSourceParametersSettingsSourceTypeEnum[keyof typeof WebsiteURLsSourceParametersSettingsSourceTypeEnum];

/**
 * 
 * @export
 * @interface WidgetAppearance
 */
export interface WidgetAppearance {
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearance
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearance
     */
    'width'?: string | null;
}
/**
 * 
 * @export
 * @interface WidgetToggleButton
 */
export interface WidgetToggleButton {
    /**
     * 
     * @type {number}
     * @memberof WidgetToggleButton
     */
    'size'?: number | null;
    /**
     * 
     * @type {ToggleButtonOffset}
     * @memberof WidgetToggleButton
     */
    'offset'?: ToggleButtonOffset;
}
/**
 * 
 * @export
 * @interface WidgetWelcomeMessage
 */
export interface WidgetWelcomeMessage {
    /**
     * 
     * @type {boolean}
     * @memberof WidgetWelcomeMessage
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetWelcomeMessage
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface WriteFileToolSettings
 */
export interface WriteFileToolSettings {
    /**
     * 
     * @type {string}
     * @memberof WriteFileToolSettings
     */
    'tool_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WriteFileToolSettings
     */
    'tool_description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WriteFileToolSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface YandexProviderSettingsInput
 */
export interface YandexProviderSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof YandexProviderSettingsInput
     */
    'provider_type'?: YandexProviderSettingsInputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof YandexProviderSettingsInput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase>}
     * @memberof YandexProviderSettingsInput
     */
    'models'?: Array<ProviderModelItemBase>;
    /**
     * 
     * @type {string}
     * @memberof YandexProviderSettingsInput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof YandexProviderSettingsInput
     */
    'folder_id'?: string | null;
}

export const YandexProviderSettingsInputProviderTypeEnum = {
    Yandex: 'YANDEX'
} as const;

export type YandexProviderSettingsInputProviderTypeEnum = typeof YandexProviderSettingsInputProviderTypeEnum[keyof typeof YandexProviderSettingsInputProviderTypeEnum];

/**
 * 
 * @export
 * @interface YandexProviderSettingsOutput
 */
export interface YandexProviderSettingsOutput {
    /**
     * 
     * @type {string}
     * @memberof YandexProviderSettingsOutput
     */
    'provider_type'?: YandexProviderSettingsOutputProviderTypeEnum;
    /**
     * 
     * @type {Array<ProviderModelType>}
     * @memberof YandexProviderSettingsOutput
     */
    'supported_model_types'?: Array<ProviderModelType>;
    /**
     * 
     * @type {Array<ProviderModelItemBase1>}
     * @memberof YandexProviderSettingsOutput
     */
    'models'?: Array<ProviderModelItemBase1>;
    /**
     * 
     * @type {string}
     * @memberof YandexProviderSettingsOutput
     */
    'api_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof YandexProviderSettingsOutput
     */
    'folder_id'?: string | null;
}

export const YandexProviderSettingsOutputProviderTypeEnum = {
    Yandex: 'YANDEX'
} as const;

export type YandexProviderSettingsOutputProviderTypeEnum = typeof YandexProviderSettingsOutputProviderTypeEnum[keyof typeof YandexProviderSettingsOutputProviderTypeEnum];


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assert session.  Args:     public_id (str): Session public ID.     request (SessionAssertRequest): Session assertion request.  Returns:     SessionAssertResponse: Session assertion response.
         * @summary Assert Session
         * @param {string} publicId 
         * @param {Request1} request1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertSession: async (publicId: string, request1: Request1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('assertSession', 'publicId', publicId)
            // verify required parameter 'request1' is not null or undefined
            assertParamExists('assertSession', 'request1', request1)
            const localVarPath = `/security/sessions/{public_id}/assert`
                .replace(`{${"public_id"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Login.  Args:     action (str): Callback action.     return_to (str): Return path.  Returns:     None: Redirects the user to the OAuth provider.
         * @summary Auth Login
         * @param {string} action 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogin: async (action: string, returnTo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'action' is not null or undefined
            assertParamExists('authLogin', 'action', action)
            // verify required parameter 'returnTo' is not null or undefined
            assertParamExists('authLogin', 'returnTo', returnTo)
            const localVarPath = `/security/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (returnTo !== undefined) {
                localVarQueryParameter['return_to'] = returnTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout.  Args:     request (Request): Logout request.  Returns:     None: Redirects the user to the index page.
         * @summary Auth Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Call ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetCallingRequest): Toolset calling request.  Returns:     ELMA365ToolsetCallingResponse: Toolset calling response.
         * @summary Call Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetCallingRequest} eLMA365ToolsetCallingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callELMA365ToolkitToolset: async (toolsetId: string, eLMA365ToolsetCallingRequest: ELMA365ToolsetCallingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('callELMA365ToolkitToolset', 'toolsetId', toolsetId)
            // verify required parameter 'eLMA365ToolsetCallingRequest' is not null or undefined
            assertParamExists('callELMA365ToolkitToolset', 'eLMA365ToolsetCallingRequest', eLMA365ToolsetCallingRequest)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/call`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetCallingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check connector.  Args:     request (ConnectorCheckingRequest): Connector checking request.  Returns:     ConnectorCheckingResponse: Connector checking response.
         * @summary Check Connector
         * @param {ConnectorCheckingRequest} connectorCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConnector: async (connectorCheckingRequest: ConnectorCheckingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorCheckingRequest' is not null or undefined
            assertParamExists('checkConnector', 'connectorCheckingRequest', connectorCheckingRequest)
            const localVarPath = `/general/connectors/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectorCheckingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check provider embedding.  Args:     request (ProviderEmbeddingCheckingRequest): Provider embedding checking request.  Returns:     ProviderEmbeddingCheckingResponse: Provider embedding checking response.
         * @summary Check Provider Embedding
         * @param {ProviderEmbeddingCheckingRequest} providerEmbeddingCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost: async (providerEmbeddingCheckingRequest: ProviderEmbeddingCheckingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerEmbeddingCheckingRequest' is not null or undefined
            assertParamExists('checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost', 'providerEmbeddingCheckingRequest', providerEmbeddingCheckingRequest)
            const localVarPath = `/general/providers/embedding/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerEmbeddingCheckingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check provider llm.  Args:     request (ProviderLLMCheckingRequest): Provider LLM checking request.  Returns:     ProviderLLMCheckingResponse: Provider LLM checking response.
         * @summary Check Provider Llm
         * @param {ProviderLLMCheckingRequest} providerLLMCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkProviderLlmGeneralProvidersLlmCheckPost: async (providerLLMCheckingRequest: ProviderLLMCheckingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerLLMCheckingRequest' is not null or undefined
            assertParamExists('checkProviderLlmGeneralProvidersLlmCheckPost', 'providerLLMCheckingRequest', providerLLMCheckingRequest)
            const localVarPath = `/general/providers/llm/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerLLMCheckingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compare ELMA365 versions.  Args:     request (ELMA365VersionComparisonRequest): Versions comparison request.  Returns:     ELMA365VersionComparisonResponse: Versions comparison response.
         * @summary Compare Elma365 Versions
         * @param {ELMA365VersionComparisonRequest} eLMA365VersionComparisonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareELMA365ToolkitVersions: async (eLMA365VersionComparisonRequest: ELMA365VersionComparisonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365VersionComparisonRequest' is not null or undefined
            assertParamExists('compareELMA365ToolkitVersions', 'eLMA365VersionComparisonRequest', eLMA365VersionComparisonRequest)
            const localVarPath = `/toolkits/elma365/versions/compare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365VersionComparisonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Completion request.  Args:     request (CompletionRequest): Completion request.  Returns:     CompletionResponse: Completion response.
         * @summary Completion
         * @param {CompletionRequest} completionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completionSearchCompletionPost: async (completionRequest: CompletionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completionRequest' is not null or undefined
            assertParamExists('completionSearchCompletionPost', 'completionRequest', completionRequest)
            const localVarPath = `/search/completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create agent.  Args:     request (AgentCreationRequest): Agent creation request.  Returns:     AgentCreationResponse: Agent creation response.
         * @summary Create Agent
         * @param {AgentCreationRequest} agentCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent: async (agentCreationRequest: AgentCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentCreationRequest' is not null or undefined
            assertParamExists('createAgent', 'agentCreationRequest', agentCreationRequest)
            const localVarPath = `/agent/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create agent relation.  Args:     request (AgentRelationCreationRequest): Agent relation creation request.  Returns:     AgentRelationCreationResponse: Agent relation creation response.
         * @summary Create Relation
         * @param {AgentRelationCreationRequest} agentRelationCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentRelation: async (agentRelationCreationRequest: AgentRelationCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentRelationCreationRequest' is not null or undefined
            assertParamExists('createAgentRelation', 'agentRelationCreationRequest', agentRelationCreationRequest)
            const localVarPath = `/agent/relations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentRelationCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create agent resource.  Args:     request (AgentResourceCreationRequest): Agent resource creation request.  Returns:     AgentResourceCreationResponse: Agent resource creation response.
         * @summary Create Resource
         * @param {AgentResourceCreationRequest} agentResourceCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentResource: async (agentResourceCreationRequest: AgentResourceCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentResourceCreationRequest' is not null or undefined
            assertParamExists('createAgentResource', 'agentResourceCreationRequest', agentResourceCreationRequest)
            const localVarPath = `/agent/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentResourceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create run.  Args:     request (AgentRunCreationRequest): Run creation request.  Returns:     AgentRunCreationResponse: Run creation response.
         * @summary Create Run
         * @param {AgentRunCreationRequest} agentRunCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentRun: async (agentRunCreationRequest: AgentRunCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentRunCreationRequest' is not null or undefined
            assertParamExists('createAgentRun', 'agentRunCreationRequest', agentRunCreationRequest)
            const localVarPath = `/agent/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentRunCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create thread.  Args:     request (AgentThreadCreationRequest): Thread creation request.  Returns:     AgentThreadCreationResponse: Thread creation response.
         * @summary Create Thread
         * @param {AgentThreadCreationRequest} agentThreadCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentThread: async (agentThreadCreationRequest: AgentThreadCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentThreadCreationRequest' is not null or undefined
            assertParamExists('createAgentThread', 'agentThreadCreationRequest', agentThreadCreationRequest)
            const localVarPath = `/agent/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentThreadCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create ApiKey.  Args:     request (ApiKeyCreationRequest): ApiKey creation request.  Returns:     ApiKeyCreationResponse: ApiKey creation response.
         * @summary Create Api Key
         * @param {ApiKeyCreationRequest} apiKeyCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeySecurityApiKeysPost: async (apiKeyCreationRequest: ApiKeyCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyCreationRequest' is not null or undefined
            assertParamExists('createApiKeySecurityApiKeysPost', 'apiKeyCreationRequest', apiKeyCreationRequest)
            const localVarPath = `/security/api_keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create connector.  Args:     request (ConnectorCreationRequest): Connector creation request.  Returns:     ConnectorCreationResponse: Connector creation response.
         * @summary Create Connector
         * @param {ConnectorCreationRequest} connectorCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnector: async (connectorCreationRequest: ConnectorCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorCreationRequest' is not null or undefined
            assertParamExists('createConnector', 'connectorCreationRequest', connectorCreationRequest)
            const localVarPath = `/general/connectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectorCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create ELMA365 toolset.  Args:     request (ELMA365ToolsetCreationRequest): Toolset creation request.  Returns:     ELMA365ToolsetCreationResponse: Toolset creation response.
         * @summary Create Elma365 Toolset
         * @param {ELMA365ToolsetCreationRequest} eLMA365ToolsetCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createELMA365ToolkitToolset: async (eLMA365ToolsetCreationRequest: ELMA365ToolsetCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365ToolsetCreationRequest' is not null or undefined
            assertParamExists('createELMA365ToolkitToolset', 'eLMA365ToolsetCreationRequest', eLMA365ToolsetCreationRequest)
            const localVarPath = `/toolkits/elma365/toolsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create ELMA365 version.  Args:     request (ELMA365VersionCreationRequest): Version creation request.  Returns:     ELMA365VersionCreationResponse: Version creation response.
         * @summary Create Elma365 Version
         * @param {ELMA365VersionCreationRequest} eLMA365VersionCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createELMA365ToolkitVersion: async (eLMA365VersionCreationRequest: ELMA365VersionCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365VersionCreationRequest' is not null or undefined
            assertParamExists('createELMA365ToolkitVersion', 'eLMA365VersionCreationRequest', eLMA365VersionCreationRequest)
            const localVarPath = `/toolkits/elma365/versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365VersionCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create file via form.  Args:     query (FileCreationQuery): Request query.     content (UploadFile): File content.  Returns:     FileCreationResponse: File creation response.
         * @summary Create File Form
         * @param {string} externalId 
         * @param {Array<FilePurpose>} purposes 
         * @param {File} content 
         * @param {string | null} [projectId] 
         * @param {string | null} [sourceId] 
         * @param {ContentStore | null} [contentStore] 
         * @param {ContentFormat | null} [contentFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileFormGeneralFilesFormPost: async (externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('createFileFormGeneralFilesFormPost', 'externalId', externalId)
            // verify required parameter 'purposes' is not null or undefined
            assertParamExists('createFileFormGeneralFilesFormPost', 'purposes', purposes)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('createFileFormGeneralFilesFormPost', 'content', content)
            const localVarPath = `/general/files/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['source_id'] = sourceId;
            }

            if (purposes) {
                localVarQueryParameter['purposes'] = purposes;
            }

            if (contentStore !== undefined) {
                localVarQueryParameter['content_store'] = contentStore;
            }

            if (contentFormat !== undefined) {
                localVarQueryParameter['content_format'] = contentFormat;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create file via JSON.  Args:     body (FileCreationBody): Request body.  Returns:     FileCreationResponse: File creation response.
         * @summary Create File Json
         * @param {FileCreationBody} fileCreationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileJsonGeneralFilesJsonPost: async (fileCreationBody: FileCreationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileCreationBody' is not null or undefined
            assertParamExists('createFileJsonGeneralFilesJsonPost', 'fileCreationBody', fileCreationBody)
            const localVarPath = `/general/files/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileCreationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create folder.  Args:     request (FolderCreationRequest): Folder creation request.  Returns:     FolderCreationResponse: Folder creation response.
         * @summary Create Folder
         * @param {FolderCreationRequest} folderCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (folderCreationRequest: FolderCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderCreationRequest' is not null or undefined
            assertParamExists('createFolder', 'folderCreationRequest', folderCreationRequest)
            const localVarPath = `/general/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create message.  Args:     request (SearchMessageCreationRequest): Message creation request.  Returns:     SearchMessageCreationResponse: Message creation response.
         * @summary Create Message
         * @param {SearchMessageCreationRequest} searchMessageCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessageSearchMessagesPost: async (searchMessageCreationRequest: SearchMessageCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchMessageCreationRequest' is not null or undefined
            assertParamExists('createMessageSearchMessagesPost', 'searchMessageCreationRequest', searchMessageCreationRequest)
            const localVarPath = `/search/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchMessageCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create process.  Args:     request (IngestionProcessCreationRequest): Process creation request.  Returns:     IngestionProcessCreationResponse: Process creation response.
         * @summary Create Process
         * @param {IngestionProcessCreationRequest} ingestionProcessCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessIngestionProcessesPost: async (ingestionProcessCreationRequest: IngestionProcessCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestionProcessCreationRequest' is not null or undefined
            assertParamExists('createProcessIngestionProcessesPost', 'ingestionProcessCreationRequest', ingestionProcessCreationRequest)
            const localVarPath = `/ingestion/processes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestionProcessCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create project.  Args:     request (ProjectCreationRequest): Project creation request.  Returns:     ProjectCreationResponse: Project creation response.
         * @summary Create Project
         * @param {ProjectCreationRequest} projectCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectGeneralProjectsPost: async (projectCreationRequest: ProjectCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectCreationRequest' is not null or undefined
            assertParamExists('createProjectGeneralProjectsPost', 'projectCreationRequest', projectCreationRequest)
            const localVarPath = `/general/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create provider.  Args:     request (ProviderCreationRequest): Provider creation request.  Returns:     ProviderCreationResponse: Provider creation response.
         * @summary Create Provider
         * @param {ProviderCreationRequest} providerCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderGeneralProvidersPost: async (providerCreationRequest: ProviderCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerCreationRequest' is not null or undefined
            assertParamExists('createProviderGeneralProvidersPost', 'providerCreationRequest', providerCreationRequest)
            const localVarPath = `/general/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create run.  Args:     request (SearchRunCreationRequest): Run creation request.  Returns:     SearchRunCreationResponse: Run creation response.
         * @summary Create Run
         * @param {SearchRunCreationRequest} searchRunCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunSearchRunsPost: async (searchRunCreationRequest: SearchRunCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchRunCreationRequest' is not null or undefined
            assertParamExists('createRunSearchRunsPost', 'searchRunCreationRequest', searchRunCreationRequest)
            const localVarPath = `/search/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchRunCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Schedule
         * @param {IngestionScheduleCreationRequest} ingestionScheduleCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule: async (ingestionScheduleCreationRequest: IngestionScheduleCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestionScheduleCreationRequest' is not null or undefined
            assertParamExists('createSchedule', 'ingestionScheduleCreationRequest', ingestionScheduleCreationRequest)
            const localVarPath = `/ingestion/schedules/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestionScheduleCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create session.  Args:     request (SessionCreationRequest): Session creation request.  Returns:     SessionModel: Created session.
         * @summary Create Session
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession: async (request: Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('createSession', 'request', request)
            const localVarPath = `/security/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Signal
         * @param {IngestionSignalCreationRequest} ingestionSignalCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSignalIngestionSignalsPost: async (ingestionSignalCreationRequest: IngestionSignalCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestionSignalCreationRequest' is not null or undefined
            assertParamExists('createSignalIngestionSignalsPost', 'ingestionSignalCreationRequest', ingestionSignalCreationRequest)
            const localVarPath = `/ingestion/signals/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestionSignalCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Source
         * @param {IngestionSourceCreationRequest} ingestionSourceCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSourceIngestionSourcesPost: async (ingestionSourceCreationRequest: IngestionSourceCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestionSourceCreationRequest' is not null or undefined
            assertParamExists('createSourceIngestionSourcesPost', 'ingestionSourceCreationRequest', ingestionSourceCreationRequest)
            const localVarPath = `/ingestion/sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestionSourceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create thread.  Args:     request (SearchThreadCreationRequest): Thread creation request.  Returns:     SearchThreadCreationResponse: Thread creation response.
         * @summary Create Thread
         * @param {SearchThreadCreationRequest} searchThreadCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThreadSearchThreadsPost: async (searchThreadCreationRequest: SearchThreadCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchThreadCreationRequest' is not null or undefined
            assertParamExists('createThreadSearchThreadsPost', 'searchThreadCreationRequest', searchThreadCreationRequest)
            const localVarPath = `/search/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchThreadCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create toolset.  Args:     request (ToolsetCreationRequest): Toolset creation request.  Returns:     ToolsetCreationResponse: Toolset creation response.
         * @summary Create Toolset
         * @param {ToolsetCreationRequest} toolsetCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToolset: async (toolsetCreationRequest: ToolsetCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetCreationRequest' is not null or undefined
            assertParamExists('createToolset', 'toolsetCreationRequest', toolsetCreationRequest)
            const localVarPath = `/agent/toolsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toolsetCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create trace provider.  Args:     request (TraceProviderCreationRequest): Provider creation request.  Returns:     TraceProviderCreationResponse: Trace provider creation response.
         * @summary Create Trace Provider
         * @param {TraceProviderCreationRequest} traceProviderCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraceProviderGeneralTraceProvidersPost: async (traceProviderCreationRequest: TraceProviderCreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'traceProviderCreationRequest' is not null or undefined
            assertParamExists('createTraceProviderGeneralTraceProvidersPost', 'traceProviderCreationRequest', traceProviderCreationRequest)
            const localVarPath = `/general/trace/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceProviderCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one agent.  Args:     agent_id (str): Agent ID.
         * @summary Delete One Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAgent', 'agentId', agentId)
            const localVarPath = `/agent/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one agent relation.  Args:     relation_id (str): Agent relation ID.
         * @summary Delete One Relation
         * @param {string} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentRelation: async (relationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('deleteAgentRelation', 'relationId', relationId)
            const localVarPath = `/agent/relations/{relation_id}`
                .replace(`{${"relation_id"}}`, encodeURIComponent(String(relationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one agent resource.  Args:     resource_id (str): Agent resource ID.
         * @summary Delete One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentResource: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteAgentResource', 'resourceId', resourceId)
            const localVarPath = `/agent/resources/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one thread.  Args:     thread_id (str): Thread ID.
         * @summary Delete One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentThread: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('deleteAgentThread', 'threadId', threadId)
            const localVarPath = `/agent/threads/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete connector.  Args:     connector_id (str): Connector ID.
         * @summary Delete Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnector: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('deleteConnector', 'connectorId', connectorId)
            const localVarPath = `/general/connectors/{connector_id}`
                .replace(`{${"connector_id"}}`, encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolDeletionResponse: Tool deletion response.
         * @summary Delete Elma365 Tool
         * @param {string} toolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteELMA365ToolkitTool: async (toolId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('deleteELMA365ToolkitTool', 'toolId', toolId)
            const localVarPath = `/toolkits/elma365/tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.
         * @summary Delete Elma365 Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteELMA365ToolkitToolset: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('deleteELMA365ToolkitToolset', 'toolsetId', toolsetId)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete ELMA365 version.  Args:     version_id (str): Version ID.
         * @summary Delete Elma365 Version
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteELMA365ToolkitVersion: async (versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('deleteELMA365ToolkitVersion', 'versionId', versionId)
            const localVarPath = `/toolkits/elma365/versions/{version_id}`
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete folder.  Args:     folder_id (str): Folder ID.
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteFolder', 'folderId', folderId)
            const localVarPath = `/general/folders/{folder_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one ApiKey.  Args:     api_key_id (str): ApiKey ID.
         * @summary Delete One Api Key
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneApiKeySecurityApiKeysApiKeyIdDelete: async (apiKeyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteOneApiKeySecurityApiKeysApiKeyIdDelete', 'apiKeyId', apiKeyId)
            const localVarPath = `/security/api_keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one file.  Args:     path (FileDeletionPath): RequestPath.
         * @summary Delete One File
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneFileGeneralFilesFileIdDelete: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteOneFileGeneralFilesFileIdDelete', 'fileId', fileId)
            const localVarPath = `/general/files/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one message.  Args:     message_id (str): Message ID.
         * @summary Delete One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneMessageSearchMessagesMessageIdDelete: async (messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('deleteOneMessageSearchMessagesMessageIdDelete', 'messageId', messageId)
            const localVarPath = `/search/messages/{message_id}`
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one project.  Args:     project_id (str): Project ID.
         * @summary Delete One Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneProjectGeneralProjectsProjectIdDelete: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteOneProjectGeneralProjectsProjectIdDelete', 'projectId', projectId)
            const localVarPath = `/general/projects/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one provider.  Args:     provider_id (str): Provider ID.
         * @summary Delete One Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneProviderGeneralProvidersProviderIdDelete: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('deleteOneProviderGeneralProvidersProviderIdDelete', 'providerId', providerId)
            const localVarPath = `/general/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one thread.  Args:     thread_id (str): Thread ID.
         * @summary Delete One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneThreadSearchThreadsThreadIdDelete: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('deleteOneThreadSearchThreadsThreadIdDelete', 'threadId', threadId)
            const localVarPath = `/search/threads/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one trace provider.  Args:     trace_provider_id (str): Trace provider ID.
         * @summary Delete One Trace Provider
         * @param {string} traceProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete: async (traceProviderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'traceProviderId' is not null or undefined
            assertParamExists('deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete', 'traceProviderId', traceProviderId)
            const localVarPath = `/general/trace/providers/{trace_provider_id}`
                .replace(`{${"trace_provider_id"}}`, encodeURIComponent(String(traceProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Schedule
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule: async (scheduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('deleteSchedule', 'scheduleId', scheduleId)
            const localVarPath = `/ingestion/schedules/{schedule_id}`
                .replace(`{${"schedule_id"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one toolset.  Args:     toolset_id (str): Toolset ID.
         * @summary Delete One Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToolset: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('deleteToolset', 'toolsetId', toolsetId)
            const localVarPath = `/agent/toolsets/{toolset_id}`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download artifact buffer content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Buffer content.
         * @summary Download Artifact Buffer
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet: async (artifactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet', 'artifactId', artifactId)
            const localVarPath = `/ingestion/artifacts/{artifact_id}/content/buffer`
                .replace(`{${"artifact_id"}}`, encodeURIComponent(String(artifactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download artifact object content.  Args:     artifact_id (str): Artifact ID.  Returns:     Any: Object content.
         * @summary Download Artifact Object
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet: async (artifactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet', 'artifactId', artifactId)
            const localVarPath = `/ingestion/artifacts/{artifact_id}/content/object`
                .replace(`{${"artifact_id"}}`, encodeURIComponent(String(artifactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download artifact stream content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Stream content.
         * @summary Download Artifact Stream
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet: async (artifactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet', 'artifactId', artifactId)
            const localVarPath = `/ingestion/artifacts/{artifact_id}/content/stream`
                .replace(`{${"artifact_id"}}`, encodeURIComponent(String(artifactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download artifact string content.  Args:     artifact_id (str): Artifact ID.  Returns:     PlainTextResponse: String content.
         * @summary Download Artifact String
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet: async (artifactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet', 'artifactId', artifactId)
            const localVarPath = `/ingestion/artifacts/{artifact_id}/content/string`
                .replace(`{${"artifact_id"}}`, encodeURIComponent(String(artifactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download file buffer content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Buffer content.
         * @summary Download File Buffer
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileBufferGeneralFilesFileIdContentBufferGet: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadFileBufferGeneralFilesFileIdContentBufferGet', 'fileId', fileId)
            const localVarPath = `/general/files/{file_id}/content/buffer`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download file object content.  Args:     file_id (str): File ID.  Returns:     Any: Object content.
         * @summary Download File Object
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileObjectGeneralFilesFileIdContentObjectGet: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadFileObjectGeneralFilesFileIdContentObjectGet', 'fileId', fileId)
            const localVarPath = `/general/files/{file_id}/content/object`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download file stream content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Stream content.
         * @summary Download File Stream
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStreamGeneralFilesFileIdContentStreamGet: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadFileStreamGeneralFilesFileIdContentStreamGet', 'fileId', fileId)
            const localVarPath = `/general/files/{file_id}/content/stream`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download file string content.  Args:     file_id (str): File ID.  Returns:     PlainTextResponse: String content.
         * @summary Download File String
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStringGeneralFilesFileIdContentStringGet: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadFileStringGeneralFilesFileIdContentStringGet', 'fileId', fileId)
            const localVarPath = `/general/files/{file_id}/content/string`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export agent as archive.  Args:     agent_id (str): Agent ID.  Returns:     FileResponse: Archive file.
         * @summary Export Agent Archive
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAgentArchive: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('exportAgentArchive', 'agentId', agentId)
            const localVarPath = `/agent/agents/{agent_id}/export/archive`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export ELMA365 toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
         * @summary Export Elma365 Toolset Archive
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetArchive: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('exportELMA365ToolkitToolsetArchive', 'toolsetId', toolsetId)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/export/archive`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export ELMA365 toolset as buffer.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
         * @summary Export Elma365 Toolset Buffer
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetBuffer: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('exportELMA365ToolkitToolsetBuffer', 'toolsetId', toolsetId)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/export/buffer`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export ELMA365 toolset as object.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetExchange: Object content.
         * @summary Export Elma365 Toolset Object
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetObject: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('exportELMA365ToolkitToolsetObject', 'toolsetId', toolsetId)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/export/object`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export ELMA365 toolset as stream.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
         * @summary Export Elma365 Toolset Stream
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetStream: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('exportELMA365ToolkitToolsetStream', 'toolsetId', toolsetId)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/export/stream`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export ELMA365 toolset as string.  Args:     toolset_id (str): Toolset ID.  Returns:     PlainTextResponse: String content.
         * @summary Export Elma365 Toolset String
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetString: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('exportELMA365ToolkitToolsetString', 'toolsetId', toolsetId)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/export/string`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export folder as archive.  Args:     folder_id (str): Folder ID.  Returns:     FileResponse: Archive file.
         * @summary Export Folder Archive
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFolderArchive: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('exportFolderArchive', 'folderId', folderId)
            const localVarPath = `/general/folders/{folder_id}/export/archive`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export project as archive.  Args:     project_id (str): Project ID.  Returns:     FileResponse: Archive file.
         * @summary Export Project Archive
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProjectArchive: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('exportProjectArchive', 'projectId', projectId)
            const localVarPath = `/general/projects/{project_id}/export/archive`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
         * @summary Export Toolset Archive
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToolsetArchive: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('exportToolsetArchive', 'toolsetId', toolsetId)
            const localVarPath = `/agent/toolsets/{toolset_id}/export/archive`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get general information about application.  Returns:     AboutInfo: General information about application.
         * @summary Get About Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAboutInfoInfoApplicationAboutGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info/application/about`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all folders.  Returns:     List[FolderModel]: Found folders.
         * @summary Get All Folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFolders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/folders/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a current identity.  Returns:     IdentityModel: Current identity.
         * @summary Get Current Identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIdentity: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/identities/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Current
         * @param {string} projectId 
         * @param {boolean | null} [withSources] 
         * @param {boolean | null} [withResources] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIngestionStateProjectIdGet: async (projectId: string, withSources?: boolean | null, withResources?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getCurrentIngestionStateProjectIdGet', 'projectId', projectId)
            const localVarPath = `/ingestion/state/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (withSources !== undefined) {
                localVarQueryParameter['with_sources'] = withSources;
            }

            if (withResources !== undefined) {
                localVarQueryParameter['with_resources'] = withResources;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of available features and their active statuses.
         * @summary Get available feature flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureFlagsFeatureManagementGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/feature-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get health information about application.  Returns:     HealthInfo: Health information about application.
         * @summary Get Health Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthInfoInfoApplicationHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info/application/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one agent.  Args:     agent_id (str): Agent ID.  Returns:     AgentModel: Found agent.
         * @summary Get One Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgent: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getOneAgent', 'agentId', agentId)
            const localVarPath = `/agent/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one message.  Args:     message_id (str): Message ID.  Returns:     AgentMessageModel: Found message.
         * @summary Get One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentMessage: async (messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getOneAgentMessage', 'messageId', messageId)
            const localVarPath = `/agent/messages/{message_id}`
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one agent relation.  Args:     relation_id (str): Agent relation ID.  Returns:     AgentRelationModel: Found agent relation.
         * @summary Get One Relation
         * @param {string} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentRelation: async (relationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('getOneAgentRelation', 'relationId', relationId)
            const localVarPath = `/agent/relations/{relation_id}`
                .replace(`{${"relation_id"}}`, encodeURIComponent(String(relationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one resource.  Args:     resource_id (str): Agent resource ID.  Returns:     AgentResourceModel: Found agent resource.
         * @summary Get One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentResource: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getOneAgentResource', 'resourceId', resourceId)
            const localVarPath = `/agent/resources/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
         * @summary Get One Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getOneAgentRun', 'runId', runId)
            const localVarPath = `/agent/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
         * @summary Get One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentThread: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('getOneAgentThread', 'threadId', threadId)
            const localVarPath = `/agent/threads/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one user run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
         * @summary Get One User Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentUserRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getOneAgentUserRun', 'runId', runId)
            const localVarPath = `/agent/runs/{run_id}/user`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
         * @summary Get One User Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentUserThread: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('getOneAgentUserThread', 'threadId', threadId)
            const localVarPath = `/agent/threads/{thread_id}/user`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one ApiKey.  Args:     api_key_id (str): ApiKey ID.  Returns:     ApiKeyModel: Found ApiKey.
         * @summary Get One Api Key
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneApiKeySecurityApiKeysApiKeyIdGet: async (apiKeyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('getOneApiKeySecurityApiKeysApiKeyIdGet', 'apiKeyId', apiKeyId)
            const localVarPath = `/security/api_keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one artifact.  Args:     artifact_id (str): Artifact ID.  Returns:     IngestionArtifactModel: Found artifacts.
         * @summary Get One Artifact
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneArtifactIngestionArtifactsArtifactIdGet: async (artifactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('getOneArtifactIngestionArtifactsArtifactIdGet', 'artifactId', artifactId)
            const localVarPath = `/ingestion/artifacts/{artifact_id}`
                .replace(`{${"artifact_id"}}`, encodeURIComponent(String(artifactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one connector.  Args:     connector_id (str): Connector ID.  Returns:     ConnectorModel: Found connector.
         * @summary Get One Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneConnector: async (connectorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('getOneConnector', 'connectorId', connectorId)
            const localVarPath = `/general/connectors/{connector_id}`
                .replace(`{${"connector_id"}}`, encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one ELMA365 application.  Args:     application_id (str): Application ID.  Returns:     ELMA365ApplicationModel: Found ELMA365 application.
         * @summary Get One Elma365 Application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitApplication: async (applicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('getOneELMA365ToolkitApplication', 'applicationId', applicationId)
            const localVarPath = `/toolkits/elma365/applications/{application_id}`
                .replace(`{${"application_id"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one ELMA365 namespace.  Args:     namespace_id (str): Namespace ID.  Returns:     ELMA365NamespaceModel: Found ELMA365 namespace.
         * @summary Get One Elma365 Namespace
         * @param {string} namespaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitNamespace: async (namespaceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'namespaceId' is not null or undefined
            assertParamExists('getOneELMA365ToolkitNamespace', 'namespaceId', namespaceId)
            const localVarPath = `/toolkits/elma365/namespaces/{namespace_id}`
                .replace(`{${"namespace_id"}}`, encodeURIComponent(String(namespaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one ELMA365 process.  Args:     process_id (str): Process ID.  Returns:     ELMA365ProcessModel: Found ELMA365 process.
         * @summary Get One Elma365 Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitProcess: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getOneELMA365ToolkitProcess', 'processId', processId)
            const localVarPath = `/toolkits/elma365/processes/{process_id}`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolModel: Found ELMA365 tool.
         * @summary Get One Elma365 Tool
         * @param {string} toolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitTool: async (toolId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('getOneELMA365ToolkitTool', 'toolId', toolId)
            const localVarPath = `/toolkits/elma365/tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetModel: Found ELMA365 toolset.
         * @summary Get One Elma365 Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitToolset: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('getOneELMA365ToolkitToolset', 'toolsetId', toolsetId)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one ELMA365 version.  Args:     version_id (str): Version ID.  Returns:     ELMA365VersionModel: Found ELMA365 version.
         * @summary Get One Elma365 Version
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitVersion: async (versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getOneELMA365ToolkitVersion', 'versionId', versionId)
            const localVarPath = `/toolkits/elma365/versions/{version_id}`
                .replace(`{${"version_id"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one file.  Args:     file_id (str): File ID.  Returns:     FileModel: Found file.
         * @summary Get One File
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneFileGeneralFilesFileIdGet: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getOneFileGeneralFilesFileIdGet', 'fileId', fileId)
            const localVarPath = `/general/files/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one folder.  Args:     folder_id (str): Folder ID.  Returns:     FolderModel: Found folder.
         * @summary Get One Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('getOneFolder', 'folderId', folderId)
            const localVarPath = `/general/folders/{folder_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one message.  Args:     message_id (str): Message ID.  Returns:     SearchMessageModel: Found message.
         * @summary Get One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneMessageSearchMessagesMessageIdGet: async (messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getOneMessageSearchMessagesMessageIdGet', 'messageId', messageId)
            const localVarPath = `/search/messages/{message_id}`
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one operation.  Args:     operation_id (str): Operation ID.  Returns:     OperationModel: Found operation.
         * @summary Get One Operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneOperationGeneralOperationsOperationIdGet: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getOneOperationGeneralOperationsOperationIdGet', 'operationId', operationId)
            const localVarPath = `/general/operations/{operation_id}`
                .replace(`{${"operation_id"}}`, encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one process.  Args:     process_id (str): Process ID.  Returns:     IngestionProcessModel: Found process.
         * @summary Get One Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneProcessIngestionProcessesProcessIdGet: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getOneProcessIngestionProcessesProcessIdGet', 'processId', processId)
            const localVarPath = `/ingestion/processes/{process_id}`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one project.  Args:     project_id (str): Project ID.  Returns:     ProjectModel: Found project.
         * @summary Get One Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneProjectGeneralProjectsProjectIdGet: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getOneProjectGeneralProjectsProjectIdGet', 'projectId', projectId)
            const localVarPath = `/general/projects/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one provider.  Args:     provider_id (str): Provider ID.  Returns:     ProviderModel: Found provider.
         * @summary Get One Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneProviderGeneralProvidersProviderIdGet: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getOneProviderGeneralProvidersProviderIdGet', 'providerId', providerId)
            const localVarPath = `/general/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one resource.  Args:     resource_id (str): Resource ID.  Returns:     IngestionResourceModel: Found resource.
         * @summary Get One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneResourceIngestionResourcesResourceIdGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('getOneResourceIngestionResourcesResourceIdGet', 'resourceId', resourceId)
            const localVarPath = `/ingestion/resources/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one run.  Args:     run_id (str): Run ID.  Returns:     SearchRunModel: Found Run.
         * @summary Get One Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneRunSearchRunsRunIdGet: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getOneRunSearchRunsRunIdGet', 'runId', runId)
            const localVarPath = `/search/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get One Signal
         * @param {string} signalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneSignalIngestionSignalsSignalIdGet: async (signalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signalId' is not null or undefined
            assertParamExists('getOneSignalIngestionSignalsSignalIdGet', 'signalId', signalId)
            const localVarPath = `/ingestion/signals/{signal_id}`
                .replace(`{${"signal_id"}}`, encodeURIComponent(String(signalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get One Source
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneSourceIngestionSourcesSourceIdGet: async (sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getOneSourceIngestionSourcesSourceIdGet', 'sourceId', sourceId)
            const localVarPath = `/ingestion/sources/{source_id}`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
         * @summary Get One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneThreadSearchThreadsThreadIdGet: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('getOneThreadSearchThreadsThreadIdGet', 'threadId', threadId)
            const localVarPath = `/search/threads/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ToolsetModel: Found toolset.
         * @summary Get One Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneToolset: async (toolsetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('getOneToolset', 'toolsetId', toolsetId)
            const localVarPath = `/agent/toolsets/{toolset_id}`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one trace provider.  Args:     trace_provider_id (str): Trace provider ID.  Returns:     TraceProviderModel: Found trace provider.
         * @summary Get One Trace Provider
         * @param {string} traceProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet: async (traceProviderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'traceProviderId' is not null or undefined
            assertParamExists('getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet', 'traceProviderId', traceProviderId)
            const localVarPath = `/general/trace/providers/{trace_provider_id}`
                .replace(`{${"trace_provider_id"}}`, encodeURIComponent(String(traceProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
         * @summary Get One User Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneUserThreadSearchThreadsThreadIdUserGet: async (threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('getOneUserThreadSearchThreadsThreadIdUserGet', 'threadId', threadId)
            const localVarPath = `/search/threads/{thread_id}/user`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Schedule
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule: async (scheduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('getSchedule', 'scheduleId', scheduleId)
            const localVarPath = `/ingestion/schedules/{schedule_id}`
                .replace(`{${"schedule_id"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one session.  Args:     public_id (str): Session public ID.  Returns:     SessionModel: Found session.
         * @summary Get Session
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('getSession', 'publicId', publicId)
            const localVarPath = `/security/sessions/{public_id}`
                .replace(`{${"public_id"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check session requirement.  Args:     f_agent_id (str): Agent ID.     f_connector_id (str): Connector ID.  Returns:     SessionRequirementModel: Session requirement response.
         * @summary Is Session Required
         * @param {string | null} [fAgentId] 
         * @param {string | null} [fConnectorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionRequirement: async (fAgentId?: string | null, fConnectorId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/sessions/required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fAgentId !== undefined) {
                localVarQueryParameter['f_agent_id'] = fAgentId;
            }

            if (fConnectorId !== undefined) {
                localVarQueryParameter['f_connector_id'] = fConnectorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Source Details
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet: async (projectId: string, sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet', 'projectId', projectId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet', 'sourceId', sourceId)
            const localVarPath = `/ingestion/state/{project_id}/sources/{source_id}/details`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Source
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceIngestionStateProjectIdSourcesSourceIdGet: async (projectId: string, sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getSourceIngestionStateProjectIdSourcesSourceIdGet', 'projectId', projectId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getSourceIngestionStateProjectIdSourcesSourceIdGet', 'sourceId', sourceId)
            const localVarPath = `/ingestion/state/{project_id}/sources/{source_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Source Resources
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet: async (projectId: string, sourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet', 'projectId', projectId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet', 'sourceId', sourceId)
            const localVarPath = `/ingestion/state/{project_id}/sources/{source_id}/resources`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import agent file via form.  Args:     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentCreateForm: async (folderId: string, content: File, dependencies: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importAgentCreateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importAgentCreateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importAgentCreateForm', 'dependencies', dependencies)
            const localVarPath = `/agent/agents/import/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) agent file via JSON.  Args:     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Create Json
         * @param {string} folderId 
         * @param {AgentImportBody} agentImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentCreateJson: async (folderId: string, agentImportBody: AgentImportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importAgentCreateJson', 'folderId', folderId)
            // verify required parameter 'agentImportBody' is not null or undefined
            assertParamExists('importAgentCreateJson', 'agentImportBody', agentImportBody)
            const localVarPath = `/agent/agents/import/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import agent file via form.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Update Form
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentUpdateForm: async (agentId: string, folderId: string, content: File, dependencies: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('importAgentUpdateForm', 'agentId', agentId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importAgentUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importAgentUpdateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importAgentUpdateForm', 'dependencies', dependencies)
            const localVarPath = `/agent/agents/{agent_id}/import/form`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) agent file via JSON.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Update Json
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {AgentImportBody} agentImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentUpdateJson: async (agentId: string, folderId: string, agentImportBody: AgentImportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('importAgentUpdateJson', 'agentId', agentId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importAgentUpdateJson', 'folderId', folderId)
            // verify required parameter 'agentImportBody' is not null or undefined
            assertParamExists('importAgentUpdateJson', 'agentImportBody', agentImportBody)
            const localVarPath = `/agent/agents/{agent_id}/import/json`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetCreateForm: async (folderId: string, content: File, dependencies: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetCreateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetCreateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetCreateForm', 'dependencies', dependencies)
            const localVarPath = `/toolkits/elma365/toolsets/import/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Create Json
         * @param {string} folderId 
         * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetCreateJson: async (folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetCreateJson', 'folderId', folderId)
            // verify required parameter 'eLMA365ToolsetImportBody' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetCreateJson', 'eLMA365ToolsetImportBody', eLMA365ToolsetImportBody)
            const localVarPath = `/toolkits/elma365/toolsets/import/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Update Form
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetUpdateForm: async (toolsetId: string, folderId: string, content: File, dependencies: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetUpdateForm', 'toolsetId', toolsetId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetUpdateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetUpdateForm', 'dependencies', dependencies)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/import/form`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Update Json
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetUpdateJson: async (toolsetId: string, folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetUpdateJson', 'toolsetId', toolsetId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetUpdateJson', 'folderId', folderId)
            // verify required parameter 'eLMA365ToolsetImportBody' is not null or undefined
            assertParamExists('importELMA365ToolkitToolsetUpdateJson', 'eLMA365ToolsetImportBody', eLMA365ToolsetImportBody)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/import/json`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) folder file via form.  Args:     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Create Form
         * @param {File} content 
         * @param {File} dependencies 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderCreateForm: async (content: File, dependencies: File, folderId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importFolderCreateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importFolderCreateForm', 'dependencies', dependencies)
            const localVarPath = `/general/folders/import/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) folder file via JSON.  Args:     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Create Json
         * @param {FolderImportBody} folderImportBody 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderCreateJson: async (folderImportBody: FolderImportBody, folderId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderImportBody' is not null or undefined
            assertParamExists('importFolderCreateJson', 'folderImportBody', folderImportBody)
            const localVarPath = `/general/folders/import/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import folder file via form.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Update Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderUpdateForm: async (folderId: string, content: File, dependencies: File, folderId2?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importFolderUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importFolderUpdateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importFolderUpdateForm', 'dependencies', dependencies)
            const localVarPath = `/general/folders/{folder_id}/import/form`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId2 !== undefined) {
                localVarQueryParameter['folder_id'] = folderId2;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (update) folder file via JSON.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Update Json
         * @param {string} folderId 
         * @param {FolderImportBody} folderImportBody 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderUpdateJson: async (folderId: string, folderImportBody: FolderImportBody, folderId2?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importFolderUpdateJson', 'folderId', folderId)
            // verify required parameter 'folderImportBody' is not null or undefined
            assertParamExists('importFolderUpdateJson', 'folderImportBody', folderImportBody)
            const localVarPath = `/general/folders/{folder_id}/import/json`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId2 !== undefined) {
                localVarQueryParameter['folder_id'] = folderId2;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) project file via form.  Args:     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectCreateForm: async (folderId: string, content: File, dependencies: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importProjectCreateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importProjectCreateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importProjectCreateForm', 'dependencies', dependencies)
            const localVarPath = `/general/projects/import/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (create) project file via JSON.  Args:     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Create Json
         * @param {string} folderId 
         * @param {ProjectImportBody} projectImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectCreateJson: async (folderId: string, projectImportBody: ProjectImportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importProjectCreateJson', 'folderId', folderId)
            // verify required parameter 'projectImportBody' is not null or undefined
            assertParamExists('importProjectCreateJson', 'projectImportBody', projectImportBody)
            const localVarPath = `/general/projects/import/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (update) project file via form.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Update Form
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectUpdateForm: async (projectId: string, folderId: string, content: File, dependencies: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('importProjectUpdateForm', 'projectId', projectId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importProjectUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('importProjectUpdateForm', 'content', content)
            // verify required parameter 'dependencies' is not null or undefined
            assertParamExists('importProjectUpdateForm', 'dependencies', dependencies)
            const localVarPath = `/general/projects/{project_id}/import/form`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
            if (dependencies !== undefined) { 
                localVarFormParams.append('dependencies', dependencies as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import (update) project file via JSON.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Update Json
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {ProjectImportBody} projectImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectUpdateJson: async (projectId: string, folderId: string, projectImportBody: ProjectImportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('importProjectUpdateJson', 'projectId', projectId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('importProjectUpdateJson', 'folderId', folderId)
            // verify required parameter 'projectImportBody' is not null or undefined
            assertParamExists('importProjectUpdateJson', 'projectImportBody', projectImportBody)
            const localVarPath = `/general/projects/{project_id}/import/json`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectImportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect agent file via form.  Args:     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentCreateForm: async (folderId: string, content: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectAgentCreateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectAgentCreateForm', 'content', content)
            const localVarPath = `/agent/agents/inspect/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect agent file via JSON.  Args:     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Create Json
         * @param {string} folderId 
         * @param {AgentInspectionBody} agentInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentCreateJson: async (folderId: string, agentInspectionBody: AgentInspectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectAgentCreateJson', 'folderId', folderId)
            // verify required parameter 'agentInspectionBody' is not null or undefined
            assertParamExists('inspectAgentCreateJson', 'agentInspectionBody', agentInspectionBody)
            const localVarPath = `/agent/agents/inspect/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect (update) agent file via form.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Update Form
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentUpdateForm: async (agentId: string, folderId: string, content: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('inspectAgentUpdateForm', 'agentId', agentId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectAgentUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectAgentUpdateForm', 'content', content)
            const localVarPath = `/agent/agents/{agent_id}/inspect/form`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspec (update) agent file via JSON.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Update Json
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {AgentInspectionBody} agentInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentUpdateJson: async (agentId: string, folderId: string, agentInspectionBody: AgentInspectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('inspectAgentUpdateJson', 'agentId', agentId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectAgentUpdateJson', 'folderId', folderId)
            // verify required parameter 'agentInspectionBody' is not null or undefined
            assertParamExists('inspectAgentUpdateJson', 'agentInspectionBody', agentInspectionBody)
            const localVarPath = `/agent/agents/{agent_id}/inspect/json`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetCreateForm: async (folderId: string, content: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetCreateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetCreateForm', 'content', content)
            const localVarPath = `/toolkits/elma365/toolsets/inspect/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Create Json
         * @param {string} folderId 
         * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetCreateJson: async (folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetCreateJson', 'folderId', folderId)
            // verify required parameter 'eLMA365ToolsetInspectionBody' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetCreateJson', 'eLMA365ToolsetInspectionBody', eLMA365ToolsetInspectionBody)
            const localVarPath = `/toolkits/elma365/toolsets/inspect/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Update Form
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetUpdateForm: async (toolsetId: string, folderId: string, content: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetUpdateForm', 'toolsetId', toolsetId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetUpdateForm', 'content', content)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/inspect/form`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspec (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Update Json
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetUpdateJson: async (toolsetId: string, folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetUpdateJson', 'toolsetId', toolsetId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetUpdateJson', 'folderId', folderId)
            // verify required parameter 'eLMA365ToolsetInspectionBody' is not null or undefined
            assertParamExists('inspectELMA365ToolkitToolsetUpdateJson', 'eLMA365ToolsetInspectionBody', eLMA365ToolsetInspectionBody)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/inspect/json`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect folder file via form.  Args:     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Create Form
         * @param {File} content 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderCreateForm: async (content: File, folderId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectFolderCreateForm', 'content', content)
            const localVarPath = `/general/folders/inspect/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect folder file via JSON.  Args:     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Create Json
         * @param {FolderInspectionBody} folderInspectionBody 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderCreateJson: async (folderInspectionBody: FolderInspectionBody, folderId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderInspectionBody' is not null or undefined
            assertParamExists('inspectFolderCreateJson', 'folderInspectionBody', folderInspectionBody)
            const localVarPath = `/general/folders/inspect/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect (update) folder file via form.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Update Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderUpdateForm: async (folderId: string, content: File, folderId2?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectFolderUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectFolderUpdateForm', 'content', content)
            const localVarPath = `/general/folders/{folder_id}/inspect/form`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId2 !== undefined) {
                localVarQueryParameter['folder_id'] = folderId2;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspec (update) folder file via JSON.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Update Json
         * @param {string} folderId 
         * @param {FolderInspectionBody} folderInspectionBody 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderUpdateJson: async (folderId: string, folderInspectionBody: FolderInspectionBody, folderId2?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectFolderUpdateJson', 'folderId', folderId)
            // verify required parameter 'folderInspectionBody' is not null or undefined
            assertParamExists('inspectFolderUpdateJson', 'folderInspectionBody', folderInspectionBody)
            const localVarPath = `/general/folders/{folder_id}/inspect/json`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId2 !== undefined) {
                localVarQueryParameter['folder_id'] = folderId2;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect project file via form.  Args:     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectCreateForm: async (folderId: string, content: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectProjectCreateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectProjectCreateForm', 'content', content)
            const localVarPath = `/general/projects/inspect/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect project file via JSON.  Args:     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Create Json
         * @param {string} folderId 
         * @param {ProjectInspectionBody} projectInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectCreateJson: async (folderId: string, projectInspectionBody: ProjectInspectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectProjectCreateJson', 'folderId', folderId)
            // verify required parameter 'projectInspectionBody' is not null or undefined
            assertParamExists('inspectProjectCreateJson', 'projectInspectionBody', projectInspectionBody)
            const localVarPath = `/general/projects/inspect/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspect (update) project file via form.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Update Form
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectUpdateForm: async (projectId: string, folderId: string, content: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('inspectProjectUpdateForm', 'projectId', projectId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectProjectUpdateForm', 'folderId', folderId)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('inspectProjectUpdateForm', 'content', content)
            const localVarPath = `/general/projects/{project_id}/inspect/form`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inspec (update) project file via JSON.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Update Json
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {ProjectInspectionBody} projectInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectUpdateJson: async (projectId: string, folderId: string, projectInspectionBody: ProjectInspectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('inspectProjectUpdateJson', 'projectId', projectId)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('inspectProjectUpdateJson', 'folderId', folderId)
            // verify required parameter 'projectInspectionBody' is not null or undefined
            assertParamExists('inspectProjectUpdateJson', 'projectInspectionBody', projectInspectionBody)
            const localVarPath = `/general/projects/{project_id}/inspect/json`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectInspectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Sources Details
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet', 'projectId', projectId)
            const localVarPath = `/ingestion/state/{project_id}/sources/details`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Sources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSourcesIngestionStateProjectIdSourcesGet: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('listSourcesIngestionStateProjectIdSourcesGet', 'projectId', projectId)
            const localVarPath = `/ingestion/state/{project_id}/sources`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Sources Resources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet', 'projectId', projectId)
            const localVarPath = `/ingestion/state/{project_id}/sources/resources`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain ELMA365 applications.  Args:     request (ELMA365ApplicationObtainingRequest): Applications obtaining request.  Returns:     ELMA365ApplicationObtainingResponse: Applications obtaining response.
         * @summary Obtain Elma365 Application
         * @param {ELMA365ApplicationObtainingRequest} eLMA365ApplicationObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitApplications: async (eLMA365ApplicationObtainingRequest: ELMA365ApplicationObtainingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365ApplicationObtainingRequest' is not null or undefined
            assertParamExists('obtainELMA365ToolkitApplications', 'eLMA365ApplicationObtainingRequest', eLMA365ApplicationObtainingRequest)
            const localVarPath = `/toolkits/elma365/applications/obtain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ApplicationObtainingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain ELMA365 namespaces.  Args:     request (ELMA365NamespaceObtainingRequest): Namespaces obtaining request.  Returns:     ELMA365NamespaceObtainingResponse: Namespaces obtaining response.
         * @summary Obtain Elma365 Namespace
         * @param {ELMA365NamespaceObtainingRequest} eLMA365NamespaceObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitNamespaces: async (eLMA365NamespaceObtainingRequest: ELMA365NamespaceObtainingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365NamespaceObtainingRequest' is not null or undefined
            assertParamExists('obtainELMA365ToolkitNamespaces', 'eLMA365NamespaceObtainingRequest', eLMA365NamespaceObtainingRequest)
            const localVarPath = `/toolkits/elma365/namespaces/obtain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365NamespaceObtainingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain ELMA365 processes.  Args:     request (ELMA365ProcessObtainingRequest): Processes obtaining request.  Returns:     ELMA365ProcessObtainingResponse: Processes obtaining response.
         * @summary Obtain Elma365 Process
         * @param {ELMA365ProcessObtainingRequest} eLMA365ProcessObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitProcesses: async (eLMA365ProcessObtainingRequest: ELMA365ProcessObtainingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365ProcessObtainingRequest' is not null or undefined
            assertParamExists('obtainELMA365ToolkitProcesses', 'eLMA365ProcessObtainingRequest', eLMA365ProcessObtainingRequest)
            const localVarPath = `/toolkits/elma365/processes/obtain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ProcessObtainingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain ELMA365 tools.  Args:     request (ELMA365ToolObtainingRequest): Tools obtaining request.  Returns:     ELMA365ToolObtainingResponse: Tools obtaining response.
         * @summary Obtain Elma365 Tools
         * @param {ELMA365ToolObtainingRequest} eLMA365ToolObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitTools: async (eLMA365ToolObtainingRequest: ELMA365ToolObtainingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365ToolObtainingRequest' is not null or undefined
            assertParamExists('obtainELMA365ToolkitTools', 'eLMA365ToolObtainingRequest', eLMA365ToolObtainingRequest)
            const localVarPath = `/toolkits/elma365/tools/obtain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolObtainingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain system folder.  Returns:     FolderModel: System folder.
         * @summary Obtain System Folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainSystemFolder: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/folders/system`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll the status of an OAuth2 connector check.  Args:     check_id (str): Check ID returned from checkConnector.  Returns:     ConnectorCheckOAuthPollingResponse: Current check status.
         * @summary Poll Connector Oauth Check
         * @param {string} checkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollConnectorOAuthCheck: async (checkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkId' is not null or undefined
            assertParamExists('pollConnectorOAuthCheck', 'checkId', checkId)
            const localVarPath = `/general/connectors/check/oauth/{check_id}`
                .replace(`{${"check_id"}}`, encodeURIComponent(String(checkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve request.  Args:     request (RetrieveRequest): Retrieve request.  Returns:     RetrieveResponse: Retrieve response.
         * @summary Retrieve
         * @param {RetrieveRequest} retrieveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveSearchRetrievePost: async (retrieveRequest: RetrieveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retrieveRequest' is not null or undefined
            assertParamExists('retrieveSearchRetrievePost', 'retrieveRequest', retrieveRequest)
            const localVarPath = `/search/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retrieveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search all messages (ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
         * @summary Search All Messages
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentAllMessages: async (fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/messages/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (fRunIds) {
                localVarQueryParameter['f_run_ids'] = fRunIds;
            }

            if (sOrder !== undefined) {
                localVarQueryParameter['s_order'] = sOrder;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentAllRuns: async (fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/runs/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fCreatedOnMin !== undefined) {
                localVarQueryParameter['f_created_on_min'] = (fCreatedOnMin as any instanceof Date) ?
                    (fCreatedOnMin as any).toISOString() :
                    fCreatedOnMin;
            }

            if (fCreatedOnMax !== undefined) {
                localVarQueryParameter['f_created_on_max'] = (fCreatedOnMax as any instanceof Date) ?
                    (fCreatedOnMax as any).toISOString() :
                    fCreatedOnMax;
            }

            if (sOrder !== undefined) {
                localVarQueryParameter['s_order'] = sOrder;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search all threads (Ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
         * @summary Search All Threads
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {string | null} [fSourceRef] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentAllThreads: async (fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/threads/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fCreatedOnMin !== undefined) {
                localVarQueryParameter['f_created_on_min'] = (fCreatedOnMin as any instanceof Date) ?
                    (fCreatedOnMin as any).toISOString() :
                    fCreatedOnMin;
            }

            if (fCreatedOnMax !== undefined) {
                localVarQueryParameter['f_created_on_max'] = (fCreatedOnMax as any instanceof Date) ?
                    (fCreatedOnMax as any).toISOString() :
                    fCreatedOnMax;
            }

            if (fSourceRef !== undefined) {
                localVarQueryParameter['f_source_ref'] = fSourceRef;
            }

            if (sOrder !== undefined) {
                localVarQueryParameter['s_order'] = sOrder;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search agent relations.  Args:     f_managing_agent_ids (Optional[List[str]]): Managing agent IDs.     f_managed_agent_ids (Optional[List[str]]): Managed agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRelationModel]: Found agent relations.
         * @summary Search Relations
         * @param {Array<string> | null} [fManagingAgentIds] 
         * @param {Array<string> | null} [fManagedAgentIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentRelations: async (fManagingAgentIds?: Array<string> | null, fManagedAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/relations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fManagingAgentIds) {
                localVarQueryParameter['f_managing_agent_ids'] = fManagingAgentIds;
            }

            if (fManagedAgentIds) {
                localVarQueryParameter['f_managed_agent_ids'] = fManagedAgentIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search agent resources.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentResourceModel]: Found agent resources.
         * @summary Search Resources
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentResources: async (fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/resources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search user messages.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
         * @summary Search User Messages
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentUserMessages: async (fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/messages/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (fRunIds) {
                localVarQueryParameter['f_run_ids'] = fRunIds;
            }

            if (sOrder !== undefined) {
                localVarQueryParameter['s_order'] = sOrder;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentUserRuns: async (fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/runs/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fCreatedOnMin !== undefined) {
                localVarQueryParameter['f_created_on_min'] = (fCreatedOnMin as any instanceof Date) ?
                    (fCreatedOnMin as any).toISOString() :
                    fCreatedOnMin;
            }

            if (fCreatedOnMax !== undefined) {
                localVarQueryParameter['f_created_on_max'] = (fCreatedOnMax as any instanceof Date) ?
                    (fCreatedOnMax as any).toISOString() :
                    fCreatedOnMax;
            }

            if (sOrder !== undefined) {
                localVarQueryParameter['s_order'] = sOrder;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search user threads.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
         * @summary Search User Threads
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {string | null} [fSourceRef] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentUserThreads: async (fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/threads/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fCreatedOnMin !== undefined) {
                localVarQueryParameter['f_created_on_min'] = (fCreatedOnMin as any instanceof Date) ?
                    (fCreatedOnMin as any).toISOString() :
                    fCreatedOnMin;
            }

            if (fCreatedOnMax !== undefined) {
                localVarQueryParameter['f_created_on_max'] = (fCreatedOnMax as any instanceof Date) ?
                    (fCreatedOnMax as any).toISOString() :
                    fCreatedOnMax;
            }

            if (fSourceRef !== undefined) {
                localVarQueryParameter['f_source_ref'] = fSourceRef;
            }

            if (sOrder !== undefined) {
                localVarQueryParameter['s_order'] = sOrder;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search agents.  Args:     f_search_text (Optional[str]): Agent search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_interface_types (Optional[List[DataInterfaceType]]): Agent interface types.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentModel]: Found Agents.
         * @summary Search Agents
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<DataInterfaceType> | null} [fInterfaceTypes] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgents: async (fSearchText?: string | null, fFolderIds?: Array<string> | null, fInterfaceTypes?: Array<DataInterfaceType> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fFolderIds) {
                localVarQueryParameter['f_folder_ids'] = fFolderIds;
            }

            if (fInterfaceTypes) {
                localVarQueryParameter['f_interface_types'] = fInterfaceTypes;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search all messages (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
         * @summary Search All Messages
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllMessagesSearchMessagesAllGet: async (fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search/messages/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (fRunIds) {
                localVarQueryParameter['f_run_ids'] = fRunIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search all threads (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
         * @summary Search All Threads
         * @param {Array<string> | null} [fProjectIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllThreadsSearchThreadsAllGet: async (fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search/threads/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fCreatedOnMin !== undefined) {
                localVarQueryParameter['f_created_on_min'] = (fCreatedOnMin as any instanceof Date) ?
                    (fCreatedOnMin as any).toISOString() :
                    fCreatedOnMin;
            }

            if (fCreatedOnMax !== undefined) {
                localVarQueryParameter['f_created_on_max'] = (fCreatedOnMax as any instanceof Date) ?
                    (fCreatedOnMax as any).toISOString() :
                    fCreatedOnMax;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ApiKeys.  Args:     f_scope_ref_types (List[ApiKeyScopeRefType]): Scope ref object types.     f_scope_ref_ids (List[str]): Scope ref object IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ApiKeyModel]: Found ApiKeys.
         * @summary Search Api Keys
         * @param {Array<ApiKeyScopeRefType> | null} [fScopeRefTypes] 
         * @param {Array<string> | null} [fScopeRefIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApiKeysSecurityApiKeysGet: async (fScopeRefTypes?: Array<ApiKeyScopeRefType> | null, fScopeRefIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/security/api_keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fScopeRefTypes) {
                localVarQueryParameter['f_scope_ref_types'] = fScopeRefTypes;
            }

            if (fScopeRefIds) {
                localVarQueryParameter['f_scope_ref_ids'] = fScopeRefIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search artifacts.  Args:     f_artifact_ids (Optional[List[str]]): Artifact IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_resource_ids (Optional[List[str]]): Resource IDs.     f_parent_ids (Optional[List[Optional[str]]]): Parent IDs.     f_file_ids (Optional[List[Optional[str]]]): File IDs.     f_types (Optional[List[IngestionArtifactType]]): Artifact types.     f_origins (Optional[List[IngestionArtifactOrigin]]): Artifact actions.     f_actions (Optional[List[IngestionArtifactCommand]]): Artifact commands.     f_node_ids (Optional[List[str]]): Node IDs.     f_node_classes (Optional[List[IngestionNodeClass]]): Node classes.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionArtifactModel]: Found artifacts.
         * @summary Search Artifacts
         * @param {Array<string> | null} [fArtifactIds] 
         * @param {Array<string> | null} [fPublicIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<string> | null} [fResourceIds] 
         * @param {Array<string> | null} [fParentIds] 
         * @param {Array<string> | null} [fFileIds] 
         * @param {Array<IngestionArtifactType> | null} [fTypes] 
         * @param {Array<IngestionArtifactOrigin> | null} [fOrigins] 
         * @param {Array<IngestionArtifactAction> | null} [fActions] 
         * @param {Array<string> | null} [fNodeIds] 
         * @param {Array<IngestionNodeClass> | null} [fNodeClasses] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArtifactsIngestionArtifactsGet: async (fArtifactIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fResourceIds?: Array<string> | null, fParentIds?: Array<string> | null, fFileIds?: Array<string> | null, fTypes?: Array<IngestionArtifactType> | null, fOrigins?: Array<IngestionArtifactOrigin> | null, fActions?: Array<IngestionArtifactAction> | null, fNodeIds?: Array<string> | null, fNodeClasses?: Array<IngestionNodeClass> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ingestion/artifacts/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fArtifactIds) {
                localVarQueryParameter['f_artifact_ids'] = fArtifactIds;
            }

            if (fPublicIds) {
                localVarQueryParameter['f_public_ids'] = fPublicIds;
            }

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fSourceIds) {
                localVarQueryParameter['f_source_ids'] = fSourceIds;
            }

            if (fResourceIds) {
                localVarQueryParameter['f_resource_ids'] = fResourceIds;
            }

            if (fParentIds) {
                localVarQueryParameter['f_parent_ids'] = fParentIds;
            }

            if (fFileIds) {
                localVarQueryParameter['f_file_ids'] = fFileIds;
            }

            if (fTypes) {
                localVarQueryParameter['f_types'] = fTypes;
            }

            if (fOrigins) {
                localVarQueryParameter['f_origins'] = fOrigins;
            }

            if (fActions) {
                localVarQueryParameter['f_actions'] = fActions;
            }

            if (fNodeIds) {
                localVarQueryParameter['f_node_ids'] = fNodeIds;
            }

            if (fNodeClasses) {
                localVarQueryParameter['f_node_classes'] = fNodeClasses;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search connectors.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Connector search text.     f_statuses (Optional[List[ConnectorStatus]]): Connector statuses.     f_availabilities (Optional[List[ConnectorStatus]]): Connector availabilities.     f_auth_types (Optional[List[ConnectorAuthType]]): Connector auth types.  Returns:     PaginationResponse[ConnectorModel]: Found connectors.
         * @summary Search Connectors
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<ConnectorStatus> | null} [fStatuses] 
         * @param {Array<ConnectorAvailability> | null} [fAvailabilities] 
         * @param {Array<ConnectorAuthType> | null} [fAuthTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConnectors: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fStatuses?: Array<ConnectorStatus> | null, fAvailabilities?: Array<ConnectorAvailability> | null, fAuthTypes?: Array<ConnectorAuthType> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/connectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fAvailabilities) {
                localVarQueryParameter['f_availabilities'] = fAvailabilities;
            }

            if (fAuthTypes) {
                localVarQueryParameter['f_auth_types'] = fAuthTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ELMA365 applications.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Application search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_statuses (Optional[List[ELMA365ApplicationStatus]]): Application statuses.     f_visibilities (Optional[List[ELMA365ApplicationVisibility]]): Application visibilities.     f_availabilities (Optional[List[ELMA365ApplicationAvailability]]): Application availabilities.  Returns:     PaginationResponse[ELMA365ApplicationModel]: Found ELMA365 applications.
         * @summary Search Elma365 Applications
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<ELMA365ApplicationStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ApplicationVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ApplicationAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitApplications: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fStatuses?: Array<ELMA365ApplicationStatus> | null, fVisibilities?: Array<ELMA365ApplicationVisibility> | null, fAvailabilities?: Array<ELMA365ApplicationAvailability> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/toolkits/elma365/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fConnectorIds) {
                localVarQueryParameter['f_connector_ids'] = fConnectorIds;
            }

            if (fToolsetIds) {
                localVarQueryParameter['f_toolset_ids'] = fToolsetIds;
            }

            if (fVersionIds) {
                localVarQueryParameter['f_version_ids'] = fVersionIds;
            }

            if (fNamespaceIds) {
                localVarQueryParameter['f_namespace_ids'] = fNamespaceIds;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fVisibilities) {
                localVarQueryParameter['f_visibilities'] = fVisibilities;
            }

            if (fAvailabilities) {
                localVarQueryParameter['f_availabilities'] = fAvailabilities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ELMA365 namespaces.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Namespace search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365NamespacenStatus]]): Namespace statuses.     f_visibilities (Optional[List[ELMA365NamespaceVisibility]]): Namespace visibilities.     f_availabilities (Optional[List[ELMA365NamespaceAvailability]]): Namespace availabilities.  Returns:     PaginationResponse[ELMA365NamespaceModel]: Found ELMA365 namespaces.
         * @summary Search Elma365 Namespaces
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<ELMA365NamespaceStatus> | null} [fStatuses] 
         * @param {Array<ELMA365NamespaceVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365NamespaceAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitNamespaces: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365NamespaceStatus> | null, fVisibilities?: Array<ELMA365NamespaceVisibility> | null, fAvailabilities?: Array<ELMA365NamespaceAvailability> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/toolkits/elma365/namespaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fConnectorIds) {
                localVarQueryParameter['f_connector_ids'] = fConnectorIds;
            }

            if (fToolsetIds) {
                localVarQueryParameter['f_toolset_ids'] = fToolsetIds;
            }

            if (fVersionIds) {
                localVarQueryParameter['f_version_ids'] = fVersionIds;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fVisibilities) {
                localVarQueryParameter['f_visibilities'] = fVisibilities;
            }

            if (fAvailabilities) {
                localVarQueryParameter['f_availabilities'] = fAvailabilities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ELMA365 processes.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Process search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_application_ids (Optional[List[str]]): Application IDs.     f_statuses (Optional[List[ELMA365ProcessStatus]]): Process statuses.     f_visibilities (Optional[List[ELMA365ProcessVisibility]]): Process visibilities.     f_availabilities (Optional[List[ELMA365ProcessAvailability]]): Process availabilities.  Returns:     PaginationResponse[ELMA365ProcessModel]: Found ELMA365 processes.
         * @summary Search Elma365 Processes
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<string> | null} [fApplicationIds] 
         * @param {Array<ELMA365ProcessStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ProcessVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ProcessAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitProcesses: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fApplicationIds?: Array<string> | null, fStatuses?: Array<ELMA365ProcessStatus> | null, fVisibilities?: Array<ELMA365ProcessVisibility> | null, fAvailabilities?: Array<ELMA365ProcessAvailability> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/toolkits/elma365/processes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fConnectorIds) {
                localVarQueryParameter['f_connector_ids'] = fConnectorIds;
            }

            if (fToolsetIds) {
                localVarQueryParameter['f_toolset_ids'] = fToolsetIds;
            }

            if (fVersionIds) {
                localVarQueryParameter['f_version_ids'] = fVersionIds;
            }

            if (fNamespaceIds) {
                localVarQueryParameter['f_namespace_ids'] = fNamespaceIds;
            }

            if (fApplicationIds) {
                localVarQueryParameter['f_application_ids'] = fApplicationIds;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fVisibilities) {
                localVarQueryParameter['f_visibilities'] = fVisibilities;
            }

            if (fAvailabilities) {
                localVarQueryParameter['f_availabilities'] = fAvailabilities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ELMA365 tools.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Tool search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_component_ids (Optional[List[str]]): Component IDs.     f_statuses (Optional[List[ELMA365ToolStatus]]): Tool statuses.     f_visibilities (Optional[List[ELMA365ToolVisibility]]): Tool visibilities.     f_availabilities (Optional[List[ELMA365ToolAvailability]]): Tool availabilities.  Returns:     PaginationResponse[ELMA365ToolModel]: Found ELMA365 tool.
         * @summary Search Elma365 Tools
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<string> | null} [fComponentIds] 
         * @param {Array<ELMA365ToolStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ToolVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ToolAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitTools: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fComponentIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolStatus> | null, fVisibilities?: Array<ELMA365ToolVisibility> | null, fAvailabilities?: Array<ELMA365ToolAvailability> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/toolkits/elma365/tools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fConnectorIds) {
                localVarQueryParameter['f_connector_ids'] = fConnectorIds;
            }

            if (fToolsetIds) {
                localVarQueryParameter['f_toolset_ids'] = fToolsetIds;
            }

            if (fVersionIds) {
                localVarQueryParameter['f_version_ids'] = fVersionIds;
            }

            if (fNamespaceIds) {
                localVarQueryParameter['f_namespace_ids'] = fNamespaceIds;
            }

            if (fComponentIds) {
                localVarQueryParameter['f_component_ids'] = fComponentIds;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fVisibilities) {
                localVarQueryParameter['f_visibilities'] = fVisibilities;
            }

            if (fAvailabilities) {
                localVarQueryParameter['f_availabilities'] = fAvailabilities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ELMA365 toolsets.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365ToolsetStatus]]): Toolset statuses.     f_visibilities (Optional[List[ELMA365ToolsetVisibility]]): Toolset visibilities.     f_availabilities (Optional[List[ELMA365ToolsetAvailability]]): Toolset availabilities.  Returns:     PaginationResponse[ELMA365ToolsetModel]: Found ELMA365 toolsets.
         * @summary Search Elma365 Toolsets
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<ELMA365ToolsetStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ToolsetVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ToolsetAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitToolsets: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fFolderIds?: Array<string> | null, fConnectorIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolsetStatus> | null, fVisibilities?: Array<ELMA365ToolsetVisibility> | null, fAvailabilities?: Array<ELMA365ToolsetAvailability> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/toolkits/elma365/toolsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fFolderIds) {
                localVarQueryParameter['f_folder_ids'] = fFolderIds;
            }

            if (fConnectorIds) {
                localVarQueryParameter['f_connector_ids'] = fConnectorIds;
            }

            if (fVersionIds) {
                localVarQueryParameter['f_version_ids'] = fVersionIds;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fVisibilities) {
                localVarQueryParameter['f_visibilities'] = fVisibilities;
            }

            if (fAvailabilities) {
                localVarQueryParameter['f_availabilities'] = fAvailabilities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search ELMA365 versions.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_statuses (Optional[List[ELMA365VersionStatus]]): Version statuses.     f_stages (Optional[List[ELMA365VersionStage]]): Version stages.     f_phases (Optional[List[ELMA365VersionPhase]]): Version phases.     f_visibilities (Optional[List[ELMA365VersionVisibility]]): Version visibilities.     f_availabilities (Optional[List[ELMA365VersionAvailability]]): Version availabilities.  Returns:     PaginationResponse[ELMA365VersionModel]: Found ELMA365 version.
         * @summary Search Elma365 Versions
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<ELMA365VersionStatus> | null} [fStatuses] 
         * @param {Array<ELMA365VersionStage> | null} [fStages] 
         * @param {Array<ELMA365VersionPhase> | null} [fPhases] 
         * @param {Array<ELMA365VersionVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365VersionAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitVersions: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fStatuses?: Array<ELMA365VersionStatus> | null, fStages?: Array<ELMA365VersionStage> | null, fPhases?: Array<ELMA365VersionPhase> | null, fVisibilities?: Array<ELMA365VersionVisibility> | null, fAvailabilities?: Array<ELMA365VersionAvailability> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/toolkits/elma365/versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fConnectorIds) {
                localVarQueryParameter['f_connector_ids'] = fConnectorIds;
            }

            if (fToolsetIds) {
                localVarQueryParameter['f_toolset_ids'] = fToolsetIds;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fStages) {
                localVarQueryParameter['f_stages'] = fStages;
            }

            if (fPhases) {
                localVarQueryParameter['f_phases'] = fPhases;
            }

            if (fVisibilities) {
                localVarQueryParameter['f_visibilities'] = fVisibilities;
            }

            if (fAvailabilities) {
                localVarQueryParameter['f_availabilities'] = fAvailabilities;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search ELMA365 applications
         * @param {string} baseUrl 
         * @param {string} xToken 
         * @param {string | null} [searchText] 
         * @param {{ [key: string]: any; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchElma365AppsElma365AppGet: async (baseUrl: string, xToken: string, searchText?: string | null, requestBody?: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUrl' is not null or undefined
            assertParamExists('searchElma365AppsElma365AppGet', 'baseUrl', baseUrl)
            // verify required parameter 'xToken' is not null or undefined
            assertParamExists('searchElma365AppsElma365AppGet', 'xToken', xToken)
            const localVarPath = `/elma365/app/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (baseUrl !== undefined) {
                localVarQueryParameter['base_url'] = baseUrl;
            }

            if (xToken !== undefined) {
                localVarQueryParameter['x_token'] = xToken;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['search_text'] = searchText;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search ELMA365 namespaces
         * @param {string} baseUrl 
         * @param {string} xToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchElma365NssElma365NsGet: async (baseUrl: string, xToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baseUrl' is not null or undefined
            assertParamExists('searchElma365NssElma365NsGet', 'baseUrl', baseUrl)
            // verify required parameter 'xToken' is not null or undefined
            assertParamExists('searchElma365NssElma365NsGet', 'xToken', xToken)
            const localVarPath = `/elma365/ns/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (baseUrl !== undefined) {
                localVarQueryParameter['base_url'] = baseUrl;
            }

            if (xToken !== undefined) {
                localVarQueryParameter['x_token'] = xToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search files.  Args:     filtration (FileFiltration): Filtration parameters.     pagination (PaginationRequest): Pagination parameters.  Returns:     PaginationResponse[FileModel]: Found files.
         * @summary Search Files Post
         * @param {BodySearchFiles} [bodySearchFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFiles: async (bodySearchFiles?: BodySearchFiles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/files/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodySearchFiles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search files.  Args:     f_file_ids (Optional[List[str]]): File IDs.     f_external_ids (Optional[List[str]]): External IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_purposes (Optional[List[FilePurpose]]): File purposes.     f_content_mimes (Optional[List[str]]): Content MIMEs.     f_content_stores (Optional[List[FileContentStore]]): Content stores.     f_content_formats (Optional[List[Optional[FileContentFormat]]]): Content formats.     f_content_encodings (Optional[List[Optional[str]]]): Content encodings.     f_content_markups (Optional[List[Optional[FileContentFormat]]]): Content markups.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[FileModel]: Found files.
         * @summary Search Files
         * @param {Array<string> | null} [fFileIds] 
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<string> | null} [fPublicIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<FilePurpose> | null} [fPurposes] 
         * @param {Array<string> | null} [fContentMimes] 
         * @param {Array<ContentStore> | null} [fContentStores] 
         * @param {Array<ContentFormat> | null} [fContentFormats] 
         * @param {Array<string> | null} [fContentEncodings] 
         * @param {Array<ContentMarkup> | null} [fContentMarkups] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFilesGeneralFilesGet: async (fFileIds?: Array<string> | null, fExternalIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fPurposes?: Array<FilePurpose> | null, fContentMimes?: Array<string> | null, fContentStores?: Array<ContentStore> | null, fContentFormats?: Array<ContentFormat> | null, fContentEncodings?: Array<string> | null, fContentMarkups?: Array<ContentMarkup> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fFileIds) {
                localVarQueryParameter['f_file_ids'] = fFileIds;
            }

            if (fExternalIds) {
                localVarQueryParameter['f_external_ids'] = fExternalIds;
            }

            if (fPublicIds) {
                localVarQueryParameter['f_public_ids'] = fPublicIds;
            }

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fSourceIds) {
                localVarQueryParameter['f_source_ids'] = fSourceIds;
            }

            if (fPurposes) {
                localVarQueryParameter['f_purposes'] = fPurposes;
            }

            if (fContentMimes) {
                localVarQueryParameter['f_content_mimes'] = fContentMimes;
            }

            if (fContentStores) {
                localVarQueryParameter['f_content_stores'] = fContentStores;
            }

            if (fContentFormats) {
                localVarQueryParameter['f_content_formats'] = fContentFormats;
            }

            if (fContentEncodings) {
                localVarQueryParameter['f_content_encodings'] = fContentEncodings;
            }

            if (fContentMarkups) {
                localVarQueryParameter['f_content_markups'] = fContentMarkups;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search folders.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Folder search text.     f_external_ids (Optional[List[str]]): Folder external IDs.     f_types (Optional[List[FolderType]]): Folder types.  Returns:     PaginationResponse[FolderModel]: Found folders.
         * @summary Search Folders
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<FolderType> | null} [fTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFolders: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fExternalIds?: Array<string> | null, fTypes?: Array<FolderType> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fExternalIds) {
                localVarQueryParameter['f_external_ids'] = fExternalIds;
            }

            if (fTypes) {
                localVarQueryParameter['f_types'] = fTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search operations.  Args:     f_operation_ids (Optional[List[str]]): Operation IDs.     f_statuses (Optional[List[OperationStatus]]): Operation statuses.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[OperationModel]: Found operations.
         * @summary Search Operations
         * @param {Array<string> | null} [fOperationIds] 
         * @param {Array<OperationStatus> | null} [fStatuses] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOperationsGeneralOperationsGet: async (fOperationIds?: Array<string> | null, fStatuses?: Array<OperationStatus> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fOperationIds) {
                localVarQueryParameter['f_operation_ids'] = fOperationIds;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search processes.  Args:     f_process_ids (Optional[List[str]]): Process IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_operation_ids (Optional[List[str]]): Operation IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionProcessModel]: Found processes.
         * @summary Search Processes
         * @param {Array<string> | null} [fProcessIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fOperationIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcessesIngestionProcessesGet: async (fProcessIds?: Array<string> | null, fProjectIds?: Array<string> | null, fOperationIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ingestion/processes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProcessIds) {
                localVarQueryParameter['f_process_ids'] = fProcessIds;
            }

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fOperationIds) {
                localVarQueryParameter['f_operation_ids'] = fOperationIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search projects.  Args:     f_search_text (Optional[str]): Project search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ProjectModel]: Found Projects.
         * @summary Search Projects
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectsGeneralProjectsGet: async (fSearchText?: string | null, fFolderIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fFolderIds) {
                localVarQueryParameter['f_folder_ids'] = fFolderIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_enabled (Optional[bool]): Filter by enabled property.  Returns:     PaginationResponse[ProviderModel]: Found Providers.
         * @summary Search Providers
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {boolean | null} [fEnabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProvidersGeneralProvidersGet: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fEnabled?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }

            if (fEnabled !== undefined) {
                localVarQueryParameter['f_enabled'] = fEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search resources.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_actions (Optional[List[IngestionResourceAction]]): Resource actions.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionResourceModel]: Found resources.
         * @summary Search Resources
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<IngestionStageType> | null} [fStages] 
         * @param {Array<IngestionResourceAction> | null} [fActions] 
         * @param {string | null} [fSearchText] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResourcesIngestionResourcesGet: async (fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fStages?: Array<IngestionStageType> | null, fActions?: Array<IngestionResourceAction> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ingestion/resources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fSourceIds) {
                localVarQueryParameter['f_source_ids'] = fSourceIds;
            }

            if (fStages) {
                localVarQueryParameter['f_stages'] = fStages;
            }

            if (fActions) {
                localVarQueryParameter['f_actions'] = fActions;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search runs.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchRunModel]: Found Runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRunsSearchRunsGet: async (fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Signals
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fProcessIds] 
         * @param {Array<IngestionSignalSubject> | null} [fSubjects] 
         * @param {Array<IngestionSignalCommand> | null} [fCommands] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSignalsIngestionSignalsGet: async (fProjectIds?: Array<string> | null, fProcessIds?: Array<string> | null, fSubjects?: Array<IngestionSignalSubject> | null, fCommands?: Array<IngestionSignalCommand> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ingestion/signals/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fProcessIds) {
                localVarQueryParameter['f_process_ids'] = fProcessIds;
            }

            if (fSubjects) {
                localVarQueryParameter['f_subjects'] = fSubjects;
            }

            if (fCommands) {
                localVarQueryParameter['f_commands'] = fCommands;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search sources.  Args:     f_external_ids (Optional[list[str]]): External project IDs.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_names (Optional[List[str]]): Source names.     f_statuses (Optional[List[IngestionSourceStatus]]): Source statuses.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_grades (Optional[List[IngestionSourceGrade]]): Stage grades.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionSourceModel]: Found sources.
         * @summary Search Sources
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fNames] 
         * @param {Array<IngestionSourceStatus> | null} [fStatuses] 
         * @param {Array<IngestionStageType> | null} [fStages] 
         * @param {Array<IngestionSourceGrade> | null} [fGrades] 
         * @param {string | null} [fSearchText] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSourcesIngestionSourcesGet: async (fExternalIds?: Array<string> | null, fFolderIds?: Array<string> | null, fProjectIds?: Array<string> | null, fNames?: Array<string> | null, fStatuses?: Array<IngestionSourceStatus> | null, fStages?: Array<IngestionStageType> | null, fGrades?: Array<IngestionSourceGrade> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ingestion/sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fExternalIds) {
                localVarQueryParameter['f_external_ids'] = fExternalIds;
            }

            if (fFolderIds) {
                localVarQueryParameter['f_folder_ids'] = fFolderIds;
            }

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fNames) {
                localVarQueryParameter['f_names'] = fNames;
            }

            if (fStatuses) {
                localVarQueryParameter['f_statuses'] = fStatuses;
            }

            if (fStages) {
                localVarQueryParameter['f_stages'] = fStages;
            }

            if (fGrades) {
                localVarQueryParameter['f_grades'] = fGrades;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search toolsets.  Args:     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_agent_ids (Optional[List[str]]): Agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ToolsetModel]: Found toolsets.
         * @summary Search Toolsets
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fAgentIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchToolsets: async (fSearchText?: string | null, fFolderIds?: Array<string> | null, fAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/toolsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fFolderIds) {
                localVarQueryParameter['f_folder_ids'] = fFolderIds;
            }

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search trace providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[TraceProviderModel]: Found trace providers.
         * @summary Search Trace Providers
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTraceProvidersGeneralTraceProvidersGet: async (pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/general/trace/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search user messages.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
         * @summary Search User Messages
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserMessagesSearchMessagesUserGet: async (fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search/messages/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fThreadIds) {
                localVarQueryParameter['f_thread_ids'] = fThreadIds;
            }

            if (fRunIds) {
                localVarQueryParameter['f_run_ids'] = fRunIds;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search user threads.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
         * @summary Search User Threads
         * @param {Array<string> | null} [fProjectIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserThreadsSearchThreadsUserGet: async (fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search/threads/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }

            if (fSearchText !== undefined) {
                localVarQueryParameter['f_search_text'] = fSearchText;
            }

            if (fCreatedOnMin !== undefined) {
                localVarQueryParameter['f_created_on_min'] = (fCreatedOnMin as any instanceof Date) ?
                    (fCreatedOnMin as any).toISOString() :
                    fCreatedOnMin;
            }

            if (fCreatedOnMax !== undefined) {
                localVarQueryParameter['f_created_on_max'] = (fCreatedOnMax as any instanceof Date) ?
                    (fCreatedOnMax as any).toISOString() :
                    fCreatedOnMax;
            }

            if (pPageIndex !== undefined) {
                localVarQueryParameter['p_page_index'] = pPageIndex;
            }

            if (pPageSize !== undefined) {
                localVarQueryParameter['p_page_size'] = pPageSize;
            }

            if (pWithTotal !== undefined) {
                localVarQueryParameter['p_with_total'] = pWithTotal;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Select ELMA365 applications.  Args:     request (ELMA365ApplicationSelectionRequest): Applications selection request.  Returns:     ELMA365ApplicationSelectionResponse: Applications selection response.
         * @summary Select Elma365 Applications
         * @param {ELMA365ApplicationSelectionRequest} eLMA365ApplicationSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitApplications: async (eLMA365ApplicationSelectionRequest: ELMA365ApplicationSelectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365ApplicationSelectionRequest' is not null or undefined
            assertParamExists('selectELMA365ToolkitApplications', 'eLMA365ApplicationSelectionRequest', eLMA365ApplicationSelectionRequest)
            const localVarPath = `/toolkits/elma365/applications/select`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ApplicationSelectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Select ELMA365 namespaces.  Args:     request (ELMA365NamespaceSelectionRequest): Namespaces selection request.  Returns:     ELMA365NamespaceSelectionResponse: Namespaces selection response.
         * @summary Select Elma365 Namespace
         * @param {ELMA365NamespaceSelectionRequest} eLMA365NamespaceSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitNamespaces: async (eLMA365NamespaceSelectionRequest: ELMA365NamespaceSelectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365NamespaceSelectionRequest' is not null or undefined
            assertParamExists('selectELMA365ToolkitNamespaces', 'eLMA365NamespaceSelectionRequest', eLMA365NamespaceSelectionRequest)
            const localVarPath = `/toolkits/elma365/namespaces/select`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365NamespaceSelectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Select ELMA365 processes.  Args:     request (ELMA365ProcessSelectionRequest): Processes selection request.  Returns:     ELMA365ProcessSelectionResponse: Processes selection response.
         * @summary Select Elma365 Processes
         * @param {ELMA365ProcessSelectionRequest} eLMA365ProcessSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitProcesses: async (eLMA365ProcessSelectionRequest: ELMA365ProcessSelectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365ProcessSelectionRequest' is not null or undefined
            assertParamExists('selectELMA365ToolkitProcesses', 'eLMA365ProcessSelectionRequest', eLMA365ProcessSelectionRequest)
            const localVarPath = `/toolkits/elma365/processes/select`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ProcessSelectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Select ELMA365 tools.  Args:     request (ELMA365ToolSelectionRequest): Tools selection request.  Returns:     ELMA365ToolSelectionResponse: Tools selection response.
         * @summary Select Elma365 Tools
         * @param {ELMA365ToolSelectionRequest} eLMA365ToolSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitTools: async (eLMA365ToolSelectionRequest: ELMA365ToolSelectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eLMA365ToolSelectionRequest' is not null or undefined
            assertParamExists('selectELMA365ToolkitTools', 'eLMA365ToolSelectionRequest', eLMA365ToolSelectionRequest)
            const localVarPath = `/toolkits/elma365/tools/select`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolSelectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign out this session.  Args:     public_id (str): Session public ID.
         * @summary Sign Out Session
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOutSession: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('signOutSession', 'publicId', publicId)
            const localVarPath = `/security/sessions/{public_id}/logout`
                .replace(`{${"public_id"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolTogglingRequest): Tool toggling request.  Returns:     ELMA365ToolTogglingResponse: Tool toggling response.
         * @summary Toggle Elma365 Tool
         * @param {string} toolId 
         * @param {ELMA365ToolTogglingRequest} eLMA365ToolTogglingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleELMA365ToolkitTool: async (toolId: string, eLMA365ToolTogglingRequest: ELMA365ToolTogglingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('toggleELMA365ToolkitTool', 'toolId', toolId)
            // verify required parameter 'eLMA365ToolTogglingRequest' is not null or undefined
            assertParamExists('toggleELMA365ToolkitTool', 'eLMA365ToolTogglingRequest', eLMA365ToolTogglingRequest)
            const localVarPath = `/toolkits/elma365/tools/{tool_id}/toggle`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolTogglingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetTogglingRequest): Toolset toggling request.  Returns:     ELMA365ToolsetTogglingResponse: Toolset toggling response.
         * @summary Toggle Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetTogglingRequest} eLMA365ToolsetTogglingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleELMA365ToolkitToolset: async (toolsetId: string, eLMA365ToolsetTogglingRequest: ELMA365ToolsetTogglingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('toggleELMA365ToolkitToolset', 'toolsetId', toolsetId)
            // verify required parameter 'eLMA365ToolsetTogglingRequest' is not null or undefined
            assertParamExists('toggleELMA365ToolkitToolset', 'eLMA365ToolsetTogglingRequest', eLMA365ToolsetTogglingRequest)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}/toggle`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetTogglingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Try to get last thread.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_source_ref (Optional[str]): Source ref.  Returns:     Optional[AgentThreadModel]: Found thread else None.
         * @summary Try Get Last
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSourceRef] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tryGetLastAgentThread: async (fAgentIds?: Array<string> | null, fSourceRef?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agent/threads/last`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fAgentIds) {
                localVarQueryParameter['f_agent_ids'] = fAgentIds;
            }

            if (fSourceRef !== undefined) {
                localVarQueryParameter['f_source_ref'] = fSourceRef;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Try to get last thread.  Args:     f_project_ids (Optional[List[str]]): Project IDs.  Returns:     Optional[SearchThreadModel]: Found Thread else None.
         * @summary Try Get Last
         * @param {Array<string> | null} [fProjectIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tryGetLastSearchThreadsLastGet: async (fProjectIds?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/search/threads/last`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fProjectIds) {
                localVarQueryParameter['f_project_ids'] = fProjectIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update agent.  Args:     agent_id (str): Agent ID.     request (AgentUpdatingRequest): Agent updating request.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdatingRequest} agentUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent: async (agentId: string, agentUpdatingRequest: AgentUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgent', 'agentId', agentId)
            // verify required parameter 'agentUpdatingRequest' is not null or undefined
            assertParamExists('updateAgent', 'agentUpdatingRequest', agentUpdatingRequest)
            const localVarPath = `/agent/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update agent relation.  Args:     relation_id (str): Agent relation ID.     request (AgentRelationUpdatingRequest): Agent relation updating request.
         * @summary Update Relation
         * @param {string} relationId 
         * @param {AgentRelationUpdatingRequest} agentRelationUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentRelation: async (relationId: string, agentRelationUpdatingRequest: AgentRelationUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('updateAgentRelation', 'relationId', relationId)
            // verify required parameter 'agentRelationUpdatingRequest' is not null or undefined
            assertParamExists('updateAgentRelation', 'agentRelationUpdatingRequest', agentRelationUpdatingRequest)
            const localVarPath = `/agent/relations/{relation_id}`
                .replace(`{${"relation_id"}}`, encodeURIComponent(String(relationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentRelationUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update agent resource.  Args:     resource_id (str): Agent resource ID.     request (AgentResourceUpdatingRequest): Agent resource updating request.
         * @summary Update Resource
         * @param {string} resourceId 
         * @param {AgentResourceUpdatingRequest} agentResourceUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentResource: async (resourceId: string, agentResourceUpdatingRequest: AgentResourceUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateAgentResource', 'resourceId', resourceId)
            // verify required parameter 'agentResourceUpdatingRequest' is not null or undefined
            assertParamExists('updateAgentResource', 'agentResourceUpdatingRequest', agentResourceUpdatingRequest)
            const localVarPath = `/agent/resources/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentResourceUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update thread.  Args:     thread_id (str): Thread ID.     request (AgentThreadUpdatingRequest): Thread updating request.
         * @summary Update Thread
         * @param {string} threadId 
         * @param {AgentThreadUpdatingRequest} agentThreadUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentThread: async (threadId: string, agentThreadUpdatingRequest: AgentThreadUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('updateAgentThread', 'threadId', threadId)
            // verify required parameter 'agentThreadUpdatingRequest' is not null or undefined
            assertParamExists('updateAgentThread', 'agentThreadUpdatingRequest', agentThreadUpdatingRequest)
            const localVarPath = `/agent/threads/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentThreadUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update ApiKey.  Args:     api_key_id (str): ApiKey ID.     request (ApiKeyUpdatingRequest): ApiKey updating request.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {ApiKeyUpdatingRequest} apiKeyUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeySecurityApiKeysApiKeyIdPut: async (apiKeyId: string, apiKeyUpdatingRequest: ApiKeyUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('updateApiKeySecurityApiKeysApiKeyIdPut', 'apiKeyId', apiKeyId)
            // verify required parameter 'apiKeyUpdatingRequest' is not null or undefined
            assertParamExists('updateApiKeySecurityApiKeysApiKeyIdPut', 'apiKeyUpdatingRequest', apiKeyUpdatingRequest)
            const localVarPath = `/security/api_keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiKeyUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update connector.  Args:     connector_id (str): Connector ID.     request (ConnectorUpdatingRequest): Connector updating request.
         * @summary Update Connector
         * @param {string} connectorId 
         * @param {ConnectorUpdatingRequest} connectorUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnector: async (connectorId: string, connectorUpdatingRequest: ConnectorUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectorId' is not null or undefined
            assertParamExists('updateConnector', 'connectorId', connectorId)
            // verify required parameter 'connectorUpdatingRequest' is not null or undefined
            assertParamExists('updateConnector', 'connectorUpdatingRequest', connectorUpdatingRequest)
            const localVarPath = `/general/connectors/{connector_id}`
                .replace(`{${"connector_id"}}`, encodeURIComponent(String(connectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectorUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolUpdatingRequest): Tool updating request.  Returns:     ELMA365ToolUpdatingResponse: Tool updating response.
         * @summary Update Elma365 Tool
         * @param {string} toolId 
         * @param {ELMA365ToolUpdatingRequest} eLMA365ToolUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateELMA365ToolkitTool: async (toolId: string, eLMA365ToolUpdatingRequest: ELMA365ToolUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolId' is not null or undefined
            assertParamExists('updateELMA365ToolkitTool', 'toolId', toolId)
            // verify required parameter 'eLMA365ToolUpdatingRequest' is not null or undefined
            assertParamExists('updateELMA365ToolkitTool', 'eLMA365ToolUpdatingRequest', eLMA365ToolUpdatingRequest)
            const localVarPath = `/toolkits/elma365/tools/{tool_id}`
                .replace(`{${"tool_id"}}`, encodeURIComponent(String(toolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetUpdatingRequest): Toolset updating request.  Returns:     ELMA365ToolsetUpdatingResponse: Toolset updating response.
         * @summary Update Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetUpdatingRequest} eLMA365ToolsetUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateELMA365ToolkitToolset: async (toolsetId: string, eLMA365ToolsetUpdatingRequest: ELMA365ToolsetUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('updateELMA365ToolkitToolset', 'toolsetId', toolsetId)
            // verify required parameter 'eLMA365ToolsetUpdatingRequest' is not null or undefined
            assertParamExists('updateELMA365ToolkitToolset', 'eLMA365ToolsetUpdatingRequest', eLMA365ToolsetUpdatingRequest)
            const localVarPath = `/toolkits/elma365/toolsets/{toolset_id}`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eLMA365ToolsetUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update file via form.  Args:     path (FileUpdatingPath): Request path.     query (FileUpdatingQuery): Request query.     content (UploadFile): File content.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Form
         * @param {string} fileId 
         * @param {string} externalId 
         * @param {Array<FilePurpose>} purposes 
         * @param {File} content 
         * @param {string | null} [projectId] 
         * @param {string | null} [sourceId] 
         * @param {ContentStore | null} [contentStore] 
         * @param {ContentFormat | null} [contentFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileFormGeneralFilesFormFileIdPut: async (fileId: string, externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('updateFileFormGeneralFilesFormFileIdPut', 'fileId', fileId)
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('updateFileFormGeneralFilesFormFileIdPut', 'externalId', externalId)
            // verify required parameter 'purposes' is not null or undefined
            assertParamExists('updateFileFormGeneralFilesFormFileIdPut', 'purposes', purposes)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('updateFileFormGeneralFilesFormFileIdPut', 'content', content)
            const localVarPath = `/general/files/form/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['external_id'] = externalId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['source_id'] = sourceId;
            }

            if (purposes) {
                localVarQueryParameter['purposes'] = purposes;
            }

            if (contentStore !== undefined) {
                localVarQueryParameter['content_store'] = contentStore;
            }

            if (contentFormat !== undefined) {
                localVarQueryParameter['content_format'] = contentFormat;
            }


            if (content !== undefined) { 
                localVarFormParams.append('content', content as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update file via JSON.  Args:     path (FileUpdatingPath): Request path.     body (FileUpdatingBody): Request body.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Json
         * @param {string} fileId 
         * @param {FileUpdatingBody} fileUpdatingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileJsonGeneralFilesJsonFileIdPut: async (fileId: string, fileUpdatingBody: FileUpdatingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('updateFileJsonGeneralFilesJsonFileIdPut', 'fileId', fileId)
            // verify required parameter 'fileUpdatingBody' is not null or undefined
            assertParamExists('updateFileJsonGeneralFilesJsonFileIdPut', 'fileUpdatingBody', fileUpdatingBody)
            const localVarPath = `/general/files/json/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUpdatingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update file\'s parameters.  Args:     path (FileUpdatingPath): Request path.     body (FileParametersInfo): Request body.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Parameters
         * @param {string} fileId 
         * @param {FileParametersInfo} fileParametersInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileParametersGeneralFilesFileIdParametersPut: async (fileId: string, fileParametersInfo: FileParametersInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('updateFileParametersGeneralFilesFileIdParametersPut', 'fileId', fileId)
            // verify required parameter 'fileParametersInfo' is not null or undefined
            assertParamExists('updateFileParametersGeneralFilesFileIdParametersPut', 'fileParametersInfo', fileParametersInfo)
            const localVarPath = `/general/files/{file_id}/parameters`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileParametersInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update folder.  Args:     folder_id (str): Folder ID.     request (FolderUpdatingRequest): Folder updating request.  Returns:     FolderUpdatingResponse: Folder updating response.
         * @summary Update Folder
         * @param {string} folderId 
         * @param {FolderUpdatingRequest} folderUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder: async (folderId: string, folderUpdatingRequest: FolderUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('updateFolder', 'folderId', folderId)
            // verify required parameter 'folderUpdatingRequest' is not null or undefined
            assertParamExists('updateFolder', 'folderUpdatingRequest', folderUpdatingRequest)
            const localVarPath = `/general/folders/{folder_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folderUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update project.  Args:     project_id (str): Project ID.     request (ProjectUpdatingRequest): Project updating request.
         * @summary Update Project
         * @param {string} projectId 
         * @param {ProjectUpdatingRequest} projectUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectGeneralProjectsProjectIdPut: async (projectId: string, projectUpdatingRequest: ProjectUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProjectGeneralProjectsProjectIdPut', 'projectId', projectId)
            // verify required parameter 'projectUpdatingRequest' is not null or undefined
            assertParamExists('updateProjectGeneralProjectsProjectIdPut', 'projectUpdatingRequest', projectUpdatingRequest)
            const localVarPath = `/general/projects/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update provider.  Args:     provider_id (str): Provider ID.     request (ProviderUpdatingRequest): Provider updating request.
         * @summary Update Provider
         * @param {string} providerId 
         * @param {ProviderUpdatingRequest} providerUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGeneralProvidersProviderIdPut: async (providerId: string, providerUpdatingRequest: ProviderUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('updateProviderGeneralProvidersProviderIdPut', 'providerId', providerId)
            // verify required parameter 'providerUpdatingRequest' is not null or undefined
            assertParamExists('updateProviderGeneralProvidersProviderIdPut', 'providerUpdatingRequest', providerUpdatingRequest)
            const localVarPath = `/general/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Schedule
         * @param {string} scheduleId 
         * @param {IngestionScheduleUpdatingRequest} ingestionScheduleUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedule: async (scheduleId: string, ingestionScheduleUpdatingRequest: IngestionScheduleUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('updateSchedule', 'scheduleId', scheduleId)
            // verify required parameter 'ingestionScheduleUpdatingRequest' is not null or undefined
            assertParamExists('updateSchedule', 'ingestionScheduleUpdatingRequest', ingestionScheduleUpdatingRequest)
            const localVarPath = `/ingestion/schedules/{schedule_id}`
                .replace(`{${"schedule_id"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestionScheduleUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Source
         * @param {string} sourceId 
         * @param {IngestionSourceUpdatingRequest} ingestionSourceUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSourceIngestionSourcesSourceIdPut: async (sourceId: string, ingestionSourceUpdatingRequest: IngestionSourceUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('updateSourceIngestionSourcesSourceIdPut', 'sourceId', sourceId)
            // verify required parameter 'ingestionSourceUpdatingRequest' is not null or undefined
            assertParamExists('updateSourceIngestionSourcesSourceIdPut', 'ingestionSourceUpdatingRequest', ingestionSourceUpdatingRequest)
            const localVarPath = `/ingestion/sources/{source_id}`
                .replace(`{${"source_id"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestionSourceUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update thread.  Args:     thread_id (str): Thread ID.     request (SearchThreadUpdatingRequest): Thread updating request.
         * @summary Update Thread
         * @param {string} threadId 
         * @param {SearchThreadUpdatingRequest} searchThreadUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateThreadSearchThreadsThreadIdPut: async (threadId: string, searchThreadUpdatingRequest: SearchThreadUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('updateThreadSearchThreadsThreadIdPut', 'threadId', threadId)
            // verify required parameter 'searchThreadUpdatingRequest' is not null or undefined
            assertParamExists('updateThreadSearchThreadsThreadIdPut', 'searchThreadUpdatingRequest', searchThreadUpdatingRequest)
            const localVarPath = `/search/threads/{thread_id}`
                .replace(`{${"thread_id"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchThreadUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update toolset.  Args:     toolset_id (str): Toolset ID.     request (ToolsetUpdatingRequest): Toolset updating request.
         * @summary Update Toolset
         * @param {string} toolsetId 
         * @param {ToolsetUpdatingRequest} toolsetUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToolset: async (toolsetId: string, toolsetUpdatingRequest: ToolsetUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toolsetId' is not null or undefined
            assertParamExists('updateToolset', 'toolsetId', toolsetId)
            // verify required parameter 'toolsetUpdatingRequest' is not null or undefined
            assertParamExists('updateToolset', 'toolsetUpdatingRequest', toolsetUpdatingRequest)
            const localVarPath = `/agent/toolsets/{toolset_id}`
                .replace(`{${"toolset_id"}}`, encodeURIComponent(String(toolsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toolsetUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update trace provider.  Args:     trace_provider_id (str): Trace provider ID.     request (TraceProviderUpdatingRequest): Trace provider updating request.
         * @summary Update Trace Provider
         * @param {string} traceProviderId 
         * @param {TraceProviderUpdatingRequest} traceProviderUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTraceProviderGeneralTraceProvidersTraceProviderIdPut: async (traceProviderId: string, traceProviderUpdatingRequest: TraceProviderUpdatingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'traceProviderId' is not null or undefined
            assertParamExists('updateTraceProviderGeneralTraceProvidersTraceProviderIdPut', 'traceProviderId', traceProviderId)
            // verify required parameter 'traceProviderUpdatingRequest' is not null or undefined
            assertParamExists('updateTraceProviderGeneralTraceProvidersTraceProviderIdPut', 'traceProviderUpdatingRequest', traceProviderUpdatingRequest)
            const localVarPath = `/general/trace/providers/{trace_provider_id}`
                .replace(`{${"trace_provider_id"}}`, encodeURIComponent(String(traceProviderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceProviderUpdatingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Assert session.  Args:     public_id (str): Session public ID.     request (SessionAssertRequest): Session assertion request.  Returns:     SessionAssertResponse: Session assertion response.
         * @summary Assert Session
         * @param {string} publicId 
         * @param {Request1} request1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assertSession(publicId: string, request1: Request1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionAssertResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assertSession(publicId, request1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assertSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Login.  Args:     action (str): Callback action.     return_to (str): Return path.  Returns:     None: Redirects the user to the OAuth provider.
         * @summary Auth Login
         * @param {string} action 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLogin(action: string, returnTo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLogin(action, returnTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Logout.  Args:     request (Request): Logout request.  Returns:     None: Redirects the user to the index page.
         * @summary Auth Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.authLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Call ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetCallingRequest): Toolset calling request.  Returns:     ELMA365ToolsetCallingResponse: Toolset calling response.
         * @summary Call Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetCallingRequest} eLMA365ToolsetCallingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetCallingRequest: ELMA365ToolsetCallingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetCallingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callELMA365ToolkitToolset(toolsetId, eLMA365ToolsetCallingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.callELMA365ToolkitToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check connector.  Args:     request (ConnectorCheckingRequest): Connector checking request.  Returns:     ConnectorCheckingResponse: Connector checking response.
         * @summary Check Connector
         * @param {ConnectorCheckingRequest} connectorCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkConnector(connectorCheckingRequest: ConnectorCheckingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorCheckingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkConnector(connectorCheckingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check provider embedding.  Args:     request (ProviderEmbeddingCheckingRequest): Provider embedding checking request.  Returns:     ProviderEmbeddingCheckingResponse: Provider embedding checking response.
         * @summary Check Provider Embedding
         * @param {ProviderEmbeddingCheckingRequest} providerEmbeddingCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost(providerEmbeddingCheckingRequest: ProviderEmbeddingCheckingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderEmbeddingCheckingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost(providerEmbeddingCheckingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check provider llm.  Args:     request (ProviderLLMCheckingRequest): Provider LLM checking request.  Returns:     ProviderLLMCheckingResponse: Provider LLM checking response.
         * @summary Check Provider Llm
         * @param {ProviderLLMCheckingRequest} providerLLMCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkProviderLlmGeneralProvidersLlmCheckPost(providerLLMCheckingRequest: ProviderLLMCheckingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderLLMCheckingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkProviderLlmGeneralProvidersLlmCheckPost(providerLLMCheckingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkProviderLlmGeneralProvidersLlmCheckPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compare ELMA365 versions.  Args:     request (ELMA365VersionComparisonRequest): Versions comparison request.  Returns:     ELMA365VersionComparisonResponse: Versions comparison response.
         * @summary Compare Elma365 Versions
         * @param {ELMA365VersionComparisonRequest} eLMA365VersionComparisonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compareELMA365ToolkitVersions(eLMA365VersionComparisonRequest: ELMA365VersionComparisonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365VersionComparisonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compareELMA365ToolkitVersions(eLMA365VersionComparisonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.compareELMA365ToolkitVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Completion request.  Args:     request (CompletionRequest): Completion request.  Returns:     CompletionResponse: Completion response.
         * @summary Completion
         * @param {CompletionRequest} completionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completionSearchCompletionPost(completionRequest: CompletionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completionSearchCompletionPost(completionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.completionSearchCompletionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create agent.  Args:     request (AgentCreationRequest): Agent creation request.  Returns:     AgentCreationResponse: Agent creation response.
         * @summary Create Agent
         * @param {AgentCreationRequest} agentCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgent(agentCreationRequest: AgentCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgent(agentCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create agent relation.  Args:     request (AgentRelationCreationRequest): Agent relation creation request.  Returns:     AgentRelationCreationResponse: Agent relation creation response.
         * @summary Create Relation
         * @param {AgentRelationCreationRequest} agentRelationCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentRelation(agentRelationCreationRequest: AgentRelationCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentRelationCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentRelation(agentRelationCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAgentRelation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create agent resource.  Args:     request (AgentResourceCreationRequest): Agent resource creation request.  Returns:     AgentResourceCreationResponse: Agent resource creation response.
         * @summary Create Resource
         * @param {AgentResourceCreationRequest} agentResourceCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentResource(agentResourceCreationRequest: AgentResourceCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResourceCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentResource(agentResourceCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAgentResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create run.  Args:     request (AgentRunCreationRequest): Run creation request.  Returns:     AgentRunCreationResponse: Run creation response.
         * @summary Create Run
         * @param {AgentRunCreationRequest} agentRunCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentRun(agentRunCreationRequest: AgentRunCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentRunCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentRun(agentRunCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAgentRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create thread.  Args:     request (AgentThreadCreationRequest): Thread creation request.  Returns:     AgentThreadCreationResponse: Thread creation response.
         * @summary Create Thread
         * @param {AgentThreadCreationRequest} agentThreadCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgentThread(agentThreadCreationRequest: AgentThreadCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentThreadCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgentThread(agentThreadCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createAgentThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create ApiKey.  Args:     request (ApiKeyCreationRequest): ApiKey creation request.  Returns:     ApiKeyCreationResponse: ApiKey creation response.
         * @summary Create Api Key
         * @param {ApiKeyCreationRequest} apiKeyCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKeySecurityApiKeysPost(apiKeyCreationRequest: ApiKeyCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKeySecurityApiKeysPost(apiKeyCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createApiKeySecurityApiKeysPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create connector.  Args:     request (ConnectorCreationRequest): Connector creation request.  Returns:     ConnectorCreationResponse: Connector creation response.
         * @summary Create Connector
         * @param {ConnectorCreationRequest} connectorCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConnector(connectorCreationRequest: ConnectorCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConnector(connectorCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create ELMA365 toolset.  Args:     request (ELMA365ToolsetCreationRequest): Toolset creation request.  Returns:     ELMA365ToolsetCreationResponse: Toolset creation response.
         * @summary Create Elma365 Toolset
         * @param {ELMA365ToolsetCreationRequest} eLMA365ToolsetCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createELMA365ToolkitToolset(eLMA365ToolsetCreationRequest: ELMA365ToolsetCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createELMA365ToolkitToolset(eLMA365ToolsetCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createELMA365ToolkitToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create ELMA365 version.  Args:     request (ELMA365VersionCreationRequest): Version creation request.  Returns:     ELMA365VersionCreationResponse: Version creation response.
         * @summary Create Elma365 Version
         * @param {ELMA365VersionCreationRequest} eLMA365VersionCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createELMA365ToolkitVersion(eLMA365VersionCreationRequest: ELMA365VersionCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365VersionCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createELMA365ToolkitVersion(eLMA365VersionCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createELMA365ToolkitVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create file via form.  Args:     query (FileCreationQuery): Request query.     content (UploadFile): File content.  Returns:     FileCreationResponse: File creation response.
         * @summary Create File Form
         * @param {string} externalId 
         * @param {Array<FilePurpose>} purposes 
         * @param {File} content 
         * @param {string | null} [projectId] 
         * @param {string | null} [sourceId] 
         * @param {ContentStore | null} [contentStore] 
         * @param {ContentFormat | null} [contentFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileFormGeneralFilesFormPost(externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileFormGeneralFilesFormPost(externalId, purposes, content, projectId, sourceId, contentStore, contentFormat, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createFileFormGeneralFilesFormPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create file via JSON.  Args:     body (FileCreationBody): Request body.  Returns:     FileCreationResponse: File creation response.
         * @summary Create File Json
         * @param {FileCreationBody} fileCreationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileJsonGeneralFilesJsonPost(fileCreationBody: FileCreationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileJsonGeneralFilesJsonPost(fileCreationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createFileJsonGeneralFilesJsonPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create folder.  Args:     request (FolderCreationRequest): Folder creation request.  Returns:     FolderCreationResponse: Folder creation response.
         * @summary Create Folder
         * @param {FolderCreationRequest} folderCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(folderCreationRequest: FolderCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(folderCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create message.  Args:     request (SearchMessageCreationRequest): Message creation request.  Returns:     SearchMessageCreationResponse: Message creation response.
         * @summary Create Message
         * @param {SearchMessageCreationRequest} searchMessageCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMessageSearchMessagesPost(searchMessageCreationRequest: SearchMessageCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchMessageCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMessageSearchMessagesPost(searchMessageCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createMessageSearchMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create process.  Args:     request (IngestionProcessCreationRequest): Process creation request.  Returns:     IngestionProcessCreationResponse: Process creation response.
         * @summary Create Process
         * @param {IngestionProcessCreationRequest} ingestionProcessCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessIngestionProcessesPost(ingestionProcessCreationRequest: IngestionProcessCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionProcessCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessIngestionProcessesPost(ingestionProcessCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createProcessIngestionProcessesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create project.  Args:     request (ProjectCreationRequest): Project creation request.  Returns:     ProjectCreationResponse: Project creation response.
         * @summary Create Project
         * @param {ProjectCreationRequest} projectCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectGeneralProjectsPost(projectCreationRequest: ProjectCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectGeneralProjectsPost(projectCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createProjectGeneralProjectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create provider.  Args:     request (ProviderCreationRequest): Provider creation request.  Returns:     ProviderCreationResponse: Provider creation response.
         * @summary Create Provider
         * @param {ProviderCreationRequest} providerCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProviderGeneralProvidersPost(providerCreationRequest: ProviderCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProviderGeneralProvidersPost(providerCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createProviderGeneralProvidersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create run.  Args:     request (SearchRunCreationRequest): Run creation request.  Returns:     SearchRunCreationResponse: Run creation response.
         * @summary Create Run
         * @param {SearchRunCreationRequest} searchRunCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRunSearchRunsPost(searchRunCreationRequest: SearchRunCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRunCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRunSearchRunsPost(searchRunCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createRunSearchRunsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Schedule
         * @param {IngestionScheduleCreationRequest} ingestionScheduleCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSchedule(ingestionScheduleCreationRequest: IngestionScheduleCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionScheduleCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSchedule(ingestionScheduleCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create session.  Args:     request (SessionCreationRequest): Session creation request.  Returns:     SessionModel: Created session.
         * @summary Create Session
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSession(request: Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSession(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Signal
         * @param {IngestionSignalCreationRequest} ingestionSignalCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSignalIngestionSignalsPost(ingestionSignalCreationRequest: IngestionSignalCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionSignalCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSignalIngestionSignalsPost(ingestionSignalCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createSignalIngestionSignalsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Source
         * @param {IngestionSourceCreationRequest} ingestionSourceCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSourceIngestionSourcesPost(ingestionSourceCreationRequest: IngestionSourceCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionSourceCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSourceIngestionSourcesPost(ingestionSourceCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createSourceIngestionSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create thread.  Args:     request (SearchThreadCreationRequest): Thread creation request.  Returns:     SearchThreadCreationResponse: Thread creation response.
         * @summary Create Thread
         * @param {SearchThreadCreationRequest} searchThreadCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createThreadSearchThreadsPost(searchThreadCreationRequest: SearchThreadCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchThreadCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createThreadSearchThreadsPost(searchThreadCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createThreadSearchThreadsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create toolset.  Args:     request (ToolsetCreationRequest): Toolset creation request.  Returns:     ToolsetCreationResponse: Toolset creation response.
         * @summary Create Toolset
         * @param {ToolsetCreationRequest} toolsetCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createToolset(toolsetCreationRequest: ToolsetCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolsetCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createToolset(toolsetCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create trace provider.  Args:     request (TraceProviderCreationRequest): Provider creation request.  Returns:     TraceProviderCreationResponse: Trace provider creation response.
         * @summary Create Trace Provider
         * @param {TraceProviderCreationRequest} traceProviderCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTraceProviderGeneralTraceProvidersPost(traceProviderCreationRequest: TraceProviderCreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceProviderCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTraceProviderGeneralTraceProvidersPost(traceProviderCreationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createTraceProviderGeneralTraceProvidersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one agent.  Args:     agent_id (str): Agent ID.
         * @summary Delete One Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgent(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgent(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one agent relation.  Args:     relation_id (str): Agent relation ID.
         * @summary Delete One Relation
         * @param {string} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentRelation(relationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentRelation(relationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteAgentRelation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one agent resource.  Args:     resource_id (str): Agent resource ID.
         * @summary Delete One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentResource(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentResource(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteAgentResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one thread.  Args:     thread_id (str): Thread ID.
         * @summary Delete One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentThread(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgentThread(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteAgentThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete connector.  Args:     connector_id (str): Connector ID.
         * @summary Delete Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConnector(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConnector(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolDeletionResponse: Tool deletion response.
         * @summary Delete Elma365 Tool
         * @param {string} toolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteELMA365ToolkitTool(toolId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteELMA365ToolkitTool(toolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteELMA365ToolkitTool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.
         * @summary Delete Elma365 Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteELMA365ToolkitToolset(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteELMA365ToolkitToolset(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteELMA365ToolkitToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete ELMA365 version.  Args:     version_id (str): Version ID.
         * @summary Delete Elma365 Version
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteELMA365ToolkitVersion(versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteELMA365ToolkitVersion(versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteELMA365ToolkitVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete folder.  Args:     folder_id (str): Folder ID.
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one ApiKey.  Args:     api_key_id (str): ApiKey ID.
         * @summary Delete One Api Key
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneApiKeySecurityApiKeysApiKeyIdDelete(apiKeyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneApiKeySecurityApiKeysApiKeyIdDelete(apiKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOneApiKeySecurityApiKeysApiKeyIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one file.  Args:     path (FileDeletionPath): RequestPath.
         * @summary Delete One File
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneFileGeneralFilesFileIdDelete(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneFileGeneralFilesFileIdDelete(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOneFileGeneralFilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one message.  Args:     message_id (str): Message ID.
         * @summary Delete One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneMessageSearchMessagesMessageIdDelete(messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneMessageSearchMessagesMessageIdDelete(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOneMessageSearchMessagesMessageIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one project.  Args:     project_id (str): Project ID.
         * @summary Delete One Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneProjectGeneralProjectsProjectIdDelete(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneProjectGeneralProjectsProjectIdDelete(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOneProjectGeneralProjectsProjectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one provider.  Args:     provider_id (str): Provider ID.
         * @summary Delete One Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneProviderGeneralProvidersProviderIdDelete(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneProviderGeneralProvidersProviderIdDelete(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOneProviderGeneralProvidersProviderIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one thread.  Args:     thread_id (str): Thread ID.
         * @summary Delete One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneThreadSearchThreadsThreadIdDelete(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneThreadSearchThreadsThreadIdDelete(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOneThreadSearchThreadsThreadIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one trace provider.  Args:     trace_provider_id (str): Trace provider ID.
         * @summary Delete One Trace Provider
         * @param {string} traceProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete(traceProviderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete(traceProviderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Schedule
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSchedule(scheduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSchedule(scheduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one toolset.  Args:     toolset_id (str): Toolset ID.
         * @summary Delete One Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteToolset(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteToolset(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download artifact buffer content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Buffer content.
         * @summary Download Artifact Buffer
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet(artifactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet(artifactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download artifact object content.  Args:     artifact_id (str): Artifact ID.  Returns:     Any: Object content.
         * @summary Download Artifact Object
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet(artifactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet(artifactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download artifact stream content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Stream content.
         * @summary Download Artifact Stream
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet(artifactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet(artifactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download artifact string content.  Args:     artifact_id (str): Artifact ID.  Returns:     PlainTextResponse: String content.
         * @summary Download Artifact String
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet(artifactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet(artifactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download file buffer content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Buffer content.
         * @summary Download File Buffer
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileBufferGeneralFilesFileIdContentBufferGet(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileBufferGeneralFilesFileIdContentBufferGet(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFileBufferGeneralFilesFileIdContentBufferGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download file object content.  Args:     file_id (str): File ID.  Returns:     Any: Object content.
         * @summary Download File Object
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileObjectGeneralFilesFileIdContentObjectGet(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileObjectGeneralFilesFileIdContentObjectGet(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFileObjectGeneralFilesFileIdContentObjectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download file stream content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Stream content.
         * @summary Download File Stream
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileStreamGeneralFilesFileIdContentStreamGet(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileStreamGeneralFilesFileIdContentStreamGet(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFileStreamGeneralFilesFileIdContentStreamGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download file string content.  Args:     file_id (str): File ID.  Returns:     PlainTextResponse: String content.
         * @summary Download File String
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileStringGeneralFilesFileIdContentStringGet(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileStringGeneralFilesFileIdContentStringGet(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadFileStringGeneralFilesFileIdContentStringGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export agent as archive.  Args:     agent_id (str): Agent ID.  Returns:     FileResponse: Archive file.
         * @summary Export Agent Archive
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAgentArchive(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAgentArchive(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportAgentArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export ELMA365 toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
         * @summary Export Elma365 Toolset Archive
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportELMA365ToolkitToolsetArchive(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportELMA365ToolkitToolsetArchive(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportELMA365ToolkitToolsetArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export ELMA365 toolset as buffer.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
         * @summary Export Elma365 Toolset Buffer
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportELMA365ToolkitToolsetBuffer(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportELMA365ToolkitToolsetBuffer(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportELMA365ToolkitToolsetBuffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export ELMA365 toolset as object.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetExchange: Object content.
         * @summary Export Elma365 Toolset Object
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportELMA365ToolkitToolsetObject(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetExchange>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportELMA365ToolkitToolsetObject(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportELMA365ToolkitToolsetObject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export ELMA365 toolset as stream.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
         * @summary Export Elma365 Toolset Stream
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportELMA365ToolkitToolsetStream(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportELMA365ToolkitToolsetStream(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportELMA365ToolkitToolsetStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export ELMA365 toolset as string.  Args:     toolset_id (str): Toolset ID.  Returns:     PlainTextResponse: String content.
         * @summary Export Elma365 Toolset String
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportELMA365ToolkitToolsetString(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportELMA365ToolkitToolsetString(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportELMA365ToolkitToolsetString']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export folder as archive.  Args:     folder_id (str): Folder ID.  Returns:     FileResponse: Archive file.
         * @summary Export Folder Archive
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportFolderArchive(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportFolderArchive(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportFolderArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export project as archive.  Args:     project_id (str): Project ID.  Returns:     FileResponse: Archive file.
         * @summary Export Project Archive
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportProjectArchive(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportProjectArchive(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportProjectArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
         * @summary Export Toolset Archive
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportToolsetArchive(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportToolsetArchive(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportToolsetArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get general information about application.  Returns:     AboutInfo: General information about application.
         * @summary Get About Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAboutInfoInfoApplicationAboutGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AboutInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAboutInfoInfoApplicationAboutGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAboutInfoInfoApplicationAboutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all folders.  Returns:     List[FolderModel]: Found folders.
         * @summary Get All Folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFolders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FolderModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFolders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a current identity.  Returns:     IdentityModel: Current identity.
         * @summary Get Current Identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentIdentity(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentIdentity(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCurrentIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Current
         * @param {string} projectId 
         * @param {boolean | null} [withSources] 
         * @param {boolean | null} [withResources] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentIngestionStateProjectIdGet(projectId: string, withSources?: boolean | null, withResources?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionStateModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentIngestionStateProjectIdGet(projectId, withSources, withResources, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCurrentIngestionStateProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of available features and their active statuses.
         * @summary Get available feature flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureFlagsFeatureManagementGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureFlagsFeatureManagementGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFeatureFlagsFeatureManagementGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get health information about application.  Returns:     HealthInfo: Health information about application.
         * @summary Get Health Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealthInfoInfoApplicationHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealthInfoInfoApplicationHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getHealthInfoInfoApplicationHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one agent.  Args:     agent_id (str): Agent ID.  Returns:     AgentModel: Found agent.
         * @summary Get One Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgent(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgent(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one message.  Args:     message_id (str): Message ID.  Returns:     AgentMessageModel: Found message.
         * @summary Get One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgentMessage(messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMessageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgentMessage(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgentMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one agent relation.  Args:     relation_id (str): Agent relation ID.  Returns:     AgentRelationModel: Found agent relation.
         * @summary Get One Relation
         * @param {string} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgentRelation(relationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgentRelation(relationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgentRelation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one resource.  Args:     resource_id (str): Agent resource ID.  Returns:     AgentResourceModel: Found agent resource.
         * @summary Get One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgentResource(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResourceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgentResource(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgentResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
         * @summary Get One Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgentRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgentRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgentRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
         * @summary Get One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgentThread(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgentThread(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgentThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one user run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
         * @summary Get One User Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgentUserRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgentUserRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgentUserRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
         * @summary Get One User Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneAgentUserThread(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneAgentUserThread(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneAgentUserThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one ApiKey.  Args:     api_key_id (str): ApiKey ID.  Returns:     ApiKeyModel: Found ApiKey.
         * @summary Get One Api Key
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneApiKeySecurityApiKeysApiKeyIdGet(apiKeyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneApiKeySecurityApiKeysApiKeyIdGet(apiKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneApiKeySecurityApiKeysApiKeyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one artifact.  Args:     artifact_id (str): Artifact ID.  Returns:     IngestionArtifactModel: Found artifacts.
         * @summary Get One Artifact
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneArtifactIngestionArtifactsArtifactIdGet(artifactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionArtifactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneArtifactIngestionArtifactsArtifactIdGet(artifactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneArtifactIngestionArtifactsArtifactIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one connector.  Args:     connector_id (str): Connector ID.  Returns:     ConnectorModel: Found connector.
         * @summary Get One Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneConnector(connectorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneConnector(connectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one ELMA365 application.  Args:     application_id (str): Application ID.  Returns:     ELMA365ApplicationModel: Found ELMA365 application.
         * @summary Get One Elma365 Application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneELMA365ToolkitApplication(applicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ApplicationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneELMA365ToolkitApplication(applicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneELMA365ToolkitApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one ELMA365 namespace.  Args:     namespace_id (str): Namespace ID.  Returns:     ELMA365NamespaceModel: Found ELMA365 namespace.
         * @summary Get One Elma365 Namespace
         * @param {string} namespaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneELMA365ToolkitNamespace(namespaceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365NamespaceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneELMA365ToolkitNamespace(namespaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneELMA365ToolkitNamespace']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one ELMA365 process.  Args:     process_id (str): Process ID.  Returns:     ELMA365ProcessModel: Found ELMA365 process.
         * @summary Get One Elma365 Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneELMA365ToolkitProcess(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ProcessModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneELMA365ToolkitProcess(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneELMA365ToolkitProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolModel: Found ELMA365 tool.
         * @summary Get One Elma365 Tool
         * @param {string} toolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneELMA365ToolkitTool(toolId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneELMA365ToolkitTool(toolId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneELMA365ToolkitTool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetModel: Found ELMA365 toolset.
         * @summary Get One Elma365 Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneELMA365ToolkitToolset(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneELMA365ToolkitToolset(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneELMA365ToolkitToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one ELMA365 version.  Args:     version_id (str): Version ID.  Returns:     ELMA365VersionModel: Found ELMA365 version.
         * @summary Get One Elma365 Version
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneELMA365ToolkitVersion(versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365VersionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneELMA365ToolkitVersion(versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneELMA365ToolkitVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one file.  Args:     file_id (str): File ID.  Returns:     FileModel: Found file.
         * @summary Get One File
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneFileGeneralFilesFileIdGet(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneFileGeneralFilesFileIdGet(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneFileGeneralFilesFileIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one folder.  Args:     folder_id (str): Folder ID.  Returns:     FolderModel: Found folder.
         * @summary Get One Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one message.  Args:     message_id (str): Message ID.  Returns:     SearchMessageModel: Found message.
         * @summary Get One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneMessageSearchMessagesMessageIdGet(messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchMessageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneMessageSearchMessagesMessageIdGet(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneMessageSearchMessagesMessageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one operation.  Args:     operation_id (str): Operation ID.  Returns:     OperationModel: Found operation.
         * @summary Get One Operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneOperationGeneralOperationsOperationIdGet(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneOperationGeneralOperationsOperationIdGet(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneOperationGeneralOperationsOperationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one process.  Args:     process_id (str): Process ID.  Returns:     IngestionProcessModel: Found process.
         * @summary Get One Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneProcessIngestionProcessesProcessIdGet(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionProcessModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneProcessIngestionProcessesProcessIdGet(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneProcessIngestionProcessesProcessIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one project.  Args:     project_id (str): Project ID.  Returns:     ProjectModel: Found project.
         * @summary Get One Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneProjectGeneralProjectsProjectIdGet(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneProjectGeneralProjectsProjectIdGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneProjectGeneralProjectsProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one provider.  Args:     provider_id (str): Provider ID.  Returns:     ProviderModel: Found provider.
         * @summary Get One Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneProviderGeneralProvidersProviderIdGet(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneProviderGeneralProvidersProviderIdGet(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneProviderGeneralProvidersProviderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one resource.  Args:     resource_id (str): Resource ID.  Returns:     IngestionResourceModel: Found resource.
         * @summary Get One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneResourceIngestionResourcesResourceIdGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionResourceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneResourceIngestionResourcesResourceIdGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneResourceIngestionResourcesResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one run.  Args:     run_id (str): Run ID.  Returns:     SearchRunModel: Found Run.
         * @summary Get One Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneRunSearchRunsRunIdGet(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneRunSearchRunsRunIdGet(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneRunSearchRunsRunIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get One Signal
         * @param {string} signalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneSignalIngestionSignalsSignalIdGet(signalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionSignalModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneSignalIngestionSignalsSignalIdGet(signalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneSignalIngestionSignalsSignalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get One Source
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneSourceIngestionSourcesSourceIdGet(sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionSourceModelOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneSourceIngestionSourcesSourceIdGet(sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneSourceIngestionSourcesSourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
         * @summary Get One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneThreadSearchThreadsThreadIdGet(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneThreadSearchThreadsThreadIdGet(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneThreadSearchThreadsThreadIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ToolsetModel: Found toolset.
         * @summary Get One Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneToolset(toolsetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolsetModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneToolset(toolsetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one trace provider.  Args:     trace_provider_id (str): Trace provider ID.  Returns:     TraceProviderModel: Found trace provider.
         * @summary Get One Trace Provider
         * @param {string} traceProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet(traceProviderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceProviderModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet(traceProviderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
         * @summary Get One User Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneUserThreadSearchThreadsThreadIdUserGet(threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneUserThreadSearchThreadsThreadIdUserGet(threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOneUserThreadSearchThreadsThreadIdUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Schedule
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchedule(scheduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionScheduleModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedule(scheduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one session.  Args:     public_id (str): Session public ID.  Returns:     SessionModel: Found session.
         * @summary Get Session
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSession(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSession(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check session requirement.  Args:     f_agent_id (str): Agent ID.     f_connector_id (str): Connector ID.  Returns:     SessionRequirementModel: Session requirement response.
         * @summary Is Session Required
         * @param {string | null} [fAgentId] 
         * @param {string | null} [fConnectorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionRequirement(fAgentId?: string | null, fConnectorId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionRequirementModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionRequirement(fAgentId, fConnectorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSessionRequirement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Source Details
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionStateSourceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet(projectId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Source
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourceIngestionStateProjectIdSourcesSourceIdGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionStateSourceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourceIngestionStateProjectIdSourcesSourceIdGet(projectId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSourceIngestionStateProjectIdSourcesSourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Source Resources
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IngestionStateResourceModelOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet(projectId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import agent file via form.  Args:     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAgentCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAgentCreateForm(folderId, content, dependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importAgentCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) agent file via JSON.  Args:     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Create Json
         * @param {string} folderId 
         * @param {AgentImportBody} agentImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAgentCreateJson(folderId: string, agentImportBody: AgentImportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAgentCreateJson(folderId, agentImportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importAgentCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import agent file via form.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Update Form
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAgentUpdateForm(agentId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAgentUpdateForm(agentId, folderId, content, dependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importAgentUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) agent file via JSON.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Update Json
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {AgentImportBody} agentImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAgentUpdateJson(agentId: string, folderId: string, agentImportBody: AgentImportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAgentUpdateJson(agentId, folderId, agentImportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importAgentUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importELMA365ToolkitToolsetCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importELMA365ToolkitToolsetCreateForm(folderId, content, dependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importELMA365ToolkitToolsetCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Create Json
         * @param {string} folderId 
         * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importELMA365ToolkitToolsetCreateJson(folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importELMA365ToolkitToolsetCreateJson(folderId, eLMA365ToolsetImportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importELMA365ToolkitToolsetCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Update Form
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importELMA365ToolkitToolsetUpdateForm(toolsetId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importELMA365ToolkitToolsetUpdateForm(toolsetId, folderId, content, dependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importELMA365ToolkitToolsetUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Update Json
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importELMA365ToolkitToolsetUpdateJson(toolsetId: string, folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importELMA365ToolkitToolsetUpdateJson(toolsetId, folderId, eLMA365ToolsetImportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importELMA365ToolkitToolsetUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) folder file via form.  Args:     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Create Form
         * @param {File} content 
         * @param {File} dependencies 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFolderCreateForm(content: File, dependencies: File, folderId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importFolderCreateForm(content, dependencies, folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importFolderCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) folder file via JSON.  Args:     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Create Json
         * @param {FolderImportBody} folderImportBody 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFolderCreateJson(folderImportBody: FolderImportBody, folderId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importFolderCreateJson(folderImportBody, folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importFolderCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import folder file via form.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Update Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFolderUpdateForm(folderId: string, content: File, dependencies: File, folderId2?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importFolderUpdateForm(folderId, content, dependencies, folderId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importFolderUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (update) folder file via JSON.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Update Json
         * @param {string} folderId 
         * @param {FolderImportBody} folderImportBody 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFolderUpdateJson(folderId: string, folderImportBody: FolderImportBody, folderId2?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importFolderUpdateJson(folderId, folderImportBody, folderId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importFolderUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) project file via form.  Args:     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProjectCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProjectCreateForm(folderId, content, dependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importProjectCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (create) project file via JSON.  Args:     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Create Json
         * @param {string} folderId 
         * @param {ProjectImportBody} projectImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProjectCreateJson(folderId: string, projectImportBody: ProjectImportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProjectCreateJson(folderId, projectImportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importProjectCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (update) project file via form.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Update Form
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProjectUpdateForm(projectId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProjectUpdateForm(projectId, folderId, content, dependencies, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importProjectUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import (update) project file via JSON.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Update Json
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {ProjectImportBody} projectImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProjectUpdateJson(projectId: string, folderId: string, projectImportBody: ProjectImportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProjectUpdateJson(projectId, folderId, projectImportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.importProjectUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect agent file via form.  Args:     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectAgentCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectAgentCreateForm(folderId, content, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectAgentCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect agent file via JSON.  Args:     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Create Json
         * @param {string} folderId 
         * @param {AgentInspectionBody} agentInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectAgentCreateJson(folderId: string, agentInspectionBody: AgentInspectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectAgentCreateJson(folderId, agentInspectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectAgentCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect (update) agent file via form.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Update Form
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectAgentUpdateForm(agentId: string, folderId: string, content: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectAgentUpdateForm(agentId, folderId, content, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectAgentUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspec (update) agent file via JSON.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Update Json
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {AgentInspectionBody} agentInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectAgentUpdateJson(agentId: string, folderId: string, agentInspectionBody: AgentInspectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectAgentUpdateJson(agentId, folderId, agentInspectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectAgentUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectELMA365ToolkitToolsetCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectELMA365ToolkitToolsetCreateForm(folderId, content, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectELMA365ToolkitToolsetCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Create Json
         * @param {string} folderId 
         * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectELMA365ToolkitToolsetCreateJson(folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectELMA365ToolkitToolsetCreateJson(folderId, eLMA365ToolsetInspectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectELMA365ToolkitToolsetCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Update Form
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectELMA365ToolkitToolsetUpdateForm(toolsetId: string, folderId: string, content: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectELMA365ToolkitToolsetUpdateForm(toolsetId, folderId, content, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectELMA365ToolkitToolsetUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspec (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Update Json
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectELMA365ToolkitToolsetUpdateJson(toolsetId: string, folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectELMA365ToolkitToolsetUpdateJson(toolsetId, folderId, eLMA365ToolsetInspectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectELMA365ToolkitToolsetUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect folder file via form.  Args:     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Create Form
         * @param {File} content 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectFolderCreateForm(content: File, folderId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectFolderCreateForm(content, folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectFolderCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect folder file via JSON.  Args:     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Create Json
         * @param {FolderInspectionBody} folderInspectionBody 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectFolderCreateJson(folderInspectionBody: FolderInspectionBody, folderId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectFolderCreateJson(folderInspectionBody, folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectFolderCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect (update) folder file via form.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Update Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectFolderUpdateForm(folderId: string, content: File, folderId2?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectFolderUpdateForm(folderId, content, folderId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectFolderUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspec (update) folder file via JSON.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Update Json
         * @param {string} folderId 
         * @param {FolderInspectionBody} folderInspectionBody 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectFolderUpdateJson(folderId: string, folderInspectionBody: FolderInspectionBody, folderId2?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectFolderUpdateJson(folderId, folderInspectionBody, folderId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectFolderUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect project file via form.  Args:     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectProjectCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectProjectCreateForm(folderId, content, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectProjectCreateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect project file via JSON.  Args:     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Create Json
         * @param {string} folderId 
         * @param {ProjectInspectionBody} projectInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectProjectCreateJson(folderId: string, projectInspectionBody: ProjectInspectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectProjectCreateJson(folderId, projectInspectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectProjectCreateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspect (update) project file via form.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Update Form
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectProjectUpdateForm(projectId: string, folderId: string, content: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectProjectUpdateForm(projectId, folderId, content, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectProjectUpdateForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inspec (update) project file via JSON.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Update Json
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {ProjectInspectionBody} projectInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectProjectUpdateJson(projectId: string, folderId: string, projectInspectionBody: ProjectInspectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectProjectUpdateJson(projectId, folderId, projectInspectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.inspectProjectUpdateJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Sources Details
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IngestionStateSourceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Sources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSourcesIngestionStateProjectIdSourcesGet(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IngestionStateSourceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSourcesIngestionStateProjectIdSourcesGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listSourcesIngestionStateProjectIdSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Sources Resources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IngestionStateResourceModelOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain ELMA365 applications.  Args:     request (ELMA365ApplicationObtainingRequest): Applications obtaining request.  Returns:     ELMA365ApplicationObtainingResponse: Applications obtaining response.
         * @summary Obtain Elma365 Application
         * @param {ELMA365ApplicationObtainingRequest} eLMA365ApplicationObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async obtainELMA365ToolkitApplications(eLMA365ApplicationObtainingRequest: ELMA365ApplicationObtainingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ApplicationObtainingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.obtainELMA365ToolkitApplications(eLMA365ApplicationObtainingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.obtainELMA365ToolkitApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain ELMA365 namespaces.  Args:     request (ELMA365NamespaceObtainingRequest): Namespaces obtaining request.  Returns:     ELMA365NamespaceObtainingResponse: Namespaces obtaining response.
         * @summary Obtain Elma365 Namespace
         * @param {ELMA365NamespaceObtainingRequest} eLMA365NamespaceObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async obtainELMA365ToolkitNamespaces(eLMA365NamespaceObtainingRequest: ELMA365NamespaceObtainingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365NamespaceObtainingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.obtainELMA365ToolkitNamespaces(eLMA365NamespaceObtainingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.obtainELMA365ToolkitNamespaces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain ELMA365 processes.  Args:     request (ELMA365ProcessObtainingRequest): Processes obtaining request.  Returns:     ELMA365ProcessObtainingResponse: Processes obtaining response.
         * @summary Obtain Elma365 Process
         * @param {ELMA365ProcessObtainingRequest} eLMA365ProcessObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async obtainELMA365ToolkitProcesses(eLMA365ProcessObtainingRequest: ELMA365ProcessObtainingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ProcessObtainingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.obtainELMA365ToolkitProcesses(eLMA365ProcessObtainingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.obtainELMA365ToolkitProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain ELMA365 tools.  Args:     request (ELMA365ToolObtainingRequest): Tools obtaining request.  Returns:     ELMA365ToolObtainingResponse: Tools obtaining response.
         * @summary Obtain Elma365 Tools
         * @param {ELMA365ToolObtainingRequest} eLMA365ToolObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async obtainELMA365ToolkitTools(eLMA365ToolObtainingRequest: ELMA365ToolObtainingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolObtainingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.obtainELMA365ToolkitTools(eLMA365ToolObtainingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.obtainELMA365ToolkitTools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtain system folder.  Returns:     FolderModel: System folder.
         * @summary Obtain System Folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async obtainSystemFolder(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.obtainSystemFolder(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.obtainSystemFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Poll the status of an OAuth2 connector check.  Args:     check_id (str): Check ID returned from checkConnector.  Returns:     ConnectorCheckOAuthPollingResponse: Current check status.
         * @summary Poll Connector Oauth Check
         * @param {string} checkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pollConnectorOAuthCheck(checkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorCheckOAuthPollingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pollConnectorOAuthCheck(checkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.pollConnectorOAuthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve request.  Args:     request (RetrieveRequest): Retrieve request.  Returns:     RetrieveResponse: Retrieve response.
         * @summary Retrieve
         * @param {RetrieveRequest} retrieveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveSearchRetrievePost(retrieveRequest: RetrieveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveSearchRetrievePost(retrieveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.retrieveSearchRetrievePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search all messages (ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
         * @summary Search All Messages
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentAllMessages(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentMessageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentAllMessages(fAgentIds, fThreadIds, fRunIds, sOrder, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentAllMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentAllRuns(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentAllRuns(fAgentIds, fThreadIds, fSearchText, fCreatedOnMin, fCreatedOnMax, sOrder, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentAllRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search all threads (Ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
         * @summary Search All Threads
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {string | null} [fSourceRef] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentAllThreads(fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentAllThreads(fAgentIds, fSearchText, fCreatedOnMin, fCreatedOnMax, fSourceRef, sOrder, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentAllThreads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search agent relations.  Args:     f_managing_agent_ids (Optional[List[str]]): Managing agent IDs.     f_managed_agent_ids (Optional[List[str]]): Managed agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRelationModel]: Found agent relations.
         * @summary Search Relations
         * @param {Array<string> | null} [fManagingAgentIds] 
         * @param {Array<string> | null} [fManagedAgentIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentRelations(fManagingAgentIds?: Array<string> | null, fManagedAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentRelations(fManagingAgentIds, fManagedAgentIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentRelations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search agent resources.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentResourceModel]: Found agent resources.
         * @summary Search Resources
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentResources(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentResourceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentResources(fAgentIds, fThreadIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search user messages.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
         * @summary Search User Messages
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentUserMessages(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentMessageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentUserMessages(fAgentIds, fThreadIds, fRunIds, sOrder, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentUserMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentUserRuns(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentUserRuns(fAgentIds, fThreadIds, fSearchText, fCreatedOnMin, fCreatedOnMax, sOrder, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentUserRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search user threads.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
         * @summary Search User Threads
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {string | null} [fSourceRef] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentUserThreads(fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentUserThreads(fAgentIds, fSearchText, fCreatedOnMin, fCreatedOnMax, fSourceRef, sOrder, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgentUserThreads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search agents.  Args:     f_search_text (Optional[str]): Agent search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_interface_types (Optional[List[DataInterfaceType]]): Agent interface types.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentModel]: Found Agents.
         * @summary Search Agents
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<DataInterfaceType> | null} [fInterfaceTypes] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgents(fSearchText?: string | null, fFolderIds?: Array<string> | null, fInterfaceTypes?: Array<DataInterfaceType> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseAgentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgents(fSearchText, fFolderIds, fInterfaceTypes, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search all messages (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
         * @summary Search All Messages
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAllMessagesSearchMessagesAllGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseSearchMessageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAllMessagesSearchMessagesAllGet(fProjectIds, fThreadIds, fRunIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAllMessagesSearchMessagesAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search all threads (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
         * @summary Search All Threads
         * @param {Array<string> | null} [fProjectIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAllThreadsSearchThreadsAllGet(fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseSearchThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAllThreadsSearchThreadsAllGet(fProjectIds, fSearchText, fCreatedOnMin, fCreatedOnMax, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchAllThreadsSearchThreadsAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ApiKeys.  Args:     f_scope_ref_types (List[ApiKeyScopeRefType]): Scope ref object types.     f_scope_ref_ids (List[str]): Scope ref object IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ApiKeyModel]: Found ApiKeys.
         * @summary Search Api Keys
         * @param {Array<ApiKeyScopeRefType> | null} [fScopeRefTypes] 
         * @param {Array<string> | null} [fScopeRefIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchApiKeysSecurityApiKeysGet(fScopeRefTypes?: Array<ApiKeyScopeRefType> | null, fScopeRefIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseApiKeyModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchApiKeysSecurityApiKeysGet(fScopeRefTypes, fScopeRefIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchApiKeysSecurityApiKeysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search artifacts.  Args:     f_artifact_ids (Optional[List[str]]): Artifact IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_resource_ids (Optional[List[str]]): Resource IDs.     f_parent_ids (Optional[List[Optional[str]]]): Parent IDs.     f_file_ids (Optional[List[Optional[str]]]): File IDs.     f_types (Optional[List[IngestionArtifactType]]): Artifact types.     f_origins (Optional[List[IngestionArtifactOrigin]]): Artifact actions.     f_actions (Optional[List[IngestionArtifactCommand]]): Artifact commands.     f_node_ids (Optional[List[str]]): Node IDs.     f_node_classes (Optional[List[IngestionNodeClass]]): Node classes.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionArtifactModel]: Found artifacts.
         * @summary Search Artifacts
         * @param {Array<string> | null} [fArtifactIds] 
         * @param {Array<string> | null} [fPublicIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<string> | null} [fResourceIds] 
         * @param {Array<string> | null} [fParentIds] 
         * @param {Array<string> | null} [fFileIds] 
         * @param {Array<IngestionArtifactType> | null} [fTypes] 
         * @param {Array<IngestionArtifactOrigin> | null} [fOrigins] 
         * @param {Array<IngestionArtifactAction> | null} [fActions] 
         * @param {Array<string> | null} [fNodeIds] 
         * @param {Array<IngestionNodeClass> | null} [fNodeClasses] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchArtifactsIngestionArtifactsGet(fArtifactIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fResourceIds?: Array<string> | null, fParentIds?: Array<string> | null, fFileIds?: Array<string> | null, fTypes?: Array<IngestionArtifactType> | null, fOrigins?: Array<IngestionArtifactOrigin> | null, fActions?: Array<IngestionArtifactAction> | null, fNodeIds?: Array<string> | null, fNodeClasses?: Array<IngestionNodeClass> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseIngestionArtifactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchArtifactsIngestionArtifactsGet(fArtifactIds, fPublicIds, fProjectIds, fSourceIds, fResourceIds, fParentIds, fFileIds, fTypes, fOrigins, fActions, fNodeIds, fNodeClasses, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchArtifactsIngestionArtifactsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search connectors.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Connector search text.     f_statuses (Optional[List[ConnectorStatus]]): Connector statuses.     f_availabilities (Optional[List[ConnectorStatus]]): Connector availabilities.     f_auth_types (Optional[List[ConnectorAuthType]]): Connector auth types.  Returns:     PaginationResponse[ConnectorModel]: Found connectors.
         * @summary Search Connectors
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<ConnectorStatus> | null} [fStatuses] 
         * @param {Array<ConnectorAvailability> | null} [fAvailabilities] 
         * @param {Array<ConnectorAuthType> | null} [fAuthTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchConnectors(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fStatuses?: Array<ConnectorStatus> | null, fAvailabilities?: Array<ConnectorAvailability> | null, fAuthTypes?: Array<ConnectorAuthType> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseConnectorModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchConnectors(pPageIndex, pPageSize, pWithTotal, fSearchText, fStatuses, fAvailabilities, fAuthTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchConnectors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ELMA365 applications.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Application search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_statuses (Optional[List[ELMA365ApplicationStatus]]): Application statuses.     f_visibilities (Optional[List[ELMA365ApplicationVisibility]]): Application visibilities.     f_availabilities (Optional[List[ELMA365ApplicationAvailability]]): Application availabilities.  Returns:     PaginationResponse[ELMA365ApplicationModel]: Found ELMA365 applications.
         * @summary Search Elma365 Applications
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<ELMA365ApplicationStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ApplicationVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ApplicationAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchELMA365ToolkitApplications(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fStatuses?: Array<ELMA365ApplicationStatus> | null, fVisibilities?: Array<ELMA365ApplicationVisibility> | null, fAvailabilities?: Array<ELMA365ApplicationAvailability> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseELMA365ApplicationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchELMA365ToolkitApplications(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fStatuses, fVisibilities, fAvailabilities, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchELMA365ToolkitApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ELMA365 namespaces.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Namespace search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365NamespacenStatus]]): Namespace statuses.     f_visibilities (Optional[List[ELMA365NamespaceVisibility]]): Namespace visibilities.     f_availabilities (Optional[List[ELMA365NamespaceAvailability]]): Namespace availabilities.  Returns:     PaginationResponse[ELMA365NamespaceModel]: Found ELMA365 namespaces.
         * @summary Search Elma365 Namespaces
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<ELMA365NamespaceStatus> | null} [fStatuses] 
         * @param {Array<ELMA365NamespaceVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365NamespaceAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchELMA365ToolkitNamespaces(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365NamespaceStatus> | null, fVisibilities?: Array<ELMA365NamespaceVisibility> | null, fAvailabilities?: Array<ELMA365NamespaceAvailability> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseELMA365NamespaceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchELMA365ToolkitNamespaces(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fStatuses, fVisibilities, fAvailabilities, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchELMA365ToolkitNamespaces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ELMA365 processes.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Process search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_application_ids (Optional[List[str]]): Application IDs.     f_statuses (Optional[List[ELMA365ProcessStatus]]): Process statuses.     f_visibilities (Optional[List[ELMA365ProcessVisibility]]): Process visibilities.     f_availabilities (Optional[List[ELMA365ProcessAvailability]]): Process availabilities.  Returns:     PaginationResponse[ELMA365ProcessModel]: Found ELMA365 processes.
         * @summary Search Elma365 Processes
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<string> | null} [fApplicationIds] 
         * @param {Array<ELMA365ProcessStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ProcessVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ProcessAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchELMA365ToolkitProcesses(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fApplicationIds?: Array<string> | null, fStatuses?: Array<ELMA365ProcessStatus> | null, fVisibilities?: Array<ELMA365ProcessVisibility> | null, fAvailabilities?: Array<ELMA365ProcessAvailability> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseELMA365ProcessModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchELMA365ToolkitProcesses(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fApplicationIds, fStatuses, fVisibilities, fAvailabilities, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchELMA365ToolkitProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ELMA365 tools.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Tool search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_component_ids (Optional[List[str]]): Component IDs.     f_statuses (Optional[List[ELMA365ToolStatus]]): Tool statuses.     f_visibilities (Optional[List[ELMA365ToolVisibility]]): Tool visibilities.     f_availabilities (Optional[List[ELMA365ToolAvailability]]): Tool availabilities.  Returns:     PaginationResponse[ELMA365ToolModel]: Found ELMA365 tool.
         * @summary Search Elma365 Tools
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<string> | null} [fComponentIds] 
         * @param {Array<ELMA365ToolStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ToolVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ToolAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchELMA365ToolkitTools(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fComponentIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolStatus> | null, fVisibilities?: Array<ELMA365ToolVisibility> | null, fAvailabilities?: Array<ELMA365ToolAvailability> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseELMA365ToolModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchELMA365ToolkitTools(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fComponentIds, fStatuses, fVisibilities, fAvailabilities, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchELMA365ToolkitTools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ELMA365 toolsets.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365ToolsetStatus]]): Toolset statuses.     f_visibilities (Optional[List[ELMA365ToolsetVisibility]]): Toolset visibilities.     f_availabilities (Optional[List[ELMA365ToolsetAvailability]]): Toolset availabilities.  Returns:     PaginationResponse[ELMA365ToolsetModel]: Found ELMA365 toolsets.
         * @summary Search Elma365 Toolsets
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<ELMA365ToolsetStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ToolsetVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ToolsetAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchELMA365ToolkitToolsets(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fFolderIds?: Array<string> | null, fConnectorIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolsetStatus> | null, fVisibilities?: Array<ELMA365ToolsetVisibility> | null, fAvailabilities?: Array<ELMA365ToolsetAvailability> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseELMA365ToolsetModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchELMA365ToolkitToolsets(pPageIndex, pPageSize, pWithTotal, fSearchText, fFolderIds, fConnectorIds, fVersionIds, fStatuses, fVisibilities, fAvailabilities, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchELMA365ToolkitToolsets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search ELMA365 versions.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_statuses (Optional[List[ELMA365VersionStatus]]): Version statuses.     f_stages (Optional[List[ELMA365VersionStage]]): Version stages.     f_phases (Optional[List[ELMA365VersionPhase]]): Version phases.     f_visibilities (Optional[List[ELMA365VersionVisibility]]): Version visibilities.     f_availabilities (Optional[List[ELMA365VersionAvailability]]): Version availabilities.  Returns:     PaginationResponse[ELMA365VersionModel]: Found ELMA365 version.
         * @summary Search Elma365 Versions
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<ELMA365VersionStatus> | null} [fStatuses] 
         * @param {Array<ELMA365VersionStage> | null} [fStages] 
         * @param {Array<ELMA365VersionPhase> | null} [fPhases] 
         * @param {Array<ELMA365VersionVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365VersionAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchELMA365ToolkitVersions(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fStatuses?: Array<ELMA365VersionStatus> | null, fStages?: Array<ELMA365VersionStage> | null, fPhases?: Array<ELMA365VersionPhase> | null, fVisibilities?: Array<ELMA365VersionVisibility> | null, fAvailabilities?: Array<ELMA365VersionAvailability> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseELMA365VersionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchELMA365ToolkitVersions(pPageIndex, pPageSize, pWithTotal, fConnectorIds, fToolsetIds, fStatuses, fStages, fPhases, fVisibilities, fAvailabilities, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchELMA365ToolkitVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search ELMA365 applications
         * @param {string} baseUrl 
         * @param {string} xToken 
         * @param {string | null} [searchText] 
         * @param {{ [key: string]: any; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchElma365AppsElma365AppGet(baseUrl: string, xToken: string, searchText?: string | null, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ELMA365AppModelOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchElma365AppsElma365AppGet(baseUrl, xToken, searchText, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchElma365AppsElma365AppGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search ELMA365 namespaces
         * @param {string} baseUrl 
         * @param {string} xToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchElma365NssElma365NsGet(baseUrl: string, xToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ELMA365NSModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchElma365NssElma365NsGet(baseUrl, xToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchElma365NssElma365NsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search files.  Args:     filtration (FileFiltration): Filtration parameters.     pagination (PaginationRequest): Pagination parameters.  Returns:     PaginationResponse[FileModel]: Found files.
         * @summary Search Files Post
         * @param {BodySearchFiles} [bodySearchFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFiles(bodySearchFiles?: BodySearchFiles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseFileModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFiles(bodySearchFiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search files.  Args:     f_file_ids (Optional[List[str]]): File IDs.     f_external_ids (Optional[List[str]]): External IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_purposes (Optional[List[FilePurpose]]): File purposes.     f_content_mimes (Optional[List[str]]): Content MIMEs.     f_content_stores (Optional[List[FileContentStore]]): Content stores.     f_content_formats (Optional[List[Optional[FileContentFormat]]]): Content formats.     f_content_encodings (Optional[List[Optional[str]]]): Content encodings.     f_content_markups (Optional[List[Optional[FileContentFormat]]]): Content markups.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[FileModel]: Found files.
         * @summary Search Files
         * @param {Array<string> | null} [fFileIds] 
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<string> | null} [fPublicIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<FilePurpose> | null} [fPurposes] 
         * @param {Array<string> | null} [fContentMimes] 
         * @param {Array<ContentStore> | null} [fContentStores] 
         * @param {Array<ContentFormat> | null} [fContentFormats] 
         * @param {Array<string> | null} [fContentEncodings] 
         * @param {Array<ContentMarkup> | null} [fContentMarkups] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFilesGeneralFilesGet(fFileIds?: Array<string> | null, fExternalIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fPurposes?: Array<FilePurpose> | null, fContentMimes?: Array<string> | null, fContentStores?: Array<ContentStore> | null, fContentFormats?: Array<ContentFormat> | null, fContentEncodings?: Array<string> | null, fContentMarkups?: Array<ContentMarkup> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseFileModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFilesGeneralFilesGet(fFileIds, fExternalIds, fPublicIds, fProjectIds, fSourceIds, fPurposes, fContentMimes, fContentStores, fContentFormats, fContentEncodings, fContentMarkups, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchFilesGeneralFilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search folders.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Folder search text.     f_external_ids (Optional[List[str]]): Folder external IDs.     f_types (Optional[List[FolderType]]): Folder types.  Returns:     PaginationResponse[FolderModel]: Found folders.
         * @summary Search Folders
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<FolderType> | null} [fTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFolders(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fExternalIds?: Array<string> | null, fTypes?: Array<FolderType> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseFolderModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFolders(pPageIndex, pPageSize, pWithTotal, fSearchText, fExternalIds, fTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search operations.  Args:     f_operation_ids (Optional[List[str]]): Operation IDs.     f_statuses (Optional[List[OperationStatus]]): Operation statuses.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[OperationModel]: Found operations.
         * @summary Search Operations
         * @param {Array<string> | null} [fOperationIds] 
         * @param {Array<OperationStatus> | null} [fStatuses] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOperationsGeneralOperationsGet(fOperationIds?: Array<string> | null, fStatuses?: Array<OperationStatus> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseOperationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOperationsGeneralOperationsGet(fOperationIds, fStatuses, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchOperationsGeneralOperationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search processes.  Args:     f_process_ids (Optional[List[str]]): Process IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_operation_ids (Optional[List[str]]): Operation IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionProcessModel]: Found processes.
         * @summary Search Processes
         * @param {Array<string> | null} [fProcessIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fOperationIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProcessesIngestionProcessesGet(fProcessIds?: Array<string> | null, fProjectIds?: Array<string> | null, fOperationIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseIngestionProcessModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProcessesIngestionProcessesGet(fProcessIds, fProjectIds, fOperationIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchProcessesIngestionProcessesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search projects.  Args:     f_search_text (Optional[str]): Project search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ProjectModel]: Found Projects.
         * @summary Search Projects
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProjectsGeneralProjectsGet(fSearchText?: string | null, fFolderIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseProjectModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProjectsGeneralProjectsGet(fSearchText, fFolderIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchProjectsGeneralProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_enabled (Optional[bool]): Filter by enabled property.  Returns:     PaginationResponse[ProviderModel]: Found Providers.
         * @summary Search Providers
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {boolean | null} [fEnabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProvidersGeneralProvidersGet(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fEnabled?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseProviderModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProvidersGeneralProvidersGet(pPageIndex, pPageSize, pWithTotal, fEnabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchProvidersGeneralProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search resources.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_actions (Optional[List[IngestionResourceAction]]): Resource actions.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionResourceModel]: Found resources.
         * @summary Search Resources
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<IngestionStageType> | null} [fStages] 
         * @param {Array<IngestionResourceAction> | null} [fActions] 
         * @param {string | null} [fSearchText] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchResourcesIngestionResourcesGet(fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fStages?: Array<IngestionStageType> | null, fActions?: Array<IngestionResourceAction> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseIngestionResourceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchResourcesIngestionResourcesGet(fProjectIds, fSourceIds, fStages, fActions, fSearchText, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchResourcesIngestionResourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search runs.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchRunModel]: Found Runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRunsSearchRunsGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseSearchRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRunsSearchRunsGet(fProjectIds, fThreadIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchRunsSearchRunsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search Signals
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fProcessIds] 
         * @param {Array<IngestionSignalSubject> | null} [fSubjects] 
         * @param {Array<IngestionSignalCommand> | null} [fCommands] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSignalsIngestionSignalsGet(fProjectIds?: Array<string> | null, fProcessIds?: Array<string> | null, fSubjects?: Array<IngestionSignalSubject> | null, fCommands?: Array<IngestionSignalCommand> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseIngestionSignalModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSignalsIngestionSignalsGet(fProjectIds, fProcessIds, fSubjects, fCommands, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchSignalsIngestionSignalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search sources.  Args:     f_external_ids (Optional[list[str]]): External project IDs.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_names (Optional[List[str]]): Source names.     f_statuses (Optional[List[IngestionSourceStatus]]): Source statuses.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_grades (Optional[List[IngestionSourceGrade]]): Stage grades.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionSourceModel]: Found sources.
         * @summary Search Sources
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fNames] 
         * @param {Array<IngestionSourceStatus> | null} [fStatuses] 
         * @param {Array<IngestionStageType> | null} [fStages] 
         * @param {Array<IngestionSourceGrade> | null} [fGrades] 
         * @param {string | null} [fSearchText] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSourcesIngestionSourcesGet(fExternalIds?: Array<string> | null, fFolderIds?: Array<string> | null, fProjectIds?: Array<string> | null, fNames?: Array<string> | null, fStatuses?: Array<IngestionSourceStatus> | null, fStages?: Array<IngestionStageType> | null, fGrades?: Array<IngestionSourceGrade> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseIngestionSourceModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSourcesIngestionSourcesGet(fExternalIds, fFolderIds, fProjectIds, fNames, fStatuses, fStages, fGrades, fSearchText, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchSourcesIngestionSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search toolsets.  Args:     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_agent_ids (Optional[List[str]]): Agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ToolsetModel]: Found toolsets.
         * @summary Search Toolsets
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fAgentIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchToolsets(fSearchText?: string | null, fFolderIds?: Array<string> | null, fAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseToolsetModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchToolsets(fSearchText, fFolderIds, fAgentIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchToolsets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search trace providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[TraceProviderModel]: Found trace providers.
         * @summary Search Trace Providers
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTraceProvidersGeneralTraceProvidersGet(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseTraceProviderModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTraceProvidersGeneralTraceProvidersGet(pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchTraceProvidersGeneralTraceProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search user messages.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
         * @summary Search User Messages
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUserMessagesSearchMessagesUserGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseSearchMessageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUserMessagesSearchMessagesUserGet(fProjectIds, fThreadIds, fRunIds, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchUserMessagesSearchMessagesUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search user threads.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
         * @summary Search User Threads
         * @param {Array<string> | null} [fProjectIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUserThreadsSearchThreadsUserGet(fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseSearchThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUserThreadsSearchThreadsUserGet(fProjectIds, fSearchText, fCreatedOnMin, fCreatedOnMax, pPageIndex, pPageSize, pWithTotal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchUserThreadsSearchThreadsUserGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Select ELMA365 applications.  Args:     request (ELMA365ApplicationSelectionRequest): Applications selection request.  Returns:     ELMA365ApplicationSelectionResponse: Applications selection response.
         * @summary Select Elma365 Applications
         * @param {ELMA365ApplicationSelectionRequest} eLMA365ApplicationSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectELMA365ToolkitApplications(eLMA365ApplicationSelectionRequest: ELMA365ApplicationSelectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ApplicationSelectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selectELMA365ToolkitApplications(eLMA365ApplicationSelectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.selectELMA365ToolkitApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Select ELMA365 namespaces.  Args:     request (ELMA365NamespaceSelectionRequest): Namespaces selection request.  Returns:     ELMA365NamespaceSelectionResponse: Namespaces selection response.
         * @summary Select Elma365 Namespace
         * @param {ELMA365NamespaceSelectionRequest} eLMA365NamespaceSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectELMA365ToolkitNamespaces(eLMA365NamespaceSelectionRequest: ELMA365NamespaceSelectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365NamespaceSelectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selectELMA365ToolkitNamespaces(eLMA365NamespaceSelectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.selectELMA365ToolkitNamespaces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Select ELMA365 processes.  Args:     request (ELMA365ProcessSelectionRequest): Processes selection request.  Returns:     ELMA365ProcessSelectionResponse: Processes selection response.
         * @summary Select Elma365 Processes
         * @param {ELMA365ProcessSelectionRequest} eLMA365ProcessSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectELMA365ToolkitProcesses(eLMA365ProcessSelectionRequest: ELMA365ProcessSelectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ProcessSelectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selectELMA365ToolkitProcesses(eLMA365ProcessSelectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.selectELMA365ToolkitProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Select ELMA365 tools.  Args:     request (ELMA365ToolSelectionRequest): Tools selection request.  Returns:     ELMA365ToolSelectionResponse: Tools selection response.
         * @summary Select Elma365 Tools
         * @param {ELMA365ToolSelectionRequest} eLMA365ToolSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectELMA365ToolkitTools(eLMA365ToolSelectionRequest: ELMA365ToolSelectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolSelectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selectELMA365ToolkitTools(eLMA365ToolSelectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.selectELMA365ToolkitTools']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign out this session.  Args:     public_id (str): Session public ID.
         * @summary Sign Out Session
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOutSession(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOutSession(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.signOutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolTogglingRequest): Tool toggling request.  Returns:     ELMA365ToolTogglingResponse: Tool toggling response.
         * @summary Toggle Elma365 Tool
         * @param {string} toolId 
         * @param {ELMA365ToolTogglingRequest} eLMA365ToolTogglingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleELMA365ToolkitTool(toolId: string, eLMA365ToolTogglingRequest: ELMA365ToolTogglingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolTogglingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleELMA365ToolkitTool(toolId, eLMA365ToolTogglingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleELMA365ToolkitTool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetTogglingRequest): Toolset toggling request.  Returns:     ELMA365ToolsetTogglingResponse: Toolset toggling response.
         * @summary Toggle Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetTogglingRequest} eLMA365ToolsetTogglingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetTogglingRequest: ELMA365ToolsetTogglingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetTogglingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleELMA365ToolkitToolset(toolsetId, eLMA365ToolsetTogglingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleELMA365ToolkitToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Try to get last thread.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_source_ref (Optional[str]): Source ref.  Returns:     Optional[AgentThreadModel]: Found thread else None.
         * @summary Try Get Last
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSourceRef] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tryGetLastAgentThread(fAgentIds?: Array<string> | null, fSourceRef?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tryGetLastAgentThread(fAgentIds, fSourceRef, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.tryGetLastAgentThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Try to get last thread.  Args:     f_project_ids (Optional[List[str]]): Project IDs.  Returns:     Optional[SearchThreadModel]: Found Thread else None.
         * @summary Try Get Last
         * @param {Array<string> | null} [fProjectIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tryGetLastSearchThreadsLastGet(fProjectIds?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchThreadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tryGetLastSearchThreadsLastGet(fProjectIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.tryGetLastSearchThreadsLastGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update agent.  Args:     agent_id (str): Agent ID.     request (AgentUpdatingRequest): Agent updating request.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdatingRequest} agentUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgent(agentId: string, agentUpdatingRequest: AgentUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgent(agentId, agentUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update agent relation.  Args:     relation_id (str): Agent relation ID.     request (AgentRelationUpdatingRequest): Agent relation updating request.
         * @summary Update Relation
         * @param {string} relationId 
         * @param {AgentRelationUpdatingRequest} agentRelationUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentRelation(relationId: string, agentRelationUpdatingRequest: AgentRelationUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentRelation(relationId, agentRelationUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAgentRelation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update agent resource.  Args:     resource_id (str): Agent resource ID.     request (AgentResourceUpdatingRequest): Agent resource updating request.
         * @summary Update Resource
         * @param {string} resourceId 
         * @param {AgentResourceUpdatingRequest} agentResourceUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentResource(resourceId: string, agentResourceUpdatingRequest: AgentResourceUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentResource(resourceId, agentResourceUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAgentResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update thread.  Args:     thread_id (str): Thread ID.     request (AgentThreadUpdatingRequest): Thread updating request.
         * @summary Update Thread
         * @param {string} threadId 
         * @param {AgentThreadUpdatingRequest} agentThreadUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentThread(threadId: string, agentThreadUpdatingRequest: AgentThreadUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentThread(threadId, agentThreadUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateAgentThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update ApiKey.  Args:     api_key_id (str): ApiKey ID.     request (ApiKeyUpdatingRequest): ApiKey updating request.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {ApiKeyUpdatingRequest} apiKeyUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiKeySecurityApiKeysApiKeyIdPut(apiKeyId: string, apiKeyUpdatingRequest: ApiKeyUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiKeySecurityApiKeysApiKeyIdPut(apiKeyId, apiKeyUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateApiKeySecurityApiKeysApiKeyIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update connector.  Args:     connector_id (str): Connector ID.     request (ConnectorUpdatingRequest): Connector updating request.
         * @summary Update Connector
         * @param {string} connectorId 
         * @param {ConnectorUpdatingRequest} connectorUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConnector(connectorId: string, connectorUpdatingRequest: ConnectorUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConnector(connectorId, connectorUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateConnector']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolUpdatingRequest): Tool updating request.  Returns:     ELMA365ToolUpdatingResponse: Tool updating response.
         * @summary Update Elma365 Tool
         * @param {string} toolId 
         * @param {ELMA365ToolUpdatingRequest} eLMA365ToolUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateELMA365ToolkitTool(toolId: string, eLMA365ToolUpdatingRequest: ELMA365ToolUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateELMA365ToolkitTool(toolId, eLMA365ToolUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateELMA365ToolkitTool']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetUpdatingRequest): Toolset updating request.  Returns:     ELMA365ToolsetUpdatingResponse: Toolset updating response.
         * @summary Update Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetUpdatingRequest} eLMA365ToolsetUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetUpdatingRequest: ELMA365ToolsetUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ELMA365ToolsetUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateELMA365ToolkitToolset(toolsetId, eLMA365ToolsetUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateELMA365ToolkitToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update file via form.  Args:     path (FileUpdatingPath): Request path.     query (FileUpdatingQuery): Request query.     content (UploadFile): File content.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Form
         * @param {string} fileId 
         * @param {string} externalId 
         * @param {Array<FilePurpose>} purposes 
         * @param {File} content 
         * @param {string | null} [projectId] 
         * @param {string | null} [sourceId] 
         * @param {ContentStore | null} [contentStore] 
         * @param {ContentFormat | null} [contentFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFileFormGeneralFilesFormFileIdPut(fileId: string, externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFileFormGeneralFilesFormFileIdPut(fileId, externalId, purposes, content, projectId, sourceId, contentStore, contentFormat, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFileFormGeneralFilesFormFileIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update file via JSON.  Args:     path (FileUpdatingPath): Request path.     body (FileUpdatingBody): Request body.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Json
         * @param {string} fileId 
         * @param {FileUpdatingBody} fileUpdatingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFileJsonGeneralFilesJsonFileIdPut(fileId: string, fileUpdatingBody: FileUpdatingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFileJsonGeneralFilesJsonFileIdPut(fileId, fileUpdatingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFileJsonGeneralFilesJsonFileIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update file\'s parameters.  Args:     path (FileUpdatingPath): Request path.     body (FileParametersInfo): Request body.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Parameters
         * @param {string} fileId 
         * @param {FileParametersInfo} fileParametersInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFileParametersGeneralFilesFileIdParametersPut(fileId: string, fileParametersInfo: FileParametersInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFileParametersGeneralFilesFileIdParametersPut(fileId, fileParametersInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFileParametersGeneralFilesFileIdParametersPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update folder.  Args:     folder_id (str): Folder ID.     request (FolderUpdatingRequest): Folder updating request.  Returns:     FolderUpdatingResponse: Folder updating response.
         * @summary Update Folder
         * @param {string} folderId 
         * @param {FolderUpdatingRequest} folderUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFolder(folderId: string, folderUpdatingRequest: FolderUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFolder(folderId, folderUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update project.  Args:     project_id (str): Project ID.     request (ProjectUpdatingRequest): Project updating request.
         * @summary Update Project
         * @param {string} projectId 
         * @param {ProjectUpdatingRequest} projectUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectGeneralProjectsProjectIdPut(projectId: string, projectUpdatingRequest: ProjectUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectGeneralProjectsProjectIdPut(projectId, projectUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateProjectGeneralProjectsProjectIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update provider.  Args:     provider_id (str): Provider ID.     request (ProviderUpdatingRequest): Provider updating request.
         * @summary Update Provider
         * @param {string} providerId 
         * @param {ProviderUpdatingRequest} providerUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProviderGeneralProvidersProviderIdPut(providerId: string, providerUpdatingRequest: ProviderUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProviderGeneralProvidersProviderIdPut(providerId, providerUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateProviderGeneralProvidersProviderIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Schedule
         * @param {string} scheduleId 
         * @param {IngestionScheduleUpdatingRequest} ingestionScheduleUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSchedule(scheduleId: string, ingestionScheduleUpdatingRequest: IngestionScheduleUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSchedule(scheduleId, ingestionScheduleUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Source
         * @param {string} sourceId 
         * @param {IngestionSourceUpdatingRequest} ingestionSourceUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSourceIngestionSourcesSourceIdPut(sourceId: string, ingestionSourceUpdatingRequest: IngestionSourceUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestionSourceUpdatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSourceIngestionSourcesSourceIdPut(sourceId, ingestionSourceUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateSourceIngestionSourcesSourceIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update thread.  Args:     thread_id (str): Thread ID.     request (SearchThreadUpdatingRequest): Thread updating request.
         * @summary Update Thread
         * @param {string} threadId 
         * @param {SearchThreadUpdatingRequest} searchThreadUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateThreadSearchThreadsThreadIdPut(threadId: string, searchThreadUpdatingRequest: SearchThreadUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateThreadSearchThreadsThreadIdPut(threadId, searchThreadUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateThreadSearchThreadsThreadIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update toolset.  Args:     toolset_id (str): Toolset ID.     request (ToolsetUpdatingRequest): Toolset updating request.
         * @summary Update Toolset
         * @param {string} toolsetId 
         * @param {ToolsetUpdatingRequest} toolsetUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateToolset(toolsetId: string, toolsetUpdatingRequest: ToolsetUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateToolset(toolsetId, toolsetUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateToolset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update trace provider.  Args:     trace_provider_id (str): Trace provider ID.     request (TraceProviderUpdatingRequest): Trace provider updating request.
         * @summary Update Trace Provider
         * @param {string} traceProviderId 
         * @param {TraceProviderUpdatingRequest} traceProviderUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTraceProviderGeneralTraceProvidersTraceProviderIdPut(traceProviderId: string, traceProviderUpdatingRequest: TraceProviderUpdatingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTraceProviderGeneralTraceProvidersTraceProviderIdPut(traceProviderId, traceProviderUpdatingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateTraceProviderGeneralTraceProvidersTraceProviderIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Assert session.  Args:     public_id (str): Session public ID.     request (SessionAssertRequest): Session assertion request.  Returns:     SessionAssertResponse: Session assertion response.
         * @summary Assert Session
         * @param {string} publicId 
         * @param {Request1} request1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertSession(publicId: string, request1: Request1, options?: RawAxiosRequestConfig): AxiosPromise<SessionAssertResponse> {
            return localVarFp.assertSession(publicId, request1, options).then((request) => request(axios, basePath));
        },
        /**
         * Login.  Args:     action (str): Callback action.     return_to (str): Return path.  Returns:     None: Redirects the user to the OAuth provider.
         * @summary Auth Login
         * @param {string} action 
         * @param {string} returnTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogin(action: string, returnTo: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authLogin(action, returnTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout.  Args:     request (Request): Logout request.  Returns:     None: Redirects the user to the index page.
         * @summary Auth Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * Call ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetCallingRequest): Toolset calling request.  Returns:     ELMA365ToolsetCallingResponse: Toolset calling response.
         * @summary Call Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetCallingRequest} eLMA365ToolsetCallingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetCallingRequest: ELMA365ToolsetCallingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetCallingResponse> {
            return localVarFp.callELMA365ToolkitToolset(toolsetId, eLMA365ToolsetCallingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check connector.  Args:     request (ConnectorCheckingRequest): Connector checking request.  Returns:     ConnectorCheckingResponse: Connector checking response.
         * @summary Check Connector
         * @param {ConnectorCheckingRequest} connectorCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConnector(connectorCheckingRequest: ConnectorCheckingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectorCheckingResponse> {
            return localVarFp.checkConnector(connectorCheckingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check provider embedding.  Args:     request (ProviderEmbeddingCheckingRequest): Provider embedding checking request.  Returns:     ProviderEmbeddingCheckingResponse: Provider embedding checking response.
         * @summary Check Provider Embedding
         * @param {ProviderEmbeddingCheckingRequest} providerEmbeddingCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost(providerEmbeddingCheckingRequest: ProviderEmbeddingCheckingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderEmbeddingCheckingResponse> {
            return localVarFp.checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost(providerEmbeddingCheckingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check provider llm.  Args:     request (ProviderLLMCheckingRequest): Provider LLM checking request.  Returns:     ProviderLLMCheckingResponse: Provider LLM checking response.
         * @summary Check Provider Llm
         * @param {ProviderLLMCheckingRequest} providerLLMCheckingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkProviderLlmGeneralProvidersLlmCheckPost(providerLLMCheckingRequest: ProviderLLMCheckingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderLLMCheckingResponse> {
            return localVarFp.checkProviderLlmGeneralProvidersLlmCheckPost(providerLLMCheckingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Compare ELMA365 versions.  Args:     request (ELMA365VersionComparisonRequest): Versions comparison request.  Returns:     ELMA365VersionComparisonResponse: Versions comparison response.
         * @summary Compare Elma365 Versions
         * @param {ELMA365VersionComparisonRequest} eLMA365VersionComparisonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compareELMA365ToolkitVersions(eLMA365VersionComparisonRequest: ELMA365VersionComparisonRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365VersionComparisonResponse> {
            return localVarFp.compareELMA365ToolkitVersions(eLMA365VersionComparisonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Completion request.  Args:     request (CompletionRequest): Completion request.  Returns:     CompletionResponse: Completion response.
         * @summary Completion
         * @param {CompletionRequest} completionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completionSearchCompletionPost(completionRequest: CompletionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompletionResponse> {
            return localVarFp.completionSearchCompletionPost(completionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create agent.  Args:     request (AgentCreationRequest): Agent creation request.  Returns:     AgentCreationResponse: Agent creation response.
         * @summary Create Agent
         * @param {AgentCreationRequest} agentCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent(agentCreationRequest: AgentCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentCreationResponse> {
            return localVarFp.createAgent(agentCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create agent relation.  Args:     request (AgentRelationCreationRequest): Agent relation creation request.  Returns:     AgentRelationCreationResponse: Agent relation creation response.
         * @summary Create Relation
         * @param {AgentRelationCreationRequest} agentRelationCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentRelation(agentRelationCreationRequest: AgentRelationCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentRelationCreationResponse> {
            return localVarFp.createAgentRelation(agentRelationCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create agent resource.  Args:     request (AgentResourceCreationRequest): Agent resource creation request.  Returns:     AgentResourceCreationResponse: Agent resource creation response.
         * @summary Create Resource
         * @param {AgentResourceCreationRequest} agentResourceCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentResource(agentResourceCreationRequest: AgentResourceCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentResourceCreationResponse> {
            return localVarFp.createAgentResource(agentResourceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create run.  Args:     request (AgentRunCreationRequest): Run creation request.  Returns:     AgentRunCreationResponse: Run creation response.
         * @summary Create Run
         * @param {AgentRunCreationRequest} agentRunCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentRun(agentRunCreationRequest: AgentRunCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentRunCreationResponse> {
            return localVarFp.createAgentRun(agentRunCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create thread.  Args:     request (AgentThreadCreationRequest): Thread creation request.  Returns:     AgentThreadCreationResponse: Thread creation response.
         * @summary Create Thread
         * @param {AgentThreadCreationRequest} agentThreadCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgentThread(agentThreadCreationRequest: AgentThreadCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentThreadCreationResponse> {
            return localVarFp.createAgentThread(agentThreadCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create ApiKey.  Args:     request (ApiKeyCreationRequest): ApiKey creation request.  Returns:     ApiKeyCreationResponse: ApiKey creation response.
         * @summary Create Api Key
         * @param {ApiKeyCreationRequest} apiKeyCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeySecurityApiKeysPost(apiKeyCreationRequest: ApiKeyCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyCreationResponse> {
            return localVarFp.createApiKeySecurityApiKeysPost(apiKeyCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create connector.  Args:     request (ConnectorCreationRequest): Connector creation request.  Returns:     ConnectorCreationResponse: Connector creation response.
         * @summary Create Connector
         * @param {ConnectorCreationRequest} connectorCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConnector(connectorCreationRequest: ConnectorCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectorCreationResponse> {
            return localVarFp.createConnector(connectorCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create ELMA365 toolset.  Args:     request (ELMA365ToolsetCreationRequest): Toolset creation request.  Returns:     ELMA365ToolsetCreationResponse: Toolset creation response.
         * @summary Create Elma365 Toolset
         * @param {ELMA365ToolsetCreationRequest} eLMA365ToolsetCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createELMA365ToolkitToolset(eLMA365ToolsetCreationRequest: ELMA365ToolsetCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetCreationResponse> {
            return localVarFp.createELMA365ToolkitToolset(eLMA365ToolsetCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create ELMA365 version.  Args:     request (ELMA365VersionCreationRequest): Version creation request.  Returns:     ELMA365VersionCreationResponse: Version creation response.
         * @summary Create Elma365 Version
         * @param {ELMA365VersionCreationRequest} eLMA365VersionCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createELMA365ToolkitVersion(eLMA365VersionCreationRequest: ELMA365VersionCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365VersionCreationResponse> {
            return localVarFp.createELMA365ToolkitVersion(eLMA365VersionCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create file via form.  Args:     query (FileCreationQuery): Request query.     content (UploadFile): File content.  Returns:     FileCreationResponse: File creation response.
         * @summary Create File Form
         * @param {string} externalId 
         * @param {Array<FilePurpose>} purposes 
         * @param {File} content 
         * @param {string | null} [projectId] 
         * @param {string | null} [sourceId] 
         * @param {ContentStore | null} [contentStore] 
         * @param {ContentFormat | null} [contentFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileFormGeneralFilesFormPost(externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options?: RawAxiosRequestConfig): AxiosPromise<FileCreationResponse> {
            return localVarFp.createFileFormGeneralFilesFormPost(externalId, purposes, content, projectId, sourceId, contentStore, contentFormat, options).then((request) => request(axios, basePath));
        },
        /**
         * Create file via JSON.  Args:     body (FileCreationBody): Request body.  Returns:     FileCreationResponse: File creation response.
         * @summary Create File Json
         * @param {FileCreationBody} fileCreationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileJsonGeneralFilesJsonPost(fileCreationBody: FileCreationBody, options?: RawAxiosRequestConfig): AxiosPromise<FileCreationResponse> {
            return localVarFp.createFileJsonGeneralFilesJsonPost(fileCreationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Create folder.  Args:     request (FolderCreationRequest): Folder creation request.  Returns:     FolderCreationResponse: Folder creation response.
         * @summary Create Folder
         * @param {FolderCreationRequest} folderCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(folderCreationRequest: FolderCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<FolderCreationResponse> {
            return localVarFp.createFolder(folderCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create message.  Args:     request (SearchMessageCreationRequest): Message creation request.  Returns:     SearchMessageCreationResponse: Message creation response.
         * @summary Create Message
         * @param {SearchMessageCreationRequest} searchMessageCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessageSearchMessagesPost(searchMessageCreationRequest: SearchMessageCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchMessageCreationResponse> {
            return localVarFp.createMessageSearchMessagesPost(searchMessageCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create process.  Args:     request (IngestionProcessCreationRequest): Process creation request.  Returns:     IngestionProcessCreationResponse: Process creation response.
         * @summary Create Process
         * @param {IngestionProcessCreationRequest} ingestionProcessCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessIngestionProcessesPost(ingestionProcessCreationRequest: IngestionProcessCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestionProcessCreationResponse> {
            return localVarFp.createProcessIngestionProcessesPost(ingestionProcessCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create project.  Args:     request (ProjectCreationRequest): Project creation request.  Returns:     ProjectCreationResponse: Project creation response.
         * @summary Create Project
         * @param {ProjectCreationRequest} projectCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectGeneralProjectsPost(projectCreationRequest: ProjectCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCreationResponse> {
            return localVarFp.createProjectGeneralProjectsPost(projectCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create provider.  Args:     request (ProviderCreationRequest): Provider creation request.  Returns:     ProviderCreationResponse: Provider creation response.
         * @summary Create Provider
         * @param {ProviderCreationRequest} providerCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderGeneralProvidersPost(providerCreationRequest: ProviderCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProviderCreationResponse> {
            return localVarFp.createProviderGeneralProvidersPost(providerCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create run.  Args:     request (SearchRunCreationRequest): Run creation request.  Returns:     SearchRunCreationResponse: Run creation response.
         * @summary Create Run
         * @param {SearchRunCreationRequest} searchRunCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRunSearchRunsPost(searchRunCreationRequest: SearchRunCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchRunCreationResponse> {
            return localVarFp.createRunSearchRunsPost(searchRunCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Schedule
         * @param {IngestionScheduleCreationRequest} ingestionScheduleCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule(ingestionScheduleCreationRequest: IngestionScheduleCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestionScheduleCreationResponse> {
            return localVarFp.createSchedule(ingestionScheduleCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create session.  Args:     request (SessionCreationRequest): Session creation request.  Returns:     SessionModel: Created session.
         * @summary Create Session
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession(request: Request, options?: RawAxiosRequestConfig): AxiosPromise<SessionCreationResponse> {
            return localVarFp.createSession(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Signal
         * @param {IngestionSignalCreationRequest} ingestionSignalCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSignalIngestionSignalsPost(ingestionSignalCreationRequest: IngestionSignalCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestionSignalCreationResponse> {
            return localVarFp.createSignalIngestionSignalsPost(ingestionSignalCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Source
         * @param {IngestionSourceCreationRequest} ingestionSourceCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSourceIngestionSourcesPost(ingestionSourceCreationRequest: IngestionSourceCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestionSourceCreationResponse> {
            return localVarFp.createSourceIngestionSourcesPost(ingestionSourceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create thread.  Args:     request (SearchThreadCreationRequest): Thread creation request.  Returns:     SearchThreadCreationResponse: Thread creation response.
         * @summary Create Thread
         * @param {SearchThreadCreationRequest} searchThreadCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThreadSearchThreadsPost(searchThreadCreationRequest: SearchThreadCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchThreadCreationResponse> {
            return localVarFp.createThreadSearchThreadsPost(searchThreadCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create toolset.  Args:     request (ToolsetCreationRequest): Toolset creation request.  Returns:     ToolsetCreationResponse: Toolset creation response.
         * @summary Create Toolset
         * @param {ToolsetCreationRequest} toolsetCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToolset(toolsetCreationRequest: ToolsetCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToolsetCreationResponse> {
            return localVarFp.createToolset(toolsetCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create trace provider.  Args:     request (TraceProviderCreationRequest): Provider creation request.  Returns:     TraceProviderCreationResponse: Trace provider creation response.
         * @summary Create Trace Provider
         * @param {TraceProviderCreationRequest} traceProviderCreationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraceProviderGeneralTraceProvidersPost(traceProviderCreationRequest: TraceProviderCreationRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceProviderCreationResponse> {
            return localVarFp.createTraceProviderGeneralTraceProvidersPost(traceProviderCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one agent.  Args:     agent_id (str): Agent ID.
         * @summary Delete One Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgent(agentId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAgent(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one agent relation.  Args:     relation_id (str): Agent relation ID.
         * @summary Delete One Relation
         * @param {string} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentRelation(relationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAgentRelation(relationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one agent resource.  Args:     resource_id (str): Agent resource ID.
         * @summary Delete One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentResource(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAgentResource(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one thread.  Args:     thread_id (str): Thread ID.
         * @summary Delete One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentThread(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAgentThread(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete connector.  Args:     connector_id (str): Connector ID.
         * @summary Delete Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConnector(connectorId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteConnector(connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolDeletionResponse: Tool deletion response.
         * @summary Delete Elma365 Tool
         * @param {string} toolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteELMA365ToolkitTool(toolId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolDeletionResponse> {
            return localVarFp.deleteELMA365ToolkitTool(toolId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.
         * @summary Delete Elma365 Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteELMA365ToolkitToolset(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteELMA365ToolkitToolset(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete ELMA365 version.  Args:     version_id (str): Version ID.
         * @summary Delete Elma365 Version
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteELMA365ToolkitVersion(versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteELMA365ToolkitVersion(versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete folder.  Args:     folder_id (str): Folder ID.
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one ApiKey.  Args:     api_key_id (str): ApiKey ID.
         * @summary Delete One Api Key
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneApiKeySecurityApiKeysApiKeyIdDelete(apiKeyId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOneApiKeySecurityApiKeysApiKeyIdDelete(apiKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one file.  Args:     path (FileDeletionPath): RequestPath.
         * @summary Delete One File
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneFileGeneralFilesFileIdDelete(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileDeletionResponse> {
            return localVarFp.deleteOneFileGeneralFilesFileIdDelete(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one message.  Args:     message_id (str): Message ID.
         * @summary Delete One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneMessageSearchMessagesMessageIdDelete(messageId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOneMessageSearchMessagesMessageIdDelete(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one project.  Args:     project_id (str): Project ID.
         * @summary Delete One Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneProjectGeneralProjectsProjectIdDelete(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOneProjectGeneralProjectsProjectIdDelete(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one provider.  Args:     provider_id (str): Provider ID.
         * @summary Delete One Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneProviderGeneralProvidersProviderIdDelete(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOneProviderGeneralProvidersProviderIdDelete(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one thread.  Args:     thread_id (str): Thread ID.
         * @summary Delete One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneThreadSearchThreadsThreadIdDelete(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOneThreadSearchThreadsThreadIdDelete(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one trace provider.  Args:     trace_provider_id (str): Trace provider ID.
         * @summary Delete One Trace Provider
         * @param {string} traceProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete(traceProviderId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete(traceProviderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Schedule
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule(scheduleId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteSchedule(scheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one toolset.  Args:     toolset_id (str): Toolset ID.
         * @summary Delete One Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToolset(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteToolset(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download artifact buffer content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Buffer content.
         * @summary Download Artifact Buffer
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet(artifactId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet(artifactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download artifact object content.  Args:     artifact_id (str): Artifact ID.  Returns:     Any: Object content.
         * @summary Download Artifact Object
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet(artifactId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet(artifactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download artifact stream content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Stream content.
         * @summary Download Artifact Stream
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet(artifactId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet(artifactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download artifact string content.  Args:     artifact_id (str): Artifact ID.  Returns:     PlainTextResponse: String content.
         * @summary Download Artifact String
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet(artifactId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet(artifactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download file buffer content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Buffer content.
         * @summary Download File Buffer
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileBufferGeneralFilesFileIdContentBufferGet(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadFileBufferGeneralFilesFileIdContentBufferGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download file object content.  Args:     file_id (str): File ID.  Returns:     Any: Object content.
         * @summary Download File Object
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileObjectGeneralFilesFileIdContentObjectGet(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadFileObjectGeneralFilesFileIdContentObjectGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download file stream content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Stream content.
         * @summary Download File Stream
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStreamGeneralFilesFileIdContentStreamGet(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadFileStreamGeneralFilesFileIdContentStreamGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download file string content.  Args:     file_id (str): File ID.  Returns:     PlainTextResponse: String content.
         * @summary Download File String
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileStringGeneralFilesFileIdContentStringGet(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadFileStringGeneralFilesFileIdContentStringGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export agent as archive.  Args:     agent_id (str): Agent ID.  Returns:     FileResponse: Archive file.
         * @summary Export Agent Archive
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAgentArchive(agentId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportAgentArchive(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export ELMA365 toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
         * @summary Export Elma365 Toolset Archive
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetArchive(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportELMA365ToolkitToolsetArchive(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export ELMA365 toolset as buffer.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
         * @summary Export Elma365 Toolset Buffer
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetBuffer(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportELMA365ToolkitToolsetBuffer(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export ELMA365 toolset as object.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetExchange: Object content.
         * @summary Export Elma365 Toolset Object
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetObject(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetExchange> {
            return localVarFp.exportELMA365ToolkitToolsetObject(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export ELMA365 toolset as stream.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
         * @summary Export Elma365 Toolset Stream
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetStream(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportELMA365ToolkitToolsetStream(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export ELMA365 toolset as string.  Args:     toolset_id (str): Toolset ID.  Returns:     PlainTextResponse: String content.
         * @summary Export Elma365 Toolset String
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportELMA365ToolkitToolsetString(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportELMA365ToolkitToolsetString(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export folder as archive.  Args:     folder_id (str): Folder ID.  Returns:     FileResponse: Archive file.
         * @summary Export Folder Archive
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFolderArchive(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportFolderArchive(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export project as archive.  Args:     project_id (str): Project ID.  Returns:     FileResponse: Archive file.
         * @summary Export Project Archive
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportProjectArchive(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportProjectArchive(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
         * @summary Export Toolset Archive
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToolsetArchive(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportToolsetArchive(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get general information about application.  Returns:     AboutInfo: General information about application.
         * @summary Get About Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAboutInfoInfoApplicationAboutGet(options?: RawAxiosRequestConfig): AxiosPromise<AboutInfo> {
            return localVarFp.getAboutInfoInfoApplicationAboutGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all folders.  Returns:     List[FolderModel]: Found folders.
         * @summary Get All Folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFolders(options?: RawAxiosRequestConfig): AxiosPromise<Array<FolderModel>> {
            return localVarFp.getAllFolders(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a current identity.  Returns:     IdentityModel: Current identity.
         * @summary Get Current Identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIdentity(options?: RawAxiosRequestConfig): AxiosPromise<IdentityModel> {
            return localVarFp.getCurrentIdentity(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Current
         * @param {string} projectId 
         * @param {boolean | null} [withSources] 
         * @param {boolean | null} [withResources] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentIngestionStateProjectIdGet(projectId: string, withSources?: boolean | null, withResources?: boolean | null, options?: RawAxiosRequestConfig): AxiosPromise<IngestionStateModel> {
            return localVarFp.getCurrentIngestionStateProjectIdGet(projectId, withSources, withResources, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of available features and their active statuses.
         * @summary Get available feature flags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureFlagsFeatureManagementGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<FeatureFlag>> {
            return localVarFp.getFeatureFlagsFeatureManagementGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get health information about application.  Returns:     HealthInfo: Health information about application.
         * @summary Get Health Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealthInfoInfoApplicationHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<HealthInfo> {
            return localVarFp.getHealthInfoInfoApplicationHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get one agent.  Args:     agent_id (str): Agent ID.  Returns:     AgentModel: Found agent.
         * @summary Get One Agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgent(agentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentModel> {
            return localVarFp.getOneAgent(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one message.  Args:     message_id (str): Message ID.  Returns:     AgentMessageModel: Found message.
         * @summary Get One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentMessage(messageId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentMessageModel> {
            return localVarFp.getOneAgentMessage(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one agent relation.  Args:     relation_id (str): Agent relation ID.  Returns:     AgentRelationModel: Found agent relation.
         * @summary Get One Relation
         * @param {string} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentRelation(relationId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentRelationModel> {
            return localVarFp.getOneAgentRelation(relationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one resource.  Args:     resource_id (str): Agent resource ID.  Returns:     AgentResourceModel: Found agent resource.
         * @summary Get One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentResource(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentResourceModel> {
            return localVarFp.getOneAgentResource(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
         * @summary Get One Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentRunModel> {
            return localVarFp.getOneAgentRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
         * @summary Get One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentThread(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentThreadModel> {
            return localVarFp.getOneAgentThread(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one user run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
         * @summary Get One User Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentUserRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentRunModel> {
            return localVarFp.getOneAgentUserRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
         * @summary Get One User Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneAgentUserThread(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentThreadModel> {
            return localVarFp.getOneAgentUserThread(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one ApiKey.  Args:     api_key_id (str): ApiKey ID.  Returns:     ApiKeyModel: Found ApiKey.
         * @summary Get One Api Key
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneApiKeySecurityApiKeysApiKeyIdGet(apiKeyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyModel> {
            return localVarFp.getOneApiKeySecurityApiKeysApiKeyIdGet(apiKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one artifact.  Args:     artifact_id (str): Artifact ID.  Returns:     IngestionArtifactModel: Found artifacts.
         * @summary Get One Artifact
         * @param {string} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneArtifactIngestionArtifactsArtifactIdGet(artifactId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionArtifactModel> {
            return localVarFp.getOneArtifactIngestionArtifactsArtifactIdGet(artifactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one connector.  Args:     connector_id (str): Connector ID.  Returns:     ConnectorModel: Found connector.
         * @summary Get One Connector
         * @param {string} connectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneConnector(connectorId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectorModel> {
            return localVarFp.getOneConnector(connectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one ELMA365 application.  Args:     application_id (str): Application ID.  Returns:     ELMA365ApplicationModel: Found ELMA365 application.
         * @summary Get One Elma365 Application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitApplication(applicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ApplicationModel> {
            return localVarFp.getOneELMA365ToolkitApplication(applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one ELMA365 namespace.  Args:     namespace_id (str): Namespace ID.  Returns:     ELMA365NamespaceModel: Found ELMA365 namespace.
         * @summary Get One Elma365 Namespace
         * @param {string} namespaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitNamespace(namespaceId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365NamespaceModel> {
            return localVarFp.getOneELMA365ToolkitNamespace(namespaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one ELMA365 process.  Args:     process_id (str): Process ID.  Returns:     ELMA365ProcessModel: Found ELMA365 process.
         * @summary Get One Elma365 Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ProcessModel> {
            return localVarFp.getOneELMA365ToolkitProcess(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolModel: Found ELMA365 tool.
         * @summary Get One Elma365 Tool
         * @param {string} toolId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitTool(toolId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolModel> {
            return localVarFp.getOneELMA365ToolkitTool(toolId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetModel: Found ELMA365 toolset.
         * @summary Get One Elma365 Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitToolset(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetModel> {
            return localVarFp.getOneELMA365ToolkitToolset(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one ELMA365 version.  Args:     version_id (str): Version ID.  Returns:     ELMA365VersionModel: Found ELMA365 version.
         * @summary Get One Elma365 Version
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneELMA365ToolkitVersion(versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365VersionModel> {
            return localVarFp.getOneELMA365ToolkitVersion(versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one file.  Args:     file_id (str): File ID.  Returns:     FileModel: Found file.
         * @summary Get One File
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneFileGeneralFilesFileIdGet(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileModel> {
            return localVarFp.getOneFileGeneralFilesFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one folder.  Args:     folder_id (str): Folder ID.  Returns:     FolderModel: Found folder.
         * @summary Get One Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<FolderModel> {
            return localVarFp.getOneFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one message.  Args:     message_id (str): Message ID.  Returns:     SearchMessageModel: Found message.
         * @summary Get One Message
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneMessageSearchMessagesMessageIdGet(messageId: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchMessageModel> {
            return localVarFp.getOneMessageSearchMessagesMessageIdGet(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one operation.  Args:     operation_id (str): Operation ID.  Returns:     OperationModel: Found operation.
         * @summary Get One Operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneOperationGeneralOperationsOperationIdGet(operationId: string, options?: RawAxiosRequestConfig): AxiosPromise<OperationModel> {
            return localVarFp.getOneOperationGeneralOperationsOperationIdGet(operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one process.  Args:     process_id (str): Process ID.  Returns:     IngestionProcessModel: Found process.
         * @summary Get One Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneProcessIngestionProcessesProcessIdGet(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionProcessModel> {
            return localVarFp.getOneProcessIngestionProcessesProcessIdGet(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one project.  Args:     project_id (str): Project ID.  Returns:     ProjectModel: Found project.
         * @summary Get One Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneProjectGeneralProjectsProjectIdGet(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProjectModel> {
            return localVarFp.getOneProjectGeneralProjectsProjectIdGet(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one provider.  Args:     provider_id (str): Provider ID.  Returns:     ProviderModel: Found provider.
         * @summary Get One Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneProviderGeneralProvidersProviderIdGet(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderModel> {
            return localVarFp.getOneProviderGeneralProvidersProviderIdGet(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one resource.  Args:     resource_id (str): Resource ID.  Returns:     IngestionResourceModel: Found resource.
         * @summary Get One Resource
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneResourceIngestionResourcesResourceIdGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionResourceModel> {
            return localVarFp.getOneResourceIngestionResourcesResourceIdGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one run.  Args:     run_id (str): Run ID.  Returns:     SearchRunModel: Found Run.
         * @summary Get One Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneRunSearchRunsRunIdGet(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchRunModel> {
            return localVarFp.getOneRunSearchRunsRunIdGet(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get One Signal
         * @param {string} signalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneSignalIngestionSignalsSignalIdGet(signalId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionSignalModel> {
            return localVarFp.getOneSignalIngestionSignalsSignalIdGet(signalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get One Source
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneSourceIngestionSourcesSourceIdGet(sourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionSourceModelOutput> {
            return localVarFp.getOneSourceIngestionSourcesSourceIdGet(sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
         * @summary Get One Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneThreadSearchThreadsThreadIdGet(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchThreadModel> {
            return localVarFp.getOneThreadSearchThreadsThreadIdGet(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ToolsetModel: Found toolset.
         * @summary Get One Toolset
         * @param {string} toolsetId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneToolset(toolsetId: string, options?: RawAxiosRequestConfig): AxiosPromise<ToolsetModel> {
            return localVarFp.getOneToolset(toolsetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one trace provider.  Args:     trace_provider_id (str): Trace provider ID.  Returns:     TraceProviderModel: Found trace provider.
         * @summary Get One Trace Provider
         * @param {string} traceProviderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet(traceProviderId: string, options?: RawAxiosRequestConfig): AxiosPromise<TraceProviderModel> {
            return localVarFp.getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet(traceProviderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
         * @summary Get One User Thread
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneUserThreadSearchThreadsThreadIdUserGet(threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchThreadModel> {
            return localVarFp.getOneUserThreadSearchThreadsThreadIdUserGet(threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Schedule
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule(scheduleId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionScheduleModel> {
            return localVarFp.getSchedule(scheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one session.  Args:     public_id (str): Session public ID.  Returns:     SessionModel: Found session.
         * @summary Get Session
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<SessionModel> {
            return localVarFp.getSession(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check session requirement.  Args:     f_agent_id (str): Agent ID.     f_connector_id (str): Connector ID.  Returns:     SessionRequirementModel: Session requirement response.
         * @summary Is Session Required
         * @param {string | null} [fAgentId] 
         * @param {string | null} [fConnectorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionRequirement(fAgentId?: string | null, fConnectorId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SessionRequirementModel> {
            return localVarFp.getSessionRequirement(fAgentId, fConnectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Source Details
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionStateSourceModel> {
            return localVarFp.getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet(projectId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Source
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceIngestionStateProjectIdSourcesSourceIdGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<IngestionStateSourceModel> {
            return localVarFp.getSourceIngestionStateProjectIdSourcesSourceIdGet(projectId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Source Resources
         * @param {string} projectId 
         * @param {string} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IngestionStateResourceModelOutput>> {
            return localVarFp.getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet(projectId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Import agent file via form.  Args:     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): AxiosPromise<AgentImportResponse> {
            return localVarFp.importAgentCreateForm(folderId, content, dependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) agent file via JSON.  Args:     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Create Json
         * @param {string} folderId 
         * @param {AgentImportBody} agentImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentCreateJson(folderId: string, agentImportBody: AgentImportBody, options?: RawAxiosRequestConfig): AxiosPromise<AgentImportResponse> {
            return localVarFp.importAgentCreateJson(folderId, agentImportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Import agent file via form.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Update Form
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentUpdateForm(agentId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): AxiosPromise<AgentImportResponse> {
            return localVarFp.importAgentUpdateForm(agentId, folderId, content, dependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) agent file via JSON.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
         * @summary Import Agent Update Json
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {AgentImportBody} agentImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAgentUpdateJson(agentId: string, folderId: string, agentImportBody: AgentImportBody, options?: RawAxiosRequestConfig): AxiosPromise<AgentImportResponse> {
            return localVarFp.importAgentUpdateJson(agentId, folderId, agentImportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetImportResponse> {
            return localVarFp.importELMA365ToolkitToolsetCreateForm(folderId, content, dependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Create Json
         * @param {string} folderId 
         * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetCreateJson(folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetImportResponse> {
            return localVarFp.importELMA365ToolkitToolsetCreateJson(folderId, eLMA365ToolsetImportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Update Form
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetUpdateForm(toolsetId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetImportResponse> {
            return localVarFp.importELMA365ToolkitToolsetUpdateForm(toolsetId, folderId, content, dependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
         * @summary Import Elma365 Toolset Update Json
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importELMA365ToolkitToolsetUpdateJson(toolsetId: string, folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetImportResponse> {
            return localVarFp.importELMA365ToolkitToolsetUpdateJson(toolsetId, folderId, eLMA365ToolsetImportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) folder file via form.  Args:     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Create Form
         * @param {File} content 
         * @param {File} dependencies 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderCreateForm(content: File, dependencies: File, folderId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderImportResponse> {
            return localVarFp.importFolderCreateForm(content, dependencies, folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) folder file via JSON.  Args:     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Create Json
         * @param {FolderImportBody} folderImportBody 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderCreateJson(folderImportBody: FolderImportBody, folderId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderImportResponse> {
            return localVarFp.importFolderCreateJson(folderImportBody, folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Import folder file via form.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Update Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderUpdateForm(folderId: string, content: File, dependencies: File, folderId2?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderImportResponse> {
            return localVarFp.importFolderUpdateForm(folderId, content, dependencies, folderId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (update) folder file via JSON.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
         * @summary Import Folder Update Json
         * @param {string} folderId 
         * @param {FolderImportBody} folderImportBody 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFolderUpdateJson(folderId: string, folderImportBody: FolderImportBody, folderId2?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderImportResponse> {
            return localVarFp.importFolderUpdateJson(folderId, folderImportBody, folderId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) project file via form.  Args:     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): AxiosPromise<ProjectImportResponse> {
            return localVarFp.importProjectCreateForm(folderId, content, dependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (create) project file via JSON.  Args:     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Create Json
         * @param {string} folderId 
         * @param {ProjectImportBody} projectImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectCreateJson(folderId: string, projectImportBody: ProjectImportBody, options?: RawAxiosRequestConfig): AxiosPromise<ProjectImportResponse> {
            return localVarFp.importProjectCreateJson(folderId, projectImportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (update) project file via form.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Update Form
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {File} dependencies 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectUpdateForm(projectId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig): AxiosPromise<ProjectImportResponse> {
            return localVarFp.importProjectUpdateForm(projectId, folderId, content, dependencies, options).then((request) => request(axios, basePath));
        },
        /**
         * Import (update) project file via JSON.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
         * @summary Import Project Update Json
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {ProjectImportBody} projectImportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProjectUpdateJson(projectId: string, folderId: string, projectImportBody: ProjectImportBody, options?: RawAxiosRequestConfig): AxiosPromise<ProjectImportResponse> {
            return localVarFp.importProjectUpdateJson(projectId, folderId, projectImportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect agent file via form.  Args:     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig): AxiosPromise<AgentInspectionResponse> {
            return localVarFp.inspectAgentCreateForm(folderId, content, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect agent file via JSON.  Args:     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Create Json
         * @param {string} folderId 
         * @param {AgentInspectionBody} agentInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentCreateJson(folderId: string, agentInspectionBody: AgentInspectionBody, options?: RawAxiosRequestConfig): AxiosPromise<AgentInspectionResponse> {
            return localVarFp.inspectAgentCreateJson(folderId, agentInspectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect (update) agent file via form.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Update Form
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentUpdateForm(agentId: string, folderId: string, content: File, options?: RawAxiosRequestConfig): AxiosPromise<AgentInspectionResponse> {
            return localVarFp.inspectAgentUpdateForm(agentId, folderId, content, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspec (update) agent file via JSON.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
         * @summary Inspect Agent Update Json
         * @param {string} agentId 
         * @param {string} folderId 
         * @param {AgentInspectionBody} agentInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectAgentUpdateJson(agentId: string, folderId: string, agentInspectionBody: AgentInspectionBody, options?: RawAxiosRequestConfig): AxiosPromise<AgentInspectionResponse> {
            return localVarFp.inspectAgentUpdateJson(agentId, folderId, agentInspectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetInspectionResponse> {
            return localVarFp.inspectELMA365ToolkitToolsetCreateForm(folderId, content, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Create Json
         * @param {string} folderId 
         * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetCreateJson(folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetInspectionResponse> {
            return localVarFp.inspectELMA365ToolkitToolsetCreateJson(folderId, eLMA365ToolsetInspectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Update Form
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetUpdateForm(toolsetId: string, folderId: string, content: File, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetInspectionResponse> {
            return localVarFp.inspectELMA365ToolkitToolsetUpdateForm(toolsetId, folderId, content, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspec (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
         * @summary Inspect Elma365 Toolset Update Json
         * @param {string} toolsetId 
         * @param {string} folderId 
         * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectELMA365ToolkitToolsetUpdateJson(toolsetId: string, folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetInspectionResponse> {
            return localVarFp.inspectELMA365ToolkitToolsetUpdateJson(toolsetId, folderId, eLMA365ToolsetInspectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect folder file via form.  Args:     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Create Form
         * @param {File} content 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderCreateForm(content: File, folderId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderInspectionResponse> {
            return localVarFp.inspectFolderCreateForm(content, folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect folder file via JSON.  Args:     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Create Json
         * @param {FolderInspectionBody} folderInspectionBody 
         * @param {string | null} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderCreateJson(folderInspectionBody: FolderInspectionBody, folderId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderInspectionResponse> {
            return localVarFp.inspectFolderCreateJson(folderInspectionBody, folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect (update) folder file via form.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Update Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderUpdateForm(folderId: string, content: File, folderId2?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderInspectionResponse> {
            return localVarFp.inspectFolderUpdateForm(folderId, content, folderId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspec (update) folder file via JSON.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
         * @summary Inspect Folder Update Json
         * @param {string} folderId 
         * @param {FolderInspectionBody} folderInspectionBody 
         * @param {string | null} [folderId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectFolderUpdateJson(folderId: string, folderInspectionBody: FolderInspectionBody, folderId2?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FolderInspectionResponse> {
            return localVarFp.inspectFolderUpdateJson(folderId, folderInspectionBody, folderId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect project file via form.  Args:     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Create Form
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig): AxiosPromise<ProjectInspectionResponse> {
            return localVarFp.inspectProjectCreateForm(folderId, content, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect project file via JSON.  Args:     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Create Json
         * @param {string} folderId 
         * @param {ProjectInspectionBody} projectInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectCreateJson(folderId: string, projectInspectionBody: ProjectInspectionBody, options?: RawAxiosRequestConfig): AxiosPromise<ProjectInspectionResponse> {
            return localVarFp.inspectProjectCreateJson(folderId, projectInspectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspect (update) project file via form.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Update Form
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {File} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectUpdateForm(projectId: string, folderId: string, content: File, options?: RawAxiosRequestConfig): AxiosPromise<ProjectInspectionResponse> {
            return localVarFp.inspectProjectUpdateForm(projectId, folderId, content, options).then((request) => request(axios, basePath));
        },
        /**
         * Inspec (update) project file via JSON.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
         * @summary Inspect Project Update Json
         * @param {string} projectId 
         * @param {string} folderId 
         * @param {ProjectInspectionBody} projectInspectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectProjectUpdateJson(projectId: string, folderId: string, projectInspectionBody: ProjectInspectionBody, options?: RawAxiosRequestConfig): AxiosPromise<ProjectInspectionResponse> {
            return localVarFp.inspectProjectUpdateJson(projectId, folderId, projectInspectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Sources Details
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IngestionStateSourceModel>> {
            return localVarFp.listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Sources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSourcesIngestionStateProjectIdSourcesGet(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IngestionStateSourceModel>> {
            return localVarFp.listSourcesIngestionStateProjectIdSourcesGet(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Sources Resources
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<IngestionStateResourceModelOutput>> {
            return localVarFp.listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain ELMA365 applications.  Args:     request (ELMA365ApplicationObtainingRequest): Applications obtaining request.  Returns:     ELMA365ApplicationObtainingResponse: Applications obtaining response.
         * @summary Obtain Elma365 Application
         * @param {ELMA365ApplicationObtainingRequest} eLMA365ApplicationObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitApplications(eLMA365ApplicationObtainingRequest: ELMA365ApplicationObtainingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ApplicationObtainingResponse> {
            return localVarFp.obtainELMA365ToolkitApplications(eLMA365ApplicationObtainingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain ELMA365 namespaces.  Args:     request (ELMA365NamespaceObtainingRequest): Namespaces obtaining request.  Returns:     ELMA365NamespaceObtainingResponse: Namespaces obtaining response.
         * @summary Obtain Elma365 Namespace
         * @param {ELMA365NamespaceObtainingRequest} eLMA365NamespaceObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitNamespaces(eLMA365NamespaceObtainingRequest: ELMA365NamespaceObtainingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365NamespaceObtainingResponse> {
            return localVarFp.obtainELMA365ToolkitNamespaces(eLMA365NamespaceObtainingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain ELMA365 processes.  Args:     request (ELMA365ProcessObtainingRequest): Processes obtaining request.  Returns:     ELMA365ProcessObtainingResponse: Processes obtaining response.
         * @summary Obtain Elma365 Process
         * @param {ELMA365ProcessObtainingRequest} eLMA365ProcessObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitProcesses(eLMA365ProcessObtainingRequest: ELMA365ProcessObtainingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ProcessObtainingResponse> {
            return localVarFp.obtainELMA365ToolkitProcesses(eLMA365ProcessObtainingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain ELMA365 tools.  Args:     request (ELMA365ToolObtainingRequest): Tools obtaining request.  Returns:     ELMA365ToolObtainingResponse: Tools obtaining response.
         * @summary Obtain Elma365 Tools
         * @param {ELMA365ToolObtainingRequest} eLMA365ToolObtainingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainELMA365ToolkitTools(eLMA365ToolObtainingRequest: ELMA365ToolObtainingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolObtainingResponse> {
            return localVarFp.obtainELMA365ToolkitTools(eLMA365ToolObtainingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain system folder.  Returns:     FolderModel: System folder.
         * @summary Obtain System Folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        obtainSystemFolder(options?: RawAxiosRequestConfig): AxiosPromise<FolderModel> {
            return localVarFp.obtainSystemFolder(options).then((request) => request(axios, basePath));
        },
        /**
         * Poll the status of an OAuth2 connector check.  Args:     check_id (str): Check ID returned from checkConnector.  Returns:     ConnectorCheckOAuthPollingResponse: Current check status.
         * @summary Poll Connector Oauth Check
         * @param {string} checkId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollConnectorOAuthCheck(checkId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectorCheckOAuthPollingResponse> {
            return localVarFp.pollConnectorOAuthCheck(checkId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve request.  Args:     request (RetrieveRequest): Retrieve request.  Returns:     RetrieveResponse: Retrieve response.
         * @summary Retrieve
         * @param {RetrieveRequest} retrieveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveSearchRetrievePost(retrieveRequest: RetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveResponse> {
            return localVarFp.retrieveSearchRetrievePost(retrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search all messages (ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
         * @summary Search All Messages
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentAllMessages(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentMessageModel> {
            return localVarFp.searchAgentAllMessages(fAgentIds, fThreadIds, fRunIds, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentAllRuns(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentRunModel> {
            return localVarFp.searchAgentAllRuns(fAgentIds, fThreadIds, fSearchText, fCreatedOnMin, fCreatedOnMax, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search all threads (Ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
         * @summary Search All Threads
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {string | null} [fSourceRef] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentAllThreads(fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentThreadModel> {
            return localVarFp.searchAgentAllThreads(fAgentIds, fSearchText, fCreatedOnMin, fCreatedOnMax, fSourceRef, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search agent relations.  Args:     f_managing_agent_ids (Optional[List[str]]): Managing agent IDs.     f_managed_agent_ids (Optional[List[str]]): Managed agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRelationModel]: Found agent relations.
         * @summary Search Relations
         * @param {Array<string> | null} [fManagingAgentIds] 
         * @param {Array<string> | null} [fManagedAgentIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentRelations(fManagingAgentIds?: Array<string> | null, fManagedAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentRelationModel> {
            return localVarFp.searchAgentRelations(fManagingAgentIds, fManagedAgentIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search agent resources.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentResourceModel]: Found agent resources.
         * @summary Search Resources
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentResources(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentResourceModel> {
            return localVarFp.searchAgentResources(fAgentIds, fThreadIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search user messages.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
         * @summary Search User Messages
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentUserMessages(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentMessageModel> {
            return localVarFp.searchAgentUserMessages(fAgentIds, fThreadIds, fRunIds, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fAgentIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentUserRuns(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentRunModel> {
            return localVarFp.searchAgentUserRuns(fAgentIds, fThreadIds, fSearchText, fCreatedOnMin, fCreatedOnMax, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search user threads.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
         * @summary Search User Threads
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {string | null} [fSourceRef] 
         * @param {SortDirection | null} [sOrder] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentUserThreads(fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentThreadModel> {
            return localVarFp.searchAgentUserThreads(fAgentIds, fSearchText, fCreatedOnMin, fCreatedOnMax, fSourceRef, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search agents.  Args:     f_search_text (Optional[str]): Agent search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_interface_types (Optional[List[DataInterfaceType]]): Agent interface types.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentModel]: Found Agents.
         * @summary Search Agents
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<DataInterfaceType> | null} [fInterfaceTypes] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgents(fSearchText?: string | null, fFolderIds?: Array<string> | null, fInterfaceTypes?: Array<DataInterfaceType> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseAgentModel> {
            return localVarFp.searchAgents(fSearchText, fFolderIds, fInterfaceTypes, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search all messages (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
         * @summary Search All Messages
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllMessagesSearchMessagesAllGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseSearchMessageModel> {
            return localVarFp.searchAllMessagesSearchMessagesAllGet(fProjectIds, fThreadIds, fRunIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search all threads (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
         * @summary Search All Threads
         * @param {Array<string> | null} [fProjectIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllThreadsSearchThreadsAllGet(fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseSearchThreadModel> {
            return localVarFp.searchAllThreadsSearchThreadsAllGet(fProjectIds, fSearchText, fCreatedOnMin, fCreatedOnMax, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ApiKeys.  Args:     f_scope_ref_types (List[ApiKeyScopeRefType]): Scope ref object types.     f_scope_ref_ids (List[str]): Scope ref object IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ApiKeyModel]: Found ApiKeys.
         * @summary Search Api Keys
         * @param {Array<ApiKeyScopeRefType> | null} [fScopeRefTypes] 
         * @param {Array<string> | null} [fScopeRefIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchApiKeysSecurityApiKeysGet(fScopeRefTypes?: Array<ApiKeyScopeRefType> | null, fScopeRefIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseApiKeyModel> {
            return localVarFp.searchApiKeysSecurityApiKeysGet(fScopeRefTypes, fScopeRefIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search artifacts.  Args:     f_artifact_ids (Optional[List[str]]): Artifact IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_resource_ids (Optional[List[str]]): Resource IDs.     f_parent_ids (Optional[List[Optional[str]]]): Parent IDs.     f_file_ids (Optional[List[Optional[str]]]): File IDs.     f_types (Optional[List[IngestionArtifactType]]): Artifact types.     f_origins (Optional[List[IngestionArtifactOrigin]]): Artifact actions.     f_actions (Optional[List[IngestionArtifactCommand]]): Artifact commands.     f_node_ids (Optional[List[str]]): Node IDs.     f_node_classes (Optional[List[IngestionNodeClass]]): Node classes.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionArtifactModel]: Found artifacts.
         * @summary Search Artifacts
         * @param {Array<string> | null} [fArtifactIds] 
         * @param {Array<string> | null} [fPublicIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<string> | null} [fResourceIds] 
         * @param {Array<string> | null} [fParentIds] 
         * @param {Array<string> | null} [fFileIds] 
         * @param {Array<IngestionArtifactType> | null} [fTypes] 
         * @param {Array<IngestionArtifactOrigin> | null} [fOrigins] 
         * @param {Array<IngestionArtifactAction> | null} [fActions] 
         * @param {Array<string> | null} [fNodeIds] 
         * @param {Array<IngestionNodeClass> | null} [fNodeClasses] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchArtifactsIngestionArtifactsGet(fArtifactIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fResourceIds?: Array<string> | null, fParentIds?: Array<string> | null, fFileIds?: Array<string> | null, fTypes?: Array<IngestionArtifactType> | null, fOrigins?: Array<IngestionArtifactOrigin> | null, fActions?: Array<IngestionArtifactAction> | null, fNodeIds?: Array<string> | null, fNodeClasses?: Array<IngestionNodeClass> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseIngestionArtifactModel> {
            return localVarFp.searchArtifactsIngestionArtifactsGet(fArtifactIds, fPublicIds, fProjectIds, fSourceIds, fResourceIds, fParentIds, fFileIds, fTypes, fOrigins, fActions, fNodeIds, fNodeClasses, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search connectors.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Connector search text.     f_statuses (Optional[List[ConnectorStatus]]): Connector statuses.     f_availabilities (Optional[List[ConnectorStatus]]): Connector availabilities.     f_auth_types (Optional[List[ConnectorAuthType]]): Connector auth types.  Returns:     PaginationResponse[ConnectorModel]: Found connectors.
         * @summary Search Connectors
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<ConnectorStatus> | null} [fStatuses] 
         * @param {Array<ConnectorAvailability> | null} [fAvailabilities] 
         * @param {Array<ConnectorAuthType> | null} [fAuthTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConnectors(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fStatuses?: Array<ConnectorStatus> | null, fAvailabilities?: Array<ConnectorAvailability> | null, fAuthTypes?: Array<ConnectorAuthType> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseConnectorModel> {
            return localVarFp.searchConnectors(pPageIndex, pPageSize, pWithTotal, fSearchText, fStatuses, fAvailabilities, fAuthTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ELMA365 applications.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Application search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_statuses (Optional[List[ELMA365ApplicationStatus]]): Application statuses.     f_visibilities (Optional[List[ELMA365ApplicationVisibility]]): Application visibilities.     f_availabilities (Optional[List[ELMA365ApplicationAvailability]]): Application availabilities.  Returns:     PaginationResponse[ELMA365ApplicationModel]: Found ELMA365 applications.
         * @summary Search Elma365 Applications
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<ELMA365ApplicationStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ApplicationVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ApplicationAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitApplications(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fStatuses?: Array<ELMA365ApplicationStatus> | null, fVisibilities?: Array<ELMA365ApplicationVisibility> | null, fAvailabilities?: Array<ELMA365ApplicationAvailability> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseELMA365ApplicationModel> {
            return localVarFp.searchELMA365ToolkitApplications(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ELMA365 namespaces.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Namespace search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365NamespacenStatus]]): Namespace statuses.     f_visibilities (Optional[List[ELMA365NamespaceVisibility]]): Namespace visibilities.     f_availabilities (Optional[List[ELMA365NamespaceAvailability]]): Namespace availabilities.  Returns:     PaginationResponse[ELMA365NamespaceModel]: Found ELMA365 namespaces.
         * @summary Search Elma365 Namespaces
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<ELMA365NamespaceStatus> | null} [fStatuses] 
         * @param {Array<ELMA365NamespaceVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365NamespaceAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitNamespaces(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365NamespaceStatus> | null, fVisibilities?: Array<ELMA365NamespaceVisibility> | null, fAvailabilities?: Array<ELMA365NamespaceAvailability> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseELMA365NamespaceModel> {
            return localVarFp.searchELMA365ToolkitNamespaces(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ELMA365 processes.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Process search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_application_ids (Optional[List[str]]): Application IDs.     f_statuses (Optional[List[ELMA365ProcessStatus]]): Process statuses.     f_visibilities (Optional[List[ELMA365ProcessVisibility]]): Process visibilities.     f_availabilities (Optional[List[ELMA365ProcessAvailability]]): Process availabilities.  Returns:     PaginationResponse[ELMA365ProcessModel]: Found ELMA365 processes.
         * @summary Search Elma365 Processes
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<string> | null} [fApplicationIds] 
         * @param {Array<ELMA365ProcessStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ProcessVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ProcessAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitProcesses(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fApplicationIds?: Array<string> | null, fStatuses?: Array<ELMA365ProcessStatus> | null, fVisibilities?: Array<ELMA365ProcessVisibility> | null, fAvailabilities?: Array<ELMA365ProcessAvailability> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseELMA365ProcessModel> {
            return localVarFp.searchELMA365ToolkitProcesses(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fApplicationIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ELMA365 tools.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Tool search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_component_ids (Optional[List[str]]): Component IDs.     f_statuses (Optional[List[ELMA365ToolStatus]]): Tool statuses.     f_visibilities (Optional[List[ELMA365ToolVisibility]]): Tool visibilities.     f_availabilities (Optional[List[ELMA365ToolAvailability]]): Tool availabilities.  Returns:     PaginationResponse[ELMA365ToolModel]: Found ELMA365 tool.
         * @summary Search Elma365 Tools
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<string> | null} [fNamespaceIds] 
         * @param {Array<string> | null} [fComponentIds] 
         * @param {Array<ELMA365ToolStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ToolVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ToolAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitTools(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fComponentIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolStatus> | null, fVisibilities?: Array<ELMA365ToolVisibility> | null, fAvailabilities?: Array<ELMA365ToolAvailability> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseELMA365ToolModel> {
            return localVarFp.searchELMA365ToolkitTools(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fComponentIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ELMA365 toolsets.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365ToolsetStatus]]): Toolset statuses.     f_visibilities (Optional[List[ELMA365ToolsetVisibility]]): Toolset visibilities.     f_availabilities (Optional[List[ELMA365ToolsetAvailability]]): Toolset availabilities.  Returns:     PaginationResponse[ELMA365ToolsetModel]: Found ELMA365 toolsets.
         * @summary Search Elma365 Toolsets
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fVersionIds] 
         * @param {Array<ELMA365ToolsetStatus> | null} [fStatuses] 
         * @param {Array<ELMA365ToolsetVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365ToolsetAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitToolsets(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fFolderIds?: Array<string> | null, fConnectorIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolsetStatus> | null, fVisibilities?: Array<ELMA365ToolsetVisibility> | null, fAvailabilities?: Array<ELMA365ToolsetAvailability> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseELMA365ToolsetModel> {
            return localVarFp.searchELMA365ToolkitToolsets(pPageIndex, pPageSize, pWithTotal, fSearchText, fFolderIds, fConnectorIds, fVersionIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(axios, basePath));
        },
        /**
         * Search ELMA365 versions.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_statuses (Optional[List[ELMA365VersionStatus]]): Version statuses.     f_stages (Optional[List[ELMA365VersionStage]]): Version stages.     f_phases (Optional[List[ELMA365VersionPhase]]): Version phases.     f_visibilities (Optional[List[ELMA365VersionVisibility]]): Version visibilities.     f_availabilities (Optional[List[ELMA365VersionAvailability]]): Version availabilities.  Returns:     PaginationResponse[ELMA365VersionModel]: Found ELMA365 version.
         * @summary Search Elma365 Versions
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {Array<string> | null} [fConnectorIds] 
         * @param {Array<string> | null} [fToolsetIds] 
         * @param {Array<ELMA365VersionStatus> | null} [fStatuses] 
         * @param {Array<ELMA365VersionStage> | null} [fStages] 
         * @param {Array<ELMA365VersionPhase> | null} [fPhases] 
         * @param {Array<ELMA365VersionVisibility> | null} [fVisibilities] 
         * @param {Array<ELMA365VersionAvailability> | null} [fAvailabilities] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchELMA365ToolkitVersions(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fStatuses?: Array<ELMA365VersionStatus> | null, fStages?: Array<ELMA365VersionStage> | null, fPhases?: Array<ELMA365VersionPhase> | null, fVisibilities?: Array<ELMA365VersionVisibility> | null, fAvailabilities?: Array<ELMA365VersionAvailability> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseELMA365VersionModel> {
            return localVarFp.searchELMA365ToolkitVersions(pPageIndex, pPageSize, pWithTotal, fConnectorIds, fToolsetIds, fStatuses, fStages, fPhases, fVisibilities, fAvailabilities, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search ELMA365 applications
         * @param {string} baseUrl 
         * @param {string} xToken 
         * @param {string | null} [searchText] 
         * @param {{ [key: string]: any; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchElma365AppsElma365AppGet(baseUrl: string, xToken: string, searchText?: string | null, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig): AxiosPromise<Array<ELMA365AppModelOutput>> {
            return localVarFp.searchElma365AppsElma365AppGet(baseUrl, xToken, searchText, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search ELMA365 namespaces
         * @param {string} baseUrl 
         * @param {string} xToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchElma365NssElma365NsGet(baseUrl: string, xToken: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ELMA365NSModel>> {
            return localVarFp.searchElma365NssElma365NsGet(baseUrl, xToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Search files.  Args:     filtration (FileFiltration): Filtration parameters.     pagination (PaginationRequest): Pagination parameters.  Returns:     PaginationResponse[FileModel]: Found files.
         * @summary Search Files Post
         * @param {BodySearchFiles} [bodySearchFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFiles(bodySearchFiles?: BodySearchFiles, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseFileModel> {
            return localVarFp.searchFiles(bodySearchFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * Search files.  Args:     f_file_ids (Optional[List[str]]): File IDs.     f_external_ids (Optional[List[str]]): External IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_purposes (Optional[List[FilePurpose]]): File purposes.     f_content_mimes (Optional[List[str]]): Content MIMEs.     f_content_stores (Optional[List[FileContentStore]]): Content stores.     f_content_formats (Optional[List[Optional[FileContentFormat]]]): Content formats.     f_content_encodings (Optional[List[Optional[str]]]): Content encodings.     f_content_markups (Optional[List[Optional[FileContentFormat]]]): Content markups.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[FileModel]: Found files.
         * @summary Search Files
         * @param {Array<string> | null} [fFileIds] 
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<string> | null} [fPublicIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<FilePurpose> | null} [fPurposes] 
         * @param {Array<string> | null} [fContentMimes] 
         * @param {Array<ContentStore> | null} [fContentStores] 
         * @param {Array<ContentFormat> | null} [fContentFormats] 
         * @param {Array<string> | null} [fContentEncodings] 
         * @param {Array<ContentMarkup> | null} [fContentMarkups] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFilesGeneralFilesGet(fFileIds?: Array<string> | null, fExternalIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fPurposes?: Array<FilePurpose> | null, fContentMimes?: Array<string> | null, fContentStores?: Array<ContentStore> | null, fContentFormats?: Array<ContentFormat> | null, fContentEncodings?: Array<string> | null, fContentMarkups?: Array<ContentMarkup> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseFileModel> {
            return localVarFp.searchFilesGeneralFilesGet(fFileIds, fExternalIds, fPublicIds, fProjectIds, fSourceIds, fPurposes, fContentMimes, fContentStores, fContentFormats, fContentEncodings, fContentMarkups, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search folders.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Folder search text.     f_external_ids (Optional[List[str]]): Folder external IDs.     f_types (Optional[List[FolderType]]): Folder types.  Returns:     PaginationResponse[FolderModel]: Found folders.
         * @summary Search Folders
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<FolderType> | null} [fTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFolders(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fExternalIds?: Array<string> | null, fTypes?: Array<FolderType> | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseFolderModel> {
            return localVarFp.searchFolders(pPageIndex, pPageSize, pWithTotal, fSearchText, fExternalIds, fTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * Search operations.  Args:     f_operation_ids (Optional[List[str]]): Operation IDs.     f_statuses (Optional[List[OperationStatus]]): Operation statuses.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[OperationModel]: Found operations.
         * @summary Search Operations
         * @param {Array<string> | null} [fOperationIds] 
         * @param {Array<OperationStatus> | null} [fStatuses] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOperationsGeneralOperationsGet(fOperationIds?: Array<string> | null, fStatuses?: Array<OperationStatus> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseOperationModel> {
            return localVarFp.searchOperationsGeneralOperationsGet(fOperationIds, fStatuses, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search processes.  Args:     f_process_ids (Optional[List[str]]): Process IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_operation_ids (Optional[List[str]]): Operation IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionProcessModel]: Found processes.
         * @summary Search Processes
         * @param {Array<string> | null} [fProcessIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fOperationIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcessesIngestionProcessesGet(fProcessIds?: Array<string> | null, fProjectIds?: Array<string> | null, fOperationIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseIngestionProcessModel> {
            return localVarFp.searchProcessesIngestionProcessesGet(fProcessIds, fProjectIds, fOperationIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search projects.  Args:     f_search_text (Optional[str]): Project search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ProjectModel]: Found Projects.
         * @summary Search Projects
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProjectsGeneralProjectsGet(fSearchText?: string | null, fFolderIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseProjectModel> {
            return localVarFp.searchProjectsGeneralProjectsGet(fSearchText, fFolderIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_enabled (Optional[bool]): Filter by enabled property.  Returns:     PaginationResponse[ProviderModel]: Found Providers.
         * @summary Search Providers
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {boolean | null} [fEnabled] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProvidersGeneralProvidersGet(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fEnabled?: boolean | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseProviderModel> {
            return localVarFp.searchProvidersGeneralProvidersGet(pPageIndex, pPageSize, pWithTotal, fEnabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Search resources.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_actions (Optional[List[IngestionResourceAction]]): Resource actions.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionResourceModel]: Found resources.
         * @summary Search Resources
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fSourceIds] 
         * @param {Array<IngestionStageType> | null} [fStages] 
         * @param {Array<IngestionResourceAction> | null} [fActions] 
         * @param {string | null} [fSearchText] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResourcesIngestionResourcesGet(fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fStages?: Array<IngestionStageType> | null, fActions?: Array<IngestionResourceAction> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseIngestionResourceModel> {
            return localVarFp.searchResourcesIngestionResourcesGet(fProjectIds, fSourceIds, fStages, fActions, fSearchText, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search runs.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchRunModel]: Found Runs.
         * @summary Search Runs
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRunsSearchRunsGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseSearchRunModel> {
            return localVarFp.searchRunsSearchRunsGet(fProjectIds, fThreadIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Signals
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fProcessIds] 
         * @param {Array<IngestionSignalSubject> | null} [fSubjects] 
         * @param {Array<IngestionSignalCommand> | null} [fCommands] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSignalsIngestionSignalsGet(fProjectIds?: Array<string> | null, fProcessIds?: Array<string> | null, fSubjects?: Array<IngestionSignalSubject> | null, fCommands?: Array<IngestionSignalCommand> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseIngestionSignalModel> {
            return localVarFp.searchSignalsIngestionSignalsGet(fProjectIds, fProcessIds, fSubjects, fCommands, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search sources.  Args:     f_external_ids (Optional[list[str]]): External project IDs.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_names (Optional[List[str]]): Source names.     f_statuses (Optional[List[IngestionSourceStatus]]): Source statuses.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_grades (Optional[List[IngestionSourceGrade]]): Stage grades.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionSourceModel]: Found sources.
         * @summary Search Sources
         * @param {Array<string> | null} [fExternalIds] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fNames] 
         * @param {Array<IngestionSourceStatus> | null} [fStatuses] 
         * @param {Array<IngestionStageType> | null} [fStages] 
         * @param {Array<IngestionSourceGrade> | null} [fGrades] 
         * @param {string | null} [fSearchText] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSourcesIngestionSourcesGet(fExternalIds?: Array<string> | null, fFolderIds?: Array<string> | null, fProjectIds?: Array<string> | null, fNames?: Array<string> | null, fStatuses?: Array<IngestionSourceStatus> | null, fStages?: Array<IngestionStageType> | null, fGrades?: Array<IngestionSourceGrade> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseIngestionSourceModel> {
            return localVarFp.searchSourcesIngestionSourcesGet(fExternalIds, fFolderIds, fProjectIds, fNames, fStatuses, fStages, fGrades, fSearchText, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search toolsets.  Args:     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_agent_ids (Optional[List[str]]): Agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ToolsetModel]: Found toolsets.
         * @summary Search Toolsets
         * @param {string | null} [fSearchText] 
         * @param {Array<string> | null} [fFolderIds] 
         * @param {Array<string> | null} [fAgentIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchToolsets(fSearchText?: string | null, fFolderIds?: Array<string> | null, fAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseToolsetModel> {
            return localVarFp.searchToolsets(fSearchText, fFolderIds, fAgentIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search trace providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[TraceProviderModel]: Found trace providers.
         * @summary Search Trace Providers
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTraceProvidersGeneralTraceProvidersGet(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseTraceProviderModel> {
            return localVarFp.searchTraceProvidersGeneralTraceProvidersGet(pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search user messages.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
         * @summary Search User Messages
         * @param {Array<string> | null} [fProjectIds] 
         * @param {Array<string> | null} [fThreadIds] 
         * @param {Array<string> | null} [fRunIds] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserMessagesSearchMessagesUserGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseSearchMessageModel> {
            return localVarFp.searchUserMessagesSearchMessagesUserGet(fProjectIds, fThreadIds, fRunIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Search user threads.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
         * @summary Search User Threads
         * @param {Array<string> | null} [fProjectIds] 
         * @param {string | null} [fSearchText] 
         * @param {string | null} [fCreatedOnMin] 
         * @param {string | null} [fCreatedOnMax] 
         * @param {number} [pPageIndex] 
         * @param {number} [pPageSize] 
         * @param {boolean} [pWithTotal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserThreadsSearchThreadsUserGet(fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginationResponseSearchThreadModel> {
            return localVarFp.searchUserThreadsSearchThreadsUserGet(fProjectIds, fSearchText, fCreatedOnMin, fCreatedOnMax, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(axios, basePath));
        },
        /**
         * Select ELMA365 applications.  Args:     request (ELMA365ApplicationSelectionRequest): Applications selection request.  Returns:     ELMA365ApplicationSelectionResponse: Applications selection response.
         * @summary Select Elma365 Applications
         * @param {ELMA365ApplicationSelectionRequest} eLMA365ApplicationSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitApplications(eLMA365ApplicationSelectionRequest: ELMA365ApplicationSelectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ApplicationSelectionResponse> {
            return localVarFp.selectELMA365ToolkitApplications(eLMA365ApplicationSelectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Select ELMA365 namespaces.  Args:     request (ELMA365NamespaceSelectionRequest): Namespaces selection request.  Returns:     ELMA365NamespaceSelectionResponse: Namespaces selection response.
         * @summary Select Elma365 Namespace
         * @param {ELMA365NamespaceSelectionRequest} eLMA365NamespaceSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitNamespaces(eLMA365NamespaceSelectionRequest: ELMA365NamespaceSelectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365NamespaceSelectionResponse> {
            return localVarFp.selectELMA365ToolkitNamespaces(eLMA365NamespaceSelectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Select ELMA365 processes.  Args:     request (ELMA365ProcessSelectionRequest): Processes selection request.  Returns:     ELMA365ProcessSelectionResponse: Processes selection response.
         * @summary Select Elma365 Processes
         * @param {ELMA365ProcessSelectionRequest} eLMA365ProcessSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitProcesses(eLMA365ProcessSelectionRequest: ELMA365ProcessSelectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ProcessSelectionResponse> {
            return localVarFp.selectELMA365ToolkitProcesses(eLMA365ProcessSelectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Select ELMA365 tools.  Args:     request (ELMA365ToolSelectionRequest): Tools selection request.  Returns:     ELMA365ToolSelectionResponse: Tools selection response.
         * @summary Select Elma365 Tools
         * @param {ELMA365ToolSelectionRequest} eLMA365ToolSelectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectELMA365ToolkitTools(eLMA365ToolSelectionRequest: ELMA365ToolSelectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolSelectionResponse> {
            return localVarFp.selectELMA365ToolkitTools(eLMA365ToolSelectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign out this session.  Args:     public_id (str): Session public ID.
         * @summary Sign Out Session
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOutSession(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.signOutSession(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolTogglingRequest): Tool toggling request.  Returns:     ELMA365ToolTogglingResponse: Tool toggling response.
         * @summary Toggle Elma365 Tool
         * @param {string} toolId 
         * @param {ELMA365ToolTogglingRequest} eLMA365ToolTogglingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleELMA365ToolkitTool(toolId: string, eLMA365ToolTogglingRequest: ELMA365ToolTogglingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolTogglingResponse> {
            return localVarFp.toggleELMA365ToolkitTool(toolId, eLMA365ToolTogglingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetTogglingRequest): Toolset toggling request.  Returns:     ELMA365ToolsetTogglingResponse: Toolset toggling response.
         * @summary Toggle Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetTogglingRequest} eLMA365ToolsetTogglingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetTogglingRequest: ELMA365ToolsetTogglingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetTogglingResponse> {
            return localVarFp.toggleELMA365ToolkitToolset(toolsetId, eLMA365ToolsetTogglingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Try to get last thread.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_source_ref (Optional[str]): Source ref.  Returns:     Optional[AgentThreadModel]: Found thread else None.
         * @summary Try Get Last
         * @param {Array<string> | null} [fAgentIds] 
         * @param {string | null} [fSourceRef] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tryGetLastAgentThread(fAgentIds?: Array<string> | null, fSourceRef?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AgentThreadModel> {
            return localVarFp.tryGetLastAgentThread(fAgentIds, fSourceRef, options).then((request) => request(axios, basePath));
        },
        /**
         * Try to get last thread.  Args:     f_project_ids (Optional[List[str]]): Project IDs.  Returns:     Optional[SearchThreadModel]: Found Thread else None.
         * @summary Try Get Last
         * @param {Array<string> | null} [fProjectIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tryGetLastSearchThreadsLastGet(fProjectIds?: Array<string> | null, options?: RawAxiosRequestConfig): AxiosPromise<SearchThreadModel> {
            return localVarFp.tryGetLastSearchThreadsLastGet(fProjectIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Update agent.  Args:     agent_id (str): Agent ID.     request (AgentUpdatingRequest): Agent updating request.
         * @summary Update Agent
         * @param {string} agentId 
         * @param {AgentUpdatingRequest} agentUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent(agentId: string, agentUpdatingRequest: AgentUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateAgent(agentId, agentUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update agent relation.  Args:     relation_id (str): Agent relation ID.     request (AgentRelationUpdatingRequest): Agent relation updating request.
         * @summary Update Relation
         * @param {string} relationId 
         * @param {AgentRelationUpdatingRequest} agentRelationUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentRelation(relationId: string, agentRelationUpdatingRequest: AgentRelationUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateAgentRelation(relationId, agentRelationUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update agent resource.  Args:     resource_id (str): Agent resource ID.     request (AgentResourceUpdatingRequest): Agent resource updating request.
         * @summary Update Resource
         * @param {string} resourceId 
         * @param {AgentResourceUpdatingRequest} agentResourceUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentResource(resourceId: string, agentResourceUpdatingRequest: AgentResourceUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateAgentResource(resourceId, agentResourceUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update thread.  Args:     thread_id (str): Thread ID.     request (AgentThreadUpdatingRequest): Thread updating request.
         * @summary Update Thread
         * @param {string} threadId 
         * @param {AgentThreadUpdatingRequest} agentThreadUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentThread(threadId: string, agentThreadUpdatingRequest: AgentThreadUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateAgentThread(threadId, agentThreadUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update ApiKey.  Args:     api_key_id (str): ApiKey ID.     request (ApiKeyUpdatingRequest): ApiKey updating request.
         * @summary Update Api Key
         * @param {string} apiKeyId 
         * @param {ApiKeyUpdatingRequest} apiKeyUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKeySecurityApiKeysApiKeyIdPut(apiKeyId: string, apiKeyUpdatingRequest: ApiKeyUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateApiKeySecurityApiKeysApiKeyIdPut(apiKeyId, apiKeyUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update connector.  Args:     connector_id (str): Connector ID.     request (ConnectorUpdatingRequest): Connector updating request.
         * @summary Update Connector
         * @param {string} connectorId 
         * @param {ConnectorUpdatingRequest} connectorUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConnector(connectorId: string, connectorUpdatingRequest: ConnectorUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectorUpdatingResponse> {
            return localVarFp.updateConnector(connectorId, connectorUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolUpdatingRequest): Tool updating request.  Returns:     ELMA365ToolUpdatingResponse: Tool updating response.
         * @summary Update Elma365 Tool
         * @param {string} toolId 
         * @param {ELMA365ToolUpdatingRequest} eLMA365ToolUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateELMA365ToolkitTool(toolId: string, eLMA365ToolUpdatingRequest: ELMA365ToolUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolUpdatingResponse> {
            return localVarFp.updateELMA365ToolkitTool(toolId, eLMA365ToolUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetUpdatingRequest): Toolset updating request.  Returns:     ELMA365ToolsetUpdatingResponse: Toolset updating response.
         * @summary Update Elma365 Toolset
         * @param {string} toolsetId 
         * @param {ELMA365ToolsetUpdatingRequest} eLMA365ToolsetUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetUpdatingRequest: ELMA365ToolsetUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ELMA365ToolsetUpdatingResponse> {
            return localVarFp.updateELMA365ToolkitToolset(toolsetId, eLMA365ToolsetUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update file via form.  Args:     path (FileUpdatingPath): Request path.     query (FileUpdatingQuery): Request query.     content (UploadFile): File content.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Form
         * @param {string} fileId 
         * @param {string} externalId 
         * @param {Array<FilePurpose>} purposes 
         * @param {File} content 
         * @param {string | null} [projectId] 
         * @param {string | null} [sourceId] 
         * @param {ContentStore | null} [contentStore] 
         * @param {ContentFormat | null} [contentFormat] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileFormGeneralFilesFormFileIdPut(fileId: string, externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options?: RawAxiosRequestConfig): AxiosPromise<FileUpdatingResponse> {
            return localVarFp.updateFileFormGeneralFilesFormFileIdPut(fileId, externalId, purposes, content, projectId, sourceId, contentStore, contentFormat, options).then((request) => request(axios, basePath));
        },
        /**
         * Update file via JSON.  Args:     path (FileUpdatingPath): Request path.     body (FileUpdatingBody): Request body.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Json
         * @param {string} fileId 
         * @param {FileUpdatingBody} fileUpdatingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileJsonGeneralFilesJsonFileIdPut(fileId: string, fileUpdatingBody: FileUpdatingBody, options?: RawAxiosRequestConfig): AxiosPromise<FileUpdatingResponse> {
            return localVarFp.updateFileJsonGeneralFilesJsonFileIdPut(fileId, fileUpdatingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update file\'s parameters.  Args:     path (FileUpdatingPath): Request path.     body (FileParametersInfo): Request body.  Returns:     FileUpdatingResponse: File updating response.
         * @summary Update File Parameters
         * @param {string} fileId 
         * @param {FileParametersInfo} fileParametersInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFileParametersGeneralFilesFileIdParametersPut(fileId: string, fileParametersInfo: FileParametersInfo, options?: RawAxiosRequestConfig): AxiosPromise<FileUpdatingResponse> {
            return localVarFp.updateFileParametersGeneralFilesFileIdParametersPut(fileId, fileParametersInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Update folder.  Args:     folder_id (str): Folder ID.     request (FolderUpdatingRequest): Folder updating request.  Returns:     FolderUpdatingResponse: Folder updating response.
         * @summary Update Folder
         * @param {string} folderId 
         * @param {FolderUpdatingRequest} folderUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder(folderId: string, folderUpdatingRequest: FolderUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<FolderUpdatingResponse> {
            return localVarFp.updateFolder(folderId, folderUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update project.  Args:     project_id (str): Project ID.     request (ProjectUpdatingRequest): Project updating request.
         * @summary Update Project
         * @param {string} projectId 
         * @param {ProjectUpdatingRequest} projectUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectGeneralProjectsProjectIdPut(projectId: string, projectUpdatingRequest: ProjectUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateProjectGeneralProjectsProjectIdPut(projectId, projectUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update provider.  Args:     provider_id (str): Provider ID.     request (ProviderUpdatingRequest): Provider updating request.
         * @summary Update Provider
         * @param {string} providerId 
         * @param {ProviderUpdatingRequest} providerUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderGeneralProvidersProviderIdPut(providerId: string, providerUpdatingRequest: ProviderUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateProviderGeneralProvidersProviderIdPut(providerId, providerUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Schedule
         * @param {string} scheduleId 
         * @param {IngestionScheduleUpdatingRequest} ingestionScheduleUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedule(scheduleId: string, ingestionScheduleUpdatingRequest: IngestionScheduleUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateSchedule(scheduleId, ingestionScheduleUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Source
         * @param {string} sourceId 
         * @param {IngestionSourceUpdatingRequest} ingestionSourceUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSourceIngestionSourcesSourceIdPut(sourceId: string, ingestionSourceUpdatingRequest: IngestionSourceUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestionSourceUpdatingResponse> {
            return localVarFp.updateSourceIngestionSourcesSourceIdPut(sourceId, ingestionSourceUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update thread.  Args:     thread_id (str): Thread ID.     request (SearchThreadUpdatingRequest): Thread updating request.
         * @summary Update Thread
         * @param {string} threadId 
         * @param {SearchThreadUpdatingRequest} searchThreadUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateThreadSearchThreadsThreadIdPut(threadId: string, searchThreadUpdatingRequest: SearchThreadUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateThreadSearchThreadsThreadIdPut(threadId, searchThreadUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update toolset.  Args:     toolset_id (str): Toolset ID.     request (ToolsetUpdatingRequest): Toolset updating request.
         * @summary Update Toolset
         * @param {string} toolsetId 
         * @param {ToolsetUpdatingRequest} toolsetUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToolset(toolsetId: string, toolsetUpdatingRequest: ToolsetUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateToolset(toolsetId, toolsetUpdatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update trace provider.  Args:     trace_provider_id (str): Trace provider ID.     request (TraceProviderUpdatingRequest): Trace provider updating request.
         * @summary Update Trace Provider
         * @param {string} traceProviderId 
         * @param {TraceProviderUpdatingRequest} traceProviderUpdatingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTraceProviderGeneralTraceProvidersTraceProviderIdPut(traceProviderId: string, traceProviderUpdatingRequest: TraceProviderUpdatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateTraceProviderGeneralTraceProvidersTraceProviderIdPut(traceProviderId, traceProviderUpdatingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Assert session.  Args:     public_id (str): Session public ID.     request (SessionAssertRequest): Session assertion request.  Returns:     SessionAssertResponse: Session assertion response.
     * @summary Assert Session
     * @param {string} publicId 
     * @param {Request1} request1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assertSession(publicId: string, request1: Request1, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assertSession(publicId, request1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Login.  Args:     action (str): Callback action.     return_to (str): Return path.  Returns:     None: Redirects the user to the OAuth provider.
     * @summary Auth Login
     * @param {string} action 
     * @param {string} returnTo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authLogin(action: string, returnTo: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authLogin(action, returnTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout.  Args:     request (Request): Logout request.  Returns:     None: Redirects the user to the index page.
     * @summary Auth Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authLogout(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Call ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetCallingRequest): Toolset calling request.  Returns:     ELMA365ToolsetCallingResponse: Toolset calling response.
     * @summary Call Elma365 Toolset
     * @param {string} toolsetId 
     * @param {ELMA365ToolsetCallingRequest} eLMA365ToolsetCallingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public callELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetCallingRequest: ELMA365ToolsetCallingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).callELMA365ToolkitToolset(toolsetId, eLMA365ToolsetCallingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check connector.  Args:     request (ConnectorCheckingRequest): Connector checking request.  Returns:     ConnectorCheckingResponse: Connector checking response.
     * @summary Check Connector
     * @param {ConnectorCheckingRequest} connectorCheckingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkConnector(connectorCheckingRequest: ConnectorCheckingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkConnector(connectorCheckingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check provider embedding.  Args:     request (ProviderEmbeddingCheckingRequest): Provider embedding checking request.  Returns:     ProviderEmbeddingCheckingResponse: Provider embedding checking response.
     * @summary Check Provider Embedding
     * @param {ProviderEmbeddingCheckingRequest} providerEmbeddingCheckingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost(providerEmbeddingCheckingRequest: ProviderEmbeddingCheckingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkProviderEmbeddingGeneralProvidersEmbeddingCheckPost(providerEmbeddingCheckingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check provider llm.  Args:     request (ProviderLLMCheckingRequest): Provider LLM checking request.  Returns:     ProviderLLMCheckingResponse: Provider LLM checking response.
     * @summary Check Provider Llm
     * @param {ProviderLLMCheckingRequest} providerLLMCheckingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkProviderLlmGeneralProvidersLlmCheckPost(providerLLMCheckingRequest: ProviderLLMCheckingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkProviderLlmGeneralProvidersLlmCheckPost(providerLLMCheckingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compare ELMA365 versions.  Args:     request (ELMA365VersionComparisonRequest): Versions comparison request.  Returns:     ELMA365VersionComparisonResponse: Versions comparison response.
     * @summary Compare Elma365 Versions
     * @param {ELMA365VersionComparisonRequest} eLMA365VersionComparisonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public compareELMA365ToolkitVersions(eLMA365VersionComparisonRequest: ELMA365VersionComparisonRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).compareELMA365ToolkitVersions(eLMA365VersionComparisonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Completion request.  Args:     request (CompletionRequest): Completion request.  Returns:     CompletionResponse: Completion response.
     * @summary Completion
     * @param {CompletionRequest} completionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public completionSearchCompletionPost(completionRequest: CompletionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).completionSearchCompletionPost(completionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create agent.  Args:     request (AgentCreationRequest): Agent creation request.  Returns:     AgentCreationResponse: Agent creation response.
     * @summary Create Agent
     * @param {AgentCreationRequest} agentCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAgent(agentCreationRequest: AgentCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAgent(agentCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create agent relation.  Args:     request (AgentRelationCreationRequest): Agent relation creation request.  Returns:     AgentRelationCreationResponse: Agent relation creation response.
     * @summary Create Relation
     * @param {AgentRelationCreationRequest} agentRelationCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAgentRelation(agentRelationCreationRequest: AgentRelationCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAgentRelation(agentRelationCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create agent resource.  Args:     request (AgentResourceCreationRequest): Agent resource creation request.  Returns:     AgentResourceCreationResponse: Agent resource creation response.
     * @summary Create Resource
     * @param {AgentResourceCreationRequest} agentResourceCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAgentResource(agentResourceCreationRequest: AgentResourceCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAgentResource(agentResourceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create run.  Args:     request (AgentRunCreationRequest): Run creation request.  Returns:     AgentRunCreationResponse: Run creation response.
     * @summary Create Run
     * @param {AgentRunCreationRequest} agentRunCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAgentRun(agentRunCreationRequest: AgentRunCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAgentRun(agentRunCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create thread.  Args:     request (AgentThreadCreationRequest): Thread creation request.  Returns:     AgentThreadCreationResponse: Thread creation response.
     * @summary Create Thread
     * @param {AgentThreadCreationRequest} agentThreadCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createAgentThread(agentThreadCreationRequest: AgentThreadCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createAgentThread(agentThreadCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create ApiKey.  Args:     request (ApiKeyCreationRequest): ApiKey creation request.  Returns:     ApiKeyCreationResponse: ApiKey creation response.
     * @summary Create Api Key
     * @param {ApiKeyCreationRequest} apiKeyCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createApiKeySecurityApiKeysPost(apiKeyCreationRequest: ApiKeyCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createApiKeySecurityApiKeysPost(apiKeyCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create connector.  Args:     request (ConnectorCreationRequest): Connector creation request.  Returns:     ConnectorCreationResponse: Connector creation response.
     * @summary Create Connector
     * @param {ConnectorCreationRequest} connectorCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createConnector(connectorCreationRequest: ConnectorCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createConnector(connectorCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create ELMA365 toolset.  Args:     request (ELMA365ToolsetCreationRequest): Toolset creation request.  Returns:     ELMA365ToolsetCreationResponse: Toolset creation response.
     * @summary Create Elma365 Toolset
     * @param {ELMA365ToolsetCreationRequest} eLMA365ToolsetCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createELMA365ToolkitToolset(eLMA365ToolsetCreationRequest: ELMA365ToolsetCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createELMA365ToolkitToolset(eLMA365ToolsetCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create ELMA365 version.  Args:     request (ELMA365VersionCreationRequest): Version creation request.  Returns:     ELMA365VersionCreationResponse: Version creation response.
     * @summary Create Elma365 Version
     * @param {ELMA365VersionCreationRequest} eLMA365VersionCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createELMA365ToolkitVersion(eLMA365VersionCreationRequest: ELMA365VersionCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createELMA365ToolkitVersion(eLMA365VersionCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create file via form.  Args:     query (FileCreationQuery): Request query.     content (UploadFile): File content.  Returns:     FileCreationResponse: File creation response.
     * @summary Create File Form
     * @param {string} externalId 
     * @param {Array<FilePurpose>} purposes 
     * @param {File} content 
     * @param {string | null} [projectId] 
     * @param {string | null} [sourceId] 
     * @param {ContentStore | null} [contentStore] 
     * @param {ContentFormat | null} [contentFormat] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFileFormGeneralFilesFormPost(externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFileFormGeneralFilesFormPost(externalId, purposes, content, projectId, sourceId, contentStore, contentFormat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create file via JSON.  Args:     body (FileCreationBody): Request body.  Returns:     FileCreationResponse: File creation response.
     * @summary Create File Json
     * @param {FileCreationBody} fileCreationBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFileJsonGeneralFilesJsonPost(fileCreationBody: FileCreationBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFileJsonGeneralFilesJsonPost(fileCreationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create folder.  Args:     request (FolderCreationRequest): Folder creation request.  Returns:     FolderCreationResponse: Folder creation response.
     * @summary Create Folder
     * @param {FolderCreationRequest} folderCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createFolder(folderCreationRequest: FolderCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createFolder(folderCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create message.  Args:     request (SearchMessageCreationRequest): Message creation request.  Returns:     SearchMessageCreationResponse: Message creation response.
     * @summary Create Message
     * @param {SearchMessageCreationRequest} searchMessageCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createMessageSearchMessagesPost(searchMessageCreationRequest: SearchMessageCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createMessageSearchMessagesPost(searchMessageCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create process.  Args:     request (IngestionProcessCreationRequest): Process creation request.  Returns:     IngestionProcessCreationResponse: Process creation response.
     * @summary Create Process
     * @param {IngestionProcessCreationRequest} ingestionProcessCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createProcessIngestionProcessesPost(ingestionProcessCreationRequest: IngestionProcessCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createProcessIngestionProcessesPost(ingestionProcessCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create project.  Args:     request (ProjectCreationRequest): Project creation request.  Returns:     ProjectCreationResponse: Project creation response.
     * @summary Create Project
     * @param {ProjectCreationRequest} projectCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createProjectGeneralProjectsPost(projectCreationRequest: ProjectCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createProjectGeneralProjectsPost(projectCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create provider.  Args:     request (ProviderCreationRequest): Provider creation request.  Returns:     ProviderCreationResponse: Provider creation response.
     * @summary Create Provider
     * @param {ProviderCreationRequest} providerCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createProviderGeneralProvidersPost(providerCreationRequest: ProviderCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createProviderGeneralProvidersPost(providerCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create run.  Args:     request (SearchRunCreationRequest): Run creation request.  Returns:     SearchRunCreationResponse: Run creation response.
     * @summary Create Run
     * @param {SearchRunCreationRequest} searchRunCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createRunSearchRunsPost(searchRunCreationRequest: SearchRunCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createRunSearchRunsPost(searchRunCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Schedule
     * @param {IngestionScheduleCreationRequest} ingestionScheduleCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSchedule(ingestionScheduleCreationRequest: IngestionScheduleCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSchedule(ingestionScheduleCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create session.  Args:     request (SessionCreationRequest): Session creation request.  Returns:     SessionModel: Created session.
     * @summary Create Session
     * @param {Request} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSession(request: Request, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSession(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Signal
     * @param {IngestionSignalCreationRequest} ingestionSignalCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSignalIngestionSignalsPost(ingestionSignalCreationRequest: IngestionSignalCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSignalIngestionSignalsPost(ingestionSignalCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Source
     * @param {IngestionSourceCreationRequest} ingestionSourceCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSourceIngestionSourcesPost(ingestionSourceCreationRequest: IngestionSourceCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSourceIngestionSourcesPost(ingestionSourceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create thread.  Args:     request (SearchThreadCreationRequest): Thread creation request.  Returns:     SearchThreadCreationResponse: Thread creation response.
     * @summary Create Thread
     * @param {SearchThreadCreationRequest} searchThreadCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createThreadSearchThreadsPost(searchThreadCreationRequest: SearchThreadCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createThreadSearchThreadsPost(searchThreadCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create toolset.  Args:     request (ToolsetCreationRequest): Toolset creation request.  Returns:     ToolsetCreationResponse: Toolset creation response.
     * @summary Create Toolset
     * @param {ToolsetCreationRequest} toolsetCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createToolset(toolsetCreationRequest: ToolsetCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createToolset(toolsetCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create trace provider.  Args:     request (TraceProviderCreationRequest): Provider creation request.  Returns:     TraceProviderCreationResponse: Trace provider creation response.
     * @summary Create Trace Provider
     * @param {TraceProviderCreationRequest} traceProviderCreationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTraceProviderGeneralTraceProvidersPost(traceProviderCreationRequest: TraceProviderCreationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createTraceProviderGeneralTraceProvidersPost(traceProviderCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one agent.  Args:     agent_id (str): Agent ID.
     * @summary Delete One Agent
     * @param {string} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAgent(agentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAgent(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one agent relation.  Args:     relation_id (str): Agent relation ID.
     * @summary Delete One Relation
     * @param {string} relationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAgentRelation(relationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAgentRelation(relationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one agent resource.  Args:     resource_id (str): Agent resource ID.
     * @summary Delete One Resource
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAgentResource(resourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAgentResource(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one thread.  Args:     thread_id (str): Thread ID.
     * @summary Delete One Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAgentThread(threadId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAgentThread(threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete connector.  Args:     connector_id (str): Connector ID.
     * @summary Delete Connector
     * @param {string} connectorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteConnector(connectorId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteConnector(connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolDeletionResponse: Tool deletion response.
     * @summary Delete Elma365 Tool
     * @param {string} toolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteELMA365ToolkitTool(toolId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteELMA365ToolkitTool(toolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.
     * @summary Delete Elma365 Toolset
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteELMA365ToolkitToolset(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteELMA365ToolkitToolset(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete ELMA365 version.  Args:     version_id (str): Version ID.
     * @summary Delete Elma365 Version
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteELMA365ToolkitVersion(versionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteELMA365ToolkitVersion(versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete folder.  Args:     folder_id (str): Folder ID.
     * @summary Delete Folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one ApiKey.  Args:     api_key_id (str): ApiKey ID.
     * @summary Delete One Api Key
     * @param {string} apiKeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOneApiKeySecurityApiKeysApiKeyIdDelete(apiKeyId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOneApiKeySecurityApiKeysApiKeyIdDelete(apiKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one file.  Args:     path (FileDeletionPath): RequestPath.
     * @summary Delete One File
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOneFileGeneralFilesFileIdDelete(fileId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOneFileGeneralFilesFileIdDelete(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one message.  Args:     message_id (str): Message ID.
     * @summary Delete One Message
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOneMessageSearchMessagesMessageIdDelete(messageId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOneMessageSearchMessagesMessageIdDelete(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one project.  Args:     project_id (str): Project ID.
     * @summary Delete One Project
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOneProjectGeneralProjectsProjectIdDelete(projectId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOneProjectGeneralProjectsProjectIdDelete(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one provider.  Args:     provider_id (str): Provider ID.
     * @summary Delete One Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOneProviderGeneralProvidersProviderIdDelete(providerId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOneProviderGeneralProvidersProviderIdDelete(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one thread.  Args:     thread_id (str): Thread ID.
     * @summary Delete One Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOneThreadSearchThreadsThreadIdDelete(threadId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOneThreadSearchThreadsThreadIdDelete(threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one trace provider.  Args:     trace_provider_id (str): Trace provider ID.
     * @summary Delete One Trace Provider
     * @param {string} traceProviderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete(traceProviderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOneTraceProviderGeneralTraceProvidersTraceProviderIdDelete(traceProviderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Schedule
     * @param {string} scheduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSchedule(scheduleId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSchedule(scheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one toolset.  Args:     toolset_id (str): Toolset ID.
     * @summary Delete One Toolset
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteToolset(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteToolset(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download artifact buffer content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Buffer content.
     * @summary Download Artifact Buffer
     * @param {string} artifactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet(artifactId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadArtifactBufferIngestionArtifactsArtifactIdContentBufferGet(artifactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download artifact object content.  Args:     artifact_id (str): Artifact ID.  Returns:     Any: Object content.
     * @summary Download Artifact Object
     * @param {string} artifactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet(artifactId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadArtifactObjectIngestionArtifactsArtifactIdContentObjectGet(artifactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download artifact stream content.  Args:     artifact_id (str): Artifact ID.  Returns:     StreamingResponse: Stream content.
     * @summary Download Artifact Stream
     * @param {string} artifactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet(artifactId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadArtifactStreamIngestionArtifactsArtifactIdContentStreamGet(artifactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download artifact string content.  Args:     artifact_id (str): Artifact ID.  Returns:     PlainTextResponse: String content.
     * @summary Download Artifact String
     * @param {string} artifactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet(artifactId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadArtifactStringIngestionArtifactsArtifactIdContentStringGet(artifactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download file buffer content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Buffer content.
     * @summary Download File Buffer
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFileBufferGeneralFilesFileIdContentBufferGet(fileId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFileBufferGeneralFilesFileIdContentBufferGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download file object content.  Args:     file_id (str): File ID.  Returns:     Any: Object content.
     * @summary Download File Object
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFileObjectGeneralFilesFileIdContentObjectGet(fileId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFileObjectGeneralFilesFileIdContentObjectGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download file stream content.  Args:     file_id (str): File ID.  Returns:     StreamingResponse: Stream content.
     * @summary Download File Stream
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFileStreamGeneralFilesFileIdContentStreamGet(fileId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFileStreamGeneralFilesFileIdContentStreamGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download file string content.  Args:     file_id (str): File ID.  Returns:     PlainTextResponse: String content.
     * @summary Download File String
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadFileStringGeneralFilesFileIdContentStringGet(fileId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadFileStringGeneralFilesFileIdContentStringGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export agent as archive.  Args:     agent_id (str): Agent ID.  Returns:     FileResponse: Archive file.
     * @summary Export Agent Archive
     * @param {string} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportAgentArchive(agentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportAgentArchive(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export ELMA365 toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
     * @summary Export Elma365 Toolset Archive
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportELMA365ToolkitToolsetArchive(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportELMA365ToolkitToolsetArchive(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export ELMA365 toolset as buffer.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
     * @summary Export Elma365 Toolset Buffer
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportELMA365ToolkitToolsetBuffer(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportELMA365ToolkitToolsetBuffer(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export ELMA365 toolset as object.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetExchange: Object content.
     * @summary Export Elma365 Toolset Object
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportELMA365ToolkitToolsetObject(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportELMA365ToolkitToolsetObject(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export ELMA365 toolset as stream.  Args:     toolset_id (str): Toolset ID.  Returns:     StreamingResponse: Stream content.
     * @summary Export Elma365 Toolset Stream
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportELMA365ToolkitToolsetStream(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportELMA365ToolkitToolsetStream(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export ELMA365 toolset as string.  Args:     toolset_id (str): Toolset ID.  Returns:     PlainTextResponse: String content.
     * @summary Export Elma365 Toolset String
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportELMA365ToolkitToolsetString(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportELMA365ToolkitToolsetString(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export folder as archive.  Args:     folder_id (str): Folder ID.  Returns:     FileResponse: Archive file.
     * @summary Export Folder Archive
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportFolderArchive(folderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportFolderArchive(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export project as archive.  Args:     project_id (str): Project ID.  Returns:     FileResponse: Archive file.
     * @summary Export Project Archive
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportProjectArchive(projectId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportProjectArchive(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export toolset as archive.  Args:     toolset_id (str): Toolset ID.  Returns:     FileResponse: Archive file.
     * @summary Export Toolset Archive
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportToolsetArchive(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportToolsetArchive(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get general information about application.  Returns:     AboutInfo: General information about application.
     * @summary Get About Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAboutInfoInfoApplicationAboutGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAboutInfoInfoApplicationAboutGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all folders.  Returns:     List[FolderModel]: Found folders.
     * @summary Get All Folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllFolders(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllFolders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a current identity.  Returns:     IdentityModel: Current identity.
     * @summary Get Current Identity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrentIdentity(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentIdentity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Current
     * @param {string} projectId 
     * @param {boolean | null} [withSources] 
     * @param {boolean | null} [withResources] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCurrentIngestionStateProjectIdGet(projectId: string, withSources?: boolean | null, withResources?: boolean | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCurrentIngestionStateProjectIdGet(projectId, withSources, withResources, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of available features and their active statuses.
     * @summary Get available feature flags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFeatureFlagsFeatureManagementGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFeatureFlagsFeatureManagementGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get health information about application.  Returns:     HealthInfo: Health information about application.
     * @summary Get Health Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getHealthInfoInfoApplicationHealthGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getHealthInfoInfoApplicationHealthGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one agent.  Args:     agent_id (str): Agent ID.  Returns:     AgentModel: Found agent.
     * @summary Get One Agent
     * @param {string} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgent(agentId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgent(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one message.  Args:     message_id (str): Message ID.  Returns:     AgentMessageModel: Found message.
     * @summary Get One Message
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgentMessage(messageId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgentMessage(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one agent relation.  Args:     relation_id (str): Agent relation ID.  Returns:     AgentRelationModel: Found agent relation.
     * @summary Get One Relation
     * @param {string} relationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgentRelation(relationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgentRelation(relationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one resource.  Args:     resource_id (str): Agent resource ID.  Returns:     AgentResourceModel: Found agent resource.
     * @summary Get One Resource
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgentResource(resourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgentResource(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
     * @summary Get One Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgentRun(runId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgentRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
     * @summary Get One Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgentThread(threadId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgentThread(threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one user run.  Args:     run_id (str): Run ID.  Returns:     AgentRunModel: Found run.
     * @summary Get One User Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgentUserRun(runId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgentUserRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     AgentThreadModel: Found thread.
     * @summary Get One User Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneAgentUserThread(threadId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneAgentUserThread(threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one ApiKey.  Args:     api_key_id (str): ApiKey ID.  Returns:     ApiKeyModel: Found ApiKey.
     * @summary Get One Api Key
     * @param {string} apiKeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneApiKeySecurityApiKeysApiKeyIdGet(apiKeyId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneApiKeySecurityApiKeysApiKeyIdGet(apiKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one artifact.  Args:     artifact_id (str): Artifact ID.  Returns:     IngestionArtifactModel: Found artifacts.
     * @summary Get One Artifact
     * @param {string} artifactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneArtifactIngestionArtifactsArtifactIdGet(artifactId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneArtifactIngestionArtifactsArtifactIdGet(artifactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one connector.  Args:     connector_id (str): Connector ID.  Returns:     ConnectorModel: Found connector.
     * @summary Get One Connector
     * @param {string} connectorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneConnector(connectorId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneConnector(connectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one ELMA365 application.  Args:     application_id (str): Application ID.  Returns:     ELMA365ApplicationModel: Found ELMA365 application.
     * @summary Get One Elma365 Application
     * @param {string} applicationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneELMA365ToolkitApplication(applicationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneELMA365ToolkitApplication(applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one ELMA365 namespace.  Args:     namespace_id (str): Namespace ID.  Returns:     ELMA365NamespaceModel: Found ELMA365 namespace.
     * @summary Get One Elma365 Namespace
     * @param {string} namespaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneELMA365ToolkitNamespace(namespaceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneELMA365ToolkitNamespace(namespaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one ELMA365 process.  Args:     process_id (str): Process ID.  Returns:     ELMA365ProcessModel: Found ELMA365 process.
     * @summary Get One Elma365 Process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneELMA365ToolkitProcess(processId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneELMA365ToolkitProcess(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one ELMA365 tool.  Args:     tool_id (str): Tool ID.  Returns:     ELMA365ToolModel: Found ELMA365 tool.
     * @summary Get One Elma365 Tool
     * @param {string} toolId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneELMA365ToolkitTool(toolId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneELMA365ToolkitTool(toolId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ELMA365ToolsetModel: Found ELMA365 toolset.
     * @summary Get One Elma365 Toolset
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneELMA365ToolkitToolset(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneELMA365ToolkitToolset(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one ELMA365 version.  Args:     version_id (str): Version ID.  Returns:     ELMA365VersionModel: Found ELMA365 version.
     * @summary Get One Elma365 Version
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneELMA365ToolkitVersion(versionId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneELMA365ToolkitVersion(versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one file.  Args:     file_id (str): File ID.  Returns:     FileModel: Found file.
     * @summary Get One File
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneFileGeneralFilesFileIdGet(fileId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneFileGeneralFilesFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one folder.  Args:     folder_id (str): Folder ID.  Returns:     FolderModel: Found folder.
     * @summary Get One Folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one message.  Args:     message_id (str): Message ID.  Returns:     SearchMessageModel: Found message.
     * @summary Get One Message
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneMessageSearchMessagesMessageIdGet(messageId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneMessageSearchMessagesMessageIdGet(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one operation.  Args:     operation_id (str): Operation ID.  Returns:     OperationModel: Found operation.
     * @summary Get One Operation
     * @param {string} operationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneOperationGeneralOperationsOperationIdGet(operationId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneOperationGeneralOperationsOperationIdGet(operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one process.  Args:     process_id (str): Process ID.  Returns:     IngestionProcessModel: Found process.
     * @summary Get One Process
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneProcessIngestionProcessesProcessIdGet(processId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneProcessIngestionProcessesProcessIdGet(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one project.  Args:     project_id (str): Project ID.  Returns:     ProjectModel: Found project.
     * @summary Get One Project
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneProjectGeneralProjectsProjectIdGet(projectId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneProjectGeneralProjectsProjectIdGet(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one provider.  Args:     provider_id (str): Provider ID.  Returns:     ProviderModel: Found provider.
     * @summary Get One Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneProviderGeneralProvidersProviderIdGet(providerId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneProviderGeneralProvidersProviderIdGet(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one resource.  Args:     resource_id (str): Resource ID.  Returns:     IngestionResourceModel: Found resource.
     * @summary Get One Resource
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneResourceIngestionResourcesResourceIdGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneResourceIngestionResourcesResourceIdGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one run.  Args:     run_id (str): Run ID.  Returns:     SearchRunModel: Found Run.
     * @summary Get One Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneRunSearchRunsRunIdGet(runId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneRunSearchRunsRunIdGet(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get One Signal
     * @param {string} signalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneSignalIngestionSignalsSignalIdGet(signalId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneSignalIngestionSignalsSignalIdGet(signalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get One Source
     * @param {string} sourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneSourceIngestionSourcesSourceIdGet(sourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneSourceIngestionSourcesSourceIdGet(sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
     * @summary Get One Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneThreadSearchThreadsThreadIdGet(threadId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneThreadSearchThreadsThreadIdGet(threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one toolset.  Args:     toolset_id (str): Toolset ID.  Returns:     ToolsetModel: Found toolset.
     * @summary Get One Toolset
     * @param {string} toolsetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneToolset(toolsetId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneToolset(toolsetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one trace provider.  Args:     trace_provider_id (str): Trace provider ID.  Returns:     TraceProviderModel: Found trace provider.
     * @summary Get One Trace Provider
     * @param {string} traceProviderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet(traceProviderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneTraceProviderGeneralTraceProvidersTraceProviderIdGet(traceProviderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one user thread.  Args:     thread_id (str): Thread ID.  Returns:     SearchThreadModel: Found thread.
     * @summary Get One User Thread
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOneUserThreadSearchThreadsThreadIdUserGet(threadId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOneUserThreadSearchThreadsThreadIdUserGet(threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Schedule
     * @param {string} scheduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSchedule(scheduleId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSchedule(scheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one session.  Args:     public_id (str): Session public ID.  Returns:     SessionModel: Found session.
     * @summary Get Session
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSession(publicId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSession(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check session requirement.  Args:     f_agent_id (str): Agent ID.     f_connector_id (str): Connector ID.  Returns:     SessionRequirementModel: Session requirement response.
     * @summary Is Session Required
     * @param {string | null} [fAgentId] 
     * @param {string | null} [fConnectorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSessionRequirement(fAgentId?: string | null, fConnectorId?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSessionRequirement(fAgentId, fConnectorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Source Details
     * @param {string} projectId 
     * @param {string} sourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSourceDetailsIngestionStateProjectIdSourcesSourceIdDetailsGet(projectId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Source
     * @param {string} projectId 
     * @param {string} sourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSourceIngestionStateProjectIdSourcesSourceIdGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSourceIngestionStateProjectIdSourcesSourceIdGet(projectId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Source Resources
     * @param {string} projectId 
     * @param {string} sourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet(projectId: string, sourceId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSourceResourcesIngestionStateProjectIdSourcesSourceIdResourcesGet(projectId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import agent file via form.  Args:     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
     * @summary Import Agent Create Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {File} dependencies 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importAgentCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importAgentCreateForm(folderId, content, dependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) agent file via JSON.  Args:     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
     * @summary Import Agent Create Json
     * @param {string} folderId 
     * @param {AgentImportBody} agentImportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importAgentCreateJson(folderId: string, agentImportBody: AgentImportBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importAgentCreateJson(folderId, agentImportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import agent file via form.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Agent dependencies.  Returns:     AgentImportResponse: Agent import response.
     * @summary Import Agent Update Form
     * @param {string} agentId 
     * @param {string} folderId 
     * @param {File} content 
     * @param {File} dependencies 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importAgentUpdateForm(agentId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importAgentUpdateForm(agentId, folderId, content, dependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) agent file via JSON.  Args:     path (AgentImportPath): Request path.     query (AgentImportQuery): Request query.     body (AgentImportBody): Request body.  Returns:     AgentImportResponse: Agent import response.
     * @summary Import Agent Update Json
     * @param {string} agentId 
     * @param {string} folderId 
     * @param {AgentImportBody} agentImportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importAgentUpdateJson(agentId: string, folderId: string, agentImportBody: AgentImportBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importAgentUpdateJson(agentId, folderId, agentImportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
     * @summary Import Elma365 Toolset Create Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {File} dependencies 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importELMA365ToolkitToolsetCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importELMA365ToolkitToolsetCreateForm(folderId, content, dependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
     * @summary Import Elma365 Toolset Create Json
     * @param {string} folderId 
     * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importELMA365ToolkitToolsetCreateJson(folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importELMA365ToolkitToolsetCreateJson(folderId, eLMA365ToolsetImportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): ELMA365 toolset dependencies.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
     * @summary Import Elma365 Toolset Update Form
     * @param {string} toolsetId 
     * @param {string} folderId 
     * @param {File} content 
     * @param {File} dependencies 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importELMA365ToolkitToolsetUpdateForm(toolsetId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importELMA365ToolkitToolsetUpdateForm(toolsetId, folderId, content, dependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetImportPath): Request path.     query (ELMA365ToolsetImportQuery): Request query.     body (ELMA365ToolsetImportBody): Request body.  Returns:     ELMA365ToolsetImportResponse: ELMA365 toolset import response.
     * @summary Import Elma365 Toolset Update Json
     * @param {string} toolsetId 
     * @param {string} folderId 
     * @param {ELMA365ToolsetImportBody} eLMA365ToolsetImportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importELMA365ToolkitToolsetUpdateJson(toolsetId: string, folderId: string, eLMA365ToolsetImportBody: ELMA365ToolsetImportBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importELMA365ToolkitToolsetUpdateJson(toolsetId, folderId, eLMA365ToolsetImportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) folder file via form.  Args:     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
     * @summary Import Folder Create Form
     * @param {File} content 
     * @param {File} dependencies 
     * @param {string | null} [folderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importFolderCreateForm(content: File, dependencies: File, folderId?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importFolderCreateForm(content, dependencies, folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) folder file via JSON.  Args:     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
     * @summary Import Folder Create Json
     * @param {FolderImportBody} folderImportBody 
     * @param {string | null} [folderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importFolderCreateJson(folderImportBody: FolderImportBody, folderId?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importFolderCreateJson(folderImportBody, folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import folder file via form.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Folder dependencies.  Returns:     FolderImportResponse: Folder import response.
     * @summary Import Folder Update Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {File} dependencies 
     * @param {string | null} [folderId2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importFolderUpdateForm(folderId: string, content: File, dependencies: File, folderId2?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importFolderUpdateForm(folderId, content, dependencies, folderId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (update) folder file via JSON.  Args:     path (FolderImportPath): Request path.     query (FolderImportQuery): Request query.     body (FolderImportBody): Request body.  Returns:     FolderImportResponse: Folder import response.
     * @summary Import Folder Update Json
     * @param {string} folderId 
     * @param {FolderImportBody} folderImportBody 
     * @param {string | null} [folderId2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importFolderUpdateJson(folderId: string, folderImportBody: FolderImportBody, folderId2?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importFolderUpdateJson(folderId, folderImportBody, folderId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) project file via form.  Args:     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
     * @summary Import Project Create Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {File} dependencies 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importProjectCreateForm(folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importProjectCreateForm(folderId, content, dependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (create) project file via JSON.  Args:     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
     * @summary Import Project Create Json
     * @param {string} folderId 
     * @param {ProjectImportBody} projectImportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importProjectCreateJson(folderId: string, projectImportBody: ProjectImportBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importProjectCreateJson(folderId, projectImportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (update) project file via form.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     content (UploadFile): File content.     dependencies (UploadFile): Project dependencies.  Returns:     ProjectImportResponse: Project import response.
     * @summary Import Project Update Form
     * @param {string} projectId 
     * @param {string} folderId 
     * @param {File} content 
     * @param {File} dependencies 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importProjectUpdateForm(projectId: string, folderId: string, content: File, dependencies: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importProjectUpdateForm(projectId, folderId, content, dependencies, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import (update) project file via JSON.  Args:     path (ProjectImportPath): Request path.     query (ProjectImportQuery): Request query.     body (ProjectImportBody): Request body.  Returns:     ProjectImportResponse: Project import response.
     * @summary Import Project Update Json
     * @param {string} projectId 
     * @param {string} folderId 
     * @param {ProjectImportBody} projectImportBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public importProjectUpdateJson(projectId: string, folderId: string, projectImportBody: ProjectImportBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).importProjectUpdateJson(projectId, folderId, projectImportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect agent file via form.  Args:     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
     * @summary Inspect Agent Create Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectAgentCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectAgentCreateForm(folderId, content, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect agent file via JSON.  Args:     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
     * @summary Inspect Agent Create Json
     * @param {string} folderId 
     * @param {AgentInspectionBody} agentInspectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectAgentCreateJson(folderId: string, agentInspectionBody: AgentInspectionBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectAgentCreateJson(folderId, agentInspectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect (update) agent file via form.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     AgentInspectionResponse: Agent inspection response.
     * @summary Inspect Agent Update Form
     * @param {string} agentId 
     * @param {string} folderId 
     * @param {File} content 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectAgentUpdateForm(agentId: string, folderId: string, content: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectAgentUpdateForm(agentId, folderId, content, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspec (update) agent file via JSON.  Args:     path (AgentInspectionPath): Request path.     query (AgentInspectionQuery): Request query.     body (AgentInspectionBody): Request body.  Returns:     AgentInspectionResponse: Agent inspection response.
     * @summary Inspect Agent Update Json
     * @param {string} agentId 
     * @param {string} folderId 
     * @param {AgentInspectionBody} agentInspectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectAgentUpdateJson(agentId: string, folderId: string, agentInspectionBody: AgentInspectionBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectAgentUpdateJson(agentId, folderId, agentInspectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect ELMA365 toolset file via form.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
     * @summary Inspect Elma365 Toolset Create Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectELMA365ToolkitToolsetCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectELMA365ToolkitToolsetCreateForm(folderId, content, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect ELMA365 toolset file via JSON.  Args:     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
     * @summary Inspect Elma365 Toolset Create Json
     * @param {string} folderId 
     * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectELMA365ToolkitToolsetCreateJson(folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectELMA365ToolkitToolsetCreateJson(folderId, eLMA365ToolsetInspectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect (update) ELMA365 toolset file via form.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
     * @summary Inspect Elma365 Toolset Update Form
     * @param {string} toolsetId 
     * @param {string} folderId 
     * @param {File} content 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectELMA365ToolkitToolsetUpdateForm(toolsetId: string, folderId: string, content: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectELMA365ToolkitToolsetUpdateForm(toolsetId, folderId, content, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspec (update) ELMA365 toolset file via JSON.  Args:     path (ELMA365ToolsetInspectionPath): Request path.     query (ELMA365ToolsetInspectionQuery): Request query.     body (ELMA365ToolsetInspectionBody): Request body.  Returns:     ELMA365ToolsetInspectionResponse: ELMA365 toolset inspection response.
     * @summary Inspect Elma365 Toolset Update Json
     * @param {string} toolsetId 
     * @param {string} folderId 
     * @param {ELMA365ToolsetInspectionBody} eLMA365ToolsetInspectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectELMA365ToolkitToolsetUpdateJson(toolsetId: string, folderId: string, eLMA365ToolsetInspectionBody: ELMA365ToolsetInspectionBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectELMA365ToolkitToolsetUpdateJson(toolsetId, folderId, eLMA365ToolsetInspectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect folder file via form.  Args:     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
     * @summary Inspect Folder Create Form
     * @param {File} content 
     * @param {string | null} [folderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectFolderCreateForm(content: File, folderId?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectFolderCreateForm(content, folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect folder file via JSON.  Args:     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
     * @summary Inspect Folder Create Json
     * @param {FolderInspectionBody} folderInspectionBody 
     * @param {string | null} [folderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectFolderCreateJson(folderInspectionBody: FolderInspectionBody, folderId?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectFolderCreateJson(folderInspectionBody, folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect (update) folder file via form.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     FolderInspectionResponse: Folder inspection response.
     * @summary Inspect Folder Update Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {string | null} [folderId2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectFolderUpdateForm(folderId: string, content: File, folderId2?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectFolderUpdateForm(folderId, content, folderId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspec (update) folder file via JSON.  Args:     path (FolderInspectionPath): Request path.     query (FolderInspectionQuery): Request query.     body (FolderInspectionBody): Request body.  Returns:     FolderInspectionResponse: Folder inspection response.
     * @summary Inspect Folder Update Json
     * @param {string} folderId 
     * @param {FolderInspectionBody} folderInspectionBody 
     * @param {string | null} [folderId2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectFolderUpdateJson(folderId: string, folderInspectionBody: FolderInspectionBody, folderId2?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectFolderUpdateJson(folderId, folderInspectionBody, folderId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect project file via form.  Args:     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
     * @summary Inspect Project Create Form
     * @param {string} folderId 
     * @param {File} content 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectProjectCreateForm(folderId: string, content: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectProjectCreateForm(folderId, content, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect project file via JSON.  Args:     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
     * @summary Inspect Project Create Json
     * @param {string} folderId 
     * @param {ProjectInspectionBody} projectInspectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectProjectCreateJson(folderId: string, projectInspectionBody: ProjectInspectionBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectProjectCreateJson(folderId, projectInspectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspect (update) project file via form.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     content (UploadFile): File content.  Returns:     ProjectInspectionResponse: Project inspection response.
     * @summary Inspect Project Update Form
     * @param {string} projectId 
     * @param {string} folderId 
     * @param {File} content 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectProjectUpdateForm(projectId: string, folderId: string, content: File, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectProjectUpdateForm(projectId, folderId, content, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inspec (update) project file via JSON.  Args:     path (ProjectInspectionPath): Request path.     query (ProjectInspectionQuery): Request query.     body (ProjectInspectionBody): Request body.  Returns:     ProjectInspectionResponse: Project inspection response.
     * @summary Inspect Project Update Json
     * @param {string} projectId 
     * @param {string} folderId 
     * @param {ProjectInspectionBody} projectInspectionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public inspectProjectUpdateJson(projectId: string, folderId: string, projectInspectionBody: ProjectInspectionBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).inspectProjectUpdateJson(projectId, folderId, projectInspectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Sources Details
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet(projectId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listSourcesDetailsIngestionStateProjectIdSourcesDetailsGet(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Sources
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listSourcesIngestionStateProjectIdSourcesGet(projectId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listSourcesIngestionStateProjectIdSourcesGet(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Sources Resources
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet(projectId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listSourcesResourcesIngestionStateProjectIdSourcesResourcesGet(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain ELMA365 applications.  Args:     request (ELMA365ApplicationObtainingRequest): Applications obtaining request.  Returns:     ELMA365ApplicationObtainingResponse: Applications obtaining response.
     * @summary Obtain Elma365 Application
     * @param {ELMA365ApplicationObtainingRequest} eLMA365ApplicationObtainingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public obtainELMA365ToolkitApplications(eLMA365ApplicationObtainingRequest: ELMA365ApplicationObtainingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).obtainELMA365ToolkitApplications(eLMA365ApplicationObtainingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain ELMA365 namespaces.  Args:     request (ELMA365NamespaceObtainingRequest): Namespaces obtaining request.  Returns:     ELMA365NamespaceObtainingResponse: Namespaces obtaining response.
     * @summary Obtain Elma365 Namespace
     * @param {ELMA365NamespaceObtainingRequest} eLMA365NamespaceObtainingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public obtainELMA365ToolkitNamespaces(eLMA365NamespaceObtainingRequest: ELMA365NamespaceObtainingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).obtainELMA365ToolkitNamespaces(eLMA365NamespaceObtainingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain ELMA365 processes.  Args:     request (ELMA365ProcessObtainingRequest): Processes obtaining request.  Returns:     ELMA365ProcessObtainingResponse: Processes obtaining response.
     * @summary Obtain Elma365 Process
     * @param {ELMA365ProcessObtainingRequest} eLMA365ProcessObtainingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public obtainELMA365ToolkitProcesses(eLMA365ProcessObtainingRequest: ELMA365ProcessObtainingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).obtainELMA365ToolkitProcesses(eLMA365ProcessObtainingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain ELMA365 tools.  Args:     request (ELMA365ToolObtainingRequest): Tools obtaining request.  Returns:     ELMA365ToolObtainingResponse: Tools obtaining response.
     * @summary Obtain Elma365 Tools
     * @param {ELMA365ToolObtainingRequest} eLMA365ToolObtainingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public obtainELMA365ToolkitTools(eLMA365ToolObtainingRequest: ELMA365ToolObtainingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).obtainELMA365ToolkitTools(eLMA365ToolObtainingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain system folder.  Returns:     FolderModel: System folder.
     * @summary Obtain System Folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public obtainSystemFolder(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).obtainSystemFolder(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll the status of an OAuth2 connector check.  Args:     check_id (str): Check ID returned from checkConnector.  Returns:     ConnectorCheckOAuthPollingResponse: Current check status.
     * @summary Poll Connector Oauth Check
     * @param {string} checkId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public pollConnectorOAuthCheck(checkId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).pollConnectorOAuthCheck(checkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve request.  Args:     request (RetrieveRequest): Retrieve request.  Returns:     RetrieveResponse: Retrieve response.
     * @summary Retrieve
     * @param {RetrieveRequest} retrieveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public retrieveSearchRetrievePost(retrieveRequest: RetrieveRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).retrieveSearchRetrievePost(retrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search all messages (ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
     * @summary Search All Messages
     * @param {Array<string> | null} [fAgentIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {Array<string> | null} [fRunIds] 
     * @param {SortDirection | null} [sOrder] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentAllMessages(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentAllMessages(fAgentIds, fThreadIds, fRunIds, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
     * @summary Search Runs
     * @param {Array<string> | null} [fAgentIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {string | null} [fSearchText] 
     * @param {string | null} [fCreatedOnMin] 
     * @param {string | null} [fCreatedOnMax] 
     * @param {SortDirection | null} [sOrder] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentAllRuns(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentAllRuns(fAgentIds, fThreadIds, fSearchText, fCreatedOnMin, fCreatedOnMax, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search all threads (Ignore identity).  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
     * @summary Search All Threads
     * @param {Array<string> | null} [fAgentIds] 
     * @param {string | null} [fSearchText] 
     * @param {string | null} [fCreatedOnMin] 
     * @param {string | null} [fCreatedOnMax] 
     * @param {string | null} [fSourceRef] 
     * @param {SortDirection | null} [sOrder] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentAllThreads(fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentAllThreads(fAgentIds, fSearchText, fCreatedOnMin, fCreatedOnMax, fSourceRef, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search agent relations.  Args:     f_managing_agent_ids (Optional[List[str]]): Managing agent IDs.     f_managed_agent_ids (Optional[List[str]]): Managed agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRelationModel]: Found agent relations.
     * @summary Search Relations
     * @param {Array<string> | null} [fManagingAgentIds] 
     * @param {Array<string> | null} [fManagedAgentIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentRelations(fManagingAgentIds?: Array<string> | null, fManagedAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentRelations(fManagingAgentIds, fManagedAgentIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search agent resources.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentResourceModel]: Found agent resources.
     * @summary Search Resources
     * @param {Array<string> | null} [fAgentIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentResources(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentResources(fAgentIds, fThreadIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search user messages.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentMessageModel]: Found messages.
     * @summary Search User Messages
     * @param {Array<string> | null} [fAgentIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {Array<string> | null} [fRunIds] 
     * @param {SortDirection | null} [sOrder] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentUserMessages(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentUserMessages(fAgentIds, fThreadIds, fRunIds, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search runs.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentRunModel]: Found runs.
     * @summary Search Runs
     * @param {Array<string> | null} [fAgentIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {string | null} [fSearchText] 
     * @param {string | null} [fCreatedOnMin] 
     * @param {string | null} [fCreatedOnMax] 
     * @param {SortDirection | null} [sOrder] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentUserRuns(fAgentIds?: Array<string> | null, fThreadIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentUserRuns(fAgentIds, fThreadIds, fSearchText, fCreatedOnMin, fCreatedOnMax, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search user threads.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     f_source_ref (Optional[str]): Source ref.     s_order (Optional[SortDirection]): Sort direction.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentThreadModel]: Found threads.
     * @summary Search User Threads
     * @param {Array<string> | null} [fAgentIds] 
     * @param {string | null} [fSearchText] 
     * @param {string | null} [fCreatedOnMin] 
     * @param {string | null} [fCreatedOnMax] 
     * @param {string | null} [fSourceRef] 
     * @param {SortDirection | null} [sOrder] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgentUserThreads(fAgentIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, fSourceRef?: string | null, sOrder?: SortDirection | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgentUserThreads(fAgentIds, fSearchText, fCreatedOnMin, fCreatedOnMax, fSourceRef, sOrder, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search agents.  Args:     f_search_text (Optional[str]): Agent search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_interface_types (Optional[List[DataInterfaceType]]): Agent interface types.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[AgentModel]: Found Agents.
     * @summary Search Agents
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fFolderIds] 
     * @param {Array<DataInterfaceType> | null} [fInterfaceTypes] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAgents(fSearchText?: string | null, fFolderIds?: Array<string> | null, fInterfaceTypes?: Array<DataInterfaceType> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAgents(fSearchText, fFolderIds, fInterfaceTypes, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search all messages (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
     * @summary Search All Messages
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {Array<string> | null} [fRunIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAllMessagesSearchMessagesAllGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAllMessagesSearchMessagesAllGet(fProjectIds, fThreadIds, fRunIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search all threads (ignore identity).  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
     * @summary Search All Threads
     * @param {Array<string> | null} [fProjectIds] 
     * @param {string | null} [fSearchText] 
     * @param {string | null} [fCreatedOnMin] 
     * @param {string | null} [fCreatedOnMax] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchAllThreadsSearchThreadsAllGet(fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchAllThreadsSearchThreadsAllGet(fProjectIds, fSearchText, fCreatedOnMin, fCreatedOnMax, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ApiKeys.  Args:     f_scope_ref_types (List[ApiKeyScopeRefType]): Scope ref object types.     f_scope_ref_ids (List[str]): Scope ref object IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ApiKeyModel]: Found ApiKeys.
     * @summary Search Api Keys
     * @param {Array<ApiKeyScopeRefType> | null} [fScopeRefTypes] 
     * @param {Array<string> | null} [fScopeRefIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchApiKeysSecurityApiKeysGet(fScopeRefTypes?: Array<ApiKeyScopeRefType> | null, fScopeRefIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchApiKeysSecurityApiKeysGet(fScopeRefTypes, fScopeRefIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search artifacts.  Args:     f_artifact_ids (Optional[List[str]]): Artifact IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_resource_ids (Optional[List[str]]): Resource IDs.     f_parent_ids (Optional[List[Optional[str]]]): Parent IDs.     f_file_ids (Optional[List[Optional[str]]]): File IDs.     f_types (Optional[List[IngestionArtifactType]]): Artifact types.     f_origins (Optional[List[IngestionArtifactOrigin]]): Artifact actions.     f_actions (Optional[List[IngestionArtifactCommand]]): Artifact commands.     f_node_ids (Optional[List[str]]): Node IDs.     f_node_classes (Optional[List[IngestionNodeClass]]): Node classes.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionArtifactModel]: Found artifacts.
     * @summary Search Artifacts
     * @param {Array<string> | null} [fArtifactIds] 
     * @param {Array<string> | null} [fPublicIds] 
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fSourceIds] 
     * @param {Array<string> | null} [fResourceIds] 
     * @param {Array<string> | null} [fParentIds] 
     * @param {Array<string> | null} [fFileIds] 
     * @param {Array<IngestionArtifactType> | null} [fTypes] 
     * @param {Array<IngestionArtifactOrigin> | null} [fOrigins] 
     * @param {Array<IngestionArtifactAction> | null} [fActions] 
     * @param {Array<string> | null} [fNodeIds] 
     * @param {Array<IngestionNodeClass> | null} [fNodeClasses] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchArtifactsIngestionArtifactsGet(fArtifactIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fResourceIds?: Array<string> | null, fParentIds?: Array<string> | null, fFileIds?: Array<string> | null, fTypes?: Array<IngestionArtifactType> | null, fOrigins?: Array<IngestionArtifactOrigin> | null, fActions?: Array<IngestionArtifactAction> | null, fNodeIds?: Array<string> | null, fNodeClasses?: Array<IngestionNodeClass> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchArtifactsIngestionArtifactsGet(fArtifactIds, fPublicIds, fProjectIds, fSourceIds, fResourceIds, fParentIds, fFileIds, fTypes, fOrigins, fActions, fNodeIds, fNodeClasses, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search connectors.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Connector search text.     f_statuses (Optional[List[ConnectorStatus]]): Connector statuses.     f_availabilities (Optional[List[ConnectorStatus]]): Connector availabilities.     f_auth_types (Optional[List[ConnectorAuthType]]): Connector auth types.  Returns:     PaginationResponse[ConnectorModel]: Found connectors.
     * @summary Search Connectors
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {string | null} [fSearchText] 
     * @param {Array<ConnectorStatus> | null} [fStatuses] 
     * @param {Array<ConnectorAvailability> | null} [fAvailabilities] 
     * @param {Array<ConnectorAuthType> | null} [fAuthTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchConnectors(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fStatuses?: Array<ConnectorStatus> | null, fAvailabilities?: Array<ConnectorAvailability> | null, fAuthTypes?: Array<ConnectorAuthType> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchConnectors(pPageIndex, pPageSize, pWithTotal, fSearchText, fStatuses, fAvailabilities, fAuthTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ELMA365 applications.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Application search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_statuses (Optional[List[ELMA365ApplicationStatus]]): Application statuses.     f_visibilities (Optional[List[ELMA365ApplicationVisibility]]): Application visibilities.     f_availabilities (Optional[List[ELMA365ApplicationAvailability]]): Application availabilities.  Returns:     PaginationResponse[ELMA365ApplicationModel]: Found ELMA365 applications.
     * @summary Search Elma365 Applications
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fConnectorIds] 
     * @param {Array<string> | null} [fToolsetIds] 
     * @param {Array<string> | null} [fVersionIds] 
     * @param {Array<string> | null} [fNamespaceIds] 
     * @param {Array<ELMA365ApplicationStatus> | null} [fStatuses] 
     * @param {Array<ELMA365ApplicationVisibility> | null} [fVisibilities] 
     * @param {Array<ELMA365ApplicationAvailability> | null} [fAvailabilities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchELMA365ToolkitApplications(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fStatuses?: Array<ELMA365ApplicationStatus> | null, fVisibilities?: Array<ELMA365ApplicationVisibility> | null, fAvailabilities?: Array<ELMA365ApplicationAvailability> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchELMA365ToolkitApplications(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ELMA365 namespaces.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Namespace search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365NamespacenStatus]]): Namespace statuses.     f_visibilities (Optional[List[ELMA365NamespaceVisibility]]): Namespace visibilities.     f_availabilities (Optional[List[ELMA365NamespaceAvailability]]): Namespace availabilities.  Returns:     PaginationResponse[ELMA365NamespaceModel]: Found ELMA365 namespaces.
     * @summary Search Elma365 Namespaces
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fConnectorIds] 
     * @param {Array<string> | null} [fToolsetIds] 
     * @param {Array<string> | null} [fVersionIds] 
     * @param {Array<ELMA365NamespaceStatus> | null} [fStatuses] 
     * @param {Array<ELMA365NamespaceVisibility> | null} [fVisibilities] 
     * @param {Array<ELMA365NamespaceAvailability> | null} [fAvailabilities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchELMA365ToolkitNamespaces(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365NamespaceStatus> | null, fVisibilities?: Array<ELMA365NamespaceVisibility> | null, fAvailabilities?: Array<ELMA365NamespaceAvailability> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchELMA365ToolkitNamespaces(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ELMA365 processes.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Process search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_application_ids (Optional[List[str]]): Application IDs.     f_statuses (Optional[List[ELMA365ProcessStatus]]): Process statuses.     f_visibilities (Optional[List[ELMA365ProcessVisibility]]): Process visibilities.     f_availabilities (Optional[List[ELMA365ProcessAvailability]]): Process availabilities.  Returns:     PaginationResponse[ELMA365ProcessModel]: Found ELMA365 processes.
     * @summary Search Elma365 Processes
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fConnectorIds] 
     * @param {Array<string> | null} [fToolsetIds] 
     * @param {Array<string> | null} [fVersionIds] 
     * @param {Array<string> | null} [fNamespaceIds] 
     * @param {Array<string> | null} [fApplicationIds] 
     * @param {Array<ELMA365ProcessStatus> | null} [fStatuses] 
     * @param {Array<ELMA365ProcessVisibility> | null} [fVisibilities] 
     * @param {Array<ELMA365ProcessAvailability> | null} [fAvailabilities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchELMA365ToolkitProcesses(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fApplicationIds?: Array<string> | null, fStatuses?: Array<ELMA365ProcessStatus> | null, fVisibilities?: Array<ELMA365ProcessVisibility> | null, fAvailabilities?: Array<ELMA365ProcessAvailability> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchELMA365ToolkitProcesses(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fApplicationIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ELMA365 tools.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Tool search text.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_namespace_ids (Optional[List[str]]): Namespace IDs.     f_component_ids (Optional[List[str]]): Component IDs.     f_statuses (Optional[List[ELMA365ToolStatus]]): Tool statuses.     f_visibilities (Optional[List[ELMA365ToolVisibility]]): Tool visibilities.     f_availabilities (Optional[List[ELMA365ToolAvailability]]): Tool availabilities.  Returns:     PaginationResponse[ELMA365ToolModel]: Found ELMA365 tool.
     * @summary Search Elma365 Tools
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fConnectorIds] 
     * @param {Array<string> | null} [fToolsetIds] 
     * @param {Array<string> | null} [fVersionIds] 
     * @param {Array<string> | null} [fNamespaceIds] 
     * @param {Array<string> | null} [fComponentIds] 
     * @param {Array<ELMA365ToolStatus> | null} [fStatuses] 
     * @param {Array<ELMA365ToolVisibility> | null} [fVisibilities] 
     * @param {Array<ELMA365ToolAvailability> | null} [fAvailabilities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchELMA365ToolkitTools(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fVersionIds?: Array<string> | null, fNamespaceIds?: Array<string> | null, fComponentIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolStatus> | null, fVisibilities?: Array<ELMA365ToolVisibility> | null, fAvailabilities?: Array<ELMA365ToolAvailability> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchELMA365ToolkitTools(pPageIndex, pPageSize, pWithTotal, fSearchText, fConnectorIds, fToolsetIds, fVersionIds, fNamespaceIds, fComponentIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ELMA365 toolsets.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_version_ids (Optional[List[str]]): Version IDs.     f_statuses (Optional[List[ELMA365ToolsetStatus]]): Toolset statuses.     f_visibilities (Optional[List[ELMA365ToolsetVisibility]]): Toolset visibilities.     f_availabilities (Optional[List[ELMA365ToolsetAvailability]]): Toolset availabilities.  Returns:     PaginationResponse[ELMA365ToolsetModel]: Found ELMA365 toolsets.
     * @summary Search Elma365 Toolsets
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fFolderIds] 
     * @param {Array<string> | null} [fConnectorIds] 
     * @param {Array<string> | null} [fVersionIds] 
     * @param {Array<ELMA365ToolsetStatus> | null} [fStatuses] 
     * @param {Array<ELMA365ToolsetVisibility> | null} [fVisibilities] 
     * @param {Array<ELMA365ToolsetAvailability> | null} [fAvailabilities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchELMA365ToolkitToolsets(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fFolderIds?: Array<string> | null, fConnectorIds?: Array<string> | null, fVersionIds?: Array<string> | null, fStatuses?: Array<ELMA365ToolsetStatus> | null, fVisibilities?: Array<ELMA365ToolsetVisibility> | null, fAvailabilities?: Array<ELMA365ToolsetAvailability> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchELMA365ToolkitToolsets(pPageIndex, pPageSize, pWithTotal, fSearchText, fFolderIds, fConnectorIds, fVersionIds, fStatuses, fVisibilities, fAvailabilities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search ELMA365 versions.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_connector_ids (Optional[List[str]]): Connector IDs.     f_toolset_ids (Optional[List[str]]): Toolset IDs.     f_statuses (Optional[List[ELMA365VersionStatus]]): Version statuses.     f_stages (Optional[List[ELMA365VersionStage]]): Version stages.     f_phases (Optional[List[ELMA365VersionPhase]]): Version phases.     f_visibilities (Optional[List[ELMA365VersionVisibility]]): Version visibilities.     f_availabilities (Optional[List[ELMA365VersionAvailability]]): Version availabilities.  Returns:     PaginationResponse[ELMA365VersionModel]: Found ELMA365 version.
     * @summary Search Elma365 Versions
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {Array<string> | null} [fConnectorIds] 
     * @param {Array<string> | null} [fToolsetIds] 
     * @param {Array<ELMA365VersionStatus> | null} [fStatuses] 
     * @param {Array<ELMA365VersionStage> | null} [fStages] 
     * @param {Array<ELMA365VersionPhase> | null} [fPhases] 
     * @param {Array<ELMA365VersionVisibility> | null} [fVisibilities] 
     * @param {Array<ELMA365VersionAvailability> | null} [fAvailabilities] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchELMA365ToolkitVersions(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fConnectorIds?: Array<string> | null, fToolsetIds?: Array<string> | null, fStatuses?: Array<ELMA365VersionStatus> | null, fStages?: Array<ELMA365VersionStage> | null, fPhases?: Array<ELMA365VersionPhase> | null, fVisibilities?: Array<ELMA365VersionVisibility> | null, fAvailabilities?: Array<ELMA365VersionAvailability> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchELMA365ToolkitVersions(pPageIndex, pPageSize, pWithTotal, fConnectorIds, fToolsetIds, fStatuses, fStages, fPhases, fVisibilities, fAvailabilities, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search ELMA365 applications
     * @param {string} baseUrl 
     * @param {string} xToken 
     * @param {string | null} [searchText] 
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchElma365AppsElma365AppGet(baseUrl: string, xToken: string, searchText?: string | null, requestBody?: { [key: string]: any; }, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchElma365AppsElma365AppGet(baseUrl, xToken, searchText, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search ELMA365 namespaces
     * @param {string} baseUrl 
     * @param {string} xToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchElma365NssElma365NsGet(baseUrl: string, xToken: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchElma365NssElma365NsGet(baseUrl, xToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search files.  Args:     filtration (FileFiltration): Filtration parameters.     pagination (PaginationRequest): Pagination parameters.  Returns:     PaginationResponse[FileModel]: Found files.
     * @summary Search Files Post
     * @param {BodySearchFiles} [bodySearchFiles] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchFiles(bodySearchFiles?: BodySearchFiles, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchFiles(bodySearchFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search files.  Args:     f_file_ids (Optional[List[str]]): File IDs.     f_external_ids (Optional[List[str]]): External IDs.     f_public_ids (Optional[List[str]]): Public IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_purposes (Optional[List[FilePurpose]]): File purposes.     f_content_mimes (Optional[List[str]]): Content MIMEs.     f_content_stores (Optional[List[FileContentStore]]): Content stores.     f_content_formats (Optional[List[Optional[FileContentFormat]]]): Content formats.     f_content_encodings (Optional[List[Optional[str]]]): Content encodings.     f_content_markups (Optional[List[Optional[FileContentFormat]]]): Content markups.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[FileModel]: Found files.
     * @summary Search Files
     * @param {Array<string> | null} [fFileIds] 
     * @param {Array<string> | null} [fExternalIds] 
     * @param {Array<string> | null} [fPublicIds] 
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fSourceIds] 
     * @param {Array<FilePurpose> | null} [fPurposes] 
     * @param {Array<string> | null} [fContentMimes] 
     * @param {Array<ContentStore> | null} [fContentStores] 
     * @param {Array<ContentFormat> | null} [fContentFormats] 
     * @param {Array<string> | null} [fContentEncodings] 
     * @param {Array<ContentMarkup> | null} [fContentMarkups] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchFilesGeneralFilesGet(fFileIds?: Array<string> | null, fExternalIds?: Array<string> | null, fPublicIds?: Array<string> | null, fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fPurposes?: Array<FilePurpose> | null, fContentMimes?: Array<string> | null, fContentStores?: Array<ContentStore> | null, fContentFormats?: Array<ContentFormat> | null, fContentEncodings?: Array<string> | null, fContentMarkups?: Array<ContentMarkup> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchFilesGeneralFilesGet(fFileIds, fExternalIds, fPublicIds, fProjectIds, fSourceIds, fPurposes, fContentMimes, fContentStores, fContentFormats, fContentEncodings, fContentMarkups, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search folders.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_search_text (Optional[str]): Folder search text.     f_external_ids (Optional[List[str]]): Folder external IDs.     f_types (Optional[List[FolderType]]): Folder types.  Returns:     PaginationResponse[FolderModel]: Found folders.
     * @summary Search Folders
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fExternalIds] 
     * @param {Array<FolderType> | null} [fTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchFolders(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fSearchText?: string | null, fExternalIds?: Array<string> | null, fTypes?: Array<FolderType> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchFolders(pPageIndex, pPageSize, pWithTotal, fSearchText, fExternalIds, fTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search operations.  Args:     f_operation_ids (Optional[List[str]]): Operation IDs.     f_statuses (Optional[List[OperationStatus]]): Operation statuses.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[OperationModel]: Found operations.
     * @summary Search Operations
     * @param {Array<string> | null} [fOperationIds] 
     * @param {Array<OperationStatus> | null} [fStatuses] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchOperationsGeneralOperationsGet(fOperationIds?: Array<string> | null, fStatuses?: Array<OperationStatus> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchOperationsGeneralOperationsGet(fOperationIds, fStatuses, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search processes.  Args:     f_process_ids (Optional[List[str]]): Process IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_operation_ids (Optional[List[str]]): Operation IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionProcessModel]: Found processes.
     * @summary Search Processes
     * @param {Array<string> | null} [fProcessIds] 
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fOperationIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchProcessesIngestionProcessesGet(fProcessIds?: Array<string> | null, fProjectIds?: Array<string> | null, fOperationIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchProcessesIngestionProcessesGet(fProcessIds, fProjectIds, fOperationIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search projects.  Args:     f_search_text (Optional[str]): Project search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ProjectModel]: Found Projects.
     * @summary Search Projects
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fFolderIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchProjectsGeneralProjectsGet(fSearchText?: string | null, fFolderIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchProjectsGeneralProjectsGet(fSearchText, fFolderIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.     f_enabled (Optional[bool]): Filter by enabled property.  Returns:     PaginationResponse[ProviderModel]: Found Providers.
     * @summary Search Providers
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {boolean | null} [fEnabled] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchProvidersGeneralProvidersGet(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, fEnabled?: boolean | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchProvidersGeneralProvidersGet(pPageIndex, pPageSize, pWithTotal, fEnabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search resources.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_source_ids (Optional[List[str]]): Source IDs.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_actions (Optional[List[IngestionResourceAction]]): Resource actions.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionResourceModel]: Found resources.
     * @summary Search Resources
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fSourceIds] 
     * @param {Array<IngestionStageType> | null} [fStages] 
     * @param {Array<IngestionResourceAction> | null} [fActions] 
     * @param {string | null} [fSearchText] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchResourcesIngestionResourcesGet(fProjectIds?: Array<string> | null, fSourceIds?: Array<string> | null, fStages?: Array<IngestionStageType> | null, fActions?: Array<IngestionResourceAction> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchResourcesIngestionResourcesGet(fProjectIds, fSourceIds, fStages, fActions, fSearchText, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search runs.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchRunModel]: Found Runs.
     * @summary Search Runs
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchRunsSearchRunsGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchRunsSearchRunsGet(fProjectIds, fThreadIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Signals
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fProcessIds] 
     * @param {Array<IngestionSignalSubject> | null} [fSubjects] 
     * @param {Array<IngestionSignalCommand> | null} [fCommands] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchSignalsIngestionSignalsGet(fProjectIds?: Array<string> | null, fProcessIds?: Array<string> | null, fSubjects?: Array<IngestionSignalSubject> | null, fCommands?: Array<IngestionSignalCommand> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchSignalsIngestionSignalsGet(fProjectIds, fProcessIds, fSubjects, fCommands, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search sources.  Args:     f_external_ids (Optional[list[str]]): External project IDs.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_project_ids (Optional[List[str]]): Project IDs.     f_names (Optional[List[str]]): Source names.     f_statuses (Optional[List[IngestionSourceStatus]]): Source statuses.     f_stages (Optional[List[IngestionStageType]]): Stage types.     f_grades (Optional[List[IngestionSourceGrade]]): Stage grades.     f_search_text (Optional[str]): Search text.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[IngestionSourceModel]: Found sources.
     * @summary Search Sources
     * @param {Array<string> | null} [fExternalIds] 
     * @param {Array<string> | null} [fFolderIds] 
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fNames] 
     * @param {Array<IngestionSourceStatus> | null} [fStatuses] 
     * @param {Array<IngestionStageType> | null} [fStages] 
     * @param {Array<IngestionSourceGrade> | null} [fGrades] 
     * @param {string | null} [fSearchText] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchSourcesIngestionSourcesGet(fExternalIds?: Array<string> | null, fFolderIds?: Array<string> | null, fProjectIds?: Array<string> | null, fNames?: Array<string> | null, fStatuses?: Array<IngestionSourceStatus> | null, fStages?: Array<IngestionStageType> | null, fGrades?: Array<IngestionSourceGrade> | null, fSearchText?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchSourcesIngestionSourcesGet(fExternalIds, fFolderIds, fProjectIds, fNames, fStatuses, fStages, fGrades, fSearchText, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search toolsets.  Args:     f_search_text (Optional[str]): Toolset search text.     f_folder_ids (Optional[List[str]]): Folder IDs.     f_agent_ids (Optional[List[str]]): Agent IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[ToolsetModel]: Found toolsets.
     * @summary Search Toolsets
     * @param {string | null} [fSearchText] 
     * @param {Array<string> | null} [fFolderIds] 
     * @param {Array<string> | null} [fAgentIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchToolsets(fSearchText?: string | null, fFolderIds?: Array<string> | null, fAgentIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchToolsets(fSearchText, fFolderIds, fAgentIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search trace providers.  Args:     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[TraceProviderModel]: Found trace providers.
     * @summary Search Trace Providers
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchTraceProvidersGeneralTraceProvidersGet(pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchTraceProvidersGeneralTraceProvidersGet(pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search user messages.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_thread_ids (Optional[List[str]]): Thread IDs.     f_run_ids (Optional[List[str]]): Run IDs.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchMessageModel]: Found Messages.
     * @summary Search User Messages
     * @param {Array<string> | null} [fProjectIds] 
     * @param {Array<string> | null} [fThreadIds] 
     * @param {Array<string> | null} [fRunIds] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchUserMessagesSearchMessagesUserGet(fProjectIds?: Array<string> | null, fThreadIds?: Array<string> | null, fRunIds?: Array<string> | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchUserMessagesSearchMessagesUserGet(fProjectIds, fThreadIds, fRunIds, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search user threads.  Args:     f_project_ids (Optional[List[str]]): Project IDs.     f_search_text (Optional[str]): Search text.     f_created_on_min (Optional[datetime]): Created on from.     f_created_on_max (Optional[datetime]): Created on to.     p_page_index (int): Page index.     p_page_size (int): Page size.     p_with_total (bool): With total.  Returns:     PaginationResponse[SearchThreadModel]: Found Threads.
     * @summary Search User Threads
     * @param {Array<string> | null} [fProjectIds] 
     * @param {string | null} [fSearchText] 
     * @param {string | null} [fCreatedOnMin] 
     * @param {string | null} [fCreatedOnMax] 
     * @param {number} [pPageIndex] 
     * @param {number} [pPageSize] 
     * @param {boolean} [pWithTotal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchUserThreadsSearchThreadsUserGet(fProjectIds?: Array<string> | null, fSearchText?: string | null, fCreatedOnMin?: string | null, fCreatedOnMax?: string | null, pPageIndex?: number, pPageSize?: number, pWithTotal?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchUserThreadsSearchThreadsUserGet(fProjectIds, fSearchText, fCreatedOnMin, fCreatedOnMax, pPageIndex, pPageSize, pWithTotal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Select ELMA365 applications.  Args:     request (ELMA365ApplicationSelectionRequest): Applications selection request.  Returns:     ELMA365ApplicationSelectionResponse: Applications selection response.
     * @summary Select Elma365 Applications
     * @param {ELMA365ApplicationSelectionRequest} eLMA365ApplicationSelectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public selectELMA365ToolkitApplications(eLMA365ApplicationSelectionRequest: ELMA365ApplicationSelectionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).selectELMA365ToolkitApplications(eLMA365ApplicationSelectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Select ELMA365 namespaces.  Args:     request (ELMA365NamespaceSelectionRequest): Namespaces selection request.  Returns:     ELMA365NamespaceSelectionResponse: Namespaces selection response.
     * @summary Select Elma365 Namespace
     * @param {ELMA365NamespaceSelectionRequest} eLMA365NamespaceSelectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public selectELMA365ToolkitNamespaces(eLMA365NamespaceSelectionRequest: ELMA365NamespaceSelectionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).selectELMA365ToolkitNamespaces(eLMA365NamespaceSelectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Select ELMA365 processes.  Args:     request (ELMA365ProcessSelectionRequest): Processes selection request.  Returns:     ELMA365ProcessSelectionResponse: Processes selection response.
     * @summary Select Elma365 Processes
     * @param {ELMA365ProcessSelectionRequest} eLMA365ProcessSelectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public selectELMA365ToolkitProcesses(eLMA365ProcessSelectionRequest: ELMA365ProcessSelectionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).selectELMA365ToolkitProcesses(eLMA365ProcessSelectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Select ELMA365 tools.  Args:     request (ELMA365ToolSelectionRequest): Tools selection request.  Returns:     ELMA365ToolSelectionResponse: Tools selection response.
     * @summary Select Elma365 Tools
     * @param {ELMA365ToolSelectionRequest} eLMA365ToolSelectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public selectELMA365ToolkitTools(eLMA365ToolSelectionRequest: ELMA365ToolSelectionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).selectELMA365ToolkitTools(eLMA365ToolSelectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign out this session.  Args:     public_id (str): Session public ID.
     * @summary Sign Out Session
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public signOutSession(publicId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signOutSession(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolTogglingRequest): Tool toggling request.  Returns:     ELMA365ToolTogglingResponse: Tool toggling response.
     * @summary Toggle Elma365 Tool
     * @param {string} toolId 
     * @param {ELMA365ToolTogglingRequest} eLMA365ToolTogglingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleELMA365ToolkitTool(toolId: string, eLMA365ToolTogglingRequest: ELMA365ToolTogglingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleELMA365ToolkitTool(toolId, eLMA365ToolTogglingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetTogglingRequest): Toolset toggling request.  Returns:     ELMA365ToolsetTogglingResponse: Toolset toggling response.
     * @summary Toggle Elma365 Toolset
     * @param {string} toolsetId 
     * @param {ELMA365ToolsetTogglingRequest} eLMA365ToolsetTogglingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetTogglingRequest: ELMA365ToolsetTogglingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleELMA365ToolkitToolset(toolsetId, eLMA365ToolsetTogglingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Try to get last thread.  Args:     f_agent_ids (Optional[List[str]]): Agent IDs.     f_source_ref (Optional[str]): Source ref.  Returns:     Optional[AgentThreadModel]: Found thread else None.
     * @summary Try Get Last
     * @param {Array<string> | null} [fAgentIds] 
     * @param {string | null} [fSourceRef] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public tryGetLastAgentThread(fAgentIds?: Array<string> | null, fSourceRef?: string | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).tryGetLastAgentThread(fAgentIds, fSourceRef, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Try to get last thread.  Args:     f_project_ids (Optional[List[str]]): Project IDs.  Returns:     Optional[SearchThreadModel]: Found Thread else None.
     * @summary Try Get Last
     * @param {Array<string> | null} [fProjectIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public tryGetLastSearchThreadsLastGet(fProjectIds?: Array<string> | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).tryGetLastSearchThreadsLastGet(fProjectIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update agent.  Args:     agent_id (str): Agent ID.     request (AgentUpdatingRequest): Agent updating request.
     * @summary Update Agent
     * @param {string} agentId 
     * @param {AgentUpdatingRequest} agentUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAgent(agentId: string, agentUpdatingRequest: AgentUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAgent(agentId, agentUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update agent relation.  Args:     relation_id (str): Agent relation ID.     request (AgentRelationUpdatingRequest): Agent relation updating request.
     * @summary Update Relation
     * @param {string} relationId 
     * @param {AgentRelationUpdatingRequest} agentRelationUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAgentRelation(relationId: string, agentRelationUpdatingRequest: AgentRelationUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAgentRelation(relationId, agentRelationUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update agent resource.  Args:     resource_id (str): Agent resource ID.     request (AgentResourceUpdatingRequest): Agent resource updating request.
     * @summary Update Resource
     * @param {string} resourceId 
     * @param {AgentResourceUpdatingRequest} agentResourceUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAgentResource(resourceId: string, agentResourceUpdatingRequest: AgentResourceUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAgentResource(resourceId, agentResourceUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update thread.  Args:     thread_id (str): Thread ID.     request (AgentThreadUpdatingRequest): Thread updating request.
     * @summary Update Thread
     * @param {string} threadId 
     * @param {AgentThreadUpdatingRequest} agentThreadUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateAgentThread(threadId: string, agentThreadUpdatingRequest: AgentThreadUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateAgentThread(threadId, agentThreadUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update ApiKey.  Args:     api_key_id (str): ApiKey ID.     request (ApiKeyUpdatingRequest): ApiKey updating request.
     * @summary Update Api Key
     * @param {string} apiKeyId 
     * @param {ApiKeyUpdatingRequest} apiKeyUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateApiKeySecurityApiKeysApiKeyIdPut(apiKeyId: string, apiKeyUpdatingRequest: ApiKeyUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateApiKeySecurityApiKeysApiKeyIdPut(apiKeyId, apiKeyUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update connector.  Args:     connector_id (str): Connector ID.     request (ConnectorUpdatingRequest): Connector updating request.
     * @summary Update Connector
     * @param {string} connectorId 
     * @param {ConnectorUpdatingRequest} connectorUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateConnector(connectorId: string, connectorUpdatingRequest: ConnectorUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateConnector(connectorId, connectorUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update ELMA365 tool.  Args:     tool_id (str): Tool ID.     request (ELMA365ToolUpdatingRequest): Tool updating request.  Returns:     ELMA365ToolUpdatingResponse: Tool updating response.
     * @summary Update Elma365 Tool
     * @param {string} toolId 
     * @param {ELMA365ToolUpdatingRequest} eLMA365ToolUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateELMA365ToolkitTool(toolId: string, eLMA365ToolUpdatingRequest: ELMA365ToolUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateELMA365ToolkitTool(toolId, eLMA365ToolUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update ELMA365 toolset.  Args:     toolset_id (str): Toolset ID.     request (ELMA365ToolsetUpdatingRequest): Toolset updating request.  Returns:     ELMA365ToolsetUpdatingResponse: Toolset updating response.
     * @summary Update Elma365 Toolset
     * @param {string} toolsetId 
     * @param {ELMA365ToolsetUpdatingRequest} eLMA365ToolsetUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateELMA365ToolkitToolset(toolsetId: string, eLMA365ToolsetUpdatingRequest: ELMA365ToolsetUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateELMA365ToolkitToolset(toolsetId, eLMA365ToolsetUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update file via form.  Args:     path (FileUpdatingPath): Request path.     query (FileUpdatingQuery): Request query.     content (UploadFile): File content.  Returns:     FileUpdatingResponse: File updating response.
     * @summary Update File Form
     * @param {string} fileId 
     * @param {string} externalId 
     * @param {Array<FilePurpose>} purposes 
     * @param {File} content 
     * @param {string | null} [projectId] 
     * @param {string | null} [sourceId] 
     * @param {ContentStore | null} [contentStore] 
     * @param {ContentFormat | null} [contentFormat] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFileFormGeneralFilesFormFileIdPut(fileId: string, externalId: string, purposes: Array<FilePurpose>, content: File, projectId?: string | null, sourceId?: string | null, contentStore?: ContentStore | null, contentFormat?: ContentFormat | null, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFileFormGeneralFilesFormFileIdPut(fileId, externalId, purposes, content, projectId, sourceId, contentStore, contentFormat, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update file via JSON.  Args:     path (FileUpdatingPath): Request path.     body (FileUpdatingBody): Request body.  Returns:     FileUpdatingResponse: File updating response.
     * @summary Update File Json
     * @param {string} fileId 
     * @param {FileUpdatingBody} fileUpdatingBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFileJsonGeneralFilesJsonFileIdPut(fileId: string, fileUpdatingBody: FileUpdatingBody, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFileJsonGeneralFilesJsonFileIdPut(fileId, fileUpdatingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update file\'s parameters.  Args:     path (FileUpdatingPath): Request path.     body (FileParametersInfo): Request body.  Returns:     FileUpdatingResponse: File updating response.
     * @summary Update File Parameters
     * @param {string} fileId 
     * @param {FileParametersInfo} fileParametersInfo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFileParametersGeneralFilesFileIdParametersPut(fileId: string, fileParametersInfo: FileParametersInfo, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFileParametersGeneralFilesFileIdParametersPut(fileId, fileParametersInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update folder.  Args:     folder_id (str): Folder ID.     request (FolderUpdatingRequest): Folder updating request.  Returns:     FolderUpdatingResponse: Folder updating response.
     * @summary Update Folder
     * @param {string} folderId 
     * @param {FolderUpdatingRequest} folderUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateFolder(folderId: string, folderUpdatingRequest: FolderUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateFolder(folderId, folderUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update project.  Args:     project_id (str): Project ID.     request (ProjectUpdatingRequest): Project updating request.
     * @summary Update Project
     * @param {string} projectId 
     * @param {ProjectUpdatingRequest} projectUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateProjectGeneralProjectsProjectIdPut(projectId: string, projectUpdatingRequest: ProjectUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateProjectGeneralProjectsProjectIdPut(projectId, projectUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update provider.  Args:     provider_id (str): Provider ID.     request (ProviderUpdatingRequest): Provider updating request.
     * @summary Update Provider
     * @param {string} providerId 
     * @param {ProviderUpdatingRequest} providerUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateProviderGeneralProvidersProviderIdPut(providerId: string, providerUpdatingRequest: ProviderUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateProviderGeneralProvidersProviderIdPut(providerId, providerUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Schedule
     * @param {string} scheduleId 
     * @param {IngestionScheduleUpdatingRequest} ingestionScheduleUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSchedule(scheduleId: string, ingestionScheduleUpdatingRequest: IngestionScheduleUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSchedule(scheduleId, ingestionScheduleUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Source
     * @param {string} sourceId 
     * @param {IngestionSourceUpdatingRequest} ingestionSourceUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateSourceIngestionSourcesSourceIdPut(sourceId: string, ingestionSourceUpdatingRequest: IngestionSourceUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateSourceIngestionSourcesSourceIdPut(sourceId, ingestionSourceUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update thread.  Args:     thread_id (str): Thread ID.     request (SearchThreadUpdatingRequest): Thread updating request.
     * @summary Update Thread
     * @param {string} threadId 
     * @param {SearchThreadUpdatingRequest} searchThreadUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateThreadSearchThreadsThreadIdPut(threadId: string, searchThreadUpdatingRequest: SearchThreadUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateThreadSearchThreadsThreadIdPut(threadId, searchThreadUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update toolset.  Args:     toolset_id (str): Toolset ID.     request (ToolsetUpdatingRequest): Toolset updating request.
     * @summary Update Toolset
     * @param {string} toolsetId 
     * @param {ToolsetUpdatingRequest} toolsetUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateToolset(toolsetId: string, toolsetUpdatingRequest: ToolsetUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateToolset(toolsetId, toolsetUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update trace provider.  Args:     trace_provider_id (str): Trace provider ID.     request (TraceProviderUpdatingRequest): Trace provider updating request.
     * @summary Update Trace Provider
     * @param {string} traceProviderId 
     * @param {TraceProviderUpdatingRequest} traceProviderUpdatingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTraceProviderGeneralTraceProvidersTraceProviderIdPut(traceProviderId: string, traceProviderUpdatingRequest: TraceProviderUpdatingRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateTraceProviderGeneralTraceProvidersTraceProviderIdPut(traceProviderId, traceProviderUpdatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



